import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Injectable, EventEmitter, Output, ViewChild, forwardRef, Directive, NgModule, Inject, ContentChildren, ContentChild } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i1$1 from '@ng-bootstrap/ng-bootstrap';
import { ModalDismissReasons, NgbDate, NgbDateParserFormatter, NgbTimepicker, NgbTypeaheadConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Chart } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import moment from 'moment';
import * as i2$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i3 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i2$2 from '@angular/router';
import { RouterModule, NavigationEnd } from '@angular/router';
import { Font, TextGeometry } from 'three-full';
import { MatDialogModule } from '@angular/material/dialog';
import * as i5 from '@angular/material/table';
import { MatTableDataSource, MatNoDataRow, MatHeaderRowDef, MatRowDef, MatColumnDef, MatTable, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import * as i6 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i4 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

/**
 * Atoms branding component (atoms-branding.component.ts).
 * Atoms -> Branding Component
 *
 * @version
 * 2.2.0 LIBNGSG-105 Required changes for landing page
 * 1.6.0 LIBNGSG-35 Change sidebar logo to light version
 * 1.3.0 LIBNGSG-8 Add branding images component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
function AtomsBrandingComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r0.image, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r0.alt)("title", ctx_r0.title);
} }
function AtomsBrandingComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r2.brandSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r2.alt)("title", ctx_r2.title);
} }
function AtomsBrandingComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r3.brandHeaderSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r3.alt)("title", ctx_r3.title);
} }
function AtomsBrandingComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r4.logoSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r4.alt)("title", ctx_r4.title);
} }
function AtomsBrandingComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r5.nameSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r5.alt)("title", ctx_r5.title);
} }
function AtomsBrandingComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r6.nameLightSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r6.alt)("title", ctx_r6.title);
} }
function AtomsBrandingComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r7.brandSrc, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("alt", ctx_r7.alt)("title", ctx_r7.title);
} }
function AtomsBrandingComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, AtomsBrandingComponent_div_2_div_1_Template, 2, 3, "div", 6);
    i0.ɵɵtemplate(2, AtomsBrandingComponent_div_2_div_2_Template, 2, 3, "div", 6);
    i0.ɵɵtemplate(3, AtomsBrandingComponent_div_2_div_3_Template, 2, 3, "div", 6);
    i0.ɵɵtemplate(4, AtomsBrandingComponent_div_2_div_4_Template, 2, 3, "div", 6);
    i0.ɵɵtemplate(5, AtomsBrandingComponent_div_2_div_5_Template, 2, 3, "div", 6);
    i0.ɵɵtemplate(6, AtomsBrandingComponent_div_2_div_6_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r1.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "brand");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "brandHeader");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "logo");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "name");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "nameLight");
} }
class AtomsBrandingComponent {
    // Inputs
    title = 'Brand Image'; // Image hover title
    type = 'brand'; // Branding type
    alt = 'Brand Image'; // Image alt text
    href; // Image href url
    target; // Image href target
    image; // Image override url
    // Branding - Defaults to Build Centrix Branding
    brandSrc = 'assets/images/branding/buildcentrix-brand.png';
    brandHeaderSrc = 'assets/images/branding/buildcentrix-brand-header.png';
    logoSrc = 'assets/images/branding/buildcentrix-logo.png';
    nameSrc = 'assets/images/branding/buildcentrix-logo-brand.png';
    nameLightSrc = 'assets/images/branding/buildcentrix-brand-light.png';
    /** @nocollapse */ static ɵfac = function AtomsBrandingComponent_Factory(t) { return new (t || AtomsBrandingComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsBrandingComponent, selectors: [["bc-atoms-branding"]], inputs: { title: "title", type: "type", alt: "alt", href: "href", target: "target", image: "image" }, decls: 3, vars: 4, consts: [[1, "brand-link"], ["class", "brand-wrapper", 4, "ngIf"], ["class", "brand-wrapper", 3, "ngSwitch", 4, "ngIf"], [1, "brand-wrapper"], [1, "brand-image", 3, "src"], [1, "brand-wrapper", 3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"]], template: function AtomsBrandingComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "a", 0);
            i0.ɵɵtemplate(1, AtomsBrandingComponent_div_1_Template, 2, 3, "div", 1);
            i0.ɵɵtemplate(2, AtomsBrandingComponent_div_2_Template, 7, 6, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵattribute("href", ctx.href, i0.ɵɵsanitizeUrl)("target", ctx.target);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.image);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.image);
        } }, dependencies: [i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i1.NgSwitchDefault], styles: [".brand-link .brand-wrapper .brand-image{vertical-align:middle;border-style:none;max-width:100%;max-height:100%}\n"], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsBrandingComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-branding', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Atoms branding component (atoms-branding.component.html).\n - Atom -> branding Component.\n -\n - @version\n - 2.2.0 LIBNGSG-105 Required changes for landing page\n - 1.6.0 LIBNGSG-35 Change sidebar logo to light version\n - 1.3.0 LIBNGSG-27 Add loader component\n - 1.3.0 LIBNGSG-8 Add branding images component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -->\n<a class=\"brand-link\" [attr.href]=\"href\" [attr.target]=\"target\">\n  <!--Override Brand Image-->\n  <div class=\"brand-wrapper\" *ngIf=\"image\">\n    <img\n      class=\"brand-image\"\n      [attr.alt]=\"alt\"\n      [attr.title]=\"title\"\n      [src]=\"image\"\n    />\n  </div>\n\n  <!--Default Brand Image-->\n  <div class=\"brand-wrapper\" *ngIf=\"!image\" [ngSwitch]=\"type\">\n    <!--Default Logo and Name Brand-->\n    <div *ngSwitchCase=\"'brand'\">\n      <img\n        class=\"brand-image\"\n        [attr.alt]=\"alt\"\n        [attr.title]=\"title\"\n        [src]=\"brandSrc\"\n      />\n    </div>\n    <!--Default Logo and Name Brand For Header-->\n    <div *ngSwitchCase=\"'brandHeader'\">\n      <img\n        class=\"brand-image\"\n        [attr.alt]=\"alt\"\n        [attr.title]=\"title\"\n        [src]=\"brandHeaderSrc\"\n      />\n    </div>\n    <!--Default Logo Only-->\n    <div *ngSwitchCase=\"'logo'\">\n      <img\n        class=\"brand-image\"\n        [attr.alt]=\"alt\"\n        [attr.title]=\"title\"\n        [src]=\"logoSrc\"\n      />\n    </div>\n    <!--Default Name Logo-->\n    <div *ngSwitchCase=\"'name'\">\n      <img\n        class=\"brand-image\"\n        [attr.alt]=\"alt\"\n        [attr.title]=\"title\"\n        [src]=\"nameSrc\"\n      />\n    </div>\n    <!--Default Name Brand - Light-->\n    <div *ngSwitchCase=\"'nameLight'\">\n      <img\n        class=\"brand-image\"\n        [attr.alt]=\"alt\"\n        [attr.title]=\"title\"\n        [src]=\"nameLightSrc\"\n      />\n    </div>\n    <!--Default-->\n    <div *ngSwitchDefault>\n      <img\n        class=\"brand-image\"\n        [attr.alt]=\"alt\"\n        [attr.title]=\"title\"\n        [src]=\"brandSrc\"\n      />\n    </div>\n  </div>\n</a>\n", styles: [".brand-link .brand-wrapper .brand-image{vertical-align:middle;border-style:none;max-width:100%;max-height:100%}\n"] }]
    }], null, { title: [{
            type: Input
        }], type: [{
            type: Input
        }], alt: [{
            type: Input
        }], href: [{
            type: Input
        }], target: [{
            type: Input
        }], image: [{
            type: Input
        }] }); })();

/**
 * Atoms branded-info component (atoms-branded-info.component.ts).
 * Atoms -> Branded Info Component
 *
 * @version
 * 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu
 * 1.3.0 LIBNGSG-27 Add loader component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
function AtomsBrandedInfoComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵelement(2, "div", 9)(3, "div", 10)(4, "div", 11)(5, "div", 12)(6, "div", 13);
    i0.ɵɵelementEnd()();
} }
function AtomsBrandedInfoComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.title);
} }
function AtomsBrandedInfoComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r2.subtitle, i0.ɵɵsanitizeHtml);
} }
class AtomsBrandedInfoComponent {
    // String Inputs
    title = null;
    subtitle = null;
    // Boolean Inputs
    isLoading = false;
    // Brand Link
    brandTitle = null;
    brandHref = null;
    // Defaults (Non-Inputs)
    brandedInfoClass = 'bc-branded-info';
    /** @nocollapse */ static ɵfac = function AtomsBrandedInfoComponent_Factory(t) { return new (t || AtomsBrandedInfoComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsBrandedInfoComponent, selectors: [["bc-atoms-branded-info"]], inputs: { title: "title", subtitle: "subtitle", isLoading: "isLoading", brandTitle: "brandTitle", brandHref: "brandHref" }, decls: 8, vars: 7, consts: [[1, "branded-info-container", "animated", "fadeIn"], [1, "branded-info"], [1, "image-section"], ["target", "_blank", "type", "brand", 3, "title", "href"], ["class", "animation-section", 4, "ngIf"], ["class", "title-section", 4, "ngIf"], ["class", "message-section", 3, "innerHTML", 4, "ngIf"], [1, "animation-section"], [1, "load-three-bounce"], [1, "load-child", "bounce1"], [1, "load-child", "bounce2"], [1, "load-child", "bounce3"], [1, "load-child", "bounce4"], [1, "load-child", "bounce5"], [1, "title-section"], [1, "message-section", 3, "innerHTML"]], template: function AtomsBrandedInfoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "div", 1)(3, "div", 2);
            i0.ɵɵelement(4, "bc-atoms-branding", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, AtomsBrandedInfoComponent_div_5_Template, 7, 0, "div", 4);
            i0.ɵɵtemplate(6, AtomsBrandedInfoComponent_div_6_Template, 3, 1, "div", 5);
            i0.ɵɵtemplate(7, AtomsBrandedInfoComponent_div_7_Template, 1, 1, "div", 6);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.brandedInfoClass);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("title", ctx.brandTitle ? ctx.brandTitle : ctx.title + " - " + ctx.subtitle)("href", ctx.brandHref);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isLoading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.subtitle);
        } }, dependencies: [i1.NgIf, AtomsBrandingComponent], styles: [".bc-branded-info[_ngcontent-%COMP%]{display:inline-block;width:100%}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]{inset:0;background-color:transparent}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]{text-align:center;overflow:hidden}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .image-section[_ngcontent-%COMP%]{margin:auto;opacity:1;max-width:280px}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .image-section[_ngcontent-%COMP%], .bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .animation-section[_ngcontent-%COMP%]{padding:5px;letter-spacing:1px}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .message-section[_ngcontent-%COMP%]{color:gray;margin:15px auto 0;letter-spacing:1px}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .title-section[_ngcontent-%COMP%]{padding-bottom:5px;color:#d3d3d3;letter-spacing:5px;font-weight:700;font-size:large}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .animation-section[_ngcontent-%COMP%]   .load-three-bounce[_ngcontent-%COMP%]   .load-child[_ngcontent-%COMP%]{display:inline-block;width:15px;height:15px;border-radius:50%;background-color:#d3d3d3;animation:_ngcontent-%COMP%_load-three-bounce 1.4s ease-in-out 0s infinite both;margin-left:5px;margin-right:5px}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .animation-section[_ngcontent-%COMP%]   .load-three-bounce[_ngcontent-%COMP%]   .bounce1[_ngcontent-%COMP%]{animation-delay:-.72s}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .animation-section[_ngcontent-%COMP%]   .load-three-bounce[_ngcontent-%COMP%]   .bounce2[_ngcontent-%COMP%]{animation-delay:-.6s}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .animation-section[_ngcontent-%COMP%]   .load-three-bounce[_ngcontent-%COMP%]   .bounce3[_ngcontent-%COMP%]{animation-delay:-.48s}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .animation-section[_ngcontent-%COMP%]   .load-three-bounce[_ngcontent-%COMP%]   .bounce4[_ngcontent-%COMP%]{animation-delay:-.32s}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container[_ngcontent-%COMP%]   .branded-info[_ngcontent-%COMP%]   .animation-section[_ngcontent-%COMP%]   .load-three-bounce[_ngcontent-%COMP%]   .bounce5[_ngcontent-%COMP%]{animation-delay:-.16s}@keyframes _ngcontent-%COMP%_load-three-bounce{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container.animated[_ngcontent-%COMP%]{animation-duration:2s;animation-fill-mode:both}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.bc-branded-info[_ngcontent-%COMP%]   .branded-info-container.fadeIn[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_fadeIn}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsBrandedInfoComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-branded-info', template: "<!--\n - Atoms branded-info component (atoms-branded-info.component.html).\n - Atom -> Branded Info Component.\n -\n - @version\n - 1.3.0 LIBNGSG-27 Add loader component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -->\n<div [class]=\"brandedInfoClass\">\n  <div class=\"branded-info-container animated fadeIn\">\n    <div class=\"branded-info\">\n      <div class=\"image-section\">\n        <bc-atoms-branding\n          [title]=\"brandTitle ? brandTitle : title + ' - ' + subtitle\"\n          [href]=\"brandHref\"\n          target=\"_blank\"\n          type=\"brand\"\n        ></bc-atoms-branding>\n      </div>\n      <div class=\"animation-section\" *ngIf=\"isLoading\">\n        <div class=\"load-three-bounce\">\n          <div class=\"load-child bounce1\"></div>\n          <div class=\"load-child bounce2\"></div>\n          <div class=\"load-child bounce3\"></div>\n          <div class=\"load-child bounce4\"></div>\n          <div class=\"load-child bounce5\"></div>\n        </div>\n      </div>\n      <!--Title-->\n      <div *ngIf=\"title\" class=\"title-section\">\n        <span>{{ title }}</span>\n      </div>\n      <!--Subtitle-->\n      <div\n        *ngIf=\"subtitle\"\n        class=\"message-section\"\n        [innerHTML]=\"subtitle\"\n      ></div>\n    </div>\n  </div>\n</div>\n", styles: [".bc-branded-info{display:inline-block;width:100%}.bc-branded-info .branded-info-container{inset:0;background-color:transparent}.bc-branded-info .branded-info-container .branded-info{text-align:center;overflow:hidden}.bc-branded-info .branded-info-container .branded-info .image-section{margin:auto;opacity:1;max-width:280px}.bc-branded-info .branded-info-container .branded-info .image-section,.bc-branded-info .branded-info-container .branded-info .animation-section{padding:5px;letter-spacing:1px}.bc-branded-info .branded-info-container .branded-info .message-section{color:gray;margin:15px auto 0;letter-spacing:1px}.bc-branded-info .branded-info-container .branded-info .title-section{padding-bottom:5px;color:#d3d3d3;letter-spacing:5px;font-weight:700;font-size:large}.bc-branded-info .branded-info-container .branded-info .animation-section .load-three-bounce .load-child{display:inline-block;width:15px;height:15px;border-radius:50%;background-color:#d3d3d3;animation:load-three-bounce 1.4s ease-in-out 0s infinite both;margin-left:5px;margin-right:5px}.bc-branded-info .branded-info-container .branded-info .animation-section .load-three-bounce .bounce1{animation-delay:-.72s}.bc-branded-info .branded-info-container .branded-info .animation-section .load-three-bounce .bounce2{animation-delay:-.6s}.bc-branded-info .branded-info-container .branded-info .animation-section .load-three-bounce .bounce3{animation-delay:-.48s}.bc-branded-info .branded-info-container .branded-info .animation-section .load-three-bounce .bounce4{animation-delay:-.32s}.bc-branded-info .branded-info-container .branded-info .animation-section .load-three-bounce .bounce5{animation-delay:-.16s}@keyframes load-three-bounce{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}.bc-branded-info .branded-info-container.animated{animation-duration:2s;animation-fill-mode:both}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.bc-branded-info .branded-info-container.fadeIn{animation-name:fadeIn}\n"] }]
    }], null, { title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], brandTitle: [{
            type: Input
        }], brandHref: [{
            type: Input
        }] }); })();

/**
 * Component Reference (component-reference.ts).
 * Lookup Classes/Values by Reference Key
 *
 * @version
 * 3.13.0 LIBNGSG-142 Remove manager link
 * 3.12.0 LIBNGSG-139 Add icons for new assembly ui tools
 * 3.10.0 LIBNGSG-131 Set a better icon for lookaheads
 * 3.10.0 LIBNGSG-134 Add new icon for prefab assemblies
 * 3.10.0 LIBNGSG-133 Rename 3D Assemblies as 3D Takeoffs
 * 3.9.0 PRDS-340 Add spooling-ui menu items to style guides
 * 3.8.0 ASBUI-304 Add required icos for assembly ui redesign
 * 3.6.0 LIBNGSG-126 Add required icons for vehicle management
 * 3.6.0 BLPRINT-47 Add icon for zoom in, zoom out and crop
 * 3.2.0 LIBNGSG-116 Update header links with landing page options
 * 2.2.0 LIBNGSG-105 Required changes for landing page
 * 2.1.0 LIBNGSG-101 Add icons for assembly and plumbings
 * 2.0.0 LIBNGSG-98 Add missing font awesome icons and fix CSS issues caused by upgrade
 * 2.0.0 LIBNGSG-97 Upgrade to font-awesome v6
 * 1.26.2 LIBGNGSG-95 Add support for Font Awesome icon: share-square
 * 1.26.1 LIBGNGSG-93 Add new shipping status icons for Harris
 * 1.26.0 LIBGNGSG-90 Add icon for "Printed" delivery status
 * 1.20.0 LIBNGSG-72 Add missing order listing icons
 * 1.19.0 LIBNGSG-70 Add missing icons for order navigation
 * 1.18.0 LIBNGSG-67 Change navigation icons
 * 1.17.0 LIBNGSG-65 Add missing calendar icons
 * 1.14.0 LIBNGSG-59 Add weight icon in Style Guide
 * 1.13.0 LIBNGSG-56 Add bell icon
 * 1.10.0 LIBNGSG-52 Add assembly icon
 * 1.10.0 LIBNGSG-48 Fix joints admin issues
 * 1.10.0 LIBNGSG-47 Add search icon
 * 1.8.0 LIBNGSG-41 Add number range validation for inputs
 * 1.6.0 LIBNGSG-36 Add Crew Link to Header
 * 1.6.0 LIBNGSG-35 Change sidebar logo to light version
 * 1.6.0 LIBNGSG-33 Minor Issues found during QA testing
 * 1.4.0 LIBNGSG-24 Add header sidebar layout components
 * 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu
 * 1.3.0 LIBNGSG-8 Add branding images component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @author Erik Orozco <erik.orozco@buildcentrix.com>
 * @author Deitric Jang <djang@buildcentrix.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2022-2024 Build Centrix
 */
const ComponentLookup = {
    buttons: {
        size: {
            small: 'btn-sm',
            default: '',
            large: 'btn-lg',
        },
        display: {
            default: '',
            block: 'btn-block',
        },
        groupDirection: {
            horizontal: 'horizontal',
            vertical: 'vertical',
        },
        type: {
            default: 'btn-light',
            dark: 'btn-dark',
            link: 'btn-link',
            linkDanger: 'btn-link text-danger',
            primary: 'btn-primary',
            secondary: 'btn-secondary',
            success: 'btn-success',
            info: 'btn-info',
            warning: 'btn-warning',
            danger: 'btn-danger',
            outlineDark: 'btn-outline-dark',
            outlinePrimary: 'btn-outline-primary',
            outlineSecondary: 'btn-outline-secondary',
            outlineSuccess: 'btn-outline-success',
            outlineInfo: 'btn-outline-info',
            outlineWarning: 'btn-outline-warning',
            outlineDanger: 'btn-outline-danger',
        },
        tag: {
            link: 'link',
            button: 'button',
            input: 'input',
            reset: 'reset',
            submit: 'submit',
        },
    },
    hrefs: {
        types: {
            brand: 'brand',
            brandHeader: 'brandHeader',
            logo: 'logo',
            name: 'name',
            nameLight: 'nameLight',
        },
        targets: {
            _blank: '_blank',
            _self: '_self',
            _parent: '_parent',
            _top: '_top',
        },
    },
    // https://fontawesome.com/search
    icons: {
        icon: {
            active: 'fa-solid fa-check',
            activityReport: 'fa-solid fa-magnifying-glass-chart',
            add: 'fa-solid fa-plus',
            adjustment: 'fa-solid fa-asterisk',
            afternoon: 'fa-regular fa-sun',
            all: 'fa-solid fa-bars',
            allUsers: 'fa-solid fa-users',
            applicationSettings: 'fa-solid fa-screwdriver-wrench',
            approve: 'fa-solid fa-check',
            approved: 'fa-solid fa-check',
            archived: 'fa-solid fa-times',
            assemblies: 'fa-solid fa-cubes',
            attachment: 'fa-solid fa-paperclip',
            atom: 'fa-regular fa-circle',
            backward: 'fa-solid fa-backward',
            bell: 'fa-regular fa-bell',
            brightness: 'fa-solid fa-circle-half-stroke',
            calendar: 'fa-regular fa-calendar',
            calculator: 'fa-solid fa-calculator',
            camera: 'fa-solid fa-camera',
            cameraRotation: 'fa-solid fa-camera-rotate',
            camExports: 'fa-solid fa-file-export',
            camExportMappings: 'fa-solid fa-share-square',
            camItemFiles: 'fa-regular fa-file-lines',
            camSoftware: 'fa-regular fa-circle-question',
            cancel: 'fa-solid fa-times',
            car: 'fa-solid fa-car',
            cart: 'fa-solid fa-shopping-cart',
            categories: 'fa-solid fa-list',
            clear: 'fa-solid fa-times',
            clone: 'fa-regular fa-clone',
            collapsed: 'fa-solid fa-caret-right',
            colours: 'fa-solid fa-paint-brush',
            country: 'fa-solid fa-earth-americas',
            createAssembly: 'fa-solid fa-cubes',
            crews: 'fa-solid fa-people-group',
            csv: 'fa-regular fa-file-text',
            customStatus: 'fa-solid fa-caret-right',
            crop: 'fa-solid fa-crop',
            dashboard: 'fa-solid fa-chart-simple',
            default: 'fa-solid fa-question-circle',
            delete: 'fa-solid fa-trash',
            deliveryCalendar: 'fa-solid fa-truck',
            denied: 'fa-solid fa-times',
            doubleTime: 'fa-solid fa-star',
            download: 'fa-solid fa-download',
            ductFabrication: 'fa-solid fa-wind',
            earlier: 'fa-regular fa-calendar-minus',
            ecommerce: 'fa-solid fa-dollar',
            edit: 'fa-regular fa-edit',
            email: 'fa-regular fa-envelope',
            entries: 'fa-regular fa-list-alt',
            environment: 'fa-solid fa-street-view',
            error: 'fa-solid fa-warning',
            expanded: 'fa-solid fa-caret-down',
            export: 'fa-regular fa-file',
            exported: 'fa-solid fa-share',
            facebook: 'fa-brands fa-facebook',
            fieldEntry: 'fa-solid fa-vcard',
            fieldTimecards: 'fa-solid fa-vcard',
            fieldUser: 'fa-regular fa-user-circle',
            first: 'fa-solid fa-fast-backward',
            file: 'fa-regular fa-file-text',
            filter: 'fa-solid fa-filter',
            fittingMaterial: 'fa-solid fa-table',
            fittingShopFactors: 'fa-solid fa-users',
            forward: 'fa-solid fa-forward',
            gavel: 'fa-solid fa-gavel',
            home: 'fa-solid fa-home',
            hvacMaterials: 'fa-solid fa-table',
            hvacSpecifications: 'fa-solid fa-pencil',
            hvacInsulations: 'fa-solid fa-sliders',
            hvacLookups: 'fa-solid fa-cog',
            icon: 'fa-solid fa-bolt',
            info: 'fa-solid fa-info-circle',
            information: 'fa-solid fa-info-circle',
            instagram: 'fa-brands fa-instagram',
            inProduction: 'fa-regular fa-play-circle',
            inProgress: 'fa-regular fa-clock',
            insulationCostWeight: 'fa-solid fa-cogs',
            insulationShopLabour: 'fa-solid fa-snowflake',
            internal: 'fa-solid fa-house-user',
            jobCode: 'fa-solid fa-copyright',
            jobsAdmin: 'fa-solid fa-briefcase',
            joint: 'fa-solid fa-link',
            joints: 'fa-solid fa-link',
            jonas: 'fa-regular fa-file-text',
            last: 'fa-solid fa-fast-forward',
            linkedIn: 'fa-brands fa-linkedin',
            later: 'fa-regular fa-calendar-plus',
            loading: 'fa-solid fa-spinner',
            locked: 'fa-solid fa-lock',
            logout: 'fa-solid fa-power-off',
            lookaheadOrders: 'fa-solid fa-scroll',
            manufacturingAdmin: 'fa-solid fa-hammer',
            materialCostWeight: 'fa-solid fa-balance-scale',
            materialGauge: 'fa-solid fa-magnifying-glass',
            menu: 'fa-solid fa-bars',
            minus: 'fa-sold fa-minus',
            molecule: 'fa-regular fa-dot-circle',
            myCrew: 'fa-solid fa-people-group',
            next: 'fa-solid fa-caret-right',
            nextDay: 'fa-solid fa-mail-forward',
            night: 'fa-regular fa-moon',
            notifications: 'fa-regular fa-comment',
            notStarted: 'fa-regular fa-circle',
            ok: 'fa-solid fa-check',
            onHold: 'fa-regular fa-hand',
            orderFulfillmentGroups: 'fa-solid fa-retweet',
            organism: 'fa-solid fa-circle',
            organization: 'fa-solid fa-people-roof',
            overtime: 'fa-regular fa-star-half-stroke',
            partiallyShipped: 'fa-regular fa-dot-circle',
            password: 'fa-solid fa-lock',
            payrollProcessed: 'fa-regular fa-check-square',
            pdf: 'fa-regular fa-file-pdf',
            pending: 'fa-regular fa-circle',
            phone: 'fa-solid fa-phone',
            palette: 'fa-solid fa-palette',
            plumbing: 'fa-solid fa-shower',
            prefabAssemblies: 'fa-solid fa-cube',
            previous: 'fa-solid fa-caret-left',
            priceAdjustment: 'fa-solid fa-magnifying-glass-dollar',
            print: 'fa-solid fa-print',
            printed: 'fa-solid fa-print',
            productionCalendar: 'fa-regular fa-calendar',
            products: 'fa-solid fa-th',
            productCatalogs: 'fa-solid fa-book',
            ready: 'fa-regular fa-check-square',
            region: 'fa-solid fa-earth-americas',
            regular: 'fa-solid fa-circle-notch',
            regularTime: 'fa-regular fa-star',
            reimbursements: 'fa-regular fa-money-bill-1',
            reports: 'fa-solid fa-line-chart',
            retail: 'fa-regular fa-user',
            rotate: 'fa-solid fa-arrows-rotate',
            ruler: 'fa-solid fa-ruler',
            save: 'fa-solid fa-save',
            savedOrders: 'fa-solid fa-save',
            search: 'fa-solid fa-search',
            selection: 'fa-solid fa-object-group',
            settings: 'fa-solid fa-sliders',
            shareSquare: 'fa-solid fa-share-square',
            shipped: 'fa-solid fa-truck',
            shipping: 'fa-solid fa-truck-fast',
            shippingCalendar: 'fa-solid fa-calendar-check',
            shippingLoadingZone: 'fa-solid fa-truck-ramp-box',
            shippingVehicle: 'fa-solid fa-truck-moving',
            shopEntry: 'fa-regular fa-vcard',
            shopTimecards: 'fa-regular fa-vcard',
            shopUser: 'fa-solid fa-user-circle',
            square: 'fa-regular fa-square',
            submittable: 'fa-solid fa-check',
            submitted: 'fa-solid fa-lock',
            systemTypes: 'fa-solid fa-bars-staggered',
            template: 'fa-regular fa-file-code',
            textSize: 'fa-solid fa-text-height',
            time: 'fa-regular fa-clock',
            timecards: 'fa-regular fa-clock',
            trackerAdmin: 'fa-solid fa-wrench',
            travelTime: 'fa-solid fa-car',
            twitter: 'fa-brands fa-twitter',
            typography: 'fa-solid fa-font',
            uiElement: 'fa-regular fa-building',
            underReview: 'fa-solid fa-lock',
            undo: 'fa-solid fa-rotate-left',
            upload: 'fa-solid fa-upload',
            user: 'fa-regular fa-user',
            userGroup: 'fa-solid fa-user-group',
            view: 'fa-regular fa-circle-right',
            viewMode: 'fa-solid fa-street-view',
            viewpoint: 'fa-regular fa-file-text',
            webduct: 'fa-solid fa-cog',
            weight: 'fa-solid fa-balance-scale',
            workOrders: 'fa-solid fa-table-cells-large',
            youTube: 'fa-brands fa-youtube',
            zoomIn: 'fa-solid fa-magnifying-glass-minus',
            zoomOut: 'fa-solid fa-magnifying-glass-plus',
            modelSpooling: 'fa fa-cogs',
        },
        size: {
            default: '',
            medium: 'fa-lg',
            large: 'fa-2x',
            larger: 'fa-3x',
            largest: 'fa-4x',
            max: 'fa-5x',
        },
        alignment: {
            default: '',
            left: 'fa-pull-left',
            right: 'fa-pull-right',
        },
        border: { enabled: 'fa-border' },
        rotate: { enabled: 'fa-spin' },
    },
    inputs: {
        alignment: {
            left: 'left',
            right: 'right',
        },
        autocomplete: {
            on: 'on',
            off: 'off',
        },
        formGroupState: {
            invalid: 'invalid',
            default: 'default',
            valid: 'valid',
        },
        inputGroupState: {
            invalid: 'invalid',
            default: '',
            valid: 'valid',
        },
        sizeCheckbox: {
            small: 'checkbox-sm',
            default: '',
            large: 'checkbox-lg',
        },
        inputGroupSize: {
            small: 'input-group-sm',
            default: '',
            large: 'input-group-lg',
        },
        formControlSize: {
            small: 'form-control-sm',
            default: '',
            large: 'form-control-lg',
        },
        type: {
            date: 'date',
            email: 'email',
            file: 'file',
            hidden: 'hidden',
            image: 'image',
            month: 'month',
            number: 'number',
            password: 'password',
            range: 'range',
            search: 'search',
            tel: 'tel',
            text: 'text',
            time: 'time',
            url: 'url',
            week: 'week',
        },
    },
    thumbnails: {
        size: {
            small: 'thumbnail-small',
            default: '',
        },
    },
};

/**
 * Component Service (component.service.ts).
 * Services -> Component Service
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu
 * 1.3.0 LIBNGSG-8 Add branding images component
 *
 */
class ComponentService {
    static componentOptions = {
        BUTTON: 'buttons',
        ICON: 'icons',
        INPUT: 'inputs',
        HREF: 'hrefs',
        THUMBNAIL: 'thumbnails',
    };
    /**
     * Get Class by Key
     * @since 1.3.0
     */
    static getComponentClassByKey(target, type, key) {
        // Default Class
        let result = '';
        // Get Class by Lookup Key
        if (ComponentLookup[target][type][key]) {
            result = ComponentLookup[target][type][key];
        }
        return result;
    }
    /**
     * Get Component Options by Key
     * @since 1.3.0
     */
    static getComponentOptionsByKey(target, key) {
        return Object.keys(ComponentLookup[target][key]);
    }
    /** @nocollapse */ static ɵfac = function ComponentService_Factory(t) { return new (t || ComponentService)(); };
    /** @nocollapse */ static ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: ComponentService, factory: ComponentService.ɵfac, providedIn: 'root' });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

/**
 * Atoms icon component (atoms-icon.component.ts).
 * Atoms -> Icon Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.3.0 LIBNGSG-8 Add branding images component
 * 1.1.0 LIBNGSG-13 Upgrade to Bootstrap v4.6.0
 * 1.1.0 LIBNGSG-10 Add Dropdown Component
 * 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components
 * 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library
 * 1.0.0 LIBNGSG-1 Add basic component library code to repository
 *
 */
class AtomsIconComponent {
    // Defaults (Non-Inputs)
    iconClass = '';
    // String Inputs
    id;
    title = '';
    // Boolean Inputs
    border = false;
    rotate = false;
    // Options
    size = null; // Options: (medium/large/larger/largest)
    align = null; // Options: (left/right)
    type = 'default'; // Options: (See "../../../services/icons/icon-reference";)
    // Validation
    alignmentOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.ICON, 'alignment');
    /**
     * Watch for Changes
     */
    ngOnChanges() {
        // Core Classes
        const iconClasses = ['fa'];
        // Icon Type / Size
        const typeClass = ComponentService.getComponentClassByKey(ComponentService.componentOptions.ICON, 'icon', this.type);
        // Add Core Classes
        iconClasses.push(typeClass);
        // Size
        if (this.size) {
            const sizeClass = ComponentService.getComponentClassByKey(ComponentService.componentOptions.ICON, 'size', this.size);
            iconClasses.push(sizeClass);
        }
        // Alignment
        if (this.align && this.alignmentOptions.includes(this.align)) {
            const alignClass = ComponentService.getComponentClassByKey(ComponentService.componentOptions.ICON, 'alignment', this.align);
            iconClasses.push(alignClass);
        }
        // Border
        if (this.border === true) {
            const borderClass = ComponentService.getComponentClassByKey(ComponentService.componentOptions.ICON, 'border', 'enabled');
            iconClasses.push(borderClass);
        }
        // Rotate
        if (this.rotate === true) {
            const iconRotationClass = ComponentService.getComponentClassByKey(ComponentService.componentOptions.ICON, 'rotate', 'enabled');
            iconClasses.push(iconRotationClass);
        }
        // Set Icon Class
        this.iconClass = iconClasses.join(' ');
    }
    /** @nocollapse */ static ɵfac = function AtomsIconComponent_Factory(t) { return new (t || AtomsIconComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsIconComponent, selectors: [["bc-atoms-icon"]], inputs: { id: "id", title: "title", border: "border", rotate: "rotate", size: "size", align: "align", type: "type" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 3, consts: [[1, "bcx-icon"]], template: function AtomsIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "span", 0);
        } if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id)("title", ctx.title)("class", ctx.iconClass);
        } }, styles: [".bcx-icon[_ngcontent-%COMP%]{vertical-align:unset!important}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsIconComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-icon', template: "<!--\n - Atoms icon component (atoms-icon.component.html).\n - Atom -> Icon Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components\n - 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library\n - 1.0.0 LIBNGSG-1 Add basic component library code to repository\n -\n -->\n<span\n  [attr.id]=\"id\"\n  [attr.title]=\"title\"\n  [attr.class]=\"iconClass\"\n  class=\"bcx-icon\"\n></span>\n", styles: [".bcx-icon{vertical-align:unset!important}\n"] }]
    }], null, { id: [{
            type: Input
        }], title: [{
            type: Input
        }], border: [{
            type: Input
        }], rotate: [{
            type: Input
        }], size: [{
            type: Input
        }], align: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

/**
 * Atoms button component (atoms-button.component.ts).
 * Atoms -> Button Component
 *
 * @version
 * 3.5.0 LIBNGSG-123 Migrate tslint to eslint
 * 1.21.0 LIBNGSG-74 Add icon only option to dropdown
 * 1.3.0 LIBNGSG-8 Add branding images component
 * 1.1.0 LIBNGSG-13 Upgrade to Bootstrap v4.6.0
 * 1.1.0 LIBNGSG-10 Add Dropdown Component
 * 1.1.0 LIBNGSG-6 Build Input Components
 * 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components
 * 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library
 * 1.0.0 LIBNGSG-1 Add basic component library code to repository
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
const _c0$s = ["confirmationTemplate"];
const _c1$j = ["dropdownContent"];
function AtomsButtonComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "bc-atoms-icon", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r0.title)("type", ctx_r0.icon);
} }
function AtomsButtonComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "bc-atoms-icon", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rotate", true);
} }
function AtomsButtonComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.label);
} }
function AtomsButtonComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.badge);
} }
function AtomsButtonComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "bc-atoms-icon", 15);
    i0.ɵɵelementEnd();
} }
function AtomsButtonComponent_ng_template_11_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.confirmMessage);
} }
function AtomsButtonComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "h4", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵtemplate(4, AtomsButtonComponent_ng_template_11_p_4_Template, 2, 1, "p", 19);
    i0.ɵɵprojection(5, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 20)(7, "bc-atoms-button", 21);
    i0.ɵɵlistener("onButtonClicked", function AtomsButtonComponent_ng_template_11_Template_bc_atoms_button_onButtonClicked_7_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const modal_r8 = restoredCtx.$implicit; return i0.ɵɵresetView(modal_r8.dismiss("cancel")); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "bc-atoms-button", 22);
    i0.ɵɵlistener("onButtonClicked", function AtomsButtonComponent_ng_template_11_Template_bc_atoms_button_onButtonClicked_8_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const modal_r8 = restoredCtx.$implicit; return i0.ɵɵresetView(modal_r8.close("ok")); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.confirmTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.confirmMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("icon", "cancel")("title", "Cancel")("label", "Cancel");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", "ok")("title", "OK")("label", "OK");
} }
const _c2$d = [[["", "dropdown-content", ""]], [["", "confirmation-body", ""]]];
const _c3$9 = function (a0) { return { "dropdown-toggle": a0 }; };
const _c4$5 = function (a0) { return { "dropdown-menu": a0 }; };
const _c5$4 = ["[dropdown-content]", "[confirmation-body]"];
class AtomsButtonComponent {
    modalService;
    // Inputs - Strings - Basic
    id;
    name;
    icon;
    label;
    title;
    badge;
    // Inputs - Strings - Options
    size = 'default'; // Options: (smallest/small/default/large)
    display = 'default'; // Options: (default/block)
    tag = 'button'; // Options: (button/submit/reset)
    type = 'default'; // Options: (default/primary/success/info/warning/danger)
    // Inputs - Strings - Confirmation
    confirmTitle = 'Confirm';
    confirmMessage;
    // Inputs - Booleans
    autofocus = false;
    disabled = false;
    pressed = false;
    iconOnly = false;
    loading = false;
    // Outputs - Callback Functions
    onButtonClicked = new EventEmitter();
    onConfirmClicked = new EventEmitter();
    onCancelClicked = new EventEmitter();
    // View Children
    template;
    dropdownContent;
    // Classes
    buttonClass;
    buttonContainerClass;
    buttonToggle;
    // Booleans
    isDropdownButton = false;
    isConfirmationButton = false;
    // Confirmation Button
    closeResult = '';
    modalOption = {};
    // Validation
    sizeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.BUTTON, 'size');
    typeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.BUTTON, 'type');
    displayOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.BUTTON, 'display');
    /**
     * Constructor
     *
     * @since 1.0.0
     * @param modalService
     */
    constructor(modalService) {
        this.modalService = modalService;
    }
    /**
     * Watch for Changes
     *
     * @since 1.0.0
     * @param changes
     */
    ngOnChanges(changes) {
        // Note: changes.prop contains the old and the new value...
        const buttonClasses = ['btn'];
        const buttonContainerClasses = ['bc-button-container'];
        // Button Size
        if (this.size && this.sizeOptions.includes(this.size)) {
            buttonClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.BUTTON, 'size', this.size));
        }
        // Button Type
        if (this.type && this.typeOptions.includes(this.type)) {
            buttonClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.BUTTON, 'type', this.type));
        }
        // Button Display
        if (this.display && this.displayOptions.includes(this.display)) {
            buttonClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.BUTTON, 'display', this.display));
            buttonContainerClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.BUTTON, 'display', this.display));
        }
        // Pressed
        if (this.pressed) {
            buttonClasses.push('pressed');
        }
        // Is Confirmation Button
        if (changes.confirmTitle || changes.confirmMessage) {
            this.isConfirmationButton = true;
        }
        // Is Dropdown Button
        if (this.dropdownContent.nativeElement.children.length > 0) {
            this.isDropdownButton = true;
            this.buttonToggle = this.isDropdownButton ? 'dropdown' : '';
            buttonClasses.push('dropdown-toggle');
            buttonContainerClasses.push('dropdown');
        }
        // Set Button Class
        this.buttonClass = buttonClasses.join(' ');
        this.buttonContainerClass = buttonContainerClasses.join(' ');
    }
    /**
     * Button Clicked
     *
     * @since 1.0.0
     * @param event
     */
    onClickButton = (event) => {
        // Button Clicked
        if (!this.disabled && !this.loading) {
            // If Confirmation Button
            if (this.isConfirmationButton) {
                this.openConfirmationModal().then((result) => {
                    if (result === 'ok') {
                        // Callback Function
                        this.onButtonClicked.emit(event);
                        this.onConfirmClicked.emit(event);
                    }
                }, (reason) => {
                    // Callback Function
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                    this.onCancelClicked.emit(event);
                });
            }
            else {
                // Callback Function
                this.onButtonClicked.emit(event);
            }
        }
        else {
            event.stopPropagation();
            return;
        }
    };
    /**
     * Open Confirmation Modal
     * @since 1.0.0
     */
    openConfirmationModal = () => {
        this.modalOption.backdrop = 'static';
        this.modalOption.keyboard = false;
        return this.modalService.open(this.template, this.modalOption).result;
    };
    /**
     * Get Dismissed Reason
     * @since 1.0.0
     * @param reason
     */
    getDismissReason = (reason) => {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
        else {
            return `with: ${reason}`;
        }
    };
    /** @nocollapse */ static ɵfac = function AtomsButtonComponent_Factory(t) { return new (t || AtomsButtonComponent)(i0.ɵɵdirectiveInject(i1$1.NgbModal)); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsButtonComponent, selectors: [["bc-atoms-button"]], viewQuery: function AtomsButtonComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$s, 7);
            i0.ɵɵviewQuery(_c1$j, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownContent = _t.first);
        } }, inputs: { id: "id", name: "name", icon: "icon", label: "label", title: "title", badge: "badge", size: "size", display: "display", tag: "tag", type: "type", confirmTitle: "confirmTitle", confirmMessage: "confirmMessage", autofocus: "autofocus", disabled: "disabled", pressed: "pressed", iconOnly: "iconOnly", loading: "loading" }, outputs: { onButtonClicked: "onButtonClicked", onConfirmClicked: "onConfirmClicked", onCancelClicked: "onCancelClicked" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5$4, decls: 13, vars: 21, consts: [[3, "type", "disabled", "autofocus", "ngClass", "click"], [1, "title"], ["class", "icon", 4, "ngIf"], ["class", "title-label", 4, "ngIf"], ["class", "badge", 4, "ngIf"], ["class", "arrow", 4, "ngIf"], [3, "ngClass"], ["dropdownContent", ""], ["confirmationTemplate", ""], [1, "icon"], [3, "title", "type"], ["title", "Please wait...", "type", "loading", 3, "rotate"], [1, "title-label"], [1, "badge"], [1, "arrow"], ["type", "expanded"], [1, "modal-header"], ["id", "modal-title", 1, "modal-title"], [1, "modal-body"], [4, "ngIf"], [1, "modal-footer"], [3, "icon", "title", "label", "onButtonClicked"], ["type", "success", 3, "icon", "title", "label", "onButtonClicked"]], template: function AtomsButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$d);
            i0.ɵɵelementStart(0, "div")(1, "button", 0);
            i0.ɵɵlistener("click", function AtomsButtonComponent_Template_button_click_1_listener($event) { return ctx.onClickButton($event); });
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵtemplate(3, AtomsButtonComponent_div_3_Template, 2, 2, "div", 2);
            i0.ɵɵtemplate(4, AtomsButtonComponent_div_4_Template, 2, 1, "div", 2);
            i0.ɵɵtemplate(5, AtomsButtonComponent_div_5_Template, 2, 1, "div", 3);
            i0.ɵɵtemplate(6, AtomsButtonComponent_div_6_Template, 2, 1, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, AtomsButtonComponent_div_7_Template, 2, 0, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 6, 7);
            i0.ɵɵprojection(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, AtomsButtonComponent_ng_template_11_Template, 9, 8, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.buttonContainerClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("type", ctx.tag)("disabled", ctx.disabled || ctx.loading)("autofocus", ctx.autofocus)("ngClass", i0.ɵɵpureFunction1(17, _c3$9, ctx.isDropdownButton && !ctx.iconOnly));
            i0.ɵɵattribute("id", ctx.id)("name", ctx.name)("title", ctx.title)("class", ctx.buttonClass)("data-toggle", ctx.buttonToggle);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.icon && !ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.label && !ctx.iconOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.badge);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isDropdownButton && !ctx.iconOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c4$5, ctx.isDropdownButton));
        } }, dependencies: [i1.NgClass, i1.NgIf, AtomsButtonComponent, AtomsIconComponent], styles: [".bc-button-container{display:inline-block}.bc-button-container.btn-block .dropdown-menu{min-width:100%}.bc-button-container button{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:box-shadow .2s ease-in-out;display:flex;align-items:center;justify-content:space-between;gap:4px;min-width:30px;min-height:26px}.bc-button-container button.btn-light{background-color:#fff;border:solid 1px lightgrey}.bc-button-container button.btn-light:not(:disabled):hover{background:whitesmoke;color:#000}.bc-button-container button.btn-link div.badge,.bc-button-container button.btn-light div.badge{border:1px solid lightgrey}.bc-button-container button.btn-primary.pressed{background-color:#4f8cf3;box-shadow:inset 0 0 4px #0a58ca;outline:none}.bc-button-container button.btn-secondary.pressed{background-color:#838f95;box-shadow:inset 0 0 4px #565e64;outline:none}.bc-button-container button.btn-success.pressed{background-color:#25b071;box-shadow:inset 0 0 4px #146c43;outline:none}.bc-button-container button.btn-danger.pressed{background-color:#e85f6d;box-shadow:inset 0 0 4px #b02a37;outline:none}.bc-button-container button.btn-warning.pressed{background-color:#ffd04c;box-shadow:inset 0 0 4px #cc9a06;outline:none}.bc-button-container button.btn-info.pressed{background-color:#5ac8e7;box-shadow:inset 0 0 4px #01778f;outline:none}.bc-button-container button.btn-light.pressed{background-color:#fff;box-shadow:inset 0 0 4px #c2c6c9;outline:none}.bc-button-container button.btn-dark.pressed{background-color:#4a4f55;box-shadow:inset 0 0 4px #16191c;outline:none}.bc-button-container button div{vertical-align:middle;display:inline-block}.bc-button-container button div.icon,.bc-button-container button div.title .title-label{line-height:normal;padding:2px 1px}.bc-button-container button div.title{flex-grow:1;white-space:nowrap;display:flex;align-items:center;gap:5px;justify-content:center;overflow:hidden;min-height:8px}.bc-button-container button div.title .title-label{overflow:hidden;text-overflow:ellipsis}.bc-button-container button div.title .badge{top:0;border:1px solid lightgrey;font-family:sans-serif;font-weight:600;border-radius:1em;position:relative;min-width:18px;padding:0 3px;line-height:unset}.bc-button-container button.dropdown-toggle div.arrow{display:contents}.bc-button-container button.dropdown-toggle div.arrow bc-atoms-icon{display:contents}.bc-button-container button.dropdown-toggle div.title{justify-content:flex-start}.bc-button-container button.dropdown-toggle:after{display:none}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsButtonComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-button', encapsulation: ViewEncapsulation.None, template: "<!--\n - Atoms button component (atoms-button.component.html).\n - Atom -> Button Component.\n -\n - @version\n - 3.14.0 LIBNGSG-148 Implement button consistency on delete confirmation modal\n - 1.21.0 LIBNGSG-74 Add icon only option to dropdown\n - 1.1.0 LIBNGSG-17 Template driven input form validation\n - 1.1.0 LIBNGSG-13 Upgrade to Bootstrap v4.6.0\n - 1.1.0 LIBNGSG-10 Add Dropdown Component\n - 1.1.0 LIBNGSG-6 Build Input Components\n - 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components\n - 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library\n - 1.0.0 LIBNGSG-1 Add basic component library code to repository\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021-2024 Build Centrix\n -->\n<div [class]=\"buttonContainerClass\">\n  <!--Button-->\n  <button\n    [attr.id]=\"id\"\n    [attr.name]=\"name\"\n    [attr.title]=\"title\"\n    [attr.class]=\"buttonClass\"\n    [type]=\"tag\"\n    [attr.data-toggle]=\"buttonToggle\"\n    (click)=\"onClickButton($event)\"\n    [disabled]=\"disabled || loading\"\n    [autofocus]=\"autofocus\"\n    [ngClass]=\"{ 'dropdown-toggle': isDropdownButton && !iconOnly }\"\n  >\n    <!--Icon / Label / Counter-->\n    <div class=\"title\">\n      <div *ngIf=\"icon && !loading\" class=\"icon\">\n        <bc-atoms-icon [title]=\"title\" [type]=\"icon\"></bc-atoms-icon>\n      </div>\n      <div *ngIf=\"loading\" class=\"icon\">\n        <bc-atoms-icon\n          title=\"Please wait...\"\n          type=\"loading\"\n          [rotate]=\"true\"\n        ></bc-atoms-icon>\n      </div>\n      <div *ngIf=\"label && !iconOnly\" class=\"title-label\">{{ label }}</div>\n      <div *ngIf=\"badge\" class=\"badge\">{{ badge }}</div>\n    </div>\n    <div *ngIf=\"isDropdownButton && !iconOnly\" class=\"arrow\">\n      <bc-atoms-icon type=\"expanded\"></bc-atoms-icon>\n    </div>\n  </button>\n\n  <!--Dropdown Content-->\n  <div [ngClass]=\"{ 'dropdown-menu': isDropdownButton }\" #dropdownContent>\n    <ng-content select=\"[dropdown-content]\"></ng-content>\n  </div>\n</div>\n\n<!--Confirmation Modal Template-->\n<ng-template #confirmationTemplate let-modal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\" id=\"modal-title\">{{confirmTitle}}</h4>\n  </div>\n  <div class=\"modal-body\">\n    <p *ngIf=\"confirmMessage\">{{confirmMessage}}</p>\n    <ng-content select=\"[confirmation-body]\"></ng-content>\n  </div>\n  <div class=\"modal-footer\">\n    <bc-atoms-button\n      [icon]=\"'cancel'\"\n      [title]=\"'Cancel'\"\n      [label]=\"'Cancel'\"\n      (onButtonClicked)=\"modal.dismiss('cancel')\"\n    ></bc-atoms-button>\n    <bc-atoms-button\n      [icon]=\"'ok'\"\n      [title]=\"'OK'\"\n      [label]=\"'OK'\"\n      type=\"success\"\n      (onButtonClicked)=\"modal.close('ok')\"\n    ></bc-atoms-button>\n  </div>\n</ng-template>\n", styles: [".bc-button-container{display:inline-block}.bc-button-container.btn-block .dropdown-menu{min-width:100%}.bc-button-container button{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:box-shadow .2s ease-in-out;display:flex;align-items:center;justify-content:space-between;gap:4px;min-width:30px;min-height:26px}.bc-button-container button.btn-light{background-color:#fff;border:solid 1px lightgrey}.bc-button-container button.btn-light:not(:disabled):hover{background:whitesmoke;color:#000}.bc-button-container button.btn-link div.badge,.bc-button-container button.btn-light div.badge{border:1px solid lightgrey}.bc-button-container button.btn-primary.pressed{background-color:#4f8cf3;box-shadow:inset 0 0 4px #0a58ca;outline:none}.bc-button-container button.btn-secondary.pressed{background-color:#838f95;box-shadow:inset 0 0 4px #565e64;outline:none}.bc-button-container button.btn-success.pressed{background-color:#25b071;box-shadow:inset 0 0 4px #146c43;outline:none}.bc-button-container button.btn-danger.pressed{background-color:#e85f6d;box-shadow:inset 0 0 4px #b02a37;outline:none}.bc-button-container button.btn-warning.pressed{background-color:#ffd04c;box-shadow:inset 0 0 4px #cc9a06;outline:none}.bc-button-container button.btn-info.pressed{background-color:#5ac8e7;box-shadow:inset 0 0 4px #01778f;outline:none}.bc-button-container button.btn-light.pressed{background-color:#fff;box-shadow:inset 0 0 4px #c2c6c9;outline:none}.bc-button-container button.btn-dark.pressed{background-color:#4a4f55;box-shadow:inset 0 0 4px #16191c;outline:none}.bc-button-container button div{vertical-align:middle;display:inline-block}.bc-button-container button div.icon,.bc-button-container button div.title .title-label{line-height:normal;padding:2px 1px}.bc-button-container button div.title{flex-grow:1;white-space:nowrap;display:flex;align-items:center;gap:5px;justify-content:center;overflow:hidden;min-height:8px}.bc-button-container button div.title .title-label{overflow:hidden;text-overflow:ellipsis}.bc-button-container button div.title .badge{top:0;border:1px solid lightgrey;font-family:sans-serif;font-weight:600;border-radius:1em;position:relative;min-width:18px;padding:0 3px;line-height:unset}.bc-button-container button.dropdown-toggle div.arrow{display:contents}.bc-button-container button.dropdown-toggle div.arrow bc-atoms-icon{display:contents}.bc-button-container button.dropdown-toggle div.title{justify-content:flex-start}.bc-button-container button.dropdown-toggle:after{display:none}\n"] }]
    }], function () { return [{ type: i1$1.NgbModal }]; }, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], icon: [{
            type: Input
        }], label: [{
            type: Input
        }], title: [{
            type: Input
        }], badge: [{
            type: Input
        }], size: [{
            type: Input
        }], display: [{
            type: Input
        }], tag: [{
            type: Input
        }], type: [{
            type: Input
        }], confirmTitle: [{
            type: Input
        }], confirmMessage: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], disabled: [{
            type: Input
        }], pressed: [{
            type: Input
        }], iconOnly: [{
            type: Input
        }], loading: [{
            type: Input
        }], onButtonClicked: [{
            type: Output
        }], onConfirmClicked: [{
            type: Output
        }], onCancelClicked: [{
            type: Output
        }], template: [{
            type: ViewChild,
            args: ['confirmationTemplate', { static: true }]
        }], dropdownContent: [{
            type: ViewChild,
            args: ['dropdownContent', { static: true }]
        }] }); })();

/**
 * Atoms button group component (atoms-button.component.ts).
 * Atoms -> Button Group Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.3.0 LIBNGSG-8 Add branding images component
 * 1.1.0 LIBNGSG-13 Upgrade to Bootstrap v4.6.0
 * 1.1.0 LIBNGSG-6 Build Input Components
 *
 */
function AtomsButtonGroupComponent_div_0_bc_atoms_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bc-atoms-button", 2);
    i0.ɵɵlistener("onButtonClicked", function AtomsButtonGroupComponent_div_0_bc_atoms_button_1_Template_bc_atoms_button_onButtonClicked_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const option_r3 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(2); ctx_r4.model = option_r3[ctx_r4.valueKey]; ctx_r4.modelChange.emit(ctx_r4.valueKey ? option_r3[ctx_r4.valueKey] : option_r3); return i0.ɵɵresetView(ctx_r4.onSelectionChanged.emit(ctx_r4.valueKey ? option_r3[ctx_r4.valueKey] : option_r3)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2.disabled)("pressed", ctx_r2.valueKey ? option_r3[ctx_r2.valueKey] === ctx_r2.model : option_r3 === ctx_r2.model)("size", ctx_r2.size)("icon", option_r3[ctx_r2.iconKey])("label", option_r3[ctx_r2.labelKey])("title", option_r3[ctx_r2.labelKey])("type", (ctx_r2.valueKey ? option_r3[ctx_r2.valueKey] === ctx_r2.model : option_r3 === ctx_r2.model) ? ctx_r2.selectedType : ctx_r2.defaultType);
} }
function AtomsButtonGroupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AtomsButtonGroupComponent_div_0_bc_atoms_button_1_Template, 1, 7, "bc-atoms-button", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.buttonGroupClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.options);
} }
function AtomsButtonGroupComponent_div_1_bc_atoms_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bc-atoms-button", 4);
    i0.ɵɵlistener("onButtonClicked", function AtomsButtonGroupComponent_div_1_bc_atoms_button_1_Template_bc_atoms_button_onButtonClicked_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const option_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); ctx_r8.model = option_r7; ctx_r8.modelChange.emit(option_r7); return i0.ɵɵresetView(ctx_r8.onSelectionChanged.emit(option_r7)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r6.disabled)("pressed", ctx_r6.model === option_r7)("size", ctx_r6.size)("label", option_r7)("title", option_r7)("type", option_r7 === ctx_r6.model ? ctx_r6.selectedType : ctx_r6.defaultType);
} }
function AtomsButtonGroupComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AtomsButtonGroupComponent_div_1_bc_atoms_button_1_Template, 1, 6, "bc-atoms-button", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.buttonGroupClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
} }
class AtomsButtonGroupComponent {
    // Classes
    buttonGroupClass;
    // Booleans
    objectArrayInput = true;
    stringArrayInput = false;
    // Inputs
    options = [];
    size = 'small';
    defaultType = 'default';
    selectedType = 'info';
    disabled;
    direction = 'horizontal';
    // Targets
    labelKey;
    iconKey;
    valueKey;
    // Two Way Data Binding
    model;
    modelChange = new EventEmitter();
    // Callback Functions
    onSelectionChanged = new EventEmitter();
    // List Options
    directions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.BUTTON, 'groupDirection');
    /**
     * Watch for Changes
     */
    ngOnChanges() {
        const buttonGroupClasses = ['button-group-container'];
        // Set Booleans
        this.objectArrayInput = !!this.labelKey;
        this.stringArrayInput = !this.labelKey;
        // Button Size
        if (this.direction && this.directions.includes(this.direction)) {
            buttonGroupClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.BUTTON, 'groupDirection', this.direction));
        }
        this.buttonGroupClass = buttonGroupClasses.join(' ');
    }
    /** @nocollapse */ static ɵfac = function AtomsButtonGroupComponent_Factory(t) { return new (t || AtomsButtonGroupComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsButtonGroupComponent, selectors: [["bc-atoms-button-group"]], inputs: { options: "options", size: "size", defaultType: "defaultType", selectedType: "selectedType", disabled: "disabled", direction: "direction", labelKey: "labelKey", iconKey: "iconKey", valueKey: "valueKey", model: "model" }, outputs: { modelChange: "modelChange", onSelectionChanged: "onSelectionChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "class", 4, "ngIf"], ["tag", "button", "display", "block", 3, "disabled", "pressed", "size", "icon", "label", "title", "type", "onButtonClicked", 4, "ngFor", "ngForOf"], ["tag", "button", "display", "block", 3, "disabled", "pressed", "size", "icon", "label", "title", "type", "onButtonClicked"], ["tag", "button", "display", "block", 3, "disabled", "pressed", "size", "label", "title", "type", "onButtonClicked", 4, "ngFor", "ngForOf"], ["tag", "button", "display", "block", 3, "disabled", "pressed", "size", "label", "title", "type", "onButtonClicked"]], template: function AtomsButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, AtomsButtonGroupComponent_div_0_Template, 2, 3, "div", 0);
            i0.ɵɵtemplate(1, AtomsButtonGroupComponent_div_1_Template, 2, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.objectArrayInput);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.stringArrayInput);
        } }, dependencies: [i1.NgForOf, i1.NgIf, AtomsButtonComponent], styles: [".button-group-container.horizontal{display:table;width:100%}  .button-group-container.horizontal bc-atoms-button{display:table-cell;width:100px}  .button-group-container.horizontal bc-atoms-button button{display:unset!important;text-align:center}  .button-group-container.horizontal bc-atoms-button:first-child .bc-button-container button{border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}  .button-group-container.horizontal bc-atoms-button:not(:first-child):not(:last-child) .bc-button-container button{border-radius:0}  .button-group-container.horizontal bc-atoms-button:last-child .bc-button-container button{border-top-left-radius:0;border-bottom-left-radius:0;border-left:none}  .button-group-container.vertical bc-atoms-button button{display:unset!important;text-align:center}  .button-group-container.vertical bc-atoms-button:first-child .bc-button-container button{border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom:none}  .button-group-container.vertical bc-atoms-button:not(:first-child):not(:last-child) .bc-button-container button{border-radius:0}  .button-group-container.vertical bc-atoms-button:last-child .bc-button-container button{border-top-left-radius:0;border-top-right-radius:0;border-top:none}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsButtonGroupComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-button-group', template: "<!--\n - Atoms button group component (atoms-button.component.html).\n - Atom -> Button Group Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.1.0 LIBNGSG-15 Fix style guide integration issues\n - 1.1.0 LIBNGSG-6 Build Input Components\n -\n -->\n<div [class]=\"buttonGroupClass\" *ngIf=\"objectArrayInput\">\n  <bc-atoms-button\n    *ngFor=\"let option of options\"\n    tag=\"button\"\n    display=\"block\"\n    [disabled]=\"disabled\"\n    [pressed]=\"valueKey ? option[valueKey] === model : option === model\"\n    [size]=\"size\"\n    [icon]=\"option[iconKey]\"\n    [label]=\"option[labelKey]\"\n    [title]=\"option[labelKey]\"\n    [type]=\"(valueKey ? option[valueKey] === model : option === model) ? selectedType : defaultType\"\n    (onButtonClicked)=\"model = option[valueKey];\n            modelChange.emit(valueKey ? option[valueKey] : option);\n            onSelectionChanged.emit(valueKey ? option[valueKey] : option)\"\n  ></bc-atoms-button>\n</div>\n<div [class]=\"buttonGroupClass\" *ngIf=\"stringArrayInput\">\n  <bc-atoms-button\n    *ngFor=\"let option of options\"\n    tag=\"button\"\n    display=\"block\"\n    [disabled]=\"disabled\"\n    [pressed]=\"model === option\"\n    [size]=\"size\"\n    [label]=\"option\"\n    [title]=\"option\"\n    [type]=\"option === model ? selectedType : defaultType\"\n    (onButtonClicked)=\"model = option;\n            modelChange.emit(option);\n            onSelectionChanged.emit(option)\"\n  ></bc-atoms-button>\n</div>\n", styles: ["::ng-deep .button-group-container.horizontal{display:table;width:100%}::ng-deep .button-group-container.horizontal bc-atoms-button{display:table-cell;width:100px}::ng-deep .button-group-container.horizontal bc-atoms-button button{display:unset!important;text-align:center}::ng-deep .button-group-container.horizontal bc-atoms-button:first-child .bc-button-container button{border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}::ng-deep .button-group-container.horizontal bc-atoms-button:not(:first-child):not(:last-child) .bc-button-container button{border-radius:0}::ng-deep .button-group-container.horizontal bc-atoms-button:last-child .bc-button-container button{border-top-left-radius:0;border-bottom-left-radius:0;border-left:none}::ng-deep .button-group-container.vertical bc-atoms-button button{display:unset!important;text-align:center}::ng-deep .button-group-container.vertical bc-atoms-button:first-child .bc-button-container button{border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom:none}::ng-deep .button-group-container.vertical bc-atoms-button:not(:first-child):not(:last-child) .bc-button-container button{border-radius:0}::ng-deep .button-group-container.vertical bc-atoms-button:last-child .bc-button-container button{border-top-left-radius:0;border-top-right-radius:0;border-top:none}\n"] }]
    }], null, { options: [{
            type: Input
        }], size: [{
            type: Input
        }], defaultType: [{
            type: Input
        }], selectedType: [{
            type: Input
        }], disabled: [{
            type: Input
        }], direction: [{
            type: Input
        }], labelKey: [{
            type: Input
        }], iconKey: [{
            type: Input
        }], valueKey: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], onSelectionChanged: [{
            type: Output
        }] }); })();

/**
 * Atoms loader component (atoms-loader.component.ts).
 * Atoms -> Loader Component
 *
 * @version
 * 1.3.0 LIBNGSG-27 Add loader component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
const _c0$r = function (a0) { return { "fullscreen": a0 }; };
function AtomsLoaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1)(2, "div", 2);
    i0.ɵɵelement(3, "bc-atoms-branded-info", 3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.loaderClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$r, ctx_r0.fullscreen));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r0.title)("subtitle", ctx_r0.subtitle)("isLoading", true);
} }
class AtomsLoaderComponent {
    // Defaults (Non-Inputs)
    loaderClass = 'bc-loader';
    // String Inputs
    title = 'Loading';
    subtitle = 'Please Wait...';
    // Boolean Inputs
    active = false;
    fullscreen = false;
    /** @nocollapse */ static ɵfac = function AtomsLoaderComponent_Factory(t) { return new (t || AtomsLoaderComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsLoaderComponent, selectors: [["bc-atoms-loader"]], inputs: { title: "title", subtitle: "subtitle", active: "active", fullscreen: "fullscreen" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [1, "loader-container", "animated", "fadeIn", 3, "ngClass"], [1, "loader"], [3, "title", "subtitle", "isLoading"]], template: function AtomsLoaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, AtomsLoaderComponent_div_0_Template, 4, 8, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.active);
        } }, dependencies: [i1.NgClass, i1.NgIf, AtomsBrandedInfoComponent], styles: [".bc-loader[_ngcontent-%COMP%]   .loader-container.fullscreen[_ngcontent-%COMP%]{position:fixed;z-index:1100}.bc-loader[_ngcontent-%COMP%]   .loader-container.fullscreen[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{width:300px;height:160px;position:absolute;inset:0;margin:auto}.bc-loader[_ngcontent-%COMP%]   .loader-container[_ngcontent-%COMP%]:not(.fullscreen){position:relative}.bc-loader[_ngcontent-%COMP%]   .loader-container[_ngcontent-%COMP%]:not(.fullscreen)   .loader[_ngcontent-%COMP%]{padding:5%}.bc-loader[_ngcontent-%COMP%]   .loader-container[_ngcontent-%COMP%]{inset:0;background-color:#fff}.bc-loader[_ngcontent-%COMP%]   .loader-container[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{text-align:center;overflow:hidden}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsLoaderComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-loader', template: "<!--\n - Atoms loader component (atoms-loader.component.html).\n - Atom -> Loader Component.\n -\n - @version\n - 1.3.0 LIBNGSG-27 Add loader component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -->\n<div [class]=\"loaderClass\" *ngIf=\"active\">\n  <div\n    class=\"loader-container animated fadeIn\"\n    [ngClass]=\"{ 'fullscreen': fullscreen }\"\n  >\n    <div class=\"loader\">\n      <bc-atoms-branded-info\n        [title]=\"title\"\n        [subtitle]=\"subtitle\"\n        [isLoading]=\"true\"\n      >\n      </bc-atoms-branded-info>\n    </div>\n  </div>\n</div>\n", styles: [".bc-loader .loader-container.fullscreen{position:fixed;z-index:1100}.bc-loader .loader-container.fullscreen .loader{width:300px;height:160px;position:absolute;inset:0;margin:auto}.bc-loader .loader-container:not(.fullscreen){position:relative}.bc-loader .loader-container:not(.fullscreen) .loader{padding:5%}.bc-loader .loader-container{inset:0;background-color:#fff}.bc-loader .loader-container .loader{text-align:center;overflow:hidden}\n"] }]
    }], null, { title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], active: [{
            type: Input
        }], fullscreen: [{
            type: Input
        }] }); })();

/**
 * Atoms chart component
 *
 * @version
 * 3.11.0 LIBNGSG-136 Add chart component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
const _c0$q = ["myCanvas"];
const _c1$i = function (a0, a1) { return { height: a0, width: a1, overflow: "auto" }; };
class AtomsChartComponent {
    // String Inputs
    id;
    title;
    description;
    type = 'bar';
    seriesData;
    seriesLabels;
    axisLabels;
    chartOptionsOverride;
    chartAxisXLabel;
    chartAxisYLabel;
    heightOverride;
    widthOverride;
    // Visuals
    titleColour;
    subtitleColour;
    legendPosition = 'top';
    // Boolean Inputs
    showLabels;
    showLegend;
    showLoader;
    // Callback Functions
    dataLabelFormatter;
    tooltipLabelFormatter;
    // Chart Data and Options
    chartData;
    chartOptions;
    canvas;
    ctx;
    chart;
    myCanvas;
    /**
     * After View Init
     * @since 3.11.0
     */
    ngAfterViewInit() {
        // Initialize chart
        this.buildChart(this.type);
    }
    /**
     * On Changes
     */
    ngOnChanges() {
        // Change chart
        if (this.type) {
            this.buildChart(this.type);
        }
    }
    /**
     * Build Chart
     * @since 3.11.0
     */
    buildChart(chartType) {
        // Remove the old chart and all its event handles
        if (this.chart) {
            this.chart.destroy();
        }
        if (this.myCanvas) {
            // Set chart data and options
            this.setChartData(chartType);
            this.setChartOptions(chartType);
            // Set canvas and context
            this.canvas = this.myCanvas.nativeElement;
            this.ctx = this.canvas.getContext('2d');
            // Horizontal bar chart was removed
            if (chartType + '' === 'horizontalBar') {
                chartType = 'bar';
            }
            // Create chart
            this.chart = new Chart(this.ctx, {
                plugins: [ChartDataLabels],
                type: chartType,
                data: this.chartData,
                options: this.chartOptions,
            });
        }
    }
    /**
     * Set Chart Data
     * @since 3.11.0
     */
    setChartData(chartType) {
        // Init chart data
        this.chartData = {
            labels: this.axisLabels,
            datasets: [],
        };
        // Multi-series charts
        const multiSeries = [
            'bar',
            'horizontalBar',
            'line',
            'radar',
        ];
        if (multiSeries.includes(chartType)) {
            this.chartData.datasets = this.getDatasetMultiSeries(this.seriesLabels, this.seriesData);
        }
        // Single series charts
        const singleSeries = ['pie', 'doughnut', 'polarArea'];
        if (singleSeries.includes(chartType)) {
            this.chartData.datasets = this.getDatasetSingleSeries(this.seriesLabels, this.seriesData);
        }
    }
    /**
     * Get Dataset for Multi-Series Charts
     * @since 3.11.0
     */
    getDatasetMultiSeries(seriesLabels, seriesData) {
        const result = [];
        seriesLabels.forEach((series, seriesIndex) => {
            result.push({ label: series, data: seriesData[seriesIndex] });
        });
        return result;
    }
    /**
     * Get Dataset for Single Series Charts
     * @since 3.11.0
     */
    getDatasetSingleSeries(seriesLabel, seriesData) {
        const result = [];
        result.push({ label: seriesLabel, data: seriesData });
        return result;
    }
    /**
     * Set Chart Options
     * @since 3.11.0
     */
    setChartOptions(chartType) {
        let align = 'center';
        let rotate = 0;
        let offset = 0;
        let anchor = 'center';
        if (chartType === 'bar') {
            align = 'top';
            offset = 5;
            rotate = -90;
        }
        else if (chartType === 'line') {
            align = 'top';
            offset = 5;
            rotate = -45;
        }
        else if (chartType === 'horizontalBar') {
            align = 'right';
            offset = 5;
        }
        else {
            anchor = 'center';
        }
        this.chartOptions = {
            responsive: true,
            plugins: {
                datalabels: {
                    color: 'darkslategrey',
                    display: this.showLabels ? 'auto' : false,
                    anchor: anchor,
                    font: {
                        size: '10',
                    },
                    align: align,
                    offset: offset,
                    rotation: rotate,
                },
                legend: {
                    display: false,
                    position: this.legendPosition,
                },
                title: {
                    display: !!this.title,
                    text: this.title,
                },
                subtitle: {
                    display: !!this.description,
                    text: this.description,
                    color: '#666',
                    font: {
                        size: 10,
                    },
                    padding: {
                        bottom: 10,
                    },
                },
            },
        };
        // Label formatter
        if (this.tooltipLabelFormatter) {
            this.chartOptions.plugins.tooltip = {
                callbacks: { label: this.tooltipLabelFormatter },
            };
            this.chartOptions.plugins.datalabels.formatter = this.dataLabelFormatter;
        }
        // Title Colours
        if (this.titleColour) {
            this.chartOptions.plugins.title.color = this.titleColour;
        }
        // Subtitle Colour
        if (this.subtitleColour) {
            this.chartOptions.plugins.subtitle.color = this.subtitleColour;
        }
        // Legend
        if (this.showLegend) {
            this.chartOptions.plugins.legend.display = true;
        }
        // Options Override
        for (const option in this.chartOptionsOverride) {
            if (Object.prototype.hasOwnProperty.call(this.chartOptionsOverride, option)) {
                this.chartOptions[option] = this.chartOptionsOverride[option];
            }
        }
        // Display Axis
        const displayAxesArr = ['bar', 'horizontalBar', 'line'];
        const displayAxes = displayAxesArr.includes(this.type);
        // Display Axes
        if (displayAxes) {
            this.chartOptions.scales = {
                y: {
                    title: {
                        display: !!this.chartAxisYLabel,
                        text: this.chartAxisYLabel,
                    },
                    ticks: {
                        autoSkip: false,
                    },
                },
                x: {
                    title: {
                        display: !!this.chartAxisXLabel,
                        text: this.chartAxisXLabel,
                    },
                    ticks: {
                        autoSkip: false,
                    },
                },
            };
        }
        // Horizontal bar charts
        const horizontalBarArr = ['horizontalBar'];
        if (horizontalBarArr.includes(this.type)) {
            this.type = 'bar';
            this.chartOptions.indexAxis = 'y';
        }
    }
    /** @nocollapse */ static ɵfac = function AtomsChartComponent_Factory(t) { return new (t || AtomsChartComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsChartComponent, selectors: [["bc-atoms-chart"]], viewQuery: function AtomsChartComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$q, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myCanvas = _t.first);
        } }, inputs: { id: "id", title: "title", description: "description", type: "type", seriesData: "seriesData", seriesLabels: "seriesLabels", axisLabels: "axisLabels", chartOptionsOverride: "chartOptionsOverride", chartAxisXLabel: "chartAxisXLabel", chartAxisYLabel: "chartAxisYLabel", heightOverride: "heightOverride", widthOverride: "widthOverride", titleColour: "titleColour", subtitleColour: "subtitleColour", legendPosition: "legendPosition", showLabels: "showLabels", showLegend: "showLegend", showLoader: "showLoader", dataLabelFormatter: "dataLabelFormatter", tooltipLabelFormatter: "tooltipLabelFormatter" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 8, consts: [[1, "chart-wrapper", 3, "ngStyle"], [3, "id", "hidden"], ["myCanvas", ""], ["title", "Loading", "subtitle", "Please Wait", 3, "active", "fullscreen"]], template: function AtomsChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "canvas", 1, 2)(3, "bc-atoms-loader", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(5, _c1$i, ctx.heightOverride, ctx.widthOverride));
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("id", ctx.id);
            i0.ɵɵproperty("hidden", ctx.showLoader);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("active", ctx.showLoader)("fullscreen", false);
        } }, dependencies: [i1.NgStyle, AtomsLoaderComponent], styles: [".chart-wrapper[_ngcontent-%COMP%]{margin:auto}.chart-wrapper[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{cursor:pointer}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsChartComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-chart', template: "<!--\n - Atoms chart component HTML\n -\n - @version\n - 3.11.0 LIBNGSG-136 Add chart component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2024 Build Centrix\n -->\n<!--Chart Wrapper-->\n<div\n  [ngStyle]=\"{ height: heightOverride,  width: widthOverride, overflow: 'auto'}\"\n  class=\"chart-wrapper\"\n>\n  <!--Chart-->\n  <canvas #myCanvas id=\"{{id}}\" [hidden]=\"showLoader\"></canvas>\n  <!--Loader-->\n  <bc-atoms-loader\n    title=\"Loading\"\n    subtitle=\"Please Wait\"\n    [active]=\"showLoader\"\n    [fullscreen]=\"false\"\n  ></bc-atoms-loader>\n</div>\n", styles: [".chart-wrapper{margin:auto}.chart-wrapper canvas{cursor:pointer}\n"] }]
    }], null, { id: [{
            type: Input
        }], title: [{
            type: Input
        }], description: [{
            type: Input
        }], type: [{
            type: Input
        }], seriesData: [{
            type: Input
        }], seriesLabels: [{
            type: Input
        }], axisLabels: [{
            type: Input
        }], chartOptionsOverride: [{
            type: Input
        }], chartAxisXLabel: [{
            type: Input
        }], chartAxisYLabel: [{
            type: Input
        }], heightOverride: [{
            type: Input
        }], widthOverride: [{
            type: Input
        }], titleColour: [{
            type: Input
        }], subtitleColour: [{
            type: Input
        }], legendPosition: [{
            type: Input
        }], showLabels: [{
            type: Input
        }], showLegend: [{
            type: Input
        }], showLoader: [{
            type: Input
        }], dataLabelFormatter: [{
            type: Input
        }], tooltipLabelFormatter: [{
            type: Input
        }], myCanvas: [{
            type: ViewChild,
            args: ['myCanvas']
        }] }); })();

/**
 * Atoms input component (atoms-input.component.ts).
 * Atoms -> Input Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
const _c0$p = ["inputRef"];
const _c1$h = ["prefixContent"];
const _c2$c = ["suffixContent"];
const _c3$8 = function (a0, a1) { return { "input-group-append clear": a0, "disabled": a1 }; };
const _c4$4 = function (a0) { return { "input-group-text button": a0 }; };
function AtomsInputComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵlistener("click", function AtomsInputComponent_span_12_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.modelChange.emit("")); });
    i0.ɵɵelementStart(1, "span", 0);
    i0.ɵɵelement(2, "bc-atoms-icon", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c3$8, ctx_r3.hasClearButton, ctx_r3.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4$4, ctx_r3.hasClearButton));
} }
const _c5$3 = [[["", "prefix-content", ""]], [["", "suffix-content", ""]]];
const _c6$3 = function (a0) { return { "input-group-prepend": a0 }; };
const _c7$3 = function (a0) { return { "input-group-text": a0 }; };
const _c8$2 = function () { return { standalone: true }; };
const _c9$2 = function (a0) { return { "input-group-append": a0 }; };
const _c10$2 = ["[prefix-content]", "[suffix-content]"];
class AtomsInputComponent {
    // Classes
    inputClass;
    inputGroupClass;
    // Booleans
    hasClearButton = false;
    hasPrefix = false;
    hasSuffix = false;
    // Inputs
    accept;
    alt;
    autocomplete = 'off';
    autofocus;
    checked;
    debounceTime = 0;
    isDisabled;
    formAction;
    formEnctype;
    formMethod;
    formNoValidate;
    formTarget;
    height;
    id;
    max;
    maxlength;
    min;
    minlength;
    name;
    pattern;
    placeholder;
    required;
    size;
    src;
    step;
    title;
    type = 'text';
    width;
    form;
    canClear = false;
    // @deprecated - Use isDisabled instead to avoid warning "It looks like you're using the
    // disabled attribute with a reactive form directive"
    disabled;
    // Two Way Data Binding
    model;
    modelChange = new EventEmitter();
    modelFocus = new EventEmitter();
    modelBlur = new EventEmitter();
    // Input reference
    inputRef;
    // Validation
    sizeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.INPUT, 'formControlSize');
    // Transcludes
    prefixContent;
    suffixContent;
    // Model change subject for debounce
    modelChangeSubject = new Subject();
    /**
     * Init Classes
     * since 1.1.0
     */
    initClasses() {
        // Has clear button enabled
        this.hasClearButton = this.canClear;
        // Set Input Classes
        const inputClasses = [];
        const inputGroupClasses = ['bc-atoms-input'];
        this.hasPrefix =
            this.prefixContent.nativeElement &&
                this.prefixContent.nativeElement.children.length > 0;
        this.hasSuffix =
            this.suffixContent.nativeElement &&
                this.suffixContent.nativeElement.children.length > 0;
        this.hasClearButton = this.canClear === true;
        // Type
        if (this.type && !['radio', 'checkbox', 'image'].includes(this.type)) {
            inputClasses.push('form-control');
            // Has Prefix
            if (!this.hasPrefix) {
                inputClasses.push('no-prefix');
            }
            // Has Suffix
            if (!this.hasSuffix && !this.hasClearButton) {
                inputClasses.push('no-suffix');
            }
            // Is Input Group
            if (this.hasPrefix || this.hasSuffix || this.hasClearButton) {
                inputGroupClasses.push('input-group');
            }
            // Size Option
            if (this.size && this.sizeOptions.includes(this.size)) {
                if (this.hasPrefix || this.hasSuffix || this.hasClearButton) {
                    inputGroupClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'inputGroupSize', this.size));
                }
                inputClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'formControlSize', this.size));
            }
        }
        // Set Classes
        this.inputClass = inputClasses.join(' ');
        this.inputGroupClass = inputGroupClasses.join(' ');
    }
    /**
     * On Changes
     */
    ngOnChanges() {
        // If isDisabled is set, it should overwrite the disabled value
        if (this.isDisabled !== undefined && this.isDisabled !== null) {
            this.disabled = this.isDisabled;
        }
        // Init Classes
        this.initClasses();
    }
    /**
     * On Init
     */
    ngOnInit() {
        // Delay emitting by input debounce time
        this.modelChangeSubject
            .pipe(debounceTime(this.debounceTime))
            .subscribe(($event) => {
            this.modelChange.emit($event);
        });
    }
    /*********************************************** Input Validation *************************************************/
    // Functions
    onChangeFn;
    onTouchedFn;
    onValidateFn;
    /**
     * Validate the input field.
     */
    validate() {
        const errors = {};
        // Check if the field is required and empty
        if (this.required &&
            (this.model === null || this.model === undefined || this.model === '')) {
            errors['required'] = true;
        }
        // Check if the field is an email type and validate email format
        if (this.type === 'email' && this.model) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.model.toString())) {
                errors['email'] = true;
            }
        }
        // Return the errors object if there are any errors, otherwise return null
        return Object.keys(errors).length ? errors : null;
    }
    /**
     * Called when the input value changes manually.
     * Invokes the registered onChange function if it exists.
     */
    onChange() {
        if (this.onChangeFn) {
            this.onChangeFn(this.model);
        }
    }
    /**
     * Called when the input field loses focus.
     */
    onBlur($event) {
        // Ensure the input value is trimmed (remove leading/trailing whitespace)
        if (this.inputRef?.nativeElement) {
            const trimmedValue = this.inputRef.nativeElement.value.trim();
            const currentValue = (this.model ?? '').toString().trim();
            // Update only if trimmed value changed
            if (trimmedValue !== currentValue) {
                // Update model and input field if trimmed value is different
                this.model = trimmedValue;
                this.inputRef.nativeElement.value = trimmedValue;
                // Emit model change event
                this.modelChange.emit(this.model);
                // Trigger onChange function if registered
                if (this.onChangeFn) {
                    this.onChangeFn(this.model);
                }
            }
        }
        // Emit blur event (passing along the original event)
        this.modelBlur.emit($event);
        // Trigger onTouched function if registered (for form validation)
        if (this.onTouchedFn) {
            this.onTouchedFn(this.model);
        }
    }
    /**
     * On Input
     */
    onInput() {
        this.onChange();
    }
    /**
     * On Model Change
     */
    onModelChange($event) {
        this.modelChangeSubject.next($event); // Trigger debounce
    }
    /**
     * On Focus
     */
    onFocus($event) {
        this.modelFocus.emit($event);
    }
    /**
     * Write Value
     *
     * @since 1.1.0
     * @param obj
     */
    writeValue(obj) {
        this.model = obj;
    }
    /**
     * Register Input as Changed
     *
     * @since 1.1.0
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /**
     * Register Input as Touched
     *
     * @since 1.1.0
     * @param fn
     */
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    /** @nocollapse */ static ɵfac = function AtomsInputComponent_Factory(t) { return new (t || AtomsInputComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsInputComponent, selectors: [["bc-atoms-input"]], viewQuery: function AtomsInputComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$p, 5);
            i0.ɵɵviewQuery(_c1$h, 7);
            i0.ɵɵviewQuery(_c2$c, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixContent = _t.first);
        } }, inputs: { accept: "accept", alt: "alt", autocomplete: "autocomplete", autofocus: "autofocus", checked: "checked", debounceTime: "debounceTime", isDisabled: "isDisabled", formAction: "formAction", formEnctype: "formEnctype", formMethod: "formMethod", formNoValidate: "formNoValidate", formTarget: "formTarget", height: "height", id: "id", max: "max", maxlength: "maxlength", min: "min", minlength: "minlength", name: "name", pattern: "pattern", placeholder: "placeholder", required: "required", size: "size", src: "src", step: "step", title: "title", type: "type", width: "width", form: "form", canClear: "canClear", disabled: "disabled", model: "model" }, outputs: { modelChange: "modelChange", modelFocus: "modelFocus", modelBlur: "modelBlur" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => AtomsInputComponent)),
                    multi: true,
                },
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef((() => AtomsInputComponent)),
                    multi: true,
                },
            ]), i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c10$2, decls: 13, vars: 44, consts: [[3, "ngClass"], ["prefixContent", ""], [3, "autofocus", "checked", "disabled", "required", "ngModel", "ngModelOptions", "ngModelChange", "focus", "input", "change", "blur"], ["inputRef", ""], ["suffixContent", ""], [3, "ngClass", "click", 4, "ngIf"], [3, "ngClass", "click"], ["type", "clear"]], template: function AtomsInputComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c5$3);
            i0.ɵɵelementStart(0, "span")(1, "span", 0)(2, "span", 0, 1);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "label")(6, "input", 2, 3);
            i0.ɵɵlistener("ngModelChange", function AtomsInputComponent_Template_input_ngModelChange_6_listener($event) { return ctx.model = $event; })("ngModelChange", function AtomsInputComponent_Template_input_ngModelChange_6_listener($event) { return ctx.onModelChange($event); })("focus", function AtomsInputComponent_Template_input_focus_6_listener($event) { return ctx.onFocus($event); })("input", function AtomsInputComponent_Template_input_input_6_listener() { return ctx.onInput(); })("change", function AtomsInputComponent_Template_input_change_6_listener() { return ctx.onChange(); })("blur", function AtomsInputComponent_Template_input_blur_6_listener($event) { return ctx.onBlur($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "span", 0)(9, "span", 0, 4);
            i0.ɵɵprojection(11, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, AtomsInputComponent_span_12_Template, 3, 7, "span", 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵattribute("class", ctx.inputGroupClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c6$3, ctx.hasPrefix));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c7$3, ctx.hasPrefix));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("autofocus", ctx.autofocus)("checked", ctx.checked)("disabled", ctx.disabled)("required", ctx.required)("ngModel", ctx.model)("ngModelOptions", i0.ɵɵpureFunction0(39, _c8$2));
            i0.ɵɵattribute("id", ctx.id)("accept", ctx.accept)("alt", ctx.alt)("autocomplete", ctx.autocomplete)("formAction", ctx.formAction, i0.ɵɵsanitizeUrl)("formEnctype", ctx.formEnctype)("formMethod", ctx.formMethod)("formNoValidate", ctx.formNoValidate)("formTarget", ctx.formTarget)("height", ctx.height)("min", ctx.min)("max", ctx.max)("minlength", ctx.minlength)("maxlength", ctx.maxlength)("name", ctx.name)("pattern", ctx.pattern)("placeholder", ctx.placeholder)("src", ctx.src, i0.ɵɵsanitizeUrl)("step", ctx.step)("type", ctx.type)("title", ctx.title)("width", ctx.width)("class", ctx.inputClass);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(40, _c9$2, ctx.hasSuffix));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(42, _c7$3, ctx.hasSuffix));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.hasClearButton);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel, AtomsIconComponent], styles: ["label[_ngcontent-%COMP%]{margin:0;display:contents!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border-radius:0}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input.no-prefix[_ngcontent-%COMP%]{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input.no-suffix[_ngcontent-%COMP%]{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.input-group[_ngcontent-%COMP%]   .input-group-append.clear[_ngcontent-%COMP%]{cursor:pointer}.input-group[_ngcontent-%COMP%]   .input-group-append.clear[_ngcontent-%COMP%]:hover{filter:brightness(80%)}.input-group[_ngcontent-%COMP%]   .input-group-append.clear.disabled[_ngcontent-%COMP%]{pointer-events:none}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsInputComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-input', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => AtomsInputComponent)),
                        multi: true,
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((() => AtomsInputComponent)),
                        multi: true,
                    },
                ], template: "<!--\n - Atoms input component (atoms-input.component.html).\n - Atom -> Input Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -->\n<span [attr.class]=\"inputGroupClass\">\n  <span [ngClass]=\"{ 'input-group-prepend': this.hasPrefix }\">\n    <span #prefixContent [ngClass]=\"{ 'input-group-text': this.hasPrefix }\">\n      <ng-content select=\"[prefix-content]\"></ng-content>\n    </span>\n  </span>\n  <label>\n    <input\n      [attr.id]=\"id\"\n      [attr.accept]=\"accept\"\n      [attr.alt]=\"alt\"\n      [attr.autocomplete]=\"autocomplete\"\n      [autofocus]=\"autofocus\"\n      [checked]=\"checked\"\n      [disabled]=\"disabled\"\n      [required]=\"required\"\n      [attr.formAction]=\"formAction\"\n      [attr.formEnctype]=\"formEnctype\"\n      [attr.formMethod]=\"formMethod\"\n      [attr.formNoValidate]=\"formNoValidate\"\n      [attr.formTarget]=\"formTarget\"\n      [attr.height]=\"height\"\n      [attr.min]=\"min\"\n      [attr.max]=\"max\"\n      [attr.minlength]=\"minlength\"\n      [attr.maxlength]=\"maxlength\"\n      [attr.name]=\"name\"\n      [attr.pattern]=\"pattern\"\n      [attr.placeholder]=\"placeholder\"\n      [attr.src]=\"src\"\n      [attr.step]=\"step\"\n      [attr.type]=\"type\"\n      [attr.title]=\"title\"\n      [attr.width]=\"width\"\n      [attr.class]=\"inputClass\"\n      [(ngModel)]=\"model\"\n      [ngModelOptions]=\"{ standalone: true }\"\n      (ngModelChange)=\"onModelChange($event)\"\n      (focus)=\"onFocus($event)\"\n      (input)=\"onInput()\"\n      (change)=\"onChange()\"\n      (blur)=\"onBlur($event)\"\n      #inputRef\n    />\n  </label>\n  <span [ngClass]=\"{ 'input-group-append': this.hasSuffix }\">\n    <span #suffixContent [ngClass]=\"{ 'input-group-text': this.hasSuffix }\">\n      <ng-content select=\"[suffix-content]\"></ng-content>\n    </span>\n  </span>\n  <span\n    [ngClass]=\"{ 'input-group-append clear': hasClearButton, 'disabled': disabled }\"\n    *ngIf=\"hasClearButton\"\n    (click)=\"modelChange.emit('');\"\n  >\n    <span [ngClass]=\"{ 'input-group-text button': hasClearButton }\">\n      <bc-atoms-icon type=\"clear\"></bc-atoms-icon>\n    </span>\n  </span>\n</span>\n", styles: ["label{margin:0;display:contents!important}.input-group label{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.input-group label input{border-radius:0}.input-group label input.no-prefix{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.input-group label input.no-suffix{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.input-group .input-group-append.clear{cursor:pointer}.input-group .input-group-append.clear:hover{filter:brightness(80%)}.input-group .input-group-append.clear.disabled{pointer-events:none}\n"] }]
    }], null, { accept: [{
            type: Input
        }], alt: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], checked: [{
            type: Input
        }], debounceTime: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], formAction: [{
            type: Input
        }], formEnctype: [{
            type: Input
        }], formMethod: [{
            type: Input
        }], formNoValidate: [{
            type: Input
        }], formTarget: [{
            type: Input
        }], height: [{
            type: Input
        }], id: [{
            type: Input
        }], max: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], min: [{
            type: Input
        }], minlength: [{
            type: Input
        }], name: [{
            type: Input
        }], pattern: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], required: [{
            type: Input
        }], size: [{
            type: Input
        }], src: [{
            type: Input
        }], step: [{
            type: Input
        }], title: [{
            type: Input
        }], type: [{
            type: Input
        }], width: [{
            type: Input
        }], form: [{
            type: Input
        }], canClear: [{
            type: Input
        }], disabled: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], modelFocus: [{
            type: Output
        }], modelBlur: [{
            type: Output
        }], inputRef: [{
            type: ViewChild,
            args: ['inputRef', { static: false }]
        }], prefixContent: [{
            type: ViewChild,
            args: ['prefixContent', { static: true }]
        }], suffixContent: [{
            type: ViewChild,
            args: ['suffixContent', { static: true }]
        }] }); })();

/**
 * Atoms checkbox component (atoms-checkbox.component.ts).
 * Atoms -> Checkbox Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.3.0 LIBNGSG-8 Add branding images component
 * 1.1.0 LIBNGSG-6 Build Input Components
 *
 */
function AtomsCheckboxComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵlistener("click", function AtomsCheckboxComponent_span_3_Template_span_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.label);
} }
function AtomsCheckboxComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function AtomsCheckboxComponent_span_5_Template_span_click_0_listener($event) { return $event.stopPropagation(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.label);
} }
function AtomsCheckboxComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("checkbox-description ", ctx_r2.align, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.description, " ");
} }
function AtomsCheckboxComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "bc-atoms-input", 9);
    i0.ɵɵlistener("modelChange", function AtomsCheckboxComponent_div_8_Template_bc_atoms_input_modelChange_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.textBoxModel = $event); })("modelChange", function AtomsCheckboxComponent_div_8_Template_bc_atoms_input_modelChange_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.textBoxModelChange.emit($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", ctx_r3.id);
    i0.ɵɵpropertyInterpolate("name", ctx_r3.name);
    i0.ɵɵpropertyInterpolate("title", ctx_r3.title);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r3.label);
    i0.ɵɵproperty("disabled", !ctx_r3.model || ctx_r3.disabled || ctx_r3.isDisabled)("model", ctx_r3.textBoxModel);
} }
const _c0$o = function (a0) { return { disabled: a0 }; };
class AtomsCheckboxComponent {
    checkboxClass;
    // Inputs
    id;
    label;
    name;
    title;
    size;
    align = 'left';
    description;
    // Booleans
    disabled = false; // Use isDisabled for reactive forms
    isDisabled = false;
    required = false;
    showTextBox = false;
    // Two Way Data Binding
    model = false;
    modelChange = new EventEmitter();
    textBoxModel;
    textBoxModelChange = new EventEmitter();
    // Callback Functions
    onCheckboxClicked = new EventEmitter();
    // Validation
    sizeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.INPUT, 'sizeCheckbox');
    /**
     * Watch for Changes
     */
    ngOnChanges() {
        // Note: changes.prop contains the old and the new value...
        const checkboxClasses = ['bc-checkbox'];
        // Checkbox Size
        if (this.size && this.sizeOptions.includes(this.size)) {
            checkboxClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'sizeCheckbox', this.size));
        }
        // Set Checkbox Class
        this.checkboxClass = checkboxClasses.join(' ');
    }
    /**
     * Checkbox Clicked
     *
     * @since 1.1.0
     * @param event
     */
    onClickCheckbox = (event) => {
        // Checkbox Clicked
        if (!this.disabled && !this.isDisabled) {
            // Update Model
            this.model = event.target.checked;
            // Callback Function
            this.onCheckboxClicked.emit(event);
        }
        else {
            // Cancel Propagation
            event.stopPropagation();
            return;
        }
    };
    /****************************************** ControlValueAccessor **************************************************/
    value;
    // ControlValueAccessor Callback onTouched
    onTouched;
    // ControlValueAccessor Callback onChange
    onChange;
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState() {
        // handle disabled state
    }
    /** @nocollapse */ static ɵfac = function AtomsCheckboxComponent_Factory(t) { return new (t || AtomsCheckboxComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsCheckboxComponent, selectors: [["bc-atoms-checkbox"]], inputs: { id: "id", label: "label", name: "name", title: "title", size: "size", align: "align", description: "description", disabled: "disabled", isDisabled: "isDisabled", required: "required", showTextBox: "showTextBox", model: "model", textBoxModel: "textBoxModel" }, outputs: { modelChange: "modelChange", textBoxModelChange: "textBoxModelChange", onCheckboxClicked: "onCheckboxClicked" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => AtomsCheckboxComponent)),
                    multi: true,
                },
            ]), i0.ɵɵNgOnChangesFeature], decls: 9, vars: 15, consts: [[1, "checkbox-label", 3, "ngClass"], ["class", "left-label", 3, "click", 4, "ngIf"], ["type", "checkbox", 3, "disabled", "required", "ngModel", "ngModelChange", "change"], ["class", "right-label", 3, "click", 4, "ngIf"], [3, "class", 4, "ngIf"], ["class", "col-md-9 mb-1", 4, "ngIf"], [1, "left-label", 3, "click"], [1, "right-label", 3, "click"], [1, "col-md-9", "mb-1"], ["size", "small", 3, "id", "name", "title", "placeholder", "disabled", "model", "modelChange"]], template: function AtomsCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "span")(2, "label", 0);
            i0.ɵɵtemplate(3, AtomsCheckboxComponent_span_3_Template, 2, 1, "span", 1);
            i0.ɵɵelementStart(4, "input", 2);
            i0.ɵɵlistener("ngModelChange", function AtomsCheckboxComponent_Template_input_ngModelChange_4_listener($event) { return ctx.model = $event; })("change", function AtomsCheckboxComponent_Template_input_change_4_listener($event) { return ctx.onClickCheckbox($event); })("ngModelChange", function AtomsCheckboxComponent_Template_input_ngModelChange_4_listener($event) { return ctx.modelChange.emit($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, AtomsCheckboxComponent_span_5_Template, 2, 1, "span", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "br");
            i0.ɵɵtemplate(7, AtomsCheckboxComponent_span_7_Template, 2, 4, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, AtomsCheckboxComponent_div_8_Template, 2, 6, "div", 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.checkboxClass);
            i0.ɵɵattribute("title", ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0$o, ctx.disabled || ctx.isDisabled));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.align === "right" && ctx.label);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.disabled || ctx.isDisabled)("required", ctx.required)("ngModel", ctx.model);
            i0.ɵɵattribute("id", ctx.id)("name", ctx.name);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.align === "left" && ctx.label || !ctx.align);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.description);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showTextBox);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2.CheckboxControlValueAccessor, i2.NgControlStatus, i2.CheckboxRequiredValidator, i2.NgModel, AtomsInputComponent], styles: [".bc-checkbox[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}.bc-checkbox.checkbox-sm[_ngcontent-%COMP%]{font-size:smaller}.bc-checkbox.checkbox-sm[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{transform:scale(.8)}.bc-checkbox.checkbox-lg[_ngcontent-%COMP%]{font-size:large}.bc-checkbox.checkbox-lg[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{transform:scale(1.5)}.bc-checkbox[_ngcontent-%COMP%]   label.checkbox-label[_ngcontent-%COMP%]{cursor:pointer;display:contents}.bc-checkbox[_ngcontent-%COMP%]   label.checkbox-label.disabled[_ngcontent-%COMP%]{cursor:not-allowed;color:#d3d3d3}.bc-checkbox[_ngcontent-%COMP%]   label.checkbox-label[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer;margin:5px 0;vertical-align:middle}.bc-checkbox[_ngcontent-%COMP%]   label.checkbox-label[_ngcontent-%COMP%]   span.left-label[_ngcontent-%COMP%], .bc-checkbox[_ngcontent-%COMP%]   label.checkbox-label[_ngcontent-%COMP%]   span.right-label[_ngcontent-%COMP%]{vertical-align:middle}.bc-checkbox[_ngcontent-%COMP%]   label.checkbox-label[_ngcontent-%COMP%]   span.left-label[_ngcontent-%COMP%]{margin-right:5px;padding:5px 5px 5px 0}.bc-checkbox[_ngcontent-%COMP%]   label.checkbox-label[_ngcontent-%COMP%]   span.right-label[_ngcontent-%COMP%]{margin-left:5px;padding:5px 0 5px 5px}.bc-checkbox[_ngcontent-%COMP%]   span.checkbox-description[_ngcontent-%COMP%]{font-size:small;opacity:.7;padding-left:25px}.bc-checkbox[_ngcontent-%COMP%]   span.checkbox-description.right[_ngcontent-%COMP%]{padding-left:0}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsCheckboxComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-checkbox', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => AtomsCheckboxComponent)),
                        multi: true,
                    },
                ], template: "<!--\n - Atoms checkbox component (atoms-checkbox.component.html).\n - Atom -> Checkbox Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.6.0 LIBNGSG-33 Minor Issues found during QA testing\n - 1.1.0 LIBNGSG-6 Build Input Components\n -\n -->\n<div [class]=\"checkboxClass\" [attr.title]=\"title\">\n  <span>\n    <label\n      class=\"checkbox-label\"\n      [ngClass]=\"{ disabled: disabled || isDisabled }\"\n    >\n      <span\n        class=\"left-label\"\n        *ngIf=\"(align === 'right' && label)\"\n        (click)=\"$event.stopPropagation()\"\n        >{{label}}</span\n      >\n      <input\n        [attr.id]=\"id\"\n        [attr.name]=\"name\"\n        type=\"checkbox\"\n        [disabled]=\"disabled || isDisabled\"\n        [required]=\"required\"\n        [(ngModel)]=\"model\"\n        (change)=\"onClickCheckbox($event)\"\n        (ngModelChange)=\"modelChange.emit($event)\"\n      />\n      <span\n        class=\"right-label\"\n        *ngIf=\"(align === 'left' && label) || !align\"\n        (click)=\"$event.stopPropagation()\"\n        >{{label}}</span\n      >\n    </label>\n    <br />\n    <span class=\"checkbox-description {{align}}\" *ngIf=\"description\">\n      {{description}}\n    </span>\n  </span>\n  <div *ngIf=\"showTextBox\" class=\"col-md-9 mb-1\">\n    <bc-atoms-input\n      id=\"{{id}}\"\n      name=\"{{name}}\"\n      title=\"{{title}}\"\n      placeholder=\"{{label}}\"\n      size=\"small\"\n      [disabled]=\"!model || disabled || isDisabled\"\n      [(model)]=\"textBoxModel\"\n      (modelChange)=\"textBoxModelChange.emit($event)\"\n    >\n    </bc-atoms-input>\n  </div>\n</div>\n", styles: [".bc-checkbox{display:flex;flex-wrap:wrap}.bc-checkbox.checkbox-sm{font-size:smaller}.bc-checkbox.checkbox-sm input{transform:scale(.8)}.bc-checkbox.checkbox-lg{font-size:large}.bc-checkbox.checkbox-lg input{transform:scale(1.5)}.bc-checkbox label.checkbox-label{cursor:pointer;display:contents}.bc-checkbox label.checkbox-label.disabled{cursor:not-allowed;color:#d3d3d3}.bc-checkbox label.checkbox-label input{cursor:pointer;margin:5px 0;vertical-align:middle}.bc-checkbox label.checkbox-label span.left-label,.bc-checkbox label.checkbox-label span.right-label{vertical-align:middle}.bc-checkbox label.checkbox-label span.left-label{margin-right:5px;padding:5px 5px 5px 0}.bc-checkbox label.checkbox-label span.right-label{margin-left:5px;padding:5px 0 5px 5px}.bc-checkbox span.checkbox-description{font-size:small;opacity:.7;padding-left:25px}.bc-checkbox span.checkbox-description.right{padding-left:0}\n"] }]
    }], null, { id: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], title: [{
            type: Input
        }], size: [{
            type: Input
        }], align: [{
            type: Input
        }], description: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], required: [{
            type: Input
        }], showTextBox: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], textBoxModel: [{
            type: Input
        }], textBoxModelChange: [{
            type: Output
        }], onCheckboxClicked: [{
            type: Output
        }] }); })();

/**
 * Atoms input group component (atoms-input-group.component.ts).
 * Atoms -> input group Component
 *
 * @version
 * 3.7.0 LIBNGSG-127 Add timepicker component
 * 1.22.0 LIBNGSG-77 Extend typeahead functionality to allow for API searching
 * 1.8.0 LIBNGSG-41 Add number range validation for inputs
 * 1.3.0 LIBNGSG-8 Add branding images component
 * 1.1.0 LIBNGSG-17 Template driven input form validation
 * 1.1.0 LIBNGSG-13 Upgrade to Bootstrap v4.6.0
 * 1.1.0 LIBNGSG-11 Add input group component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
function AtomsInputGroupComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵelement(1, "bc-atoms-icon", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r0.labelIcon);
} }
function AtomsInputGroupComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.labelTitle);
} }
function AtomsInputGroupComponent_small_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1, " *");
    i0.ɵɵelementEnd();
} }
function AtomsInputGroupComponent_small_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.loadingText, "");
} }
function AtomsInputGroupComponent_small_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 7);
    i0.ɵɵtext(1, " \u00A0 ");
    i0.ɵɵelement(2, "bc-atoms-icon", 8);
    i0.ɵɵtemplate(3, AtomsInputGroupComponent_small_5_span_3_Template, 2, 1, "span", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rotate", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.loadingText);
} }
function AtomsInputGroupComponent_div_9_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "bc-atoms-icon", 10);
    i0.ɵɵelementEnd();
} }
function AtomsInputGroupComponent_div_9_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "bc-atoms-icon", 11);
    i0.ɵɵelementEnd();
} }
function AtomsInputGroupComponent_div_9_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "bc-atoms-icon", 12);
    i0.ɵɵelementEnd();
} }
function AtomsInputGroupComponent_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AtomsInputGroupComponent_div_9_div_1_span_1_Template, 2, 0, "span", 2);
    i0.ɵɵtemplate(2, AtomsInputGroupComponent_div_9_div_1_span_2_Template, 2, 0, "span", 2);
    i0.ɵɵtemplate(3, AtomsInputGroupComponent_div_9_div_1_span_3_Template, 2, 0, "span", 2);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.state.toLowerCase() === "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.state.toLowerCase() === "default");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.state.toLowerCase() === "invalid");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", message_r7, " ");
} }
function AtomsInputGroupComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, AtomsInputGroupComponent_div_9_div_1_Template, 5, 4, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r4.messageClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.messagesArray);
} }
const _c0$n = ["*"];
class AtomsInputGroupComponent {
    // Inputs
    labelIcon;
    labelTitle;
    labelDescription;
    loadingText;
    state;
    stateInput;
    stateTrigger;
    // Booleans
    required;
    loading;
    // Classes
    formGroupClass;
    inputGroupClass;
    labelClass;
    contentClass;
    messageClass;
    // List Options
    stateOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.INPUT, 'inputGroupState');
    icons = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.ICON, 'icon');
    // Output Messages
    messagesArray;
    /**
     * Constructor
     * @since 1.1.0
     */
    constructor() {
        this.initClasses();
    }
    /**
     * Initialize Classes
     * @since 1.1.0
     */
    initClasses() {
        const state = this.state ? this.state.toLowerCase() : null;
        const formGroupClasses = ['bc-form-group form-group position-relative'];
        const inputGroupClasses = ['bc-input-group'];
        const labelClasses = ['bc-input-group-label'];
        const contentClasses = ['bc-input-group-content'];
        const messageClasses = ['bc-input-group-message'];
        // Form Group State Color
        if (state && this.stateOptions.includes(state)) {
            contentClasses.push('is-' +
                ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'formGroupState', state));
            messageClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'formGroupState', state) + '-tooltip');
        }
        // Input Group State Color
        if (state && this.stateOptions.includes(state)) {
            inputGroupClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'inputGroupState', state));
        }
        // Set Classes
        this.formGroupClass = formGroupClasses.join(' ');
        this.inputGroupClass = inputGroupClasses.join(' ');
        this.labelClass = labelClasses.join(' ');
        this.contentClass = contentClasses.join(' ');
        this.messageClass = messageClasses.join(' ');
    }
    /**
     * Watch for Changes
     *
     * @since 1.1.0
     * @param changes
     */
    ngOnChanges(changes) {
        // Init Classes
        this.initClasses();
        // State Input Changes
        if (changes.stateInput) {
            this.processStateInputForDisplay(this.stateInput);
        }
    }
    /**
     * Process State Input for Display
     *
     * @since 1.1.0
     * @param input
     */
    processStateInputForDisplay(input) {
        this.messagesArray = [];
        if (input) {
            // Output String
            if (typeof input === 'string') {
                this.messagesArray.push(input);
            }
            // Output Errors Array
            if (Array.isArray(input)) {
                this.messagesArray = input;
            }
            // Build Error Messages
            if (typeof input === 'object') {
                if (input.minRange) {
                    const message = 'Value too small' +
                        (Object.prototype.hasOwnProperty.call(input, 'value')
                            ? ' (minimum: ' + input.value + ')'
                            : '');
                    this.messagesArray.push(message);
                }
                if (input.maxRange) {
                    const message = 'Value too large' +
                        (Object.prototype.hasOwnProperty.call(input, 'value')
                            ? ' (maximum: ' + input.value + ')'
                            : '');
                    this.messagesArray.push(message);
                }
                if (input.required) {
                    this.messagesArray.push('Required Field');
                }
                if (input.requiredTrue) {
                    this.messagesArray.push('Required Field');
                }
                if (input.email && input.pattern) {
                    this.messagesArray.push('Please enter a valid email address');
                }
                if (input.minlength) {
                    this.messagesArray.push('Requires minimum ' +
                        input.minlength.requiredLength +
                        ' characters');
                }
                if (input.maxlength) {
                    this.messagesArray.push('Requires maximum ' +
                        input.maxlength.requiredLength +
                        ' characters');
                }
                if (!input.email && input.pattern) {
                    this.messagesArray.push('Input provided does not match the expected pattern');
                }
                if (input.mustMatch) {
                    this.messagesArray.push('Must match [' + input.mustMatch.label + '] field');
                }
                if (input.custom) {
                    this.messagesArray.push(input.mustMatch.custom);
                }
            }
        }
    }
    /** @nocollapse */ static ɵfac = function AtomsInputGroupComponent_Factory(t) { return new (t || AtomsInputGroupComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsInputGroupComponent, selectors: [["bc-atoms-input-group"]], inputs: { labelIcon: "labelIcon", labelTitle: "labelTitle", labelDescription: "labelDescription", loadingText: "loadingText", state: "state", stateInput: "stateInput", stateTrigger: "stateTrigger", required: "required", loading: "loading" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0$n, decls: 10, vars: 10, consts: [[3, "ngClass"], ["class", "label-icon", 4, "ngIf"], [4, "ngIf"], ["class", "text-success", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [1, "label-icon"], [3, "type"], [1, "text-success"], ["type", "loading", 3, "rotate"], [4, "ngFor", "ngForOf"], ["type", "ok"], ["type", "info"], ["type", "error"]], template: function AtomsInputGroupComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 0);
            i0.ɵɵtemplate(2, AtomsInputGroupComponent_span_2_Template, 2, 1, "span", 1);
            i0.ɵɵtemplate(3, AtomsInputGroupComponent_span_3_Template, 2, 1, "span", 2);
            i0.ɵɵtemplate(4, AtomsInputGroupComponent_small_4_Template, 2, 0, "small", 2);
            i0.ɵɵtemplate(5, AtomsInputGroupComponent_small_5_Template, 4, 2, "small", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 0)(7, "div", 0);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, AtomsInputGroupComponent_div_9_Template, 2, 2, "div", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.inputGroupClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", ctx.labelClass);
            i0.ɵɵattribute("title", ctx.labelDescription + (ctx.required ? " (Required)" : ""));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.labelIcon);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.labelTitle);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.required);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", ctx.formGroupClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", ctx.contentClass);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.stateTrigger && ctx.messagesArray.length > 0);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, AtomsIconComponent], styles: [".bc-input-group[_ngcontent-%COMP%]{margin-bottom:15px}.bc-input-group[_ngcontent-%COMP%]   .bc-input-group-label[_ngcontent-%COMP%]{cursor:pointer;letter-spacing:.5px;font-size:inherit;color:#789;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;width:100%}.bc-input-group[_ngcontent-%COMP%]   .bc-input-group-label[_ngcontent-%COMP%]   .label-icon[_ngcontent-%COMP%]{margin-right:5px}.bc-input-group[_ngcontent-%COMP%]   .bc-input-group-message[_ngcontent-%COMP%]{letter-spacing:1px;font-size:x-small;font-weight:700;display:block;position:relative;margin:5px 0;float:left;opacity:.5}.bc-input-group[_ngcontent-%COMP%]   .bc-input-group-message.default-tooltip[_ngcontent-%COMP%]{top:100%;left:0;z-index:5;max-width:100%;padding:.25rem .5rem;line-height:1.5;color:#2f4f4f;background-color:transparent;border-radius:.25rem}.bc-input-group[_ngcontent-%COMP%]   bc-atoms-checkbox[_ngcontent-%COMP%]{display:block;padding:10px;border:lightgray 1px dashed;border-radius:8px}"], changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsInputGroupComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-input-group', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Atoms input group component (atoms-input-group.component.html).\n - Atom -> input group Component.\n -\n - @version\n - 1.22.0 LIBNGSG-77 Extend typeahead functionality to allow for API searching\n - 1.1.0 LIBNGSG-17 Template driven input form validation\n - 1.1.0 LIBNGSG-11 Add input group component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021-2022 Build Centrix\n -->\n<div [ngClass]=\"inputGroupClass\">\n  <label\n    [ngClass]=\"labelClass\"\n    [attr.title]=\"labelDescription + (required ? ' (Required)' : '')\"\n  >\n    <span class=\"label-icon\" *ngIf=\"labelIcon\">\n      <bc-atoms-icon [type]=\"labelIcon\"></bc-atoms-icon>\n    </span>\n    <span *ngIf=\"labelTitle\">{{labelTitle}}</span>\n    <small *ngIf=\"required\"> *</small>\n    <small class=\"text-success\" *ngIf=\"loading\">\n      &nbsp;\n      <bc-atoms-icon type=\"loading\" [rotate]=\"true\"></bc-atoms-icon>\n      <span *ngIf=\"loadingText\"> {{loadingText}}</span>\n    </small>\n  </label>\n  <div [ngClass]=\"formGroupClass\">\n    <div [ngClass]=\"contentClass\">\n      <ng-content></ng-content>\n    </div>\n    <div\n      [ngClass]=\"messageClass\"\n      *ngIf=\"stateTrigger && messagesArray.length > 0\"\n    >\n      <div *ngFor=\"let message of messagesArray\">\n        <span *ngIf=\"state.toLowerCase()==='valid'\">\n          <bc-atoms-icon type=\"ok\"></bc-atoms-icon>\n        </span>\n        <span *ngIf=\"state.toLowerCase()==='default'\">\n          <bc-atoms-icon type=\"info\"></bc-atoms-icon>\n        </span>\n        <span *ngIf=\"state.toLowerCase()==='invalid'\">\n          <bc-atoms-icon type=\"error\"></bc-atoms-icon>\n        </span>\n        {{message}}\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".bc-input-group{margin-bottom:15px}.bc-input-group .bc-input-group-label{cursor:pointer;letter-spacing:.5px;font-size:inherit;color:#789;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;width:100%}.bc-input-group .bc-input-group-label .label-icon{margin-right:5px}.bc-input-group .bc-input-group-message{letter-spacing:1px;font-size:x-small;font-weight:700;display:block;position:relative;margin:5px 0;float:left;opacity:.5}.bc-input-group .bc-input-group-message.default-tooltip{top:100%;left:0;z-index:5;max-width:100%;padding:.25rem .5rem;line-height:1.5;color:#2f4f4f;background-color:transparent;border-radius:.25rem}.bc-input-group bc-atoms-checkbox{display:block;padding:10px;border:lightgray 1px dashed;border-radius:8px}\n"] }]
    }], function () { return []; }, { labelIcon: [{
            type: Input
        }], labelTitle: [{
            type: Input
        }], labelDescription: [{
            type: Input
        }], loadingText: [{
            type: Input
        }], state: [{
            type: Input
        }], stateInput: [{
            type: Input
        }], stateTrigger: [{
            type: Input
        }], required: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();

/**
 * atoms-checkbox-group.component.ts
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 *
 * @copyright (c) 2024 Build Centrix
 */
function AtomsCheckboxGroupComponent_div_2_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "bc-atoms-checkbox", 4);
    i0.ɵɵlistener("onCheckboxClicked", function AtomsCheckboxGroupComponent_div_2_div_3_div_1_Template_bc_atoms_checkbox_onCheckboxClicked_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const subOption_r4 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r5.toggleCheck(subOption_r4)); })("textBoxModelChange", function AtomsCheckboxGroupComponent_div_2_div_3_div_1_Template_bc_atoms_checkbox_textBoxModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r6); const subOption_r4 = restoredCtx.$implicit; return i0.ɵɵresetView(subOption_r4.textBoxValue = $event); })("textBoxModelChange", function AtomsCheckboxGroupComponent_div_2_div_3_div_1_Template_bc_atoms_checkbox_textBoxModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r6); const subOption_r4 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r8.updateTextBoxValue($event, subOption_r4)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subOption_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", ctx_r3.name)("label", ctx_r3.labelKey ? subOption_r4[ctx_r3.labelKey] : subOption_r4)("disabled", ctx_r3.disabled)("showTextBox", subOption_r4.showTextBox)("model", ctx_r3.contains(subOption_r4[ctx_r3.idKey]))("textBoxModel", subOption_r4.textBoxValue);
} }
function AtomsCheckboxGroupComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AtomsCheckboxGroupComponent_div_2_div_3_div_1_Template, 2, 6, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", option_r1.options);
} }
const _c0$m = function (a0) { return { "width": a0 }; };
function AtomsCheckboxGroupComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div")(2, "bc-atoms-checkbox", 4);
    i0.ɵɵlistener("onCheckboxClicked", function AtomsCheckboxGroupComponent_div_2_Template_bc_atoms_checkbox_onCheckboxClicked_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const option_r1 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.toggleCheck(option_r1)); })("textBoxModelChange", function AtomsCheckboxGroupComponent_div_2_Template_bc_atoms_checkbox_textBoxModelChange_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r11); const option_r1 = restoredCtx.$implicit; return i0.ɵɵresetView(option_r1.textBoxValue = $event); })("textBoxModelChange", function AtomsCheckboxGroupComponent_div_2_Template_bc_atoms_checkbox_textBoxModelChange_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r11); const option_r1 = restoredCtx.$implicit; const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.updateTextBoxValue($event, option_r1)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(3, AtomsCheckboxGroupComponent_div_2_div_3_Template, 2, 1, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c0$m, ctx_r0.columns === "2" ? "50%" : "100%"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r0.name)("label", ctx_r0.labelKey ? option_r1[ctx_r0.labelKey] : option_r1)("disabled", ctx_r0.disabled)("showTextBox", option_r1.showTextBox)("model", ctx_r0.contains(option_r1[ctx_r0.idKey]))("textBoxModel", option_r1.textBoxValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", option_r1.options);
} }
class AtomsCheckboxGroupComponent {
    // ControlValueAccessor Callback onTouched
    onTouched;
    // ControlValueAccessor Callback onChange
    onChange;
    // Inputs
    id;
    name;
    title = 'Select all that apply:';
    description;
    options;
    columns = '1';
    // Booleans
    disabled = false;
    // Targets
    idKey;
    labelKey;
    // Two Way Data Binding
    model;
    modelChange = new EventEmitter();
    /**
     * Method overrides for ControlValueAccessor interface
     */
    writeValue(value) {
        this.model = value;
    }
    /**
     * Method overrides for ControlValueAccessor interface
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Method overrides for ControlValueAccessor interface
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Set model value
     */
    set(value) {
        this.model = value;
        this.onChange(this.model);
    }
    /**
     * Add or remove item from array model
     */
    addOrRemove(value) {
        if (this.contains(value)) {
            this.remove(value);
        }
        else {
            this.add(value);
        }
    }
    /**
     * Check if item already exist on array model
     */
    contains(value) {
        if (this.model instanceof Array) {
            return this.model.includes(value);
        }
        else if (this.model) {
            return this.model === value;
        }
        return false;
    }
    /**
     * Handler to update the text box input value in the option
     */
    updateTextBoxValue(textBoxValue, option) {
        option['textBoxValue'] = textBoxValue;
        this.modelChange.emit(this.model);
    }
    /**
     * Handler when a checkbox in the checkbox group is toggled
     */
    toggleCheck(option) {
        const value = this.idKey ? option[this.idKey] : option;
        if (option.showTextBox && this.contains(value)) {
            option['textBoxValue'] = null;
        }
        this.addOrRemove(value);
        this.modelChange.emit(this.model);
    }
    /**
     * Add item to model
     */
    add(value) {
        if (!this.contains(value)) {
            if (this.model instanceof Array) {
                this.model.push(value);
            }
            else {
                this.model = [value];
            }
            this.onChange(this.model);
            this.onTouched(this.model);
        }
    }
    /**
     * Remove item from model
     */
    remove(value) {
        const index = this.model.indexOf(value);
        if (index < 0) {
            return;
        }
        this.model.splice(index, 1);
        this.onChange(this.model);
    }
    /** @nocollapse */ static ɵfac = function AtomsCheckboxGroupComponent_Factory(t) { return new (t || AtomsCheckboxGroupComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsCheckboxGroupComponent, selectors: [["bc-atoms-checkbox-group"]], inputs: { id: "id", name: "name", title: "title", description: "description", options: "options", columns: "columns", disabled: "disabled", idKey: "idKey", labelKey: "labelKey", model: "model" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => AtomsCheckboxGroupComponent)),
                    multi: true,
                },
            ])], decls: 3, vars: 4, consts: [[3, "id", "labelTitle", "labelDescription"], [1, "row", "col-md-12"], [3, "ngStyle", 4, "ngFor", "ngForOf"], [3, "ngStyle"], [3, "name", "label", "disabled", "showTextBox", "model", "textBoxModel", "onCheckboxClicked", "textBoxModelChange"], [4, "ngIf"], ["class", "pl-4", 4, "ngFor", "ngForOf"], [1, "pl-4"]], template: function AtomsCheckboxGroupComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "bc-atoms-input-group", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, AtomsCheckboxGroupComponent_div_2_Template, 4, 10, "div", 2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate("id", ctx.id);
            i0.ɵɵpropertyInterpolate("labelTitle", ctx.title);
            i0.ɵɵpropertyInterpolate("labelDescription", ctx.description);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.options);
        } }, dependencies: [i1.NgForOf, i1.NgIf, i1.NgStyle, AtomsCheckboxComponent, AtomsInputGroupComponent] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsCheckboxGroupComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-checkbox-group', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => AtomsCheckboxGroupComponent)),
                        multi: true,
                    },
                ], template: "<!--\n - Atoms checkbox group component (atoms-checkbox-group.component.html).\n - Atom -> Checkbox Group Component.\n -\n - @author Jenny Lam <jlam@buildcentrix.com>\n - @copyright (c) 2024 Build Centrix\n -->\n<bc-atoms-input-group\n  id=\"{{id}}\"\n  labelTitle=\"{{title}}\"\n  labelDescription=\"{{description}}\"\n>\n  <div class=\"row col-md-12\">\n    <div\n      [ngStyle]=\"{'width': columns === '2' ? '50%' : '100%'}\"\n      *ngFor=\"let option of options\"\n    >\n      <div>\n        <bc-atoms-checkbox\n          [name]=\"name\"\n          [label]=\"labelKey ? option[labelKey] : option\"\n          [disabled]=\"disabled\"\n          [showTextBox]=\"option.showTextBox\"\n          [model]=\"contains(option[idKey])\"\n          (onCheckboxClicked)=\"toggleCheck(option)\"\n          [(textBoxModel)]=\"option.textBoxValue\"\n          (textBoxModelChange)=\"updateTextBoxValue($event, option)\"\n        ></bc-atoms-checkbox>\n      </div>\n      <div *ngIf=\"option.options\">\n        <div class=\"pl-4\" *ngFor=\"let subOption of option.options\">\n          <bc-atoms-checkbox\n            [name]=\"name\"\n            [label]=\"labelKey ? subOption[labelKey] : subOption\"\n            [disabled]=\"disabled\"\n            [showTextBox]=\"subOption.showTextBox\"\n            [model]=\"contains(subOption[idKey])\"\n            (onCheckboxClicked)=\"toggleCheck(subOption)\"\n            [(textBoxModel)]=\"subOption.textBoxValue\"\n            (textBoxModelChange)=\"updateTextBoxValue($event, subOption)\"\n          ></bc-atoms-checkbox>\n        </div>\n      </div>\n    </div>\n  </div>\n</bc-atoms-input-group>\n" }]
    }], null, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], title: [{
            type: Input
        }], description: [{
            type: Input
        }], options: [{
            type: Input
        }], columns: [{
            type: Input
        }], disabled: [{
            type: Input
        }], idKey: [{
            type: Input
        }], labelKey: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }] }); })();

/**
 * Atoms dropdown component (atoms-dropdown.component.ts).
 * Atoms -> Dropdown Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2022 Build Centrix
 */
function AtomsDropdownComponent_button_4_span_1_bc_atoms_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "bc-atoms-icon", 8);
} if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r5.iconKey ? option_r2[ctx_r5.iconKey] : null);
} }
function AtomsDropdownComponent_button_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, AtomsDropdownComponent_button_4_span_1_bc_atoms_icon_1_Template, 1, 1, "bc-atoms-icon", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", option_r2[ctx_r3.iconKey]);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.labelKey ? option_r2[ctx_r3.labelKey] : option_r2, " ");
} }
function AtomsDropdownComponent_button_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r2, " ");
} }
const _c0$l = function (a0) { return { active: a0 }; };
function AtomsDropdownComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function AtomsDropdownComponent_button_4_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const option_r2 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.selectionChanged(option_r2)); });
    i0.ɵɵtemplate(1, AtomsDropdownComponent_button_4_span_1_Template, 3, 2, "span", 6);
    i0.ɵɵtemplate(2, AtomsDropdownComponent_button_4_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$l, ctx_r0.selectedOption === option_r2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isObjectInput);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isObjectInput);
} }
function AtomsDropdownComponent_div_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "bc-atoms-icon", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.label, " ");
} }
function AtomsDropdownComponent_div_5_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.label, " ");
} }
function AtomsDropdownComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "li", 10);
    i0.ɵɵelementStart(2, "button", 5);
    i0.ɵɵlistener("click", function AtomsDropdownComponent_div_5_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.selectionChanged(null)); });
    i0.ɵɵtemplate(3, AtomsDropdownComponent_div_5_span_3_Template, 3, 1, "span", 6);
    i0.ɵɵtemplate(4, AtomsDropdownComponent_div_5_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$l, !ctx_r1.model));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.iconKey);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.iconKey);
} }
const _c1$g = function (a0, a1) { return [a0, a1]; };
const _c2$b = function (a0) { return { "max-height": a0 }; };
class AtomsDropdownComponent {
    // Classes
    dropdownClass;
    // Booleans
    isObjectInput;
    // Strings
    iconDisplay;
    labelDisplay;
    // Visible Options Height
    visibleOptionsHeight;
    onTouched;
    onChange;
    // String Inputs
    id;
    name;
    label;
    badge;
    title;
    // Boolean Inputs
    autofocus = false;
    iconOnly = false;
    loading = false;
    requireSelection = false;
    isDisabled = undefined;
    // @deprecated - Use isDisabled instead to avoid warning "It looks like you're using the
    // disabled attribute with a reactive form directive"
    disabled = false;
    // Array Inputs
    options = [];
    optionSuffix;
    maxVisibleOptions = 10; // Default to a maximum of 10 visible options
    // Targets
    idKey;
    labelKey;
    iconKey;
    // Options
    size = 'default'; // Options: (smallest/small/default/large)
    display = 'default'; // Options: (default/block)
    type = 'default'; // Options: (default/primary/success/info/warning/danger)
    // Two Way Data Binding
    model;
    selectedOption;
    // Form control -> Used for make this component compatible with reactive forms
    // If pass formControl instance. Skip passing model when calling this component. Form control will override this.model
    formControl;
    // Callback Functions
    modelChange = new EventEmitter();
    /**
     * Get Button Icon
     *
     * @since 1.1.0
     * @param selection
     */
    getButtonIcon(selection) {
        let result = null;
        if (selection &&
            this.isObjectInput &&
            this.isValidObjectKey(this.iconKey)) {
            result = selection[this.iconKey];
        }
        return result;
    }
    /**
     * Get Button Label
     *
     * @since 1.1.0
     * @param selection
     */
    getButtonLabel(selection) {
        let result = selection ? selection : this.label;
        if (selection &&
            this.isObjectInput &&
            this.isValidObjectKey(this.labelKey)) {
            result = selection[this.labelKey];
        }
        return result;
    }
    /**
     * Get Unselected Dropdown Option
     * @since 1.1.0
     */
    getUnselectedOption() {
        let unselectedOption;
        if (this.isObjectInput) {
            unselectedOption = {};
            if (this.iconKey)
                unselectedOption[this.iconKey] = 'all';
            unselectedOption[this.labelKey] = this.label;
        }
        else {
            unselectedOption = this.label;
        }
        return unselectedOption;
    }
    /**
     * Check if Key is Valid
     *
     * @since 1.1.0
     * @param key
     */
    isValidObjectKey(key) {
        const optionObjectKeys = Object.keys(this.options[0]);
        return key && optionObjectKeys.includes(key);
    }
    /**
     * Watch for Changes
     */
    ngOnChanges(changes) {
        // If isDisabled is set, it should overwrite the disabled value
        if (this.isDisabled !== undefined && this.isDisabled !== null) {
            this.disabled = this.isDisabled;
        }
        // Set the maximum visible options before scrolling
        if (this.maxVisibleOptions) {
            // 37px is the current total height of each option
            this.visibleOptionsHeight = this.maxVisibleOptions * 37;
        }
        // If form control is set. Then use form control value as model value
        this.model = this.formControl?.value || this.model;
        // Classes
        const dropdownClasses = ['bc-dropdown-container'];
        // Booleans
        this.isObjectInput =
            this.options &&
                typeof this.options[0] === 'object' &&
                this.options[0] !== null;
        // Check for Input/Output Changes
        if (changes.idKey ||
            changes.labelKey ||
            changes.iconKey ||
            changes.options ||
            changes.model) {
            // Trigger Selection
            this.selectionChanged(this.model, true);
        }
        // Style unselected dropdowns differently
        if (!this.model && !this.requireSelection) {
            dropdownClasses.push('unselected');
        }
        // Set Dropdown Class
        this.dropdownClass = dropdownClasses.join(' ');
    }
    /**
     * On Selection Changed
     *
     * @since 1.1.0
     * @param option
     * @param skipEmit
     */
    selectionChanged(option, skipEmit) {
        let result = option;
        if (option && this.isObjectInput) {
            // Object or ID Comparison
            if (this.isValidObjectKey(this.idKey)) {
                // Select Correct Option
                result = this.options.find((cOption) => {
                    return cOption[this.idKey] === option[this.idKey];
                });
            }
            else {
                // Select Correct Option
                result = this.options.find((cOption) => {
                    return JSON.stringify(cOption) === JSON.stringify(option);
                });
            }
        }
        this.model = result;
        this.selectedOption = option ? result : this.getUnselectedOption();
        this.labelDisplay = this.getButtonLabel(this.selectedOption);
        this.iconDisplay = this.getButtonIcon(this.selectedOption);
        if (!skipEmit) {
            this.modelChange.emit(this.model);
            // If form control is set. Update form control for catch form validators
            if (this.formControl) {
                this.formControl.setValue(this.model);
                this.formControl.markAsTouched();
                this.formControl.markAsDirty();
            }
        }
    }
    /**
     * Method overrides for ControlValueAccessor interface
     *
     * @since 1.23.0
     */
    writeValue(value) {
        this.model = value;
    }
    /**
     * Method overrides for ControlValueAccessor interface
     *
     * @since 1.23.0
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Method overrides for ControlValueAccessor interface
     *
     * @since 1.23.0
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /** @nocollapse */ static ɵfac = function AtomsDropdownComponent_Factory(t) { return new (t || AtomsDropdownComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsDropdownComponent, selectors: [["bc-atoms-dropdown"]], inputs: { id: "id", name: "name", label: "label", badge: "badge", title: "title", autofocus: "autofocus", iconOnly: "iconOnly", loading: "loading", requireSelection: "requireSelection", isDisabled: "isDisabled", disabled: "disabled", options: "options", optionSuffix: "optionSuffix", maxVisibleOptions: "maxVisibleOptions", idKey: "idKey", labelKey: "labelKey", iconKey: "iconKey", size: "size", display: "display", type: "type", model: "model", selectedOption: "selectedOption", formControl: "formControl" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => AtomsDropdownComponent)),
                    multi: true,
                },
            ]), i0.ɵɵNgOnChangesFeature], decls: 6, vars: 24, consts: [[3, "id", "name", "title", "icon", "label", "badge", "autofocus", "disabled", "loading", "iconOnly", "type", "display", "size"], ["dropdown-content", ""], [1, "options"], ["class", "dropdown-item", "role", "option", "type", "button", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "default-option", 4, "ngIf"], ["role", "option", "type", "button", 1, "dropdown-item", 3, "ngClass", "click"], [4, "ngIf"], [3, "type", 4, "ngIf"], [3, "type"], [1, "default-option"], ["role", "separator", 1, "divider"], ["type", "all"]], template: function AtomsDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "bc-atoms-button", 0)(2, "div", 1)(3, "div", 2);
            i0.ɵɵtemplate(4, AtomsDropdownComponent_button_4_Template, 3, 5, "button", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, AtomsDropdownComponent_div_5_Template, 5, 5, "div", 4);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.dropdownClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("id", ctx.id)("name", ctx.name)("title", ctx.title)("icon", ctx.iconDisplay)("label", i0.ɵɵpureFunction2(19, _c1$g, ctx.labelDisplay, ctx.model ? ctx.optionSuffix : "").join(" "))("badge", ctx.badge)("autofocus", ctx.autofocus)("disabled", ctx.disabled)("loading", ctx.loading)("iconOnly", ctx.iconOnly)("type", ctx.type)("display", ctx.display)("size", ctx.size);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleMap(i0.ɵɵpureFunction1(22, _c2$b, ctx.visibleOptionsHeight + "px"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.options);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.requireSelection);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, AtomsButtonComponent, AtomsIconComponent], styles: [".bc-dropdown-container.unselected button .icon,.bc-dropdown-container.unselected button .title{color:gray}.bc-dropdown-container .dropdown-menu.show{min-width:100%}.bc-dropdown-container .dropdown-menu .options{overflow-y:auto}.bc-dropdown-container .dropdown-menu .options,.bc-dropdown-container .dropdown-menu .default-option{background:white}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsDropdownComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-dropdown', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => AtomsDropdownComponent)),
                        multi: true,
                    },
                ], encapsulation: ViewEncapsulation.None, template: "<!--\n - Atoms dropdown component (atoms-dropdown.component.html).\n - Atom -> Dropdown Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021-2022 Build Centrix\n -->\n<div [class]=\"dropdownClass\">\n  <!--Button-->\n  <bc-atoms-button\n    [id]=\"id\"\n    [name]=\"name\"\n    [title]=\"title\"\n    [icon]=\"iconDisplay\"\n    [label]=\"[labelDisplay, (model ? optionSuffix : '')].join(' ')\"\n    [badge]=\"badge\"\n    [autofocus]=\"autofocus\"\n    [disabled]=\"disabled\"\n    [loading]=\"loading\"\n    [iconOnly]=\"iconOnly\"\n    [type]=\"type\"\n    [display]=\"display\"\n    [size]=\"size\"\n  >\n    <!--Dropdown-->\n    <div dropdown-content>\n      <div\n        class=\"options\"\n        [style]=\"{ 'max-height': visibleOptionsHeight + 'px' }\"\n      >\n        <!--Options-->\n        <button\n          class=\"dropdown-item\"\n          role=\"option\"\n          type=\"button\"\n          *ngFor=\"let option of options\"\n          (click)=\"selectionChanged(option)\"\n          [ngClass]=\"{ active: (this.selectedOption === option) }\"\n        >\n          <!--Object Option-->\n          <span *ngIf=\"isObjectInput\">\n            <bc-atoms-icon\n              *ngIf=\"option[iconKey]\"\n              [type]=\"iconKey ? option[iconKey] : null\"\n            ></bc-atoms-icon>\n            {{labelKey ? option[labelKey] : option}}\n          </span>\n\n          <!--String Option-->\n          <span *ngIf=\"!isObjectInput\">\n            {{option}}\n          </span>\n        </button>\n      </div>\n      <div class=\"default-option\" *ngIf=\"!requireSelection\">\n        <!--Divider-->\n        <li role=\"separator\" class=\"divider\"></li>\n        <!--Select Option-->\n        <button\n          class=\"dropdown-item\"\n          role=\"option\"\n          type=\"button\"\n          (click)=\"selectionChanged(null)\"\n          [ngClass]=\"{ active: !model }\"\n        >\n          <span *ngIf=\"iconKey\">\n            <bc-atoms-icon type=\"all\"></bc-atoms-icon>\n            {{label}}\n          </span>\n          <span *ngIf=\"!iconKey\">\n            {{label}}\n          </span>\n        </button>\n      </div>\n    </div>\n  </bc-atoms-button>\n</div>\n", styles: [".bc-dropdown-container.unselected button .icon,.bc-dropdown-container.unselected button .title{color:gray}.bc-dropdown-container .dropdown-menu.show{min-width:100%}.bc-dropdown-container .dropdown-menu .options{overflow-y:auto}.bc-dropdown-container .dropdown-menu .options,.bc-dropdown-container .dropdown-menu .default-option{background:white}\n"] }]
    }], null, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], label: [{
            type: Input
        }], badge: [{
            type: Input
        }], title: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], iconOnly: [{
            type: Input
        }], loading: [{
            type: Input
        }], requireSelection: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], disabled: [{
            type: Input
        }], options: [{
            type: Input
        }], optionSuffix: [{
            type: Input
        }], maxVisibleOptions: [{
            type: Input
        }], idKey: [{
            type: Input
        }], labelKey: [{
            type: Input
        }], iconKey: [{
            type: Input
        }], size: [{
            type: Input
        }], display: [{
            type: Input
        }], type: [{
            type: Input
        }], model: [{
            type: Input
        }], selectedOption: [{
            type: Input
        }], formControl: [{
            type: Input
        }], modelChange: [{
            type: Output
        }] }); })();

/**
 * custom-input-field.component.ts
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
function AtomsCustomInputFieldComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "bc-atoms-input-group", 1)(2, "bc-atoms-input", 2);
    i0.ɵɵlistener("modelChange", function AtomsCustomInputFieldComponent_div_1_Template_bc_atoms_input_modelChange_2_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView((ctx_r3.model[ctx_r3.idKey] = $event)); })("modelChange", function AtomsCustomInputFieldComponent_div_1_Template_bc_atoms_input_modelChange_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onModelChange()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("labelTitle", ctx_r0.label);
    i0.ɵɵpropertyInterpolate("labelDescription", ctx_r0.label);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.label);
    i0.ɵɵpropertyInterpolate("title", ctx_r0.label);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r0.label);
    i0.ɵɵproperty("disabled", ctx_r0.disabled)("model", ctx_r0.model[ctx_r0.idKey]);
    i0.ɵɵattribute("formControlName", ctx_r0.fieldFormGroup ? ctx_r0.frmCtrlName : null);
} }
function AtomsCustomInputFieldComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "bc-atoms-input-group", 1)(2, "bc-atoms-dropdown", 3);
    i0.ɵɵlistener("modelChange", function AtomsCustomInputFieldComponent_div_2_Template_bc_atoms_dropdown_modelChange_2_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView((ctx_r6.model[ctx_r6.idKey] = $event)); })("modelChange", function AtomsCustomInputFieldComponent_div_2_Template_bc_atoms_dropdown_modelChange_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onModelChange()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("labelTitle", ctx_r1.label);
    i0.ɵɵpropertyInterpolate("labelDescription", ctx_r1.label);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.label);
    i0.ɵɵproperty("labelKey", ctx_r1.labelKey)("options", ctx_r1.options)("model", ctx_r1.model[ctx_r1.idKey])("disabled", ctx_r1.disabled);
    i0.ɵɵattribute("formControl", ctx_r1.fieldFormGroup ? ctx_r1.fieldFormGroup.get(ctx_r1.frmCtrlName) : null)("formControlName", ctx_r1.fieldFormGroup ? ctx_r1.frmCtrlName : null);
} }
function AtomsCustomInputFieldComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "bc-atoms-input-group", 1)(2, "div", 4)(3, "bc-atoms-checkbox-group", 5);
    i0.ɵɵlistener("modelChange", function AtomsCustomInputFieldComponent_div_3_Template_bc_atoms_checkbox_group_modelChange_3_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView((ctx_r9.model[ctx_r9.idKey] = $event)); })("modelChange", function AtomsCustomInputFieldComponent_div_3_Template_bc_atoms_checkbox_group_modelChange_3_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onModelChange()); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("labelTitle", ctx_r2.label);
    i0.ɵɵpropertyInterpolate("labelDescription", ctx_r2.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("idKey", ctx_r2.idKey)("labelKey", ctx_r2.labelKey)("options", ctx_r2.options)("columns", ctx_r2.columns)("disabled", ctx_r2.disabled)("model", ctx_r2.model[ctx_r2.idKey]);
    i0.ɵɵattribute("formControlName", ctx_r2.fieldFormGroup ? ctx_r2.frmCtrlName : null);
} }
class AtomsCustomInputFieldComponent {
    fieldFormGroup;
    columns = '1';
    // Booleans
    disabled = false;
    // Targets
    idKey = 'value';
    labelKey = 'label';
    // Form control -> Used for make this component compatible with reactive forms
    // If pass formControl instance. Skip passing model when calling this component. Form control will override this.model
    frmCtrlName = 'value';
    // Two Way Data Binding
    model = new CustomInputField();
    modelChange = new EventEmitter();
    ECustomInputFieldType = ECustomInputFieldType;
    label;
    type;
    options;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
    /**
     * OnInit
     */
    ngOnInit() {
        this.setData();
    }
    /**
     * Set Data
     */
    setData() {
        this.model = this.fieldFormGroup ? this.fieldFormGroup.value : this.model;
        const { label, type, options } = this.model;
        this.label = label;
        this.type = type;
        this.options = options ? options : [];
        // filter out bad options that doesn't have label or value or empty labels
        this.options = this.options.filter((option) => option.label && option.value && option.label.length > 0);
    }
    /**
     * On change of any field
     *
     * @since 3.18.0
     */
    onModelChange() {
        this.modelChange.emit(this.model);
    }
    /** @nocollapse */ static ɵfac = function AtomsCustomInputFieldComponent_Factory(t) { return new (t || AtomsCustomInputFieldComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsCustomInputFieldComponent, selectors: [["bc-atoms-custom-input-field"]], inputs: { fieldFormGroup: "fieldFormGroup", columns: "columns", disabled: "disabled", idKey: "idKey", labelKey: "labelKey", frmCtrlName: "frmCtrlName", model: "model" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([], [
                { provide: ControlContainer, useExisting: FormGroupDirective },
            ])], decls: 4, vars: 4, consts: [[4, "ngIf"], [3, "labelTitle", "labelDescription"], ["size", "small", 3, "id", "title", "placeholder", "disabled", "model", "modelChange"], ["display", "block", "iconKey", "type", "label", "Select option", "size", "small", 3, "title", "labelKey", "options", "model", "disabled", "modelChange"], [1, "col-md-12", "checkbox-group-container"], [3, "idKey", "labelKey", "options", "columns", "disabled", "model", "modelChange"]], template: function AtomsCustomInputFieldComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "form");
            i0.ɵɵtemplate(1, AtomsCustomInputFieldComponent_div_1_Template, 3, 8, "div", 0);
            i0.ɵɵtemplate(2, AtomsCustomInputFieldComponent_div_2_Template, 3, 9, "div", 0);
            i0.ɵɵtemplate(3, AtomsCustomInputFieldComponent_div_3_Template, 4, 9, "div", 0);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵattribute("formGroup", ctx.fieldFormGroup ? ctx.fieldFormGroup : null);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.type === ctx.ECustomInputFieldType.TEXTBOX);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.type === ctx.ECustomInputFieldType.DROPDOWN);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.type === ctx.ECustomInputFieldType.CHECKBOX);
        } }, dependencies: [i1.NgIf, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.NgForm, AtomsCheckboxGroupComponent, AtomsDropdownComponent, AtomsInputComponent, AtomsInputGroupComponent], styles: [".checkbox-group-container[_ngcontent-%COMP%]{margin-bottom:1em}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsCustomInputFieldComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-custom-input-field', viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ], template: "<!--\n * custom-input-field.component.html\n *\n * @author Jenny Lam <jlam@buildcentrix.com>\n * @copyright (c) 2024 Build Centrix\n-->\n<form [attr.formGroup]=\"fieldFormGroup ? fieldFormGroup : null\">\n  <!-- Text box type input -->\n  <div *ngIf=\"type === ECustomInputFieldType.TEXTBOX\">\n    <bc-atoms-input-group labelTitle=\"{{label}}\" labelDescription=\"{{label}}\">\n      <bc-atoms-input\n        id=\"{{label}}\"\n        title=\"{{label}}\"\n        placeholder=\"{{label}}\"\n        size=\"small\"\n        [disabled]=\"disabled\"\n        [(model)]=\"model[idKey]\"\n        (modelChange)=\"onModelChange()\"\n        [attr.formControlName]=\"fieldFormGroup ? frmCtrlName : null\"\n      >\n      </bc-atoms-input>\n    </bc-atoms-input-group>\n  </div>\n\n  <!-- Drop down type input -->\n  <div *ngIf=\"type === ECustomInputFieldType.DROPDOWN\">\n    <bc-atoms-input-group labelTitle=\"{{label}}\" labelDescription=\"{{label}}\">\n      <bc-atoms-dropdown\n        title=\"{{label}}\"\n        display=\"block\"\n        iconKey=\"type\"\n        label=\"Select option\"\n        size=\"small\"\n        [labelKey]=\"labelKey\"\n        [options]=\"options\"\n        [(model)]=\"model[idKey]\"\n        [disabled]=\"disabled\"\n        (modelChange)=\"onModelChange()\"\n        [attr.formControl]=\"fieldFormGroup ? fieldFormGroup.get(frmCtrlName) : null\"\n        [attr.formControlName]=\"fieldFormGroup ? frmCtrlName : null\"\n      >\n      </bc-atoms-dropdown>\n    </bc-atoms-input-group>\n  </div>\n\n  <!-- Checkbox type input -->\n  <div *ngIf=\"type === ECustomInputFieldType.CHECKBOX\">\n    <bc-atoms-input-group labelTitle=\"{{label}}\" labelDescription=\"{{label}}\">\n      <div class=\"col-md-12 checkbox-group-container\">\n        <bc-atoms-checkbox-group\n          [idKey]=\"idKey\"\n          [labelKey]=\"labelKey\"\n          [options]=\"options\"\n          [columns]=\"columns\"\n          [disabled]=\"disabled\"\n          [(model)]=\"model[idKey]\"\n          (modelChange)=\"onModelChange()\"\n          [attr.formControlName]=\"fieldFormGroup ? frmCtrlName : null\"\n        >\n        </bc-atoms-checkbox-group>\n      </div>\n    </bc-atoms-input-group>\n  </div>\n</form>\n", styles: [".checkbox-group-container{margin-bottom:1em}\n"] }]
    }], function () { return []; }, { fieldFormGroup: [{
            type: Input
        }], columns: [{
            type: Input
        }], disabled: [{
            type: Input
        }], idKey: [{
            type: Input
        }], labelKey: [{
            type: Input
        }], frmCtrlName: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }] }); })();
var ECustomInputFieldType;
(function (ECustomInputFieldType) {
    ECustomInputFieldType["TEXTBOX"] = "textbox";
    ECustomInputFieldType["DROPDOWN"] = "dropdown";
    ECustomInputFieldType["CHECKBOX"] = "checkbox";
})(ECustomInputFieldType || (ECustomInputFieldType = {}));
class CustomInputField {
    label;
    uid;
    type;
    options;
    sortOrder;
    value;
}

/**
 * Atoms input component (atoms-date-picker.component.ts).
 * Atoms -> input.group Component
 *
 * @version
 * 3.5.0 LIBNGSG-124 Add firstDayOfWeek to date-picker component
 * 3.5.0 PRDS-193 Add filters on assembly listing page
 * 3.0.0 UIUP-5 Upgrade Angular to v16
 * 1.3.0 LIBNGSG-8 Add branding images component
 * 1.1.0 LIBNGSG-12 Add date-picker component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
const _c0$k = ["prefixContent"];
const _c1$f = ["suffixContent"];
const _c2$a = function (a0) { return { "input-group-append": a0 }; };
const _c3$7 = function (a0) { return { "input-group-text button": a0 }; };
function AtomsDatePickerComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵlistener("click", function AtomsDatePickerComponent_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.modelChange.emit(undefined)); });
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵelement(2, "bc-atoms-icon", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2$a, ctx_r1.hasClearButton));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3$7, ctx_r1.hasClearButton));
} }
function AtomsDatePickerComponent_ng_template_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "bc-atoms-button", 15);
    i0.ɵɵlistener("onButtonClicked", function AtomsDatePickerComponent_ng_template_8_div_1_Template_bc_atoms_button_onButtonClicked_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); const _r0 = i0.ɵɵreference(3); ctx_r7.selectToday(); return i0.ɵɵresetView(ctx_r7.closeDropdown(_r0)); });
    i0.ɵɵelementEnd()();
} }
function AtomsDatePickerComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, AtomsDatePickerComponent_ng_template_8_div_1_Template, 2, 0, "div", 12);
    i0.ɵɵelementStart(2, "div", 13)(3, "bc-atoms-button", 14);
    i0.ɵɵlistener("onButtonClicked", function AtomsDatePickerComponent_ng_template_8_Template_bc_atoms_button_onButtonClicked_3_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); const _r0 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx_r9.closeDropdown(_r0)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isTodayEnabled);
} }
class AtomsDatePickerComponent {
    // Classes
    inputClass;
    inputGroupClass;
    // Booleans
    isTodayEnabled = false;
    // Selected Date
    selectedDate;
    // Validation
    sizeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.INPUT, 'formControlSize');
    minDate;
    maxDate;
    // Inputs
    id;
    name;
    autocomplete = 'off';
    placeholder;
    size;
    title;
    dateFormat = 'MMMM Do YYYY';
    canClear = false;
    firstDayOfWeek = 1;
    // Other
    min;
    max;
    // Booleans
    required = false;
    disabled = false;
    // Two Way Data Binding
    model;
    modelChange = new EventEmitter();
    // Transcludes
    prefixContent;
    suffixContent;
    hasClearButton = false;
    /**
     * Constructor
     *
     * @since 1.1.0
     */
    constructor() {
        // Init Classes
        this.initClasses();
    }
    /**
     * Close Dropdown
     *
     * @since 1.1.0
     * @param datepickerDropdown
     */
    closeDropdown(datepickerDropdown) {
        datepickerDropdown.close();
    }
    /**
     * Date Changed
     * @since 1.1.0
     *
     * @param $event
     */
    dateChanged($event) {
        // Convert Selected Date to JsDate Model
        this.modelChange.emit(AtomsDatePickerComponent.toDateJsStructure($event));
    }
    /**
     * Format Date
     * @since 1.1.0
     * @param date
     */
    format(date) {
        let formattedDate = '';
        if (date) {
            const ngbDateAsDate = new Date(date.year, date.month - 1, date.day);
            formattedDate = moment(ngbDateAsDate).format(this.dateFormat);
        }
        return formattedDate;
    }
    /**
     * Initialize Classes
     * @since 1.1.0
     */
    initClasses() {
        this.hasClearButton = this.canClear;
        // Set input.group Classes
        const inputClasses = [];
        const inputGroupClasses = [];
        inputClasses.push('form-control no-prefix');
        inputGroupClasses.push('bc-date-picker input-group');
        // Size Option
        if (this.size && this.sizeOptions.includes(this.size)) {
            inputClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'formControlSize', this.size));
            inputGroupClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'inputGroupSize', this.size));
        }
        if (this.disabled) {
            inputGroupClasses.push('disabled');
        }
        // Set Classes
        this.inputClass = inputClasses.join(' ');
        this.inputGroupClass = inputGroupClasses.join(' ');
    }
    /**
     * Watch for Changes
     *
     * @since 1.1.0
     * @param changes
     */
    ngOnChanges(changes) {
        // Init Classes
        this.initClasses();
        // Convert Min NgbDate Structure
        if (changes.min || changes.dateFormat) {
            this.minDate = AtomsDatePickerComponent.toDateNgbStructure(this.min);
        }
        // Convert Max NgbDate Structure
        if (changes.max || changes.dateFormat) {
            this.maxDate = AtomsDatePickerComponent.toDateNgbStructure(this.max);
        }
        // Convert Selected NgbDate Structure
        if (changes.model || changes.dateFormat) {
            this.selectedDate = AtomsDatePickerComponent.toDateNgbStructure(this.model);
        }
        this.isTodayEnabled = AtomsDatePickerComponent.checkTodayWithinRange(this.min, this.max);
    }
    /**
     * On Init
     * @since 1.1.0
     */
    ngOnInit() {
        // Convert JsDate Model to NgbDate
        this.selectedDate = AtomsDatePickerComponent.toDateNgbStructure(this.model);
    }
    /**
     * Select Todays Date
     * @since 1.1.0
     */
    selectToday() {
        this.model = new Date();
        this.modelChange.emit(this.model);
        this.selectedDate = AtomsDatePickerComponent.toDateNgbStructure(this.model);
    }
    /**
     * Toggle Dropdown
     *
     * @since 1.1.0
     * @param datepickerDropdown
     */
    toggleDropdown(datepickerDropdown) {
        if (!this.disabled) {
            datepickerDropdown.toggle();
        }
    }
    /**
     * Check if Today is within Range
     *
     * @since 1.1.0
     * @param min
     * @param max
     */
    static checkTodayWithinRange(min, max) {
        let result = true;
        const todayAsMoment = moment(new Date());
        const minAsMoment = min ? moment(min) : null;
        const maxAsMoment = max ? moment(max) : null;
        if (minAsMoment && !todayAsMoment.isSameOrAfter(minAsMoment)) {
            result = false;
        }
        if (maxAsMoment && !todayAsMoment.isSameOrBefore(maxAsMoment)) {
            result = false;
        }
        return result;
    }
    /**
     * To JsDate Structure
     *
     * @since 1.1.0
     * @param date
     */
    static toDateJsStructure(date) {
        return date ? new Date(date.year, date.month - 1, date.day) : null;
    }
    /**
     * To NgbDate Structure
     *
     * @since 1.1.0
     * @param date
     */
    static toDateNgbStructure(date) {
        return date
            ? new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
            : null;
    }
    /** @nocollapse */ static ɵfac = function AtomsDatePickerComponent_Factory(t) { return new (t || AtomsDatePickerComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsDatePickerComponent, selectors: [["bc-atoms-date-picker"]], viewQuery: function AtomsDatePickerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$k, 7);
            i0.ɵɵviewQuery(_c1$f, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixContent = _t.first);
        } }, inputs: { id: "id", name: "name", autocomplete: "autocomplete", placeholder: "placeholder", size: "size", title: "title", dateFormat: "dateFormat", canClear: "canClear", firstDayOfWeek: "firstDayOfWeek", min: "min", max: "max", required: "required", disabled: "disabled", model: "model" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([
                { provide: NgbDateParserFormatter, useExisting: AtomsDatePickerComponent },
            ]), i0.ɵɵNgOnChangesFeature], decls: 10, vars: 16, consts: [[3, "title"], ["container", "body", "ngbDatepicker", "", "readonly", "", 3, "disabled", "ngModel", "minDate", "maxDate", "footerTemplate", "firstDayOfWeek", "ngModelChange", "click"], ["datepickerDropdown", "ngbDatepicker"], [1, "input-group-append", 3, "click"], [1, "input-group-text"], ["type", "calendar"], [3, "ngClass", "click", 4, "ngIf"], ["footerTemplate", ""], [3, "ngClass", "click"], [3, "ngClass"], ["type", "clear"], [1, "text-center"], ["class", "p-2 d-inline-block", 4, "ngIf"], [1, "p-2", "d-inline-block"], ["label", "Close", "display", "block", "icon", "cancel", "size", "small", 3, "onButtonClicked"], ["label", "Today", "type", "primary", "display", "block", "icon", "calendar", "size", "small", 3, "onButtonClicked"]], template: function AtomsDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
            const _r11 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "span", 0)(1, "label")(2, "input", 1, 2);
            i0.ɵɵlistener("ngModelChange", function AtomsDatePickerComponent_Template_input_ngModelChange_2_listener($event) { return ctx.selectedDate = $event; })("ngModelChange", function AtomsDatePickerComponent_Template_input_ngModelChange_2_listener($event) { return ctx.dateChanged($event); })("click", function AtomsDatePickerComponent_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r11); const _r0 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx.toggleDropdown(_r0)); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵlistener("click", function AtomsDatePickerComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r11); const _r0 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx.toggleDropdown(_r0)); });
            i0.ɵɵelementStart(5, "span", 4);
            i0.ɵɵelement(6, "bc-atoms-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, AtomsDatePickerComponent_span_7_Template, 3, 6, "span", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, AtomsDatePickerComponent_ng_template_8_Template, 4, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(9);
            i0.ɵɵproperty("title", ctx.title);
            i0.ɵɵattribute("class", ctx.inputGroupClass);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disabled)("ngModel", ctx.selectedDate)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("footerTemplate", _r2)("firstDayOfWeek", ctx.firstDayOfWeek);
            i0.ɵɵattribute("id", ctx.id)("autocomplete", ctx.autocomplete)("name", ctx.name)("placeholder", ctx.placeholder)("required", ctx.required)("title", ctx.title)("class", ctx.inputClass);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.hasClearButton);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, i1$1.NgbInputDatepicker, AtomsButtonComponent, AtomsIconComponent], styles: [".bc-date-picker[_ngcontent-%COMP%]{cursor:pointer}.bc-date-picker.disabled[_ngcontent-%COMP%]{opacity:.6}.bc-date-picker.input-group[_ngcontent-%COMP%]     label{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.bc-date-picker.input-group[_ngcontent-%COMP%]     label input{cursor:pointer;border-top-left-radius:5px;border-bottom-left-radius:5px}.bc-date-picker.input-group[_ngcontent-%COMP%]     label input[readonly]{background:white;border-top-right-radius:0;border-bottom-right-radius:0}.bc-date-picker.input-group[_ngcontent-%COMP%]     label input.no-prefix{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.bc-date-picker.input-group[_ngcontent-%COMP%]     label input.no-suffix{border-top-right-radius:5px;border-bottom-right-radius:5px}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsDatePickerComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-date-picker', providers: [
                    { provide: NgbDateParserFormatter, useExisting: AtomsDatePickerComponent },
                ], template: "<!--\n - Atoms input component (atoms-date-picker.component.html).\n - Atom -> input.group Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @author Monika Gole <monika.gole@ncircletech.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 3.5.0 LIBNGSG-124 Add firstDayOfWeek to date-picker component\n - 3.5.0 PRDS-193 Add filters on assembly listing page\n - 1.1.0 LIBNGSG-12 Add date-picker component\n -\n -->\n<span [attr.class]=\"inputGroupClass\" [title]=\"title\">\n  <label>\n    <input\n      [attr.id]=\"id\"\n      [attr.autocomplete]=\"autocomplete\"\n      [disabled]=\"disabled\"\n      [attr.name]=\"name\"\n      [attr.placeholder]=\"placeholder\"\n      [attr.required]=\"required\"\n      [attr.title]=\"title\"\n      [attr.class]=\"inputClass\"\n      [(ngModel)]=\"selectedDate\"\n      [minDate]=\"minDate\"\n      [maxDate]=\"maxDate\"\n      [footerTemplate]=\"footerTemplate\"\n      (ngModelChange)=\"dateChanged($event);\"\n      (click)=\"toggleDropdown(datepickerDropdown)\"\n      container=\"body\"\n      ngbDatepicker\n      #datepickerDropdown=\"ngbDatepicker\"\n      [firstDayOfWeek]=\"firstDayOfWeek\"\n      readonly\n    />\n  </label>\n  <span class=\"input-group-append\" (click)=\"toggleDropdown(datepickerDropdown)\">\n    <span class=\"input-group-text\">\n      <bc-atoms-icon type=\"calendar\"></bc-atoms-icon>\n    </span>\n  </span>\n  <span\n    [ngClass]=\"{ 'input-group-append': hasClearButton }\"\n    *ngIf=\"hasClearButton\"\n    (click)=\"modelChange.emit(undefined);\"\n  >\n    <span [ngClass]=\"{ 'input-group-text button': hasClearButton }\">\n      <bc-atoms-icon type=\"clear\"></bc-atoms-icon>\n    </span>\n  </span>\n</span>\n\n<ng-template #footerTemplate>\n  <div class=\"text-center\">\n    <div class=\"p-2 d-inline-block\" *ngIf=\"isTodayEnabled\">\n      <bc-atoms-button\n        label=\"Today\"\n        type=\"primary\"\n        display=\"block\"\n        icon=\"calendar\"\n        size=\"small\"\n        (onButtonClicked)=\"selectToday(); closeDropdown(datepickerDropdown)\"\n      ></bc-atoms-button>\n    </div>\n    <div class=\"p-2 d-inline-block\">\n      <bc-atoms-button\n        label=\"Close\"\n        display=\"block\"\n        icon=\"cancel\"\n        size=\"small\"\n        (onButtonClicked)=\"closeDropdown(datepickerDropdown)\"\n      ></bc-atoms-button>\n    </div>\n  </div>\n</ng-template>\n", styles: [".bc-date-picker{cursor:pointer}.bc-date-picker.disabled{opacity:.6}.bc-date-picker.input-group ::ng-deep label{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.bc-date-picker.input-group ::ng-deep label input{cursor:pointer;border-top-left-radius:5px;border-bottom-left-radius:5px}.bc-date-picker.input-group ::ng-deep label input[readonly]{background:white;border-top-right-radius:0;border-bottom-right-radius:0}.bc-date-picker.input-group ::ng-deep label input.no-prefix{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.bc-date-picker.input-group ::ng-deep label input.no-suffix{border-top-right-radius:5px;border-bottom-right-radius:5px}\n"] }]
    }], function () { return []; }, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], size: [{
            type: Input
        }], title: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], canClear: [{
            type: Input
        }], firstDayOfWeek: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], required: [{
            type: Input
        }], disabled: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], prefixContent: [{
            type: ViewChild,
            args: ['prefixContent', { static: true }]
        }], suffixContent: [{
            type: ViewChild,
            args: ['suffixContent', { static: true }]
        }] }); })();

/**
 * Forbidden name directive (forbidden-name.directive.ts).
 * Example of Custom Input Validators.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.1.0 LIBNGSG-17 Template driven input form validation
 *
 */
/**
 * Input Cannot Match Validator
 * @since 1.1.0
 */
class ForbiddenValidatorDirective {
    forbiddenName;
    validate(control) {
        if (control.value === this.forbiddenName) {
            return { forbiddenName: { value: control.value } };
        }
        return null;
    }
    /** @nocollapse */ static ɵfac = function ForbiddenValidatorDirective_Factory(t) { return new (t || ForbiddenValidatorDirective)(); };
    /** @nocollapse */ static ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: ForbiddenValidatorDirective, selectors: [["", "appForbiddenName", ""]], inputs: { forbiddenName: ["appForbiddenName", "forbiddenName"] }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALIDATORS,
                    useExisting: ForbiddenValidatorDirective,
                    multi: true,
                },
            ])] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ForbiddenValidatorDirective, [{
        type: Directive,
        args: [{
                selector: '[appForbiddenName]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: ForbiddenValidatorDirective,
                        multi: true,
                    },
                ],
            }]
    }], null, { forbiddenName: [{
            type: Input,
            args: ['appForbiddenName']
        }] }); })();
/**
 * Forbidden Name Validator
 *
 * @since 1.1.0
 * @param forbiddenName
 */
function createForbiddenNameValidator(forbiddenName) {
    return function validateCounterRange(c) {
        const err = {
            forbiddenName: {
                value: c.value,
            },
        };
        return c.value === forbiddenName ? err : null;
    };
}

/**
 * Atoms textarea component (atoms-textarea.component.ts).
 *
 * @version
 * 3.14.0 LIBNGSG-147 Add max input for text-area and typeahead components
 * 3.5.0 LIBNGSG-123 Migrate tslint to eslint
 * 1.9.0 LIBNGSG-44 Add text-area component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
const _c0$j = ["prefixContent"];
const _c1$e = ["suffixContent"];
const _c2$9 = [[["", "prefix-content", ""]], [["", "suffix-content", ""]]];
const _c3$6 = function (a0) { return { "input-group-prepend": a0 }; };
const _c4$3 = function (a0) { return { "input-group-text": a0 }; };
const _c5$2 = function () { return { standalone: true }; };
const _c6$2 = function (a0) { return { "input-group-append": a0 }; };
const _c7$2 = ["[prefix-content]", "[suffix-content]"];
class AtomsTextAreaComponent {
    // Classes
    textareaClass;
    inputGroupClass;
    // Booleans
    hasPrefix = false;
    hasSuffix = false;
    // Inputs
    accept;
    alt;
    autocomplete = 'off';
    autofocus;
    formAction;
    formEnctype;
    formMethod;
    formNoValidate;
    formTarget;
    height;
    id;
    rows;
    name;
    placeholder;
    required;
    size;
    title;
    form;
    maxlength;
    isDisabled = false;
    // @deprecated - Use isDisabled instead to avoid warning "It looks like you're using the
    // disabled attribute with a reactive form directive"
    disabled = false;
    // Two Way Data Binding
    model;
    modelChange = new EventEmitter();
    modelFocus = new EventEmitter();
    modelBlur = new EventEmitter();
    // Variables
    type = 'text';
    sizeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.INPUT, 'formControlSize');
    // Transcludes
    prefixContent;
    suffixContent;
    /**
     * Init Classes
     * since 1.9.0
     */
    initClasses() {
        // Set Input Classes
        const inputClasses = [];
        const inputGroupClasses = ['bc-atoms-textarea'];
        this.hasPrefix =
            this.prefixContent.nativeElement &&
                this.prefixContent.nativeElement.children.length > 0;
        this.hasSuffix =
            this.suffixContent.nativeElement &&
                this.suffixContent.nativeElement.children.length > 0;
        // Type
        if (this.type && !['radio', 'checkbox', 'image'].includes(this.type)) {
            inputClasses.push('form-control');
            // Has Prefix
            if (!this.hasPrefix) {
                inputClasses.push('no-prefix');
            }
            // Has Suffix
            if (!this.hasSuffix) {
                inputClasses.push('no-suffix');
            }
            // Is Input Group
            if (this.hasPrefix || this.hasSuffix) {
                inputGroupClasses.push('input-group');
            }
            // Size Option
            if (this.size && this.sizeOptions.includes(this.size)) {
                if (this.hasPrefix || this.hasSuffix) {
                    inputGroupClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'inputGroupSize', this.size));
                }
                inputClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'formControlSize', this.size));
            }
        }
        // Set Classes
        this.textareaClass = inputClasses.join(' ');
        this.inputGroupClass = inputGroupClasses.join(' ');
    }
    /**
     * Watch for Changes
     */
    ngOnChanges() {
        // Init Classes
        this.initClasses();
    }
    /*********************************************** Input Validation *************************************************/
    // Custom Validator Example
    validateFn = createForbiddenNameValidator('tom');
    // Functions
    onChangeFn;
    onTouchedFn;
    /**
     * Validate Input
     * @param c
     */
    validate(c) {
        return this.validateFn(c);
    }
    /**
     * On Change
     * @since 1.9.0
     */
    onChange() {
        if (this.onChangeFn) {
            this.onChangeFn(this.model);
        }
    }
    /**
     * On Blur
     * @since 1.9.0
     */
    inputBlur($event) {
        this.modelBlur.emit($event);
        if (this.onTouchedFn) {
            this.onTouchedFn(this.model);
        }
    }
    /**
     * On Focus
     * @since 1.9.0
     */
    inputFocus($event) {
        this.modelFocus.emit($event);
        if (this.onTouchedFn) {
            this.onTouchedFn(this.model);
        }
    }
    /**
     * Write Value
     *
     * @since 1.9.0
     * @param obj
     */
    writeValue(obj) {
        this.model = obj;
    }
    /**
     * Register Input as Changed
     *
     * @since 1.9.0
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /**
     * Register Input as Touched
     *
     * @since 1.9.0
     * @param fn
     */
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    /** @nocollapse */ static ɵfac = function AtomsTextAreaComponent_Factory(t) { return new (t || AtomsTextAreaComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsTextAreaComponent, selectors: [["bc-atoms-textarea"]], viewQuery: function AtomsTextAreaComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$j, 7);
            i0.ɵɵviewQuery(_c1$e, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixContent = _t.first);
        } }, inputs: { accept: "accept", alt: "alt", autocomplete: "autocomplete", autofocus: "autofocus", formAction: "formAction", formEnctype: "formEnctype", formMethod: "formMethod", formNoValidate: "formNoValidate", formTarget: "formTarget", height: "height", id: "id", rows: "rows", name: "name", placeholder: "placeholder", required: "required", size: "size", title: "title", form: "form", maxlength: "maxlength", isDisabled: "isDisabled", disabled: "disabled", model: "model" }, outputs: { modelChange: "modelChange", modelFocus: "modelFocus", modelBlur: "modelBlur" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => AtomsTextAreaComponent)),
                    multi: true,
                },
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef((() => AtomsTextAreaComponent)),
                    multi: true,
                },
            ]), i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c7$2, decls: 11, vars: 35, consts: [[3, "ngClass"], ["prefixContent", ""], [3, "autofocus", "disabled", "required", "ngModel", "ngModelOptions", "ngModelChange", "focus", "input", "change", "blur"], ["suffixContent", ""]], template: function AtomsTextAreaComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$9);
            i0.ɵɵelementStart(0, "span")(1, "span", 0)(2, "span", 0, 1);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "label")(6, "textarea", 2);
            i0.ɵɵlistener("ngModelChange", function AtomsTextAreaComponent_Template_textarea_ngModelChange_6_listener($event) { return ctx.model = $event; })("ngModelChange", function AtomsTextAreaComponent_Template_textarea_ngModelChange_6_listener($event) { return ctx.modelChange.emit($event); })("focus", function AtomsTextAreaComponent_Template_textarea_focus_6_listener($event) { return ctx.inputFocus($event); })("input", function AtomsTextAreaComponent_Template_textarea_input_6_listener() { return ctx.onChange(); })("change", function AtomsTextAreaComponent_Template_textarea_change_6_listener() { return ctx.onChange(); })("blur", function AtomsTextAreaComponent_Template_textarea_blur_6_listener($event) { return ctx.inputBlur($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "span", 0)(8, "span", 0, 3);
            i0.ɵɵprojection(10, 1);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵattribute("class", ctx.inputGroupClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c3$6, ctx.hasPrefix));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c4$3, ctx.hasPrefix));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("autofocus", ctx.autofocus)("disabled", ctx.disabled || ctx.isDisabled)("required", ctx.required)("ngModel", ctx.model)("ngModelOptions", i0.ɵɵpureFunction0(30, _c5$2));
            i0.ɵɵattribute("id", ctx.id)("accept", ctx.accept)("alt", ctx.alt)("autocomplete", ctx.autocomplete)("formAction", ctx.formAction, i0.ɵɵsanitizeUrl)("formEnctype", ctx.formEnctype)("formMethod", ctx.formMethod)("formNoValidate", ctx.formNoValidate)("formTarget", ctx.formTarget)("height", ctx.height)("rows", ctx.rows)("name", ctx.name)("placeholder", ctx.placeholder)("title", ctx.title)("class", ctx.textareaClass)("maxlength", ctx.maxlength);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(31, _c6$2, ctx.hasSuffix));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(33, _c4$3, ctx.hasSuffix));
        } }, dependencies: [i1.NgClass, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel], styles: ["label[_ngcontent-%COMP%]{margin:0;display:contents!important}textarea[_ngcontent-%COMP%]{resize:none}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   textarea.no-prefix[_ngcontent-%COMP%]{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   textarea.no-suffix[_ngcontent-%COMP%]{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsTextAreaComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-textarea', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => AtomsTextAreaComponent)),
                        multi: true,
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((() => AtomsTextAreaComponent)),
                        multi: true,
                    },
                ], template: "<!--\n - Atoms textarea component (atoms-textarea.component.html).\n -\n - @version\n - 3.14.0 LIBNGSG-147 Add max input for text-area and typeahead components\n - 1.9.0 LIBNGSG-44 Add text-area component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021-2024 Build Centrix\n -->\n<span [attr.class]=\"inputGroupClass\">\n  <span [ngClass]=\"{ 'input-group-prepend': this.hasPrefix }\">\n    <span #prefixContent [ngClass]=\"{ 'input-group-text': this.hasPrefix }\">\n      <ng-content select=\"[prefix-content]\"></ng-content>\n    </span>\n  </span>\n  <label>\n    <textarea\n      [attr.id]=\"id\"\n      [attr.accept]=\"accept\"\n      [attr.alt]=\"alt\"\n      [attr.autocomplete]=\"autocomplete\"\n      [autofocus]=\"autofocus\"\n      [disabled]=\"disabled || isDisabled\"\n      [required]=\"required\"\n      [attr.formAction]=\"formAction\"\n      [attr.formEnctype]=\"formEnctype\"\n      [attr.formMethod]=\"formMethod\"\n      [attr.formNoValidate]=\"formNoValidate\"\n      [attr.formTarget]=\"formTarget\"\n      [attr.height]=\"height\"\n      [attr.rows]=\"rows\"\n      [attr.name]=\"name\"\n      [attr.placeholder]=\"placeholder\"\n      [attr.title]=\"title\"\n      [attr.class]=\"textareaClass\"\n      [attr.maxlength]=\"maxlength\"\n      [(ngModel)]=\"model\"\n      [ngModelOptions]=\"{ standalone: true }\"\n      (ngModelChange)=\"modelChange.emit($event)\"\n      (focus)=\"inputFocus($event)\"\n      (input)=\"onChange()\"\n      (change)=\"onChange()\"\n      (blur)=\"inputBlur($event)\"\n    ></textarea>\n  </label>\n  <span [ngClass]=\"{ 'input-group-append': this.hasSuffix }\">\n    <span #suffixContent [ngClass]=\"{ 'input-group-text': this.hasSuffix }\">\n      <ng-content select=\"[suffix-content]\"></ng-content>\n    </span>\n  </span>\n</span>\n", styles: ["label{margin:0;display:contents!important}textarea{resize:none}.input-group label{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.input-group label textarea{border-top-left-radius:0;border-bottom-left-radius:0}.input-group label textarea.no-prefix{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.input-group label textarea.no-suffix{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}\n"] }]
    }], null, { accept: [{
            type: Input
        }], alt: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], formAction: [{
            type: Input
        }], formEnctype: [{
            type: Input
        }], formMethod: [{
            type: Input
        }], formNoValidate: [{
            type: Input
        }], formTarget: [{
            type: Input
        }], height: [{
            type: Input
        }], id: [{
            type: Input
        }], rows: [{
            type: Input
        }], name: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], required: [{
            type: Input
        }], size: [{
            type: Input
        }], title: [{
            type: Input
        }], form: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], disabled: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], modelFocus: [{
            type: Output
        }], modelBlur: [{
            type: Output
        }], prefixContent: [{
            type: ViewChild,
            args: ['prefixContent', { static: true }]
        }], suffixContent: [{
            type: ViewChild,
            args: ['suffixContent', { static: true }]
        }] }); })();

/**
 * Atoms thumbnail component (atoms-thumbnail.component.ts).
 * Atoms -> Thumbnail Component
 *
 * @version
 * 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
function AtomsThumbnailComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function AtomsThumbnailComponent_div_1_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onClickDelete($event)); });
    i0.ɵɵelement(1, "bc-atoms-icon", 9);
    i0.ɵɵelementEnd();
} }
function AtomsThumbnailComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function AtomsThumbnailComponent_div_2_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onClickEdit($event)); });
    i0.ɵɵelement(1, "bc-atoms-icon", 11);
    i0.ɵɵelementEnd();
} }
function AtomsThumbnailComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "img", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r2.src, i0.ɵɵsanitizeUrl);
} }
function AtomsThumbnailComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "bc-atoms-icon", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r3.icon);
} }
function AtomsThumbnailComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", ctx_r4.label);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.label, " ");
} }
function AtomsThumbnailComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", ctx_r5.description);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.description, " ");
} }
const _c0$i = function (a0, a1) { return { "active": a0, "disabled": a1 }; };
class AtomsThumbnailComponent {
    // Defaults (Non-Inputs)
    thumbnailClass;
    // String Inputs
    title = '';
    label = null;
    description = null;
    src = '';
    icon = null;
    size = 'default';
    // Boolean Inputs
    isActive = false;
    isDisabled = false;
    canEdit = false;
    canDelete = false;
    // Callback Functions
    onThumbnailClicked = new EventEmitter();
    onDeleteClicked = new EventEmitter();
    onEditClicked = new EventEmitter();
    // Validation
    sizeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.THUMBNAIL, 'size');
    /**
     * Watch for Changes
     */
    ngOnChanges() {
        // Note: changes.prop contains the old and the new value...
        const thumbnailClasses = ['bc-thumbnail'];
        // Thumbnail Size
        if (this.size && this.sizeOptions.includes(this.size)) {
            thumbnailClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.THUMBNAIL, 'size', this.size));
        }
        // Set Thumbnail Class
        this.thumbnailClass = thumbnailClasses.join(' ');
    }
    /**
     * Edit Clicked
     *
     * @since 1.3.0
     * @param event
     */
    onClickEdit = (event) => {
        // Button Clicked
        if (!this.isDisabled) {
            // Callback Function
            this.onEditClicked.emit(event);
        }
        else {
            event.stopPropagation();
            return;
        }
    };
    /**
     * Delete Clicked
     *
     * @since 1.3.0
     * @param event
     */
    onClickDelete = (event) => {
        // Button Clicked
        if (!this.isDisabled) {
            // Callback Function
            this.onDeleteClicked.emit(event);
        }
        else {
            event.stopPropagation();
            return;
        }
    };
    /**
     * Thumbnail Clicked
     *
     * @since 1.3.0
     * @param event
     */
    onClickThumbnail = (event) => {
        // Button Clicked
        if (!this.isDisabled) {
            // Callback Function
            this.onThumbnailClicked.emit(event);
        }
        else {
            event.stopPropagation();
            return;
        }
    };
    /** @nocollapse */ static ɵfac = function AtomsThumbnailComponent_Factory(t) { return new (t || AtomsThumbnailComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsThumbnailComponent, selectors: [["bc-atoms-thumbnail"]], inputs: { title: "title", label: "label", description: "description", src: "src", icon: "icon", size: "size", isActive: "isActive", isDisabled: "isDisabled", canEdit: "canEdit", canDelete: "canDelete" }, outputs: { onThumbnailClicked: "onThumbnailClicked", onDeleteClicked: "onDeleteClicked", onEditClicked: "onEditClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 8, vars: 13, consts: [[3, "title"], ["class", "badge-button delete", 3, "click", 4, "ngIf"], ["class", "badge-button edit", 3, "click", 4, "ngIf"], [1, "content", 3, "ngClass", "click"], ["class", "thumbnail-image", 4, "ngIf"], ["class", "thumbnail-icon", 4, "ngIf"], ["class", "thumbnail-title", 3, "title", 4, "ngIf"], ["class", "thumbnail-subtitle", 3, "title", 4, "ngIf"], [1, "badge-button", "delete", 3, "click"], ["type", "cancel"], [1, "badge-button", "edit", 3, "click"], ["type", "edit"], [1, "thumbnail-image"], ["alt", "Thumbnail Image", 1, "img-responsive", 3, "src"], [1, "thumbnail-icon"], [3, "type"], [1, "thumbnail-title", 3, "title"], [1, "thumbnail-subtitle", 3, "title"]], template: function AtomsThumbnailComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, AtomsThumbnailComponent_div_1_Template, 2, 0, "div", 1);
            i0.ɵɵtemplate(2, AtomsThumbnailComponent_div_2_Template, 2, 0, "div", 2);
            i0.ɵɵelementStart(3, "a", 3);
            i0.ɵɵlistener("click", function AtomsThumbnailComponent_Template_a_click_3_listener($event) { return ctx.onClickThumbnail($event); });
            i0.ɵɵtemplate(4, AtomsThumbnailComponent_div_4_Template, 2, 1, "div", 4);
            i0.ɵɵtemplate(5, AtomsThumbnailComponent_div_5_Template, 2, 1, "div", 5);
            i0.ɵɵtemplate(6, AtomsThumbnailComponent_div_6_Template, 2, 2, "div", 6);
            i0.ɵɵtemplate(7, AtomsThumbnailComponent_div_7_Template, 2, 2, "div", 7);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.thumbnailClass);
            i0.ɵɵproperty("title", ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.canDelete && !ctx.isDisabled);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.canEdit && !ctx.isDisabled);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c0$i, ctx.isActive, ctx.isDisabled));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.src);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.src);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.label);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !!ctx.description);
        } }, dependencies: [i1.NgClass, i1.NgIf, AtomsIconComponent], styles: [".bc-thumbnail.thumbnail-small .content .thumbnail-icon,.bc-thumbnail.thumbnail-small .content .thumbnail-image,.bc-thumbnail.thumbnail-small .content .thumbnail-icon img,.bc-thumbnail.thumbnail-small .content .thumbnail-image img{height:55px;width:55px}.bc-thumbnail.thumbnail-small .content .thumbnail-icon bc-atoms-icon,.bc-thumbnail.thumbnail-small .content .thumbnail-image bc-atoms-icon{font-size:30px}.bc-thumbnail.thumbnail-small .content .thumbnail-icon bc-atoms-icon .fa,.bc-thumbnail.thumbnail-small .content .thumbnail-image bc-atoms-icon .fa{line-height:55px}.bc-thumbnail.thumbnail-small .content .thumbnail-title,.bc-thumbnail.thumbnail-small .content .thumbnail-subtitle{font-size:smaller;letter-spacing:1px;max-width:55px}.bc-thumbnail.thumbnail-small .content .thumbnail-subtitle{display:none}.bc-thumbnail.thumbnail-small .badge-button{left:80px}.bc-thumbnail.thumbnail-small .badge-button:nth-child(2){left:50px}.bc-thumbnail .content{display:inline-block;background-color:#fff;border:solid 1px grey;text-decoration:none;padding:5px;margin:2.5px;border-radius:4px;cursor:pointer;text-align:center;line-height:1.42857143}.bc-thumbnail .content .thumbnail-icon,.bc-thumbnail .content .thumbnail-image{background:white;border:solid 1px lightgrey;border-radius:3px;height:120px;width:120px}.bc-thumbnail .content .thumbnail-icon img,.bc-thumbnail .content .thumbnail-image img{height:120px;width:120px}.bc-thumbnail .content .thumbnail-icon bc-atoms-icon,.bc-thumbnail .content .thumbnail-image bc-atoms-icon{font-size:90px;color:#6495ed}.bc-thumbnail .content .thumbnail-icon bc-atoms-icon .fa,.bc-thumbnail .content .thumbnail-image bc-atoms-icon .fa{line-height:120px}.bc-thumbnail .content .thumbnail-title{color:#212529;height:inherit}.bc-thumbnail .content .thumbnail-subtitle{color:#212529c4;font-size:smaller;font-family:monospace}.bc-thumbnail .content .thumbnail-title,.bc-thumbnail .content .thumbnail-subtitle{max-width:120px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.bc-thumbnail .content.disabled{cursor:default;opacity:.6}.bc-thumbnail .content.active,.bc-thumbnail .content:not(.disabled):hover{background-color:#add8e669}.bc-thumbnail .content.active .thumbnail-image img,.bc-thumbnail .content:not(.disabled):hover .thumbnail-image img{border:solid 1px grey}.bc-thumbnail .badge-button{position:absolute;padding:5px;height:25px;width:25px;border:solid 1px darkslategray;border-radius:50%;line-height:22px;text-align:center;cursor:pointer;top:5px;left:145px}.bc-thumbnail .badge-button.delete{background:red;color:#fff}.bc-thumbnail .badge-button.edit{background:lightsteelblue;color:#000}.bc-thumbnail .badge-button:nth-child(2){left:115px}.bc-thumbnail .badge-button:hover{background:grey}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsThumbnailComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-thumbnail', encapsulation: ViewEncapsulation.None, template: "<!--\n - Atoms thumbnail component (atoms-thumbnail.component.html).\n - Atom -> Thumbnail Component.\n -\n - @version\n - 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -->\n<div [class]=\"thumbnailClass\" [title]=\"title\">\n  <!--Delete-->\n  <div\n    class=\"badge-button delete\"\n    *ngIf=\"canDelete && !isDisabled\"\n    (click)=\"onClickDelete($event)\"\n  >\n    <bc-atoms-icon type=\"cancel\"></bc-atoms-icon>\n  </div>\n\n  <!--Edit-->\n  <div\n    class=\"badge-button edit\"\n    *ngIf=\"canEdit && !isDisabled\"\n    (click)=\"onClickEdit($event)\"\n  >\n    <bc-atoms-icon type=\"edit\"></bc-atoms-icon>\n  </div>\n\n  <!--Content-->\n  <a\n    class=\"content\"\n    [ngClass]=\"{ 'active':isActive, 'disabled': isDisabled }\"\n    (click)=\"onClickThumbnail($event)\"\n  >\n    <!--ui-sref=\"{{ sref ? sref : false }}\"-->\n\n    <!--Image-->\n    <div *ngIf=\"!!src\" class=\"thumbnail-image\">\n      <img class=\"img-responsive\" alt=\"Thumbnail Image\" [src]=\"src\" />\n    </div>\n\n    <!--Icon-->\n    <div *ngIf=\"!src\" class=\"thumbnail-icon\">\n      <bc-atoms-icon [type]=\"icon\"></bc-atoms-icon>\n    </div>\n\n    <!--Display Label-->\n    <div *ngIf=\"!!label\" class=\"thumbnail-title\" title=\"{{label}}\">\n      {{label}}\n    </div>\n\n    <!--Display Description-->\n    <div\n      *ngIf=\"!!description\"\n      class=\"thumbnail-subtitle\"\n      title=\"{{description}}\"\n    >\n      {{description}}\n    </div>\n  </a>\n</div>\n", styles: [".bc-thumbnail.thumbnail-small .content .thumbnail-icon,.bc-thumbnail.thumbnail-small .content .thumbnail-image,.bc-thumbnail.thumbnail-small .content .thumbnail-icon img,.bc-thumbnail.thumbnail-small .content .thumbnail-image img{height:55px;width:55px}.bc-thumbnail.thumbnail-small .content .thumbnail-icon bc-atoms-icon,.bc-thumbnail.thumbnail-small .content .thumbnail-image bc-atoms-icon{font-size:30px}.bc-thumbnail.thumbnail-small .content .thumbnail-icon bc-atoms-icon .fa,.bc-thumbnail.thumbnail-small .content .thumbnail-image bc-atoms-icon .fa{line-height:55px}.bc-thumbnail.thumbnail-small .content .thumbnail-title,.bc-thumbnail.thumbnail-small .content .thumbnail-subtitle{font-size:smaller;letter-spacing:1px;max-width:55px}.bc-thumbnail.thumbnail-small .content .thumbnail-subtitle{display:none}.bc-thumbnail.thumbnail-small .badge-button{left:80px}.bc-thumbnail.thumbnail-small .badge-button:nth-child(2){left:50px}.bc-thumbnail .content{display:inline-block;background-color:#fff;border:solid 1px grey;text-decoration:none;padding:5px;margin:2.5px;border-radius:4px;cursor:pointer;text-align:center;line-height:1.42857143}.bc-thumbnail .content .thumbnail-icon,.bc-thumbnail .content .thumbnail-image{background:white;border:solid 1px lightgrey;border-radius:3px;height:120px;width:120px}.bc-thumbnail .content .thumbnail-icon img,.bc-thumbnail .content .thumbnail-image img{height:120px;width:120px}.bc-thumbnail .content .thumbnail-icon bc-atoms-icon,.bc-thumbnail .content .thumbnail-image bc-atoms-icon{font-size:90px;color:#6495ed}.bc-thumbnail .content .thumbnail-icon bc-atoms-icon .fa,.bc-thumbnail .content .thumbnail-image bc-atoms-icon .fa{line-height:120px}.bc-thumbnail .content .thumbnail-title{color:#212529;height:inherit}.bc-thumbnail .content .thumbnail-subtitle{color:#212529c4;font-size:smaller;font-family:monospace}.bc-thumbnail .content .thumbnail-title,.bc-thumbnail .content .thumbnail-subtitle{max-width:120px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.bc-thumbnail .content.disabled{cursor:default;opacity:.6}.bc-thumbnail .content.active,.bc-thumbnail .content:not(.disabled):hover{background-color:#add8e669}.bc-thumbnail .content.active .thumbnail-image img,.bc-thumbnail .content:not(.disabled):hover .thumbnail-image img{border:solid 1px grey}.bc-thumbnail .badge-button{position:absolute;padding:5px;height:25px;width:25px;border:solid 1px darkslategray;border-radius:50%;line-height:22px;text-align:center;cursor:pointer;top:5px;left:145px}.bc-thumbnail .badge-button.delete{background:red;color:#fff}.bc-thumbnail .badge-button.edit{background:lightsteelblue;color:#000}.bc-thumbnail .badge-button:nth-child(2){left:115px}.bc-thumbnail .badge-button:hover{background:grey}\n"] }]
    }], null, { title: [{
            type: Input
        }], label: [{
            type: Input
        }], description: [{
            type: Input
        }], src: [{
            type: Input
        }], icon: [{
            type: Input
        }], size: [{
            type: Input
        }], isActive: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], canEdit: [{
            type: Input
        }], canDelete: [{
            type: Input
        }], onThumbnailClicked: [{
            type: Output
        }], onDeleteClicked: [{
            type: Output
        }], onEditClicked: [{
            type: Output
        }] }); })();

/**
 * Atoms -> Time Picker Component
 *
 * @version 3.7.0 LIBNGSG-127 Add timepicker component
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2023 Build Centrix
 */
function AtomsTimePickerComponent_label_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 4)(1, "bc-atoms-button", 5);
    i0.ɵɵlistener("onButtonClicked", function AtomsTimePickerComponent_label_5_Template_bc_atoms_button_onButtonClicked_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.clearTime()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("size", ctx_r1.size)("disabled", !ctx_r1.model);
} }
class AtomsTimePickerComponent {
    // ViewChild Picker
    picker;
    // Inputs
    id;
    name;
    size;
    title;
    hourStep = 1;
    minuteStep = 1;
    secondStep = 1;
    isDisabled = false;
    isMeridian = false;
    isSeconds = false;
    isSpinners = true;
    canClear = false;
    // Model & Event Emitter
    model = {
        hour: null,
        minute: null,
        second: null,
    };
    modelChange = new EventEmitter();
    // CSS Classes
    inputClass;
    inputGroupClass;
    // -------------------------------------- Lifecycle Hooks ----------------------------------------------------------
    /**
     * On Init
     */
    ngOnInit() {
        this.initClasses();
    }
    /**
     * On Changes
     */
    ngOnChanges(changes) {
        if (changes.hourStep?.currentValue) {
            this.hourStep = parseInt(changes.hourStep.currentValue.toString(), 10);
        }
        if (changes.minuteStep?.currentValue) {
            this.minuteStep = parseInt(changes.minuteStep.currentValue.toString(), 10);
        }
        if (changes.secondStep?.currentValue) {
            this.secondStep = parseInt(changes.secondStep.currentValue.toString(), 10);
        }
        this.initClasses();
    }
    // -------------------------------------- Basic Functions ----------------------------------------------------------
    /**
     * Clears the selected time
     */
    clearTime() {
        if (this.picker) {
            this.picker.updateHour(null);
            this.picker.updateMinute(null);
            this.picker.updateSecond(null);
        }
        this.model = null;
        // Update model value
        this.updateModelValue(this.model);
    }
    /**
     * Handles time change events and emits model update
     */
    timeChanged() {
        if (this.picker?.model) {
            if (isNaN(this.picker?.model.hour))
                this.picker.model.hour = 0;
            if (isNaN(this.picker?.model.minute))
                this.picker.model.minute = 0;
            if (isNaN(this.picker?.model.second))
                this.picker.model.second = 0;
            this.model = {
                hour: this.picker?.model.hour,
                minute: this.picker?.model.minute,
                second: this.picker?.model.second,
            };
        }
        // Update model value
        this.updateModelValue(this.model);
    }
    /**
     * Update modal time value
     */
    updateModelValue(value) {
        setTimeout(() => {
            this.onTouched();
            this.onChange(this.model);
            this.modelChange.emit(value);
        }, 0);
    }
    // -------------------------------------- ControlValueAccessor -----------------------------------------------------
    // ControlValueAccessor Callback onTouched
    onTouched;
    // ControlValueAccessor Callback onChange
    onChange;
    /**
     * Write value
     */
    writeValue(value) {
        this.model = value || { hour: null, minute: null, second: null };
    }
    /**
     * Register OnChange
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Register OnTouched
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Set Disabled State
     */
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    // -------------------------------------- Private Functions --------------------------------------------------------
    get sizeOptions() {
        return ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.INPUT, 'formControlSize');
    }
    /**
     * Initializes component CSS classes
     */
    initClasses() {
        const inputClasses = ['form-control no-prefix'];
        const inputGroupClasses = ['bc-time-picker input-group'];
        if (this.size && this.sizeOptions.includes(this.size)) {
            inputClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'formControlSize', this.size));
            inputGroupClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'inputGroupSize', this.size));
        }
        if (this.isDisabled) {
            inputGroupClasses.push('disabled');
        }
        this.inputClass = inputClasses.join(' ');
        this.inputGroupClass = inputGroupClasses.join(' ');
    }
    /** @nocollapse */ static ɵfac = function AtomsTimePickerComponent_Factory(t) { return new (t || AtomsTimePickerComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsTimePickerComponent, selectors: [["bc-atoms-time-picker"]], viewQuery: function AtomsTimePickerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(NgbTimepicker, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.picker = _t.first);
        } }, inputs: { id: "id", name: "name", size: "size", title: "title", hourStep: "hourStep", minuteStep: "minuteStep", secondStep: "secondStep", isDisabled: "isDisabled", isMeridian: "isMeridian", isSeconds: "isSeconds", isSpinners: "isSpinners", canClear: "canClear", model: "model" }, outputs: { modelChange: "modelChange" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => AtomsTimePickerComponent)),
                    multi: true,
                },
            ]), i0.ɵɵNgOnChangesFeature], decls: 6, vars: 15, consts: [[1, "d-flex", "align-items-center"], [3, "hourStep", "meridian", "minuteStep", "readonlyInputs", "seconds", "secondStep", "size", "spinners", "ngModel", "ngModelChange"], ["picker", "ngbTimepicker"], ["class", "ml-2", 4, "ngIf"], [1, "ml-2"], ["label", "clear time", "iconOnly", "true", "icon", "cancel", 3, "size", "disabled", "onButtonClicked"]], template: function AtomsTimePickerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "span")(1, "div", 0)(2, "label")(3, "ngb-timepicker", 1, 2);
            i0.ɵɵlistener("ngModelChange", function AtomsTimePickerComponent_Template_ngb_timepicker_ngModelChange_3_listener($event) { return ctx.model = $event; })("ngModelChange", function AtomsTimePickerComponent_Template_ngb_timepicker_ngModelChange_3_listener() { return ctx.timeChanged(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, AtomsTimePickerComponent_label_5_Template, 2, 2, "label", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵattribute("class", ctx.inputGroupClass)("title", ctx.title);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hourStep", ctx.hourStep)("meridian", ctx.isMeridian)("minuteStep", ctx.minuteStep)("readonlyInputs", ctx.isDisabled)("seconds", ctx.isSeconds)("secondStep", ctx.secondStep)("size", ctx.size)("spinners", ctx.isSpinners)("ngModel", ctx.model);
            i0.ɵɵattribute("id", ctx.id)("name", ctx.name)("disabled", ctx.isDisabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.canClear);
        } }, dependencies: [i1.NgIf, i2.NgControlStatus, i2.NgModel, i1$1.NgbTimepicker, AtomsButtonComponent], styles: [".bc-time-picker{cursor:pointer}.bc-time-picker.disabled{opacity:.6;pointer-events:none}.bc-time-picker ngb-timepicker input.form-control-lg{font-size:1.15rem}.bc-time-picker .ngb-tp-spacer{width:.6em}.bc-time-picker .visually-hidden{display:none}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsTimePickerComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-time-picker', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => AtomsTimePickerComponent)),
                        multi: true,
                    },
                ], encapsulation: ViewEncapsulation.None, template: "<!--\n - Atoms -> Time picker component HTML\n -\n - @version\n - 3.7.0 LIBNGSG-127 Add timepicker component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2023 Build Centrix\n -->\n<span [attr.class]=\"inputGroupClass\" [attr.title]=\"title\">\n  <div class=\"d-flex align-items-center\">\n    <label>\n      <ngb-timepicker\n        [attr.id]=\"id\"\n        [attr.name]=\"name\"\n        [hourStep]=\"hourStep\"\n        [meridian]=\"isMeridian\"\n        [minuteStep]=\"minuteStep\"\n        [readonlyInputs]=\"isDisabled\"\n        [attr.disabled]=\"isDisabled\"\n        [seconds]=\"isSeconds\"\n        [secondStep]=\"secondStep\"\n        [size]=\"size\"\n        [spinners]=\"isSpinners\"\n        [(ngModel)]=\"model\"\n        (ngModelChange)=\"timeChanged()\"\n        #picker=\"ngbTimepicker\"\n      >\n      </ngb-timepicker>\n    </label>\n    <label class=\"ml-2\" *ngIf=\"canClear\">\n      <bc-atoms-button\n        label=\"clear time\"\n        iconOnly=\"true\"\n        icon=\"cancel\"\n        [size]=\"size\"\n        (onButtonClicked)=\"clearTime()\"\n        [disabled]=\"!model\"\n      ></bc-atoms-button>\n    </label>\n  </div>\n</span>\n", styles: [".bc-time-picker{cursor:pointer}.bc-time-picker.disabled{opacity:.6;pointer-events:none}.bc-time-picker ngb-timepicker input.form-control-lg{font-size:1.15rem}.bc-time-picker .ngb-tp-spacer{width:.6em}.bc-time-picker .visually-hidden{display:none}\n"] }]
    }], null, { picker: [{
            type: ViewChild,
            args: [NgbTimepicker]
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], size: [{
            type: Input
        }], title: [{
            type: Input
        }], hourStep: [{
            type: Input
        }], minuteStep: [{
            type: Input
        }], secondStep: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], isMeridian: [{
            type: Input
        }], isSeconds: [{
            type: Input
        }], isSpinners: [{
            type: Input
        }], canClear: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }] }); })();

/**
 * Atoms typeahead component (atoms-typeahead.component.ts).
 * Atoms -> Typeahead Component
 *
 * @version
 * 3.14.0 LIBNGSG-149 Add callback when typeahead is cleared
 * 3.14.0 LIBNGSG-147 Add max input for text-area and typeahead components
 * 3.14.0 LIBNGSG-146 Add blur callback function for typeahead
 * 1.24.0 LIBNGSG-83 Typeahead model change event is getting triggered multiple times
 * 1.23.0 LIBNGSG-40 Investigate adding drop-downs and typeahead to reactive form validation
 * 1.22.0 LIBNGSG-77 Extend typeahead functionality to allow for API searching
 * 1.10.0 LIBNGSG-50 Typeahead doesn't search special characters
 * 1.6.0 LIBNGSG-33 Minor Issues found during QA testing
 * 1.3.0 LIBNGSG-8 Add branding images component
 * 1.2.0 LIBNGSG-19 Update typeahead component to be compatible with Angular forms
 * 1.1.0 LIBNGSG-15 Fix style guide integration issues
 * 1.1.0 LIBNGSG-14 Add typeahead component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
const _c0$h = ["typeaheadInstance"];
const _c1$d = ["resultTemplate"];
const _c2$8 = ["prefixContent"];
const _c3$5 = ["suffixContent"];
const _c4$2 = function (a0) { return { "input-group-append": a0 }; };
const _c5$1 = function (a0) { return { "input-group-text button": a0 }; };
function AtomsTypeaheadComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function AtomsTypeaheadComponent_span_12_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); ctx_r6.modelChange.emit(undefined); return i0.ɵɵresetView(ctx_r6.modelClear.emit(undefined)); });
    i0.ɵɵelementStart(1, "span", 0);
    i0.ɵɵelement(2, "bc-atoms-icon", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c4$2, ctx_r3.hasClearButton));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c5$1, ctx_r3.hasClearButton));
} }
function AtomsTypeaheadComponent_ng_template_13_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵelement(1, "img", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r8 = i0.ɵɵnextContext().result;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("alt", r_r8.image)("src", r_r8[ctx_r10.imageKey], i0.ɵɵsanitizeUrl);
} }
function AtomsTypeaheadComponent_ng_template_13_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵelement(1, "bc-atoms-icon", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r8 = i0.ɵɵnextContext().result;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", r_r8[ctx_r11.iconKey]);
} }
function AtomsTypeaheadComponent_ng_template_13_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "ngb-highlight", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    const r_r8 = ctx_r15.result;
    const t_r9 = ctx_r15.term;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("result", r_r8[ctx_r12.labelKey])("term", t_r9);
} }
function AtomsTypeaheadComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AtomsTypeaheadComponent_ng_template_13_span_0_Template, 2, 2, "span", 9);
    i0.ɵɵtemplate(1, AtomsTypeaheadComponent_ng_template_13_span_1_Template, 2, 1, "span", 9);
    i0.ɵɵtemplate(2, AtomsTypeaheadComponent_ng_template_13_span_2_Template, 2, 2, "span", 10);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.imageKey);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.iconKey);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.labelKey);
} }
const _c6$1 = [[["", "prefix-content", ""]], [["", "suffix-content", ""]]];
const _c7$1 = function (a0) { return { "input-group-prepend": a0 }; };
const _c8$1 = function (a0) { return { "input-group-text": a0 }; };
const _c9$1 = function () { return { standalone: true }; };
const _c10$1 = ["[prefix-content]", "[suffix-content]"];
class AtomsTypeaheadComponent {
    // Inputs
    id;
    name;
    title;
    placeholder;
    size;
    maxlength;
    // Options
    options;
    // Booleans
    required = false;
    canClear = false;
    disabled = false;
    editable = false;
    focusFirst = true;
    // Numbers
    maxResults = 10;
    // Object Keys
    labelKey = 'label';
    iconKey;
    imageKey;
    // Two Way Data Binding
    model;
    // Callback Functions
    modelChange = new EventEmitter();
    modelClear = new EventEmitter();
    modelBlur = new EventEmitter();
    searchChange = new EventEmitter();
    // Form control -> Used for make this component compatible with reactive forms
    // If pass formControl instance. Skip passing model when calling this component. Form control will override this.model
    formControl;
    // Elements
    typeaheadInstance;
    template;
    prefixContent;
    suffixContent;
    // Typeahead Options
    focus$ = new Subject();
    click$ = new Subject();
    // Validation
    sizeOptions = ComponentService.getComponentOptionsByKey(ComponentService.componentOptions.INPUT, 'formControlSize');
    // Classes
    inputGroupClass;
    inputClass;
    // Booleans
    hasPrefix = false;
    hasSuffix = false;
    hasClearButton = false;
    modelChangeSubscription;
    /**
     * Constructor
     *
     * @since 1.1.0
     */
    constructor(config) {
        // Init Classes
        this.initClasses();
        // Set Config
        config.focusFirst = this.focusFirst;
    }
    /**
     * Search Options
     *
     * @since 1.1.0
     * @param text$
     */
    search = (text$) => {
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.typeaheadInstance.isPopupOpen()));
        const inputFocus$ = this.focus$;
        return merge(debouncedText$, clicksWithClosedPopup$, inputFocus$).pipe(map((term) => {
            this.searchChange.emit(term); // Triggered when search term changes
            return this.options
                .filter((option) => {
                // Regex test escapes special characters for search
                return new RegExp(term.replace(/[!@#$%^&*()_+\-={};':"\\|,.<>/?]/g, '\\$&'), 'mi').test(option[this.labelKey]);
            })
                .slice(0, this.maxResults);
        }));
    };
    /**
     * Format Options
     *
     * @since 1.1.0
     * @param option
     */
    formatter = (option) => option[this.labelKey];
    /**
     * Initialize Classes
     * @since 1.1.0
     */
    initClasses() {
        // Set Input Classes
        const inputClasses = ['form-control'];
        const inputGroupClasses = ['bc-typeahead'];
        this.hasPrefix =
            this.prefixContent &&
                this.prefixContent.nativeElement &&
                this.prefixContent.nativeElement.children.length > 0;
        this.hasSuffix =
            this.suffixContent &&
                this.suffixContent.nativeElement &&
                this.suffixContent.nativeElement.children.length > 0;
        this.hasClearButton = this.canClear;
        // Has Prefix
        if (!this.hasPrefix) {
            inputClasses.push('no-prefix');
        }
        // Has Suffix
        if (!this.hasSuffix && !this.hasClearButton) {
            inputClasses.push('no-suffix');
        }
        // Is Input Group
        if (this.hasPrefix || this.hasSuffix || this.canClear) {
            inputGroupClasses.push('input-group');
        }
        // Size Option
        if (this.size && this.sizeOptions.includes(this.size)) {
            if (this.hasPrefix || this.hasSuffix || this.canClear) {
                inputGroupClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'inputGroupSize', this.size));
            }
            inputClasses.push(ComponentService.getComponentClassByKey(ComponentService.componentOptions.INPUT, 'formControlSize', this.size));
        }
        // Set Classes
        this.inputClass = inputClasses.join(' ');
        this.inputGroupClass = inputGroupClasses.join(' ');
    }
    /**
     * Watch for Changes
     */
    ngOnChanges() {
        // Init Classes
        this.initClasses();
        // Typeahead Configuration
        this.typeaheadInstance.focusFirst = this.focusFirst;
    }
    /**
     * On Click
     *
     * @since 1.1.0
     * @param $event
     */
    onClick($event) {
        this.click$.next($event.target.value);
    }
    /**
     * On Focus
     *
     * @since 1.1.0
     * @param $event
     */
    onFocus($event) {
        this.focus$.next($event.target.value);
    }
    /**
     * On Blur
     *
     * @since 3.14.0
     */
    onBlur() {
        if (!this.editable && !this.model) {
            this.model = null;
        }
        this.modelBlur.emit(this.model);
    }
    /*********************************************** Input Validation *************************************************/
    // Custom Validator Example
    validateFn = createForbiddenNameValidator('tom');
    onChangeFn;
    onTouchedFn;
    /**
     * Validate Input
     *
     * @since 1.2.0
     * @param c
     */
    validate(c) {
        return this.validateFn(c);
    }
    /**
     * On Touched
     * @since 1.6.0
     */
    onTouched() {
        if (this.onTouchedFn) {
            this.onTouchedFn(this.model);
        }
    }
    /**
     * Write Value
     *
     * @since 1.2.0
     * @param obj
     */
    writeValue(obj) {
        this.model = obj;
    }
    /**
     * Register Input as Changed
     *
     * @since 1.2.0
     * @param fn
     */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /**
     * Register Input as Touched
     *
     * @since 1.2.0
     * @param fn
     */
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    /**
     * Handles input changes for the form control instance
     * @since 1.24.0
     */
    formControlChangeHandler($event) {
        // Trigger model change event
        this.modelChange.emit($event);
        // Update subscriptions
        if (!this.modelChangeSubscription) {
            if (this.formControl) {
                this.triggerFormControlStateChanges(this.model);
                this.modelChangeSubscription = this.modelChange.subscribe((model) => {
                    this.triggerFormControlStateChanges(model);
                });
            }
        }
    }
    /**
     * Updates form control instance for reactive form usage
     *
     * @since 1.23.0
     */
    triggerFormControlStateChanges(value) {
        if (this.formControl) {
            this.formControl.setValue(value);
            this.formControl.markAsTouched();
            this.formControl.markAsDirty();
        }
    }
    /** @nocollapse */ static ɵfac = function AtomsTypeaheadComponent_Factory(t) { return new (t || AtomsTypeaheadComponent)(i0.ɵɵdirectiveInject(i1$1.NgbTypeaheadConfig)); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AtomsTypeaheadComponent, selectors: [["bc-atoms-typeahead"]], viewQuery: function AtomsTypeaheadComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$h, 7);
            i0.ɵɵviewQuery(_c1$d, 7);
            i0.ɵɵviewQuery(_c2$8, 7);
            i0.ɵɵviewQuery(_c3$5, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.typeaheadInstance = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixContent = _t.first);
        } }, inputs: { id: "id", name: "name", title: "title", placeholder: "placeholder", size: "size", maxlength: "maxlength", options: "options", required: "required", canClear: "canClear", disabled: "disabled", editable: "editable", focusFirst: "focusFirst", maxResults: "maxResults", labelKey: "labelKey", iconKey: "iconKey", imageKey: "imageKey", model: "model", formControl: "formControl" }, outputs: { modelChange: "modelChange", modelClear: "modelClear", modelBlur: "modelBlur", searchChange: "searchChange" }, features: [i0.ɵɵProvidersFeature([
                NgbTypeaheadConfig,
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => AtomsTypeaheadComponent)),
                    multi: true,
                },
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef((() => AtomsTypeaheadComponent)),
                    multi: true,
                },
            ]), i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c10$1, decls: 15, vars: 32, consts: [[3, "ngClass"], ["prefixContent", ""], ["type", "text", "container", "body", 3, "disabled", "editable", "required", "ngModel", "ngModelOptions", "ngbTypeahead", "resultTemplate", "inputFormatter", "ngModelChange", "focus", "click", "blur"], ["typeaheadInstance", "ngbTypeahead"], ["suffixContent", ""], [3, "ngClass", "click", 4, "ngIf"], ["resultTemplate", ""], [3, "ngClass", "click"], ["type", "clear"], ["class", "mr-2", 4, "ngIf"], [4, "ngIf"], [1, "mr-2"], [2, "width", "30px", 3, "alt", "src"], [3, "type"], [3, "result", "term"]], template: function AtomsTypeaheadComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c6$1);
            i0.ɵɵelementStart(0, "div")(1, "span", 0)(2, "span", 0, 1);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "label")(6, "input", 2, 3);
            i0.ɵɵlistener("ngModelChange", function AtomsTypeaheadComponent_Template_input_ngModelChange_6_listener($event) { return ctx.model = $event; })("ngModelChange", function AtomsTypeaheadComponent_Template_input_ngModelChange_6_listener($event) { return ctx.formControlChangeHandler($event); })("focus", function AtomsTypeaheadComponent_Template_input_focus_6_listener($event) { return ctx.onFocus($event); })("click", function AtomsTypeaheadComponent_Template_input_click_6_listener($event) { return ctx.onClick($event); })("blur", function AtomsTypeaheadComponent_Template_input_blur_6_listener() { ctx.onBlur(); return ctx.onTouched(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "span", 0)(9, "span", 0, 4);
            i0.ɵɵprojection(11, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, AtomsTypeaheadComponent_span_12_Template, 3, 6, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, AtomsTypeaheadComponent_ng_template_13_Template, 3, 3, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r4 = i0.ɵɵreference(14);
            i0.ɵɵclassMap(ctx.inputGroupClass);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c7$1, ctx.hasPrefix));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c8$1, ctx.hasPrefix));
            i0.ɵɵadvance(4);
            i0.ɵɵclassMap(ctx.inputClass);
            i0.ɵɵproperty("disabled", ctx.disabled)("editable", ctx.editable)("required", ctx.required)("ngModel", ctx.model)("ngModelOptions", i0.ɵɵpureFunction0(27, _c9$1))("ngbTypeahead", ctx.search)("resultTemplate", _r4)("inputFormatter", ctx.formatter);
            i0.ɵɵattribute("id", ctx.id)("name", ctx.name)("title", ctx.title)("placeholder", ctx.placeholder)("autocomplete", "off")("maxlength", ctx.maxlength);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c4$2, ctx.hasSuffix));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(30, _c8$1, ctx.hasSuffix));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.hasClearButton);
        } }, dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel, i1$1.NgbHighlight, i1$1.NgbTypeahead, AtomsIconComponent], styles: ["label[_ngcontent-%COMP%]{margin:0;display:contents!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border-radius:0}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input.no-prefix[_ngcontent-%COMP%]{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.input-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   input.no-suffix[_ngcontent-%COMP%]{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.input-group[_ngcontent-%COMP%]   span.input-group-append[_ngcontent-%COMP%]   .input-group-text.button[_ngcontent-%COMP%]{cursor:pointer}.input-group[_ngcontent-%COMP%]   span.input-group-append[_ngcontent-%COMP%]   .input-group-text.button[_ngcontent-%COMP%]:hover{color:#000;background:lightgray}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtomsTypeaheadComponent, [{
        type: Component,
        args: [{ selector: 'bc-atoms-typeahead', providers: [
                    NgbTypeaheadConfig,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => AtomsTypeaheadComponent)),
                        multi: true,
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((() => AtomsTypeaheadComponent)),
                        multi: true,
                    },
                ], template: "<!--\n - Atoms typeahead component (atoms-typeahead.component.html).\n - Atom -> Typeahead Component.\n -\n - @version\n - 3.14.0 LIBNGSG-149 Add callback when typeahead is cleared\n - 3.14.0 LIBNGSG-147 Add max input for text-area and typeahead components\n - 3.14.0 LIBNGSG-146 Add blur callback function for typeahead\n - 1.24.0 LIBNGSG-83 Typeahead model change event is getting triggered multiple times\n - 1.23.0 LIBNGSG-40 Investigate adding drop-downs and typeahead to reactive form validation\n - 1.6.0 LIBNGSG-33 Minor Issues found during QA testing\n - 1.2.0 LIBNGSG-19 Update typeahead component to be compatible with Angular forms\n - 1.1.0 LIBNGSG-15 Fix style guide integration issues\n - 1.1.0 LIBNGSG-14 Add typeahead component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @author Erik Orozco <eorozco@intersog.com>\n - @copyright (c) 2021-2024 Build Centrix\n -->\n<div [class]=\"inputGroupClass\">\n  <span [ngClass]=\"{ 'input-group-prepend': hasPrefix }\">\n    <span #prefixContent [ngClass]=\"{ 'input-group-text': hasPrefix }\">\n      <ng-content select=\"[prefix-content]\"></ng-content>\n    </span>\n  </span>\n  <label>\n    <input\n      [attr.id]=\"id\"\n      [attr.name]=\"name\"\n      [attr.title]=\"title\"\n      [attr.placeholder]=\"placeholder\"\n      [attr.autocomplete]=\"'off'\"\n      [attr.maxlength]=\"maxlength\"\n      [class]=\"inputClass\"\n      [disabled]=\"disabled\"\n      [editable]=\"editable\"\n      [required]=\"required\"\n      [(ngModel)]=\"model\"\n      (ngModelChange)=\"formControlChangeHandler($event);\"\n      [ngModelOptions]=\"{ standalone: true }\"\n      [ngbTypeahead]=\"search\"\n      [resultTemplate]=\"resultTemplate\"\n      [inputFormatter]=\"formatter\"\n      (focus)=\"onFocus($event)\"\n      (click)=\"onClick($event)\"\n      (blur)=\"onBlur(); onTouched()\"\n      type=\"text\"\n      container=\"body\"\n      #typeaheadInstance=\"ngbTypeahead\"\n    />\n  </label>\n  <span [ngClass]=\"{ 'input-group-append': hasSuffix }\">\n    <span #suffixContent [ngClass]=\"{ 'input-group-text': hasSuffix }\">\n      <ng-content select=\"[suffix-content]\"></ng-content>\n    </span>\n  </span>\n  <span\n    [ngClass]=\"{ 'input-group-append': hasClearButton }\"\n    *ngIf=\"hasClearButton\"\n    (click)=\"modelChange.emit(undefined); modelClear.emit(undefined);\"\n  >\n    <span [ngClass]=\"{ 'input-group-text button': hasClearButton }\">\n      <bc-atoms-icon type=\"clear\"></bc-atoms-icon>\n    </span>\n  </span>\n</div>\n\n<!--Output Template-->\n<ng-template #resultTemplate let-r=\"result\" let-t=\"term\">\n  <span *ngIf=\"imageKey\" class=\"mr-2\">\n    <img [alt]=\"r.image\" [src]=\"r[imageKey]\" style=\"width: 30px;\" />\n  </span>\n  <span *ngIf=\"iconKey\" class=\"mr-2\">\n    <bc-atoms-icon [type]=\"r[iconKey]\"></bc-atoms-icon>\n  </span>\n  <span *ngIf=\"labelKey\">\n    <ngb-highlight [result]=\"r[labelKey]\" [term]=\"t\"></ngb-highlight>\n  </span>\n</ng-template>\n", styles: ["label{margin:0;display:contents!important}.input-group label{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0;display:block!important}.input-group label input{border-radius:0}.input-group label input.no-prefix{border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.input-group label input.no-suffix{border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}.input-group span.input-group-append .input-group-text.button{cursor:pointer}.input-group span.input-group-append .input-group-text.button:hover{color:#000;background:lightgray}\n"] }]
    }], function () { return [{ type: i1$1.NgbTypeaheadConfig }]; }, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], title: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], size: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], options: [{
            type: Input
        }], required: [{
            type: Input
        }], canClear: [{
            type: Input
        }], disabled: [{
            type: Input
        }], editable: [{
            type: Input
        }], focusFirst: [{
            type: Input
        }], maxResults: [{
            type: Input
        }], labelKey: [{
            type: Input
        }], iconKey: [{
            type: Input
        }], imageKey: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], modelClear: [{
            type: Output
        }], modelBlur: [{
            type: Output
        }], searchChange: [{
            type: Output
        }], formControl: [{
            type: Input
        }], typeaheadInstance: [{
            type: ViewChild,
            args: ['typeaheadInstance', { static: true }]
        }], template: [{
            type: ViewChild,
            args: ['resultTemplate', { static: true }]
        }], prefixContent: [{
            type: ViewChild,
            args: ['prefixContent', { static: true }]
        }], suffixContent: [{
            type: ViewChild,
            args: ['suffixContent', { static: true }]
        }] }); })();

/**
 * Must match directive (must-match.directive.ts).
 * Inputs Must Match Custom Input Validators.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.1.0 LIBNGSG-17 Template driven input form validation
 *
 */
/**
 * Inputs Must Match Validator
 * @since 1.1.0
 */
class MustMatchValidatorDirective {
    mustMatch = [];
    validate(formGroup) {
        return MustMatch(this.mustMatch[0], this.mustMatch[1], this.mustMatch[2])(formGroup);
    }
    /** @nocollapse */ static ɵfac = function MustMatchValidatorDirective_Factory(t) { return new (t || MustMatchValidatorDirective)(); };
    /** @nocollapse */ static ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: MustMatchValidatorDirective, selectors: [["", "mustMatch", ""]], inputs: { mustMatch: "mustMatch" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALIDATORS,
                    useExisting: MustMatchValidatorDirective,
                    multi: true,
                },
            ])] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MustMatchValidatorDirective, [{
        type: Directive,
        args: [{
                selector: '[mustMatch]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: MustMatchValidatorDirective,
                        multi: true,
                    },
                ],
            }]
    }], null, { mustMatch: [{
            type: Input
        }] }); })();
/**
 * Must Match Validator
 *
 * @since 1.1.0
 * @param controlLabel
 * @param controlName
 * @param matchingControlName
 */
function MustMatch(controlLabel, controlName, matchingControlName) {
    return (formGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        // return null if controls haven't initialised yet
        if (!control || !matchingControl) {
            return null;
        }
        // return null if another validator has already found an error on the matchingControl
        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            return null;
        }
        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({
                mustMatch: {
                    label: controlLabel,
                    control: controlName,
                    matchingControl: matchingControlName,
                },
            });
        }
        else {
            matchingControl.setErrors(null);
        }
    };
}

/**
 * Number range directive (number-range.directive.ts).
 *
 * @version
 * 1.8.0 LIBNGSG-41 Add number range validation for inputs
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
/**
 * Input Cannot Match Validator
 * @since 1.8.0
 */
class NumberRangeValidatorDirective {
    params;
    validate(control) {
        if (control && control.value) {
            const val = control.value ? Number(control.value) : null;
            const min = this.params.min ? Number(this.params.min) : null;
            const max = this.params.max ? Number(this.params.max) : null;
            if (val) {
                const minInput = this.params.min;
                const maxInput = this.params.max;
                if (!isNaN(minInput) && !isNaN(maxInput)) {
                    // Check within valid range
                    let result = null;
                    if (val < min) {
                        result = { minRange: true, value: minInput };
                    }
                    if (val > max) {
                        result = { maxRange: true, value: maxInput };
                    }
                    return result;
                }
                else if (!isNaN(minInput)) {
                    // Check value is bigger than minimum
                    return val < min ? { minRange: true, value: minInput } : null;
                }
                else if (!isNaN(maxInput)) {
                    // Check value is smaller than maximum
                    return val > max ? { maxRange: true, value: maxInput } : null;
                }
                else {
                    return null;
                }
            }
        }
    }
    /** @nocollapse */ static ɵfac = function NumberRangeValidatorDirective_Factory(t) { return new (t || NumberRangeValidatorDirective)(); };
    /** @nocollapse */ static ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: NumberRangeValidatorDirective, selectors: [["", "validateNumberRange", ""]], inputs: { params: ["validateNumberRange", "params"] }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALIDATORS,
                    useExisting: NumberRangeValidatorDirective,
                    multi: true,
                },
            ])] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumberRangeValidatorDirective, [{
        type: Directive,
        args: [{
                selector: '[validateNumberRange]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: NumberRangeValidatorDirective,
                        multi: true,
                    },
                ],
            }]
    }], null, { params: [{
            type: Input,
            args: ['validateNumberRange']
        }] }); })();

/**
 * Atoms module (components.module.ts).
 * Atoms Module.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
class BcAtomsModule {
    /** @nocollapse */ static ɵfac = function BcAtomsModule_Factory(t) { return new (t || BcAtomsModule)(); };
    /** @nocollapse */ static ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: BcAtomsModule });
    /** @nocollapse */ static ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            NgbModule,
            // Temp Reactive + Template Driven Forms Fix - https://stackoverflow.com/a/49918631
            ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
            TranslateModule, TranslateModule] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BcAtomsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    NgbModule,
                    // Temp Reactive + Template Driven Forms Fix - https://stackoverflow.com/a/49918631
                    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
                    TranslateModule,
                ],
                exports: [
                    AtomsBrandedInfoComponent,
                    AtomsBrandingComponent,
                    AtomsButtonComponent,
                    AtomsButtonGroupComponent,
                    AtomsChartComponent,
                    AtomsCheckboxComponent,
                    AtomsCheckboxGroupComponent,
                    AtomsCustomInputFieldComponent,
                    AtomsDatePickerComponent,
                    AtomsDropdownComponent,
                    AtomsIconComponent,
                    AtomsInputComponent,
                    AtomsInputGroupComponent,
                    AtomsLoaderComponent,
                    AtomsTextAreaComponent,
                    AtomsThumbnailComponent,
                    AtomsTimePickerComponent,
                    AtomsTypeaheadComponent,
                    ForbiddenValidatorDirective,
                    MustMatchValidatorDirective,
                    NumberRangeValidatorDirective,
                    TranslateModule,
                ],
                declarations: [
                    AtomsBrandedInfoComponent,
                    AtomsBrandingComponent,
                    AtomsButtonComponent,
                    AtomsButtonGroupComponent,
                    AtomsChartComponent,
                    AtomsCheckboxComponent,
                    AtomsCheckboxGroupComponent,
                    AtomsCustomInputFieldComponent,
                    AtomsDatePickerComponent,
                    AtomsDropdownComponent,
                    AtomsIconComponent,
                    AtomsInputComponent,
                    AtomsInputGroupComponent,
                    AtomsLoaderComponent,
                    AtomsTextAreaComponent,
                    AtomsThumbnailComponent,
                    AtomsTimePickerComponent,
                    AtomsTypeaheadComponent,
                    ForbiddenValidatorDirective,
                    NumberRangeValidatorDirective,
                    MustMatchValidatorDirective,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BcAtomsModule, { declarations: [AtomsBrandedInfoComponent,
        AtomsBrandingComponent,
        AtomsButtonComponent,
        AtomsButtonGroupComponent,
        AtomsChartComponent,
        AtomsCheckboxComponent,
        AtomsCheckboxGroupComponent,
        AtomsCustomInputFieldComponent,
        AtomsDatePickerComponent,
        AtomsDropdownComponent,
        AtomsIconComponent,
        AtomsInputComponent,
        AtomsInputGroupComponent,
        AtomsLoaderComponent,
        AtomsTextAreaComponent,
        AtomsThumbnailComponent,
        AtomsTimePickerComponent,
        AtomsTypeaheadComponent,
        ForbiddenValidatorDirective,
        NumberRangeValidatorDirective,
        MustMatchValidatorDirective], imports: [CommonModule,
        FormsModule,
        NgbModule, i2.ReactiveFormsModule, TranslateModule], exports: [AtomsBrandedInfoComponent,
        AtomsBrandingComponent,
        AtomsButtonComponent,
        AtomsButtonGroupComponent,
        AtomsChartComponent,
        AtomsCheckboxComponent,
        AtomsCheckboxGroupComponent,
        AtomsCustomInputFieldComponent,
        AtomsDatePickerComponent,
        AtomsDropdownComponent,
        AtomsIconComponent,
        AtomsInputComponent,
        AtomsInputGroupComponent,
        AtomsLoaderComponent,
        AtomsTextAreaComponent,
        AtomsThumbnailComponent,
        AtomsTimePickerComponent,
        AtomsTypeaheadComponent,
        ForbiddenValidatorDirective,
        MustMatchValidatorDirective,
        NumberRangeValidatorDirective,
        TranslateModule] }); })();

/**
 * Molecules multiselect dropdown component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */
function MoleculesMultiSelectDropdownComponent_ng_template_2_bc_atoms_checkbox_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bc-atoms-checkbox", 6);
    i0.ɵɵlistener("modelChange", function MoleculesMultiSelectDropdownComponent_ng_template_2_bc_atoms_checkbox_0_Template_bc_atoms_checkbox_modelChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const item$_r4 = i0.ɵɵnextContext().item$; return i0.ɵɵresetView(item$_r4.selected = $event); });
    i0.ɵɵpipe(1, "uppercase");
    i0.ɵɵpipe(2, "uppercase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const index_r5 = ctx_r11.index;
    const item_r3 = ctx_r11.item;
    const item$_r4 = ctx_r11.item$;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "item-", index_r5, "-category");
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, item_r3[ctx_r6.groupBy]))("title", i0.ɵɵpipeBind1(2, 6, item_r3[ctx_r6.groupBy]))("model", item$_r4.selected);
} }
function MoleculesMultiSelectDropdownComponent_ng_template_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "uppercase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().item;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, item_r3[ctx_r7.groupBy]));
} }
function MoleculesMultiSelectDropdownComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MoleculesMultiSelectDropdownComponent_ng_template_2_bc_atoms_checkbox_0_Template, 3, 8, "bc-atoms-checkbox", 4);
    i0.ɵɵtemplate(1, MoleculesMultiSelectDropdownComponent_ng_template_2_span_1_Template, 3, 3, "span", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isSelectableGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isSelectableGroup);
} }
function MoleculesMultiSelectDropdownComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bc-atoms-checkbox", 6);
    i0.ɵɵlistener("modelChange", function MoleculesMultiSelectDropdownComponent_ng_template_3_Template_bc_atoms_checkbox_modelChange_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r17); const item$_r14 = restoredCtx.item$; return i0.ɵɵresetView(item$_r14.selected = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.item;
    const item$_r14 = ctx.item$;
    const index_r15 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "item-", index_r15, "");
    i0.ɵɵproperty("label", item_r13[ctx_r1.labelKey])("title", item_r13[ctx_r1.labelKey])("model", item$_r14.selected);
} }
function MoleculesMultiSelectDropdownComponent_ng_template_4_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵlistener("click", function MoleculesMultiSelectDropdownComponent_ng_template_4_div_0_div_1_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r25); const item_r23 = restoredCtx.$implicit; const clear_r19 = i0.ɵɵnextContext(2).clear; return i0.ɵɵresetView(clear_r19(item_r23)); });
    i0.ɵɵtext(4, "\u00D7");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r23 = ctx.$implicit;
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r23[ctx_r22.labelKey]);
} }
function MoleculesMultiSelectDropdownComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, MoleculesMultiSelectDropdownComponent_ng_template_4_div_0_div_1_Template, 5, 1, "div", 10);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const items_r18 = i0.ɵɵnextContext().items;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 1, items_r18, 0, ctx_r20.maxDisplayedItems));
} }
function MoleculesMultiSelectDropdownComponent_ng_template_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 11)(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 13);
    i0.ɵɵlistener("click", function MoleculesMultiSelectDropdownComponent_ng_template_4_div_1_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r28.clearAll()); });
    i0.ɵɵtext(5, "\u00D7");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", ctx_r21.model == null ? null : ctx_r21.model.length, " ", ctx_r21.selectedItemsText, "");
} }
function MoleculesMultiSelectDropdownComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MoleculesMultiSelectDropdownComponent_ng_template_4_div_0_Template, 3, 5, "div", 7);
    i0.ɵɵtemplate(1, MoleculesMultiSelectDropdownComponent_ng_template_4_div_1_Template, 6, 2, "div", 8);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", (ctx_r2.model == null ? null : ctx_r2.model.length) <= ctx_r2.maxDisplayedItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r2.model == null ? null : ctx_r2.model.length) > ctx_r2.maxDisplayedItems);
} }
class MoleculesMultiSelectDropdownComponent {
    // Inputs - Strings - Basic
    id;
    name;
    title;
    placeholder;
    labelKey; // Object property to use for label. Default is label
    valueKey; // Object property to use for selected model; binds to whole object by default.
    notFoundText = 'No Options Found';
    loadingText = 'Loading...';
    groupBy;
    selectedItemsText = 'Selected Items';
    // Inputs - Strings - Options
    size = 'default'; // Options: (smallest/small/default/large)
    // Inputs - Numbers - Basic
    maxSelectedItems;
    maxDisplayedItems = 5;
    // Inputs - Booleans - Basic
    isDisabled = false;
    isLoading = false;
    isSearchable = true;
    isCloseOnSelect = false;
    isSelectableGroup = false;
    isClearable = true;
    isClearOnBackspace = true;
    // Inputs - Model / Options
    options = [];
    model = [];
    modelChange = new EventEmitter(); // Event for two-way binding
    // Outputs - Callback Functions
    onBlur = new EventEmitter();
    onChange = new EventEmitter();
    onClose = new EventEmitter();
    onFocus = new EventEmitter();
    onOpen = new EventEmitter();
    onSearch = new EventEmitter();
    // Defaults
    dropdownPosition = 'auto';
    isMultiple = true;
    // Strings
    hoverTitle;
    /**
     * Clear all selected items
     */
    clearAll() {
        this.onSelectionChange([]);
    }
    /**
     * On Changes
     */
    ngOnInit() {
        this.hoverTitle = this.title;
    }
    /**
     * Handles input changes for the form control instance
     * and emits the model change event.
     */
    onSelectionChange(selected) {
        this.model = selected;
        this.modelChange.emit(this.model);
        this.onChange.emit(this.model);
        this.hoverTitle = this.getHoverTitle();
        if (this.onChangeFn) {
            this.onChangeFn(this.model);
        }
    }
    /**
     * Get hover title
     */
    getHoverTitle() {
        if (!this.model || this.model.length === 0) {
            return this.title;
        }
        const selectedOptions = this.options
            .filter((option) => this.model.includes(this.valueKey ? option[this.valueKey] : option))
            .map((option) => this.labelKey ? option[this.labelKey] : JSON.stringify(option));
        return `${this.title}\n\n${selectedOptions.join('\n')}`;
    }
    /*********************************************** Input Validation *************************************************/
    onChangeFn;
    onTouchedFn;
    /**
     * On Touched
     */
    onTouched() {
        if (this.onTouchedFn) {
            this.onTouchedFn(this.model);
        }
    }
    /**
     * Validate Input
     */
    validate() {
        return null;
    }
    /**
     * Write Value
     */
    writeValue(obj) {
        this.model = obj || [];
    }
    /**
     * Register Input as Changed
     */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /**
     * Register Input as Touched
     */
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    /** @nocollapse */ static ɵfac = function MoleculesMultiSelectDropdownComponent_Factory(t) { return new (t || MoleculesMultiSelectDropdownComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MoleculesMultiSelectDropdownComponent, selectors: [["bc-molecules-multi-select-dropdown"]], inputs: { id: "id", name: "name", title: "title", placeholder: "placeholder", labelKey: "labelKey", valueKey: "valueKey", notFoundText: "notFoundText", loadingText: "loadingText", groupBy: "groupBy", selectedItemsText: "selectedItemsText", size: "size", maxSelectedItems: "maxSelectedItems", maxDisplayedItems: "maxDisplayedItems", isDisabled: "isDisabled", isLoading: "isLoading", isSearchable: "isSearchable", isCloseOnSelect: "isCloseOnSelect", isSelectableGroup: "isSelectableGroup", isClearable: "isClearable", isClearOnBackspace: "isClearOnBackspace", options: "options", model: "model" }, outputs: { modelChange: "modelChange", onBlur: "onBlur", onChange: "onChange", onClose: "onClose", onFocus: "onFocus", onOpen: "onOpen", onSearch: "onSearch" }, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef((() => MoleculesMultiSelectDropdownComponent)),
                    multi: true,
                },
                {
                    provide: NG_VALIDATORS,
                    useExisting: forwardRef((() => MoleculesMultiSelectDropdownComponent)),
                    multi: true,
                },
            ])], decls: 5, vars: 26, consts: [["appendTo", "body", 3, "name", "placeholder", "bindLabel", "bindValue", "notFoundText", "maxSelectedItems", "disabled", "loading", "multiple", "searchable", "clearSearchOnAdd", "closeOnSelect", "selectableGroup", "selectableGroupAsModel", "clearable", "clearOnBackspace", "items", "ngModel", "groupBy", "virtualScroll", "bufferAmount", "ngModelChange", "focus", "blur", "open", "close", "search"], ["ng-optgroup-tmp", ""], ["ng-option-tmp", ""], ["ng-multi-label-tmp", ""], [3, "id", "label", "title", "model", "modelChange", 4, "ngIf"], [4, "ngIf"], [3, "id", "label", "title", "model", "modelChange"], ["class", "ng-values-list", 4, "ngIf"], ["class", "ng-summary-list", 4, "ngIf"], [1, "ng-values-list"], ["class", "ng-value", 4, "ngFor", "ngForOf"], [1, "ng-value"], [1, "ng-value-label"], [1, "ng-value-icon", "right", 3, "click"], [1, "ng-summary-list"]], template: function MoleculesMultiSelectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "ng-select", 0);
            i0.ɵɵlistener("ngModelChange", function MoleculesMultiSelectDropdownComponent_Template_ng_select_ngModelChange_1_listener($event) { return ctx.model = $event; })("ngModelChange", function MoleculesMultiSelectDropdownComponent_Template_ng_select_ngModelChange_1_listener($event) { return ctx.onSelectionChange($event); })("focus", function MoleculesMultiSelectDropdownComponent_Template_ng_select_focus_1_listener($event) { return ctx.onFocus.emit($event); })("blur", function MoleculesMultiSelectDropdownComponent_Template_ng_select_blur_1_listener($event) { return ctx.onBlur.emit($event); })("open", function MoleculesMultiSelectDropdownComponent_Template_ng_select_open_1_listener() { return ctx.onOpen.emit(); })("close", function MoleculesMultiSelectDropdownComponent_Template_ng_select_close_1_listener() { return ctx.onClose.emit(); })("search", function MoleculesMultiSelectDropdownComponent_Template_ng_select_search_1_listener($event) { return ctx.onSearch.emit($event); });
            i0.ɵɵtemplate(2, MoleculesMultiSelectDropdownComponent_ng_template_2_Template, 2, 2, "ng-template", 1);
            i0.ɵɵtemplate(3, MoleculesMultiSelectDropdownComponent_ng_template_3_Template, 1, 4, "ng-template", 2);
            i0.ɵɵtemplate(4, MoleculesMultiSelectDropdownComponent_ng_template_4_Template, 2, 2, "ng-template", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("bc-multi-select-dropdown ", ctx.size ? "ms-" + ctx.size : "", "");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("name", ctx.name)("placeholder", ctx.isLoading ? ctx.loadingText : ctx.placeholder)("bindLabel", ctx.labelKey)("bindValue", ctx.valueKey)("notFoundText", ctx.notFoundText)("maxSelectedItems", ctx.maxSelectedItems)("disabled", ctx.isDisabled || ctx.isLoading)("loading", ctx.isLoading)("multiple", ctx.isMultiple)("searchable", ctx.isSearchable)("clearSearchOnAdd", true)("closeOnSelect", ctx.isCloseOnSelect)("selectableGroup", ctx.isSelectableGroup)("selectableGroupAsModel", false)("clearable", ctx.isClearable)("clearOnBackspace", ctx.isClearOnBackspace)("items", ctx.options)("ngModel", ctx.model)("groupBy", ctx.groupBy)("virtualScroll", true)("bufferAmount", 15);
            i0.ɵɵattribute("id", ctx.id)("title", ctx.hoverTitle);
        } }, dependencies: [AtomsCheckboxComponent, i1.NgForOf, i1.NgIf, i3.NgSelectComponent, i3.NgOptgroupTemplateDirective, i3.NgOptionTemplateDirective, i3.NgMultiLabelTemplateDirective, i2.NgControlStatus, i2.NgModel, i1.UpperCasePipe, i1.SlicePipe], styles: [".bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container{height:30.75px;min-height:30.75px}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-top:4px;padding-left:5px;flex-wrap:nowrap;white-space:nowrap;overflow:hidden}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:unset!important;padding-bottom:3px!important}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{border:solid 1px lightgrey;letter-spacing:1px;display:inline-block}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper{text-align:center}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper .ng-clear,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper .ng-arrow,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper .ng-clear,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper .ng-arrow{vertical-align:middle}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper .ng-arrow,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper .ng-arrow{top:1px;left:3px;border-color:darkslategrey transparent transparent;border-style:solid;border-width:4px 4px 3px}.bc-multi-select-dropdown .ng-select.ng-select-opened .ng-select-container .ng-arrow-wrapper .ng-arrow{top:-1px;left:3px;border-color:transparent transparent darkslategrey;border-width:0 4px 4px}.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container{height:26px;min-height:26px}.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value,.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{font-size:.875em;line-height:1.3em}.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper,.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper{line-height:unset}.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container{height:38px;min-height:38px}.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value,.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{font-size:1.1em}.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper,.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper{line-height:normal}.ng-dropdown-panel{width:auto!important}.ng-dropdown-panel.ng-select-bottom{border-top-right-radius:4px}.ng-dropdown-panel.ng-select-top{border-bottom-right-radius:4px}\n"], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MoleculesMultiSelectDropdownComponent, [{
        type: Component,
        args: [{ selector: 'bc-molecules-multi-select-dropdown', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((() => MoleculesMultiSelectDropdownComponent)),
                        multi: true,
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((() => MoleculesMultiSelectDropdownComponent)),
                        multi: true,
                    },
                ], template: "<!--\n - Molecules multi-select dropdown component HTML\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2025 Build Centrix\n -->\n<div class=\"bc-multi-select-dropdown {{ size? 'ms-' + size : '' }}\">\n  <ng-select\n    appendTo=\"body\"\n    [attr.id]=\"id\"\n    [attr.title]=\"hoverTitle\"\n    [name]=\"name\"\n    [placeholder]=\"isLoading ? loadingText : placeholder\"\n    [bindLabel]=\"labelKey\"\n    [bindValue]=\"valueKey\"\n    [notFoundText]=\"notFoundText\"\n    [maxSelectedItems]=\"maxSelectedItems\"\n    [disabled]=\"isDisabled || isLoading\"\n    [loading]=\"isLoading\"\n    [multiple]=\"isMultiple\"\n    [searchable]=\"isSearchable\"\n    [clearSearchOnAdd]=\"true\"\n    [closeOnSelect]=\"isCloseOnSelect\"\n    [selectableGroup]=\"isSelectableGroup\"\n    [selectableGroupAsModel]=\"false\"\n    [clearable]=\"isClearable\"\n    [clearOnBackspace]=\"isClearOnBackspace\"\n    [items]=\"options\"\n    [(ngModel)]=\"model\"\n    (ngModelChange)=\"onSelectionChange($event)\"\n    [groupBy]=\"groupBy\"\n    [virtualScroll]=\"true\"\n    [bufferAmount]=\"15\"\n    (focus)=\"onFocus.emit($event)\"\n    (blur)=\"onBlur.emit($event)\"\n    (open)=\"onOpen.emit()\"\n    (close)=\"onClose.emit()\"\n    (search)=\"onSearch.emit($event)\"\n  >\n    <!--Grouped Entries-->\n    <ng-template\n      ng-optgroup-tmp\n      let-item=\"item\"\n      let-item$=\"item$\"\n      let-index=\"index\"\n    >\n      <!--Grouped Option-->\n      <bc-atoms-checkbox\n        *ngIf=\"isSelectableGroup\"\n        id=\"item-{{ index }}-category\"\n        [label]=\"item[groupBy]| uppercase\"\n        [title]=\"item[groupBy]| uppercase\"\n        [(model)]=\"item$.selected\"\n      ></bc-atoms-checkbox>\n      <!--Non-grouped Option-->\n      <span *ngIf=\"!isSelectableGroup\">{{item[groupBy]| uppercase}}</span>\n    </ng-template>\n    <!--Ungrouped Entries-->\n    <ng-template\n      ng-option-tmp\n      let-item=\"item\"\n      let-item$=\"item$\"\n      let-index=\"index\"\n    >\n      <bc-atoms-checkbox\n        id=\"item-{{ index }}\"\n        [label]=\"item[labelKey]\"\n        [title]=\"item[labelKey]\"\n        [(model)]=\"item$.selected\"\n      ></bc-atoms-checkbox>\n    </ng-template>\n    <!--Displayed Item Template-->\n    <ng-template ng-multi-label-tmp let-items=\"items\" let-clear=\"clear\">\n      <div *ngIf=\"model?.length <= maxDisplayedItems\" class=\"ng-values-list\">\n        <div\n          class=\"ng-value\"\n          *ngFor=\"let item of items | slice:0:maxDisplayedItems\"\n        >\n          <span class=\"ng-value-label\">{{item[labelKey]}}</span>\n          <span class=\"ng-value-icon right\" (click)=\"clear(item)\">\u00D7</span>\n        </div>\n      </div>\n      <div *ngIf=\"model?.length > maxDisplayedItems\" class=\"ng-summary-list\">\n        <div class=\"ng-value\">\n          <span class=\"ng-value-label\"\n            >{{ model?.length }} {{ selectedItemsText }}</span\n          >\n          <span class=\"ng-value-icon right\" (click)=\"clearAll()\">\u00D7</span>\n        </div>\n      </div>\n    </ng-template>\n  </ng-select>\n</div>\n", styles: [".bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container{height:30.75px;min-height:30.75px}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-top:4px;padding-left:5px;flex-wrap:nowrap;white-space:nowrap;overflow:hidden}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:unset!important;padding-bottom:3px!important}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{border:solid 1px lightgrey;letter-spacing:1px;display:inline-block}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper{text-align:center}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper .ng-clear,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper .ng-arrow,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper .ng-clear,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper .ng-arrow{vertical-align:middle}.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper .ng-arrow,.bc-multi-select-dropdown .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper .ng-arrow{top:1px;left:3px;border-color:darkslategrey transparent transparent;border-style:solid;border-width:4px 4px 3px}.bc-multi-select-dropdown .ng-select.ng-select-opened .ng-select-container .ng-arrow-wrapper .ng-arrow{top:-1px;left:3px;border-color:transparent transparent darkslategrey;border-width:0 4px 4px}.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container{height:26px;min-height:26px}.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value,.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{font-size:.875em;line-height:1.3em}.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper,.bc-multi-select-dropdown.ms-small .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper{line-height:unset}.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container{height:38px;min-height:38px}.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value,.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{font-size:1.1em}.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-clear-wrapper,.bc-multi-select-dropdown.ms-large .ng-select.ng-select-multiple .ng-select-container .ng-arrow-wrapper{line-height:normal}.ng-dropdown-panel{width:auto!important}.ng-dropdown-panel.ng-select-bottom{border-top-right-radius:4px}.ng-dropdown-panel.ng-select-top{border-bottom-right-radius:4px}\n"] }]
    }], null, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], title: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], labelKey: [{
            type: Input
        }], valueKey: [{
            type: Input
        }], notFoundText: [{
            type: Input
        }], loadingText: [{
            type: Input
        }], groupBy: [{
            type: Input
        }], selectedItemsText: [{
            type: Input
        }], size: [{
            type: Input
        }], maxSelectedItems: [{
            type: Input
        }], maxDisplayedItems: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], isSearchable: [{
            type: Input
        }], isCloseOnSelect: [{
            type: Input
        }], isSelectableGroup: [{
            type: Input
        }], isClearable: [{
            type: Input
        }], isClearOnBackspace: [{
            type: Input
        }], options: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], onChange: [{
            type: Output
        }], onClose: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onOpen: [{
            type: Output
        }], onSearch: [{
            type: Output
        }] }); })();

/**
 * custom-input-field.component.ts
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
function MoleculesNotificationsFormComponent_tr_30_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "li");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td")(5, "bc-atoms-button", 12);
    i0.ɵɵlistener("onButtonClicked", function MoleculesNotificationsFormComponent_tr_30_Template_bc_atoms_button_onButtonClicked_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const i_r3 = restoredCtx.index; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.deleteNotifications(ctx_r4.EOrderNotificationsType.USERS, i_r3)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const user_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(user_r2[ctx_r0.userKey]);
} }
function MoleculesNotificationsFormComponent_tr_31_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "li");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td")(5, "bc-atoms-button", 12);
    i0.ɵɵlistener("onButtonClicked", function MoleculesNotificationsFormComponent_tr_31_Template_bc_atoms_button_onButtonClicked_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const i_r7 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.deleteNotifications(ctx_r8.EOrderNotificationsType.EMAILS, i_r7)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const email_r6 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(email_r6);
} }
class MoleculesNotificationsFormComponent {
    controlContainer;
    translate;
    EOrderNotificationsType = EOrderNotificationsType;
    limit = 5;
    formGroupName;
    // Array options
    usersOptions;
    // Booleans
    isDisabled = false;
    // User Settings
    userKey = 'fullName';
    // Two Way Data Binding
    userModel = {};
    emailModel = '';
    get form() {
        return this.controlContainer.control.get(this.formGroupName);
    }
    totalNotificationsNum = 0;
    MAX_EMAIL_LENGTH = 255;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(controlContainer, translate) {
        this.controlContainer = controlContainer;
        this.translate = translate;
    }
    /**
     * On add notifications event handler
     */
    addNotifications(key, item) {
        const formControl = this.form.get(key);
        const notificationsList = formControl?.value ?? [];
        if (item) {
            if (notificationsList.includes(item)) {
                // Case where the item is already in the list
                this.handleDuplicateNotifications(key, formControl);
            }
            else if (key === EOrderNotificationsType.EMAILS &&
                !this.validateEmail(item)) {
                // Case where the email given is invalid
                this.handleInvalidEmail(formControl);
            }
            else {
                // add the item to the notifications form group
                notificationsList.push(item);
                formControl?.setValue(notificationsList);
                // increment the total notifications count
                this.totalNotificationsNum++;
                // clear the input boxes
                this.clearInputBox(key);
            }
        }
        else {
            // clear the input boxes
            if (key === EOrderNotificationsType.EMAILS) {
                this.clearInputBox(key);
            }
            formControl.updateValueAndValidity();
        }
    }
    /**
     * On Delete notifications event handler
     */
    deleteNotifications(key, index) {
        const formControl = this.form.get(key);
        const notificationsList = formControl?.value ?? [];
        // remove the item from the form group
        notificationsList.splice(index, 1);
        formControl?.setValue(notificationsList);
        // decrement the total notifications count
        this.totalNotificationsNum--;
    }
    /**
     * Check if the email is valid
     */
    validateEmail(email) {
        return String(email)
            .toLowerCase()
            .match(/^\S+@\S+\.\S+$/);
    }
    /**
     * Event handler when an item already exists in the notificationFormGroup
     */
    handleDuplicateNotifications(key, formControl) {
        // Show an error if the item is already in the list
        // Tailor the error message depending on the notification type
        let errorMessage = '';
        switch (key) {
            case EOrderNotificationsType.EMAILS:
                errorMessage = this.translate.instant('components.molecules.notificationsForm.email.notUnique');
                break;
            case EOrderNotificationsType.USERS:
                errorMessage = this.translate.instant('components.molecules.notificationsForm.user.notUnique');
                break;
        }
        formControl.setErrors(errorMessage);
        formControl.markAsDirty();
    }
    /**
     * Event handler for invalid emails
     */
    handleInvalidEmail(formControl) {
        // Show an error if the input email is not valid
        formControl.setErrors({ email: true, pattern: true });
        formControl.markAsDirty();
    }
    /**
     * Clear the input box for the given type
     */
    clearInputBox(key) {
        switch (key) {
            case EOrderNotificationsType.EMAILS:
                this.emailModel = '';
                break;
            case EOrderNotificationsType.USERS:
                this.userModel = {};
                break;
        }
    }
    /** @nocollapse */ static ɵfac = function MoleculesNotificationsFormComponent_Factory(t) { return new (t || MoleculesNotificationsFormComponent)(i0.ɵɵdirectiveInject(i2.ControlContainer), i0.ɵɵdirectiveInject(i2$1.TranslateService)); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MoleculesNotificationsFormComponent, selectors: [["bc-molecules-notifications-form"]], inputs: { limit: "limit", formGroupName: "formGroupName", usersOptions: "usersOptions", isDisabled: "isDisabled", userModel: "userModel", emailModel: "emailModel" }, features: [i0.ɵɵProvidersFeature([], [
                { provide: ControlContainer, useExisting: FormGroupDirective },
            ])], decls: 32, vars: 48, consts: [["id", "notifications", 1, "notifications-form", "card-body"], [1, "notifications-subtitle"], [1, "row"], [1, "col-6"], ["labelIcon", "user", 3, "labelTitle", "labelDescription", "state", "stateInput", "stateTrigger"], ["id", "notificationsFormUser", "size", "small", 3, "title", "placeholder", "labelKey", "disabled", "options", "model", "modelChange"], ["labelIcon", "email", 3, "labelTitle", "labelDescription", "state", "stateInput", "stateTrigger"], ["id", "notificationsFormEmail", "size", "small", "autofocus", "true", 3, "title", "placeholder", "maxlength", "disabled", "model", "modelChange", "modelBlur", "keydown.enter"], [1, "table"], [1, "notifications-table-column"], ["labelIcon", "allUsers", 1, "table-title", 3, "labelTitle", "labelDescription"], [4, "ngFor", "ngForOf"], ["icon", "delete", "display", "block", "type", "outlineDanger", "size", "small", 3, "onButtonClicked"]], template: function MoleculesNotificationsFormComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 2)(6, "div", 3)(7, "bc-atoms-input-group", 4);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementStart(10, "bc-atoms-typeahead", 5);
            i0.ɵɵlistener("modelChange", function MoleculesNotificationsFormComponent_Template_bc_atoms_typeahead_modelChange_10_listener($event) { return ctx.userModel = $event; })("modelChange", function MoleculesNotificationsFormComponent_Template_bc_atoms_typeahead_modelChange_10_listener($event) { return ctx.addNotifications(ctx.EOrderNotificationsType.USERS, $event); });
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "bc-atoms-input-group", 6);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementStart(16, "bc-atoms-input", 7);
            i0.ɵɵlistener("modelChange", function MoleculesNotificationsFormComponent_Template_bc_atoms_input_modelChange_16_listener($event) { return ctx.emailModel = $event; })("modelBlur", function MoleculesNotificationsFormComponent_Template_bc_atoms_input_modelBlur_16_listener($event) { return ctx.addNotifications(ctx.EOrderNotificationsType.EMAILS, $event.target.value); })("keydown.enter", function MoleculesNotificationsFormComponent_Template_bc_atoms_input_keydown_enter_16_listener($event) { return $event.target.blur(); });
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "div", 3)(20, "table", 8)(21, "thead")(22, "tr")(23, "th", 9);
            i0.ɵɵelement(24, "bc-atoms-input-group", 10);
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "th", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "tbody")(29, "ol");
            i0.ɵɵtemplate(30, MoleculesNotificationsFormComponent_tr_30_Template, 6, 1, "tr", 11);
            i0.ɵɵtemplate(31, MoleculesNotificationsFormComponent_tr_31_Template, 6, 1, "tr", 11);
            i0.ɵɵelementEnd()()()()()();
        } if (rf & 2) {
            let tmp_3_0;
            let tmp_4_0;
            let tmp_5_0;
            let tmp_14_0;
            let tmp_15_0;
            let tmp_16_0;
            let tmp_24_0;
            let tmp_25_0;
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 26, "components.molecules.notificationsForm.subtitle"));
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("labelTitle", i0.ɵɵpipeBind1(8, 28, "components.molecules.notificationsForm.user.title"));
            i0.ɵɵpropertyInterpolate("labelDescription", i0.ɵɵpipeBind1(9, 30, "components.molecules.notificationsForm.user.description"));
            i0.ɵɵproperty("state", (tmp_3_0 = ctx.form.get(ctx.EOrderNotificationsType.USERS)) == null ? null : tmp_3_0.status)("stateInput", (tmp_4_0 = ctx.form.get(ctx.EOrderNotificationsType.USERS)) == null ? null : tmp_4_0.errors)("stateTrigger", ((tmp_5_0 = ctx.form.get(ctx.EOrderNotificationsType.USERS)) == null ? null : tmp_5_0.invalid) && ((tmp_5_0 = ctx.form.get(ctx.EOrderNotificationsType.USERS)) == null ? null : tmp_5_0.dirty));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(11, 32, "components.molecules.notificationsForm.user.placeholder"));
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(12, 34, "components.molecules.notificationsForm.user.placeholder"));
            i0.ɵɵpropertyInterpolate("labelKey", ctx.userKey);
            i0.ɵɵproperty("disabled", !(ctx.usersOptions == null ? null : ctx.usersOptions.length) || ctx.isDisabled || ctx.totalNotificationsNum >= ctx.limit)("options", ctx.usersOptions)("model", ctx.userModel);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("labelTitle", i0.ɵɵpipeBind1(14, 36, "components.molecules.notificationsForm.email.title"));
            i0.ɵɵpropertyInterpolate("labelDescription", i0.ɵɵpipeBind1(15, 38, "components.molecules.notificationsForm.email.description"));
            i0.ɵɵproperty("state", (tmp_14_0 = ctx.form.get(ctx.EOrderNotificationsType.EMAILS)) == null ? null : tmp_14_0.status)("stateInput", (tmp_15_0 = ctx.form.get(ctx.EOrderNotificationsType.EMAILS)) == null ? null : tmp_15_0.errors)("stateTrigger", ((tmp_16_0 = ctx.form.get(ctx.EOrderNotificationsType.EMAILS)) == null ? null : tmp_16_0.invalid) && ((tmp_16_0 = ctx.form.get(ctx.EOrderNotificationsType.EMAILS)) == null ? null : tmp_16_0.dirty));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(17, 40, "components.molecules.notificationsForm.email.placeholder"));
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 42, "components.molecules.notificationsForm.email.placeholder"));
            i0.ɵɵpropertyInterpolate("maxlength", ctx.MAX_EMAIL_LENGTH);
            i0.ɵɵproperty("disabled", ctx.isDisabled || ctx.totalNotificationsNum >= ctx.limit)("model", ctx.emailModel);
            i0.ɵɵadvance(8);
            i0.ɵɵpropertyInterpolate("labelTitle", i0.ɵɵpipeBind1(25, 44, "components.molecules.notificationsForm.recipients.title"));
            i0.ɵɵpropertyInterpolate("labelDescription", i0.ɵɵpipeBind1(26, 46, "components.molecules.notificationsForm.recipients.description"));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngForOf", (tmp_24_0 = ctx.form.get(ctx.EOrderNotificationsType.USERS)) == null ? null : tmp_24_0.value);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", (tmp_25_0 = ctx.form.get(ctx.EOrderNotificationsType.EMAILS)) == null ? null : tmp_25_0.value);
        } }, dependencies: [AtomsButtonComponent, AtomsInputComponent, AtomsInputGroupComponent, AtomsTypeaheadComponent, i1.NgForOf, i2$1.TranslatePipe], styles: [".notifications-form bc-atoms-input-group .bc-input-group-label{font-weight:700}.notifications-form .notifications-table-column{padding:0!important;border-bottom-width:0}.notifications-form .notifications-table-column bc-atoms-input-group .bc-input-group{margin-bottom:0!important}.notifications-form .notifications-table-column bc-atoms-input-group .bc-form-group{margin-bottom:0!important}.notifications-form .bc-form-group{margin-bottom:0}.notifications-form table th{border-top:0!important;border-bottom-width:0!important}.notifications-form table td{max-width:5em;width:100%;vertical-align:middle!important}.notifications-form table ol{padding:0}.notifications-form table li{word-wrap:break-word}.notifications-form .notifications-subtitle{color:#696969;letter-spacing:1px;font-size:10px;margin:0 0 20px}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MoleculesNotificationsFormComponent, [{
        type: Component,
        args: [{ selector: 'bc-molecules-notifications-form', encapsulation: ViewEncapsulation.None, viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ], template: "<!--\n - Molecules notifications form component\n -\n - @@author Jenny Lam <jlam@buildcentrix.com>\n - @copyright (c) 2024 Build Centrix\n -->\n<div id=\"notifications\" class=\"notifications-form card-body\">\n  <div class=\"notifications-subtitle\">\n    <span\n      >{{'components.molecules.notificationsForm.subtitle' | translate}}</span\n    >\n  </div>\n  <div class=\"row\">\n    <!--Typeahead to select users-->\n    <div class=\"col-6\">\n      <bc-atoms-input-group\n        labelIcon=\"user\"\n        labelTitle=\"{{'components.molecules.notificationsForm.user.title' | translate}}\"\n        labelDescription=\"{{'components.molecules.notificationsForm.user.description' | translate}}\"\n        [state]=\"form.get(EOrderNotificationsType.USERS)?.status\"\n        [stateInput]=\"form.get(EOrderNotificationsType.USERS)?.errors\"\n        [stateTrigger]=\"form.get(EOrderNotificationsType.USERS)?.invalid && (form.get(EOrderNotificationsType.USERS)?.dirty)\"\n      >\n        <bc-atoms-typeahead\n          id=\"notificationsFormUser\"\n          title=\"{{'components.molecules.notificationsForm.user.placeholder' | translate}}\"\n          placeholder=\"{{'components.molecules.notificationsForm.user.placeholder' | translate}}\"\n          size=\"small\"\n          labelKey=\"{{userKey}}\"\n          [disabled]=\"(!usersOptions?.length || isDisabled || totalNotificationsNum >= limit)\"\n          [options]=\"usersOptions\"\n          [(model)]=\"userModel\"\n          (modelChange)=\"addNotifications(EOrderNotificationsType.USERS, $event)\"\n        >\n        </bc-atoms-typeahead>\n      </bc-atoms-input-group>\n\n      <!--Input box to type emails-->\n      <bc-atoms-input-group\n        labelIcon=\"email\"\n        labelTitle=\"{{'components.molecules.notificationsForm.email.title' | translate}}\"\n        labelDescription=\"{{'components.molecules.notificationsForm.email.description' | translate}}\"\n        [state]=\"form.get(EOrderNotificationsType.EMAILS)?.status\"\n        [stateInput]=\"form.get(EOrderNotificationsType.EMAILS)?.errors\"\n        [stateTrigger]=\"form.get(EOrderNotificationsType.EMAILS)?.invalid && (form.get(EOrderNotificationsType.EMAILS)?.dirty)\"\n      >\n        <bc-atoms-input\n          id=\"notificationsFormEmail\"\n          title=\"{{'components.molecules.notificationsForm.email.placeholder' | translate}}\"\n          placeholder=\"{{'components.molecules.notificationsForm.email.placeholder' | translate}}\"\n          size=\"small\"\n          autofocus=\"true\"\n          maxlength=\"{{MAX_EMAIL_LENGTH}}\"\n          [disabled]=\"isDisabled || totalNotificationsNum >= limit\"\n          [(model)]=\"emailModel\"\n          (modelBlur)=\"addNotifications(EOrderNotificationsType.EMAILS, $event.target.value)\"\n          (keydown.enter)=\"$event.target.blur()\"\n        >\n        </bc-atoms-input>\n      </bc-atoms-input-group>\n    </div>\n\n    <!--Table to list the users/emails to send order notification emails-->\n    <div class=\"col-6\">\n      <table class=\"table\">\n        <thead>\n          <tr>\n            <th class=\"notifications-table-column\">\n              <bc-atoms-input-group\n                class=\"table-title\"\n                labelIcon=\"allUsers\"\n                labelTitle=\"{{'components.molecules.notificationsForm.recipients.title' | translate}}\"\n                labelDescription=\"{{'components.molecules.notificationsForm.recipients.description' | translate}}\"\n              >\n              </bc-atoms-input-group>\n            </th>\n            <th class=\"notifications-table-column\"></th>\n          </tr>\n        </thead>\n        <tbody>\n          <ol>\n            <tr\n              *ngFor=\"let user of form.get(EOrderNotificationsType.USERS)?.value; let i = index\"\n            >\n              <td>\n                <li>{{user[userKey]}}</li>\n              </td>\n\n              <td>\n                <bc-atoms-button\n                  icon=\"delete\"\n                  display=\"block\"\n                  type=\"outlineDanger\"\n                  size=\"small\"\n                  (onButtonClicked)=\"deleteNotifications(EOrderNotificationsType.USERS, i)\"\n                >\n                </bc-atoms-button>\n              </td>\n            </tr>\n\n            <tr\n              *ngFor=\"let email of form.get(EOrderNotificationsType.EMAILS)?.value; let i = index\"\n            >\n              <td><li>{{email}}</li></td>\n\n              <td>\n                <bc-atoms-button\n                  icon=\"delete\"\n                  display=\"block\"\n                  type=\"outlineDanger\"\n                  size=\"small\"\n                  (onButtonClicked)=\"deleteNotifications(EOrderNotificationsType.EMAILS, i)\"\n                >\n                </bc-atoms-button>\n              </td>\n            </tr>\n          </ol>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n", styles: [".notifications-form bc-atoms-input-group .bc-input-group-label{font-weight:700}.notifications-form .notifications-table-column{padding:0!important;border-bottom-width:0}.notifications-form .notifications-table-column bc-atoms-input-group .bc-input-group{margin-bottom:0!important}.notifications-form .notifications-table-column bc-atoms-input-group .bc-form-group{margin-bottom:0!important}.notifications-form .bc-form-group{margin-bottom:0}.notifications-form table th{border-top:0!important;border-bottom-width:0!important}.notifications-form table td{max-width:5em;width:100%;vertical-align:middle!important}.notifications-form table ol{padding:0}.notifications-form table li{word-wrap:break-word}.notifications-form .notifications-subtitle{color:#696969;letter-spacing:1px;font-size:10px;margin:0 0 20px}\n"] }]
    }], function () { return [{ type: i2.ControlContainer }, { type: i2$1.TranslateService }]; }, { limit: [{
            type: Input
        }], formGroupName: [{
            type: Input
        }], usersOptions: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], userModel: [{
            type: Input
        }], emailModel: [{
            type: Input
        }] }); })();
var EOrderNotificationsType;
(function (EOrderNotificationsType) {
    EOrderNotificationsType["EMAILS"] = "emails";
    EOrderNotificationsType["USERS"] = "users";
})(EOrderNotificationsType || (EOrderNotificationsType = {}));

/**
 * Molecules sidebar item component (molecules-sidebar-item.component.ts).
 * Molecules -> Sidebar Item Component
 *
 * @version
 * 1.16.0 LIBNGSG-63 Add routerLinkActiveOptions to sidebar items
 * 1.4.0 LIBNGSG-24 Add header sidebar layout components
 * 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components
 * 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library
 * 1.0.0 LIBNGSG-1 Add basic component library code to repository
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
const _c0$g = function (a0) { return { "active-override": a0 }; };
function MoleculesSidebarItemComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵelement(1, "bc-atoms-icon", 5);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r0.href, i0.ɵɵsanitizeUrl)("target", ctx_r0.target)("routerLinkActive", ctx_r0.linkActive)("ngClass", i0.ɵɵpureFunction1(9, _c0$g, ctx_r0.isActive))("title", ctx_r0.title || ctx_r0.label)("routerLinkActiveOptions", ctx_r0.linkActiveOptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r0.type)("title", ctx_r0.title || ctx_r0.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.label);
} }
function MoleculesSidebarItemComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵelement(1, "bc-atoms-icon", 5);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r1.link)("routerLinkActive", ctx_r1.linkActive)("ngClass", i0.ɵɵpureFunction1(8, _c0$g, ctx_r1.isActive))("title", ctx_r1.title || ctx_r1.label)("routerLinkActiveOptions", ctx_r1.linkActiveOptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r1.type)("title", ctx_r1.title || ctx_r1.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.label);
} }
const _c1$c = function (a0, a1) { return { "active-override": a0, collapsed: a1 }; };
function MoleculesSidebarItemComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵelement(1, "bc-atoms-icon", 5);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r2.href, i0.ɵɵsanitizeUrl)("target", ctx_r2.target)("routerLinkActive", ctx_r2.linkActive)("ngClass", i0.ɵɵpureFunction2(10, _c1$c, ctx_r2.isActive, !ctx_r2.isExpanded))("title", ctx_r2.title || ctx_r2.label)("routerLinkActiveOptions", ctx_r2.linkActiveOptions);
    i0.ɵɵattribute("aria-expanded", ctx_r2.isExpanded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r2.type)("title", ctx_r2.title || ctx_r2.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.label);
} }
function MoleculesSidebarItemComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵelement(1, "bc-atoms-icon", 5);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r3.link)("routerLinkActive", ctx_r3.linkActive)("ngClass", i0.ɵɵpureFunction2(9, _c1$c, ctx_r3.isActive, !ctx_r3.isExpanded))("title", ctx_r3.label)("routerLinkActiveOptions", ctx_r3.linkActiveOptions);
    i0.ɵɵattribute("aria-expanded", ctx_r3.isExpanded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r3.type)("title", ctx_r3.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.label);
} }
class MoleculesSidebarItemComponent {
    href = null;
    link = null;
    linkActive = 'active';
    linkActiveOptions = { exact: false };
    target = '_self';
    type = null;
    label = null;
    title = null;
    // Booleans
    isActive = false; // Overrides and sets link to active
    isExpanded = false; // Overrides and sets dropdown to expanded
    dropdown = false;
    /** @nocollapse */ static ɵfac = function MoleculesSidebarItemComponent_Factory(t) { return new (t || MoleculesSidebarItemComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MoleculesSidebarItemComponent, selectors: [["bc-molecules-sidebar-item"]], inputs: { href: "href", link: "link", linkActive: "linkActive", linkActiveOptions: "linkActiveOptions", target: "target", type: "type", label: "label", title: "title", isActive: "isActive", isExpanded: "isExpanded", dropdown: "dropdown" }, decls: 4, vars: 4, consts: [["class", "list-group-item d-inline-block collapsed", 3, "href", "target", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions", 4, "ngIf"], ["class", "list-group-item d-inline-block collapsed", 3, "routerLink", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions", 4, "ngIf"], ["data-toggle", "collapse", "class", "list-group-item d-inline-block collapsed", 3, "href", "target", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions", 4, "ngIf"], ["data-toggle", "collapse", "class", "list-group-item d-inline-block collapsed", 3, "routerLink", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions", 4, "ngIf"], [1, "list-group-item", "d-inline-block", "collapsed", 3, "href", "target", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions"], [3, "type", "title"], [1, "item-label"], [1, "list-group-item", "d-inline-block", "collapsed", 3, "routerLink", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions"], ["data-toggle", "collapse", 1, "list-group-item", "d-inline-block", "collapsed", 3, "href", "target", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions"], ["data-toggle", "collapse", 1, "list-group-item", "d-inline-block", "collapsed", 3, "routerLink", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions"]], template: function MoleculesSidebarItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, MoleculesSidebarItemComponent_a_0_Template, 4, 11, "a", 0);
            i0.ɵɵtemplate(1, MoleculesSidebarItemComponent_a_1_Template, 4, 10, "a", 1);
            i0.ɵɵtemplate(2, MoleculesSidebarItemComponent_a_2_Template, 4, 13, "a", 2);
            i0.ɵɵtemplate(3, MoleculesSidebarItemComponent_a_3_Template, 4, 12, "a", 3);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.dropdown && ctx.href);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.dropdown && ctx.link);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.dropdown && ctx.href);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.dropdown && ctx.link);
        } }, dependencies: [AtomsIconComponent, i1.NgClass, i1.NgIf, i2$2.RouterLink, i2$2.RouterLinkActive], styles: [".list-group-item[_ngcontent-%COMP%]{width:100%;background-color:#333;color:#ccc;white-space:nowrap;letter-spacing:1px;border-radius:0;border-left:0;border-right:0;border-color:#2c2c2c;border-top:none;overflow:hidden;text-overflow:ellipsis;float:left}.list-group-item.active[_ngcontent-%COMP%], .list-group-item.active-override[_ngcontent-%COMP%]{background-color:#222;border-color:#222}.list-group-item[_ngcontent-%COMP%]:hover{text-decoration:none;color:#fff}.list-group-item[aria-expanded=false][_ngcontent-%COMP%]:after{content:\" \\f0da\";font-family:FontAwesome,monospace;display:inline;text-align:right;padding-left:5px;float:right}.list-group-item[aria-expanded=true][_ngcontent-%COMP%]:after{content:\" \\f0d7\";font-family:FontAwesome,monospace;display:inline;text-align:right;padding-left:5px;float:right}@media (max-width: 768px){.list-group-item[_ngcontent-%COMP%]{text-align:center;font-size:20px;float:none}.list-group-item[_ngcontent-%COMP%]   .item-label[_ngcontent-%COMP%]{display:none}.list-group-item[aria-expanded=true][_ngcontent-%COMP%]:after, .list-group-item[aria-expanded=false][_ngcontent-%COMP%]:after{display:none}}"], changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MoleculesSidebarItemComponent, [{
        type: Component,
        args: [{ selector: 'bc-molecules-sidebar-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Molecules sidebar item component (molecules-sidebar-item.component.html).\n - Molecule -> Sidebar Item Component.\n -\n - @version\n - 1.16.0 LIBNGSG-63 Add routerLinkActiveOptions to sidebar items\n - 1.10.0 LIBNGSG-46 Add a toggle button to the side bar\n - 1.4.0 LIBNGSG-24 Add header sidebar layout components\n - 1.1.0 LIBNGSG-12 Add date-picker component\n - 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components\n - 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library\n - 1.0.0 LIBNGSG-1 Add basic component library code to repository\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -->\n<!--Standard Link-->\n<!--HREF-->\n<a\n  *ngIf=\"!dropdown && href\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [routerLinkActive]=\"linkActive\"\n  [ngClass]=\"{ 'active-override': isActive }\"\n  class=\"list-group-item d-inline-block collapsed\"\n  [title]=\"title || label\"\n  [routerLinkActiveOptions]=\"linkActiveOptions\"\n>\n  <bc-atoms-icon [type]=\"type\" [title]=\"title || label\"></bc-atoms-icon>\n  <span class=\"item-label\">{{label}}</span>\n</a>\n\n<!--Router Link-->\n<a\n  *ngIf=\"!dropdown && link\"\n  [routerLink]=\"link\"\n  [routerLinkActive]=\"linkActive\"\n  [ngClass]=\"{ 'active-override': isActive }\"\n  class=\"list-group-item d-inline-block collapsed\"\n  [title]=\"title || label\"\n  [routerLinkActiveOptions]=\"linkActiveOptions\"\n>\n  <bc-atoms-icon [type]=\"type\" [title]=\"title || label\"></bc-atoms-icon>\n  <span class=\"item-label\">{{label}}</span>\n</a>\n\n<!--Dropdown-->\n<!--HREF-->\n<a\n  *ngIf=\"dropdown && href\"\n  [href]=\"href\"\n  [target]=\"target\"\n  [routerLinkActive]=\"linkActive\"\n  [ngClass]=\"{ 'active-override': isActive, collapsed: !isExpanded }\"\n  data-toggle=\"collapse\"\n  [attr.aria-expanded]=\"isExpanded\"\n  class=\"list-group-item d-inline-block collapsed\"\n  [title]=\"title || label\"\n  [routerLinkActiveOptions]=\"linkActiveOptions\"\n>\n  <bc-atoms-icon [type]=\"type\" [title]=\"title || label\"></bc-atoms-icon>\n  <span class=\"item-label\">{{label}}</span>\n</a>\n\n<!--Router Link-->\n<a\n  *ngIf=\"dropdown && link\"\n  [routerLink]=\"link\"\n  [routerLinkActive]=\"linkActive\"\n  [ngClass]=\"{ 'active-override': isActive, collapsed: !isExpanded }\"\n  data-toggle=\"collapse\"\n  [attr.aria-expanded]=\"isExpanded\"\n  class=\"list-group-item d-inline-block collapsed\"\n  [title]=\"label\"\n  [routerLinkActiveOptions]=\"linkActiveOptions\"\n>\n  <bc-atoms-icon [type]=\"type\" [title]=\"label\"></bc-atoms-icon>\n  <span class=\"item-label\">{{label}}</span>\n</a>\n", styles: [".list-group-item{width:100%;background-color:#333;color:#ccc;white-space:nowrap;letter-spacing:1px;border-radius:0;border-left:0;border-right:0;border-color:#2c2c2c;border-top:none;overflow:hidden;text-overflow:ellipsis;float:left}.list-group-item.active,.list-group-item.active-override{background-color:#222;border-color:#222}.list-group-item:hover{text-decoration:none;color:#fff}.list-group-item[aria-expanded=false]:after{content:\" \\f0da\";font-family:FontAwesome,monospace;display:inline;text-align:right;padding-left:5px;float:right}.list-group-item[aria-expanded=true]:after{content:\" \\f0d7\";font-family:FontAwesome,monospace;display:inline;text-align:right;padding-left:5px;float:right}@media (max-width: 768px){.list-group-item{text-align:center;font-size:20px;float:none}.list-group-item .item-label{display:none}.list-group-item[aria-expanded=true]:after,.list-group-item[aria-expanded=false]:after{display:none}}\n"] }]
    }], null, { href: [{
            type: Input
        }], link: [{
            type: Input
        }], linkActive: [{
            type: Input
        }], linkActiveOptions: [{
            type: Input
        }], target: [{
            type: Input
        }], type: [{
            type: Input
        }], label: [{
            type: Input
        }], title: [{
            type: Input
        }], isActive: [{
            type: Input
        }], isExpanded: [{
            type: Input
        }], dropdown: [{
            type: Input
        }] }); })();

/**
 * Molecules sidebar dropdown component (molecules-sidebar-dropdown.component.ts).
 * Molecules -> Sidebar Dropdown Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.4.0 LIBNGSG-24 Add header sidebar layout components
 * 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components
 * 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library
 * 1.0.0 LIBNGSG-1 Add basic component library code to repository
 *
 */
const _c0$f = [[["", "dropdown-content", ""]]];
const _c1$b = function (a0) { return { show: a0 }; };
const _c2$7 = ["[dropdown-content]"];
class MoleculesSidebarDropdownComponent {
    targetId;
    label;
    type = null;
    // Booleans
    isExpanded = false;
    /** @nocollapse */ static ɵfac = function MoleculesSidebarDropdownComponent_Factory(t) { return new (t || MoleculesSidebarDropdownComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MoleculesSidebarDropdownComponent, selectors: [["bc-molecules-sidebar-dropdown"]], inputs: { targetId: "targetId", label: "label", type: "type", isExpanded: "isExpanded" }, ngContentSelectors: _c2$7, decls: 3, vars: 9, consts: [[3, "label", "type", "href", "dropdown", "isExpanded"], [1, "item-dropdown", "collapse", 3, "id", "ngClass"]], template: function MoleculesSidebarDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$f);
            i0.ɵɵelement(0, "bc-molecules-sidebar-item", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate1("href", "#", ctx.targetId, "");
            i0.ɵɵproperty("label", ctx.label)("type", ctx.type)("dropdown", true)("isExpanded", ctx.isExpanded);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("id", ctx.targetId)("ngClass", i0.ɵɵpureFunction1(7, _c1$b, ctx.isExpanded));
        } }, dependencies: [i1.NgClass, MoleculesSidebarItemComponent], changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MoleculesSidebarDropdownComponent, [{
        type: Component,
        args: [{ selector: 'bc-molecules-sidebar-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Molecules sidebar dropdown component (molecules-sidebar-dropdown.component.html).\n - Molecule -> Sidebar Dropdown Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.4.0 LIBNGSG-24 Add header sidebar layout components\n - 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components\n - 1.0.0 LIBNGSG-3 Configure style guide components as an exportable library\n - 1.0.0 LIBNGSG-1 Add basic component library code to repository\n -\n -->\n<bc-molecules-sidebar-item\n  [label]=\"label\"\n  [type]=\"type\"\n  href=\"#{{targetId}}\"\n  [dropdown]=\"true\"\n  [isExpanded]=\"isExpanded\"\n></bc-molecules-sidebar-item>\n<div\n  class=\"item-dropdown collapse\"\n  [id]=\"targetId\"\n  [ngClass]=\"{ show: isExpanded }\"\n>\n  <ng-content select=\"[dropdown-content]\"></ng-content>\n</div>\n" }]
    }], null, { targetId: [{
            type: Input
        }], label: [{
            type: Input
        }], type: [{
            type: Input
        }], isExpanded: [{
            type: Input
        }] }); })();

/**
 * Molecules view header component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
const _c0$e = function (a0, a1) { return { active: a0, disabled: a1 }; };
function MoleculesViewHeaderComponent_div_3_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const breadcrumb_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", breadcrumb_r5.href, i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpureFunction2(4, _c0$e, breadcrumb_r5.active, breadcrumb_r5.disabled))("title", breadcrumb_r5.title || breadcrumb_r5.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(breadcrumb_r5.label);
} }
const _c1$a = function () { return { exact: false }; };
function MoleculesViewHeaderComponent_div_3_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const breadcrumb_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", breadcrumb_r5.link)("routerLinkActive", breadcrumb_r5.active ? "active" : "inactive")("ngClass", i0.ɵɵpureFunction2(6, _c0$e, breadcrumb_r5.active, breadcrumb_r5.disabled))("title", breadcrumb_r5.title || breadcrumb_r5.label)("routerLinkActiveOptions", i0.ɵɵpureFunction0(9, _c1$a));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(breadcrumb_r5.label);
} }
function MoleculesViewHeaderComponent_div_3_ng_container_1_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const breadcrumb_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0$e, breadcrumb_r5.active, breadcrumb_r5.disabled))("title", breadcrumb_r5.title || breadcrumb_r5.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(breadcrumb_r5.label);
} }
function MoleculesViewHeaderComponent_div_3_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelement(2, "bc-atoms-icon", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function MoleculesViewHeaderComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MoleculesViewHeaderComponent_div_3_ng_container_1_a_1_Template, 3, 7, "a", 11);
    i0.ɵɵtemplate(2, MoleculesViewHeaderComponent_div_3_ng_container_1_a_2_Template, 3, 10, "a", 12);
    i0.ɵɵtemplate(3, MoleculesViewHeaderComponent_div_3_ng_container_1_a_3_Template, 3, 6, "a", 13);
    i0.ɵɵtemplate(4, MoleculesViewHeaderComponent_div_3_ng_container_1_ng_container_4_Template, 3, 0, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const breadcrumb_r5 = ctx.$implicit;
    const isLast_r6 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", breadcrumb_r5.href);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", breadcrumb_r5.link);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !breadcrumb_r5.link && !breadcrumb_r5.href);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !isLast_r6);
} }
function MoleculesViewHeaderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, MoleculesViewHeaderComponent_div_3_ng_container_1_Template, 5, 4, "ng-container", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.breadcrumbs);
} }
function MoleculesViewHeaderComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24);
    i0.ɵɵtext(2, "Suffix 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵtext(4, "Suffix 2");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r14.titleSuffixPrimary, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r14.titleSuffixSecondary, i0.ɵɵsanitizeHtml);
} }
function MoleculesViewHeaderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "div", 21);
    i0.ɵɵtemplate(2, MoleculesViewHeaderComponent_div_4_div_2_Template, 5, 2, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r1.title, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.titleSuffixPrimary || ctx_r1.titleSuffixSecondary);
} }
function MoleculesViewHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "pre")(2, "code");
    i0.ɵɵelement(3, "span", 24);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", ctx_r2.code, i0.ɵɵsanitizeHtml);
} }
function MoleculesViewHeaderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r3.subtitle, i0.ɵɵsanitizeHtml);
} }
const _c2$6 = [[["", "buttons", ""]]];
const _c3$4 = ["[buttons]"];
class MoleculesViewHeaderComponent {
    /**
     * Breadcrumbs (Navigation)
     * Placed above the main title for quick access
     */
    breadcrumbs = [];
    /**
     * Title
     * Main page title (and suffixes)
     * Examples: ("Work Orders", "Job Codes", etc.)
     */
    title = null;
    titleSuffixPrimary = null;
    titleSuffixSecondary = null;
    /**
     * Code
     * Code Examples
     * Examples: ("<bc-atoms-input>", etc.)
     */
    code = null;
    /**
     * Subtitle
     * A brief description of the page
     * Examples: ("This page contains...", etc.)
     */
    subtitle = null;
    /** @nocollapse */ static ɵfac = function MoleculesViewHeaderComponent_Factory(t) { return new (t || MoleculesViewHeaderComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MoleculesViewHeaderComponent, selectors: [["bc-molecules-view-header"]], inputs: { breadcrumbs: "breadcrumbs", title: "title", titleSuffixPrimary: "titleSuffixPrimary", titleSuffixSecondary: "titleSuffixSecondary", code: "code", subtitle: "subtitle" }, ngContentSelectors: _c3$4, decls: 10, vars: 4, consts: [[1, "bcx-view-header"], [1, "row"], [1, "col-md", "col-sm-12", "bcx-header-titles"], ["class", "bcx-header-breadcrumbs", 4, "ngIf"], ["class", "bcx-header-title", 4, "ngIf"], ["class", "bcx-header-code", 4, "ngIf"], ["class", "bcx-header-subtitle", 4, "ngIf"], [1, "col-md-auto", "col-sm-12", "bcx-header-content"], [1, "bcx-header-buttons-container"], [1, "bcx-header-breadcrumbs"], [4, "ngFor", "ngForOf"], ["class", "breadcrumb-text", 3, "href", "ngClass", "title", 4, "ngIf"], ["class", "breadcrumb-text", 3, "routerLink", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions", 4, "ngIf"], ["class", "breadcrumb-text text-only", 3, "ngClass", "title", 4, "ngIf"], [4, "ngIf"], [1, "breadcrumb-text", 3, "href", "ngClass", "title"], [1, "breadcrumb-text", 3, "routerLink", "routerLinkActive", "ngClass", "title", "routerLinkActiveOptions"], [1, "breadcrumb-text", "text-only", 3, "ngClass", "title"], [1, "breadcrumb-separator"], ["type", "next"], [1, "bcx-header-title"], [1, "title", 3, "innerHTML"], ["class", "suffixes", 4, "ngIf"], [1, "suffixes"], [3, "innerHTML"], [1, "bcx-header-code"], [1, "bcx-header-subtitle"]], template: function MoleculesViewHeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$6);
            i0.ɵɵelementStart(0, "header", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, MoleculesViewHeaderComponent_div_3_Template, 2, 1, "div", 3);
            i0.ɵɵtemplate(4, MoleculesViewHeaderComponent_div_4_Template, 3, 2, "div", 4);
            i0.ɵɵtemplate(5, MoleculesViewHeaderComponent_div_5_Template, 4, 1, "div", 5);
            i0.ɵɵtemplate(6, MoleculesViewHeaderComponent_div_6_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 7)(8, "div", 8);
            i0.ɵɵprojection(9);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.breadcrumbs && ctx.breadcrumbs.length);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.title || ctx.titleSuffixPrimary || ctx.titleSuffixSecondary);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.code);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.subtitle);
        } }, dependencies: [AtomsIconComponent, i1.NgClass, i1.NgForOf, i1.NgIf, i2$2.RouterLink, i2$2.RouterLinkActive], styles: [".bcx-view-header{font-family:sans-serif}.bcx-view-header .row{align-items:flex-end}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs,.bcx-view-header .row .bcx-header-titles .bcx-header-title,.bcx-view-header .row .bcx-header-titles .bcx-header-code,.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{margin-bottom:0}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs,.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{font-size:10px;font-weight:500}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs,.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{letter-spacing:1px}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs{margin-bottom:2.5px;text-transform:uppercase}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text,.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-separator{color:#0006;vertical-align:top;display:inline-block}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-separator{padding:0 5px}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text{max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-break:break-all;cursor:pointer}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.active{font-weight:700}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.disabled,.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.text-only{pointer-events:none}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.disabled{opacity:.5}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.text-only{text-decoration:none}.bcx-view-header .row .bcx-header-titles .bcx-header-title{display:flex;align-items:center;padding:5px 0;gap:18px}.bcx-view-header .row .bcx-header-titles .bcx-header-title .title{font-size:24px;font-weight:700;display:flex;align-items:center}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes{display:flex;flex-direction:column;align-items:flex-start;position:relative}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes>div{text-align:left;font-size:12px;color:#2f4f4f;letter-spacing:1px;margin:-2px}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes:before{content:\"\";position:absolute;left:-10px;top:0;bottom:0;width:1px;background-color:#ccc}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes>div:first-child:last-child{align-self:center}.bcx-view-header .row .bcx-header-titles .bcx-header-code{letter-spacing:1px;line-height:normal}.bcx-view-header .row .bcx-header-titles .bcx-header-code pre{background:whitesmoke;margin:2.5px 0 5px;padding:6px;border-radius:4px;width:-moz-fit-content;width:fit-content;border:solid 1px lightgray;color:#dc3545}.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{margin-top:2.5px;color:#696969}.bcx-view-header .row .bcx-header-content{margin-top:auto}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container{display:flex;gap:1rem;padding:0 10px}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container bc-atoms-button{flex:1 1 auto;min-width:83.5px}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container bc-atoms-button:only-child{flex:1 0 100%;min-width:180px}@media (max-width: 768px){.bcx-view-header .row{text-align:center}.bcx-view-header .row .bcx-header-titles .bcx-header-title{justify-content:center}.bcx-view-header .row .bcx-header-content{margin-top:10px;text-align:center}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container{margin-left:auto;margin-right:auto;display:inline-flex}}\n"], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MoleculesViewHeaderComponent, [{
        type: Component,
        args: [{ selector: 'bc-molecules-view-header', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Molecules view header component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2024 Build Centrix\n -->\n<header class=\"bcx-view-header\">\n  <div class=\"row\">\n    <!--Left-->\n    <div class=\"col-md col-sm-12 bcx-header-titles\">\n      <div\n        class=\"bcx-header-breadcrumbs\"\n        *ngIf=\"breadcrumbs && breadcrumbs.length\"\n      >\n        <ng-container *ngFor=\"let breadcrumb of breadcrumbs; let isLast = last\">\n          <!--Href-->\n          <a\n            *ngIf=\"breadcrumb.href\"\n            class=\"breadcrumb-text\"\n            [href]=\"breadcrumb.href\"\n            [ngClass]=\"{ active: breadcrumb.active, disabled: breadcrumb.disabled }\"\n            [title]=\"breadcrumb.title || breadcrumb.label\"\n          >\n            <span>{{ breadcrumb.label }}</span>\n          </a>\n\n          <!--Router Link-->\n          <a\n            *ngIf=\"breadcrumb.link\"\n            class=\"breadcrumb-text\"\n            [routerLink]=\"breadcrumb.link\"\n            [routerLinkActive]=\"breadcrumb.active ? 'active' : 'inactive'\"\n            [ngClass]=\"{ active: breadcrumb.active, disabled: breadcrumb.disabled }\"\n            [title]=\"breadcrumb.title || breadcrumb.label\"\n            [routerLinkActiveOptions]=\"{ exact: false }\"\n          >\n            <span>{{ breadcrumb.label }}</span>\n          </a>\n\n          <!--Text Only-->\n          <a\n            *ngIf=\"!breadcrumb.link && !breadcrumb.href\"\n            class=\"breadcrumb-text text-only\"\n            [ngClass]=\"{ active: breadcrumb.active, disabled: breadcrumb.disabled }\"\n            [title]=\"breadcrumb.title || breadcrumb.label\"\n          >\n            <span>{{ breadcrumb.label }}</span>\n          </a>\n\n          <!-- Display caret unless it's the last breadcrumb -->\n          <ng-container *ngIf=\"!isLast\">\n            <div class=\"breadcrumb-separator\">\n              <bc-atoms-icon type=\"next\"></bc-atoms-icon>\n            </div>\n          </ng-container>\n        </ng-container>\n      </div>\n      <div\n        class=\"bcx-header-title\"\n        *ngIf=\"title || titleSuffixPrimary || titleSuffixSecondary\"\n      >\n        <div class=\"title\" [innerHTML]=\"title\"></div>\n        <div\n          class=\"suffixes\"\n          *ngIf=\"titleSuffixPrimary || titleSuffixSecondary\"\n        >\n          <div [innerHTML]=\"titleSuffixPrimary\">Suffix 1</div>\n          <div [innerHTML]=\"titleSuffixSecondary\">Suffix 2</div>\n        </div>\n      </div>\n      <div class=\"bcx-header-code\" *ngIf=\"code\">\n        <pre><code><span [innerHTML]=\"code\"></span></code></pre>\n      </div>\n      <div class=\"bcx-header-subtitle\" *ngIf=\"subtitle\">\n        <span [innerHTML]=\"subtitle\"></span>\n      </div>\n    </div>\n\n    <!--Right-->\n    <div class=\"col-md-auto col-sm-12 bcx-header-content\">\n      <div class=\"bcx-header-buttons-container\">\n        <ng-content select=\"[buttons]\"></ng-content>\n      </div>\n    </div>\n  </div>\n</header>\n", styles: [".bcx-view-header{font-family:sans-serif}.bcx-view-header .row{align-items:flex-end}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs,.bcx-view-header .row .bcx-header-titles .bcx-header-title,.bcx-view-header .row .bcx-header-titles .bcx-header-code,.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{margin-bottom:0}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs,.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{font-size:10px;font-weight:500}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs,.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{letter-spacing:1px}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs{margin-bottom:2.5px;text-transform:uppercase}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text,.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-separator{color:#0006;vertical-align:top;display:inline-block}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-separator{padding:0 5px}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text{max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-break:break-all;cursor:pointer}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.active{font-weight:700}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.disabled,.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.text-only{pointer-events:none}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.disabled{opacity:.5}.bcx-view-header .row .bcx-header-titles .bcx-header-breadcrumbs .breadcrumb-text.text-only{text-decoration:none}.bcx-view-header .row .bcx-header-titles .bcx-header-title{display:flex;align-items:center;padding:5px 0;gap:18px}.bcx-view-header .row .bcx-header-titles .bcx-header-title .title{font-size:24px;font-weight:700;display:flex;align-items:center}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes{display:flex;flex-direction:column;align-items:flex-start;position:relative}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes>div{text-align:left;font-size:12px;color:#2f4f4f;letter-spacing:1px;margin:-2px}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes:before{content:\"\";position:absolute;left:-10px;top:0;bottom:0;width:1px;background-color:#ccc}.bcx-view-header .row .bcx-header-titles .bcx-header-title .suffixes>div:first-child:last-child{align-self:center}.bcx-view-header .row .bcx-header-titles .bcx-header-code{letter-spacing:1px;line-height:normal}.bcx-view-header .row .bcx-header-titles .bcx-header-code pre{background:whitesmoke;margin:2.5px 0 5px;padding:6px;border-radius:4px;width:-moz-fit-content;width:fit-content;border:solid 1px lightgray;color:#dc3545}.bcx-view-header .row .bcx-header-titles .bcx-header-subtitle{margin-top:2.5px;color:#696969}.bcx-view-header .row .bcx-header-content{margin-top:auto}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container{display:flex;gap:1rem;padding:0 10px}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container bc-atoms-button{flex:1 1 auto;min-width:83.5px}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container bc-atoms-button:only-child{flex:1 0 100%;min-width:180px}@media (max-width: 768px){.bcx-view-header .row{text-align:center}.bcx-view-header .row .bcx-header-titles .bcx-header-title{justify-content:center}.bcx-view-header .row .bcx-header-content{margin-top:10px;text-align:center}.bcx-view-header .row .bcx-header-content .bcx-header-buttons-container{margin-left:auto;margin-right:auto;display:inline-flex}}\n"] }]
    }], null, { breadcrumbs: [{
            type: Input
        }], title: [{
            type: Input
        }], titleSuffixPrimary: [{
            type: Input
        }], titleSuffixSecondary: [{
            type: Input
        }], code: [{
            type: Input
        }], subtitle: [{
            type: Input
        }] }); })();

/**
 * Molecules view header component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
function MoleculesViewHeaderBarComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 27)(2, "bc-atoms-checkbox", 28);
    i0.ɵɵlistener("modelChange", function MoleculesViewHeaderBarComponent_div_17_Template_bc_atoms_checkbox_modelChange_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r3); const column_r1 = restoredCtx.$implicit; return i0.ɵɵresetView(column_r1.selected = $event); })("onCheckboxClicked", function MoleculesViewHeaderBarComponent_div_17_Template_bc_atoms_checkbox_onCheckboxClicked_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onColumnOptionsChange()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const column_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", column_r1.label)("title", column_r1.description)("model", column_r1.selected)("disabled", !column_r1.canToggle);
} }
const _c0$d = [[["", "select-action", ""]], [["", "exports", ""]], [["", "filters", ""]]];
const _c1$9 = ["[select-action]", "[exports]", "[filters]"];
class MoleculesViewHeaderBarComponent {
    // Navigation
    currentDatasetCount = 1;
    currentPage = 1;
    currentPageLabel = 'Page 1';
    currentPageTitle = 'Page 1';
    firstPageTitle = 'Go to first page';
    nextPageTitle = 'Go to next page';
    pageSize = 15;
    pageSizeOptions = [15, 25, 50, 75, 100];
    // Callback Functions
    onColumnOptionsChanged = new EventEmitter();
    onExportsClicked = new EventEmitter();
    onFiltersClicked = new EventEmitter();
    onFirstPageClicked = new EventEmitter();
    onNextPageClicked = new EventEmitter();
    onPageSizeChanged = new EventEmitter();
    onSearchChanged = new EventEmitter();
    onResetFiltersClicked = new EventEmitter();
    // Exports
    exportsTitle = 'Exports';
    exportsDescription = 'Export Data';
    // Filters
    filtersTitle = 'Filters';
    filtersDescription = 'Filters Data';
    // Search
    searchPlaceholder = 'Search';
    searchTitle = 'Search';
    searchValue = '';
    searchMaxLength = null;
    // Settings
    settingsTitle = 'Settings';
    // Page Size
    pageSizeLabel = 'Page Size';
    pageSizeDescription = 'Change page size';
    // Toggle Filters
    filtersVisible = false;
    // Toggle Columns
    toggleColumnsLabel = 'Toggle Columns';
    toggleColumnsDescription = 'Toggle columns on/off';
    columnsOptions = [];
    // Booleans (Visibility)
    showExports = false;
    showFilters = false;
    showNavigation = false;
    showSearch = false;
    showSettings = false;
    showActions = true;
    // Booleans (Disabled)
    exportsDisabled = false;
    filtersDisabled = false;
    navigationDisabled = false;
    searchDisabled = false;
    settingsDisabled = false;
    /**
     * On exports button clicked
     */
    onExportsButtonClicked($event) {
        this.onExportsClicked.emit($event);
    }
    /**
     * On filters button clicked
     */
    onFiltersButtonClicked($event) {
        this.filtersVisible = !this.filtersVisible;
        this.onFiltersClicked.emit($event);
    }
    /**
     * On first page button clicked
     */
    onFirstPage($event) {
        this.onFirstPageClicked.emit($event);
    }
    /**
     * On next page button clicked
     */
    onNextPage($event) {
        this.onNextPageClicked.emit($event);
    }
    /**
     * On columns changed
     */
    onColumnOptionsChange() {
        this.onColumnOptionsChanged.emit(this.columnsOptions);
    }
    /**
     * On page size changed
     */
    onPageSizeChange($event) {
        this.pageSize = $event;
        this.onPageSizeChanged.emit($event);
    }
    /**
     * On search changed
     */
    onSearchChange($event) {
        this.searchValue = $event;
        this.onSearchChanged.emit($event);
    }
    /** @nocollapse */ static ɵfac = function MoleculesViewHeaderBarComponent_Factory(t) { return new (t || MoleculesViewHeaderBarComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MoleculesViewHeaderBarComponent, selectors: [["bc-molecules-view-header-bar"]], inputs: { currentDatasetCount: "currentDatasetCount", currentPage: "currentPage", currentPageLabel: "currentPageLabel", currentPageTitle: "currentPageTitle", firstPageTitle: "firstPageTitle", nextPageTitle: "nextPageTitle", pageSize: "pageSize", pageSizeOptions: "pageSizeOptions", exportsTitle: "exportsTitle", exportsDescription: "exportsDescription", filtersTitle: "filtersTitle", filtersDescription: "filtersDescription", searchPlaceholder: "searchPlaceholder", searchTitle: "searchTitle", searchValue: "searchValue", searchMaxLength: "searchMaxLength", settingsTitle: "settingsTitle", pageSizeLabel: "pageSizeLabel", pageSizeDescription: "pageSizeDescription", filtersVisible: "filtersVisible", toggleColumnsLabel: "toggleColumnsLabel", toggleColumnsDescription: "toggleColumnsDescription", columnsOptions: "columnsOptions", showExports: "showExports", showFilters: "showFilters", showNavigation: "showNavigation", showSearch: "showSearch", showSettings: "showSettings", showActions: "showActions", exportsDisabled: "exportsDisabled", filtersDisabled: "filtersDisabled", navigationDisabled: "navigationDisabled", searchDisabled: "searchDisabled", settingsDisabled: "settingsDisabled" }, outputs: { onColumnOptionsChanged: "onColumnOptionsChanged", onExportsClicked: "onExportsClicked", onFiltersClicked: "onFiltersClicked", onFirstPageClicked: "onFirstPageClicked", onNextPageClicked: "onNextPageClicked", onPageSizeChanged: "onPageSizeChanged", onSearchChanged: "onSearchChanged", onResetFiltersClicked: "onResetFiltersClicked" }, ngContentSelectors: _c1$9, decls: 33, vars: 39, consts: [[1, "bcx-view-header-bar"], [1, "row"], [1, "col-sm-6", "col-md"], [1, "main-container"], [1, "left-container"], [1, "inner-content", "navigation", 3, "hidden"], ["id", "first", "icon", "first", "display", "block", "size", "small", "type", "default", 3, "title", "disabled", "onButtonClicked"], ["id", "currentPage", "display", "block", "size", "small", "type", "default", "disabled", "true", 3, "label", "title"], ["id", "next", "icon", "forward", "display", "block", "size", "small", "type", "default", 3, "title", "disabled", "onButtonClicked"], [1, "inner-content", "settings", 3, "hidden"], ["id", "settings", "icon", "webduct", "display", "block", "size", "small", "type", "default", 3, "iconOnly", "title", "disabled"], ["dropdown-content", ""], [1, "m-2"], ["labelIcon", "workOrders", 3, "labelTitle", "labelDescription", "hidden"], [1, "sub-item"], ["direction", "horizontal", "size", "small", "selectedType", "primary", 3, "options", "model", "modelChange", "onSelectionChanged"], ["labelIcon", "all", 3, "labelTitle", "labelDescription", "hidden"], [4, "ngFor", "ngForOf"], [1, "inner-content", "select-action", 3, "hidden"], [1, "right-container"], [1, "inner-content", "export", 3, "hidden"], ["id", "exports", "icon", "download", "size", "small", "type", "default", 3, "iconOnly", "title", "disabled", "onButtonClicked"], [1, "inner-content", "filter", 3, "hidden"], ["id", "filters", "icon", "filter", "size", "small", "type", "default", 3, "iconOnly", "title", "disabled", "pressed", "onButtonClicked"], [1, "inner-content", "search", 3, "hidden"], ["type", "text", "size", "small", 3, "debounceTime", "maxlength", "placeholder", "disabled", "title", "model", "canClear", "modelChange"], [1, "bcx-view-header-filters", 3, "hidden"], [1, "item"], [3, "label", "title", "model", "disabled", "modelChange", "onCheckboxClicked"]], template: function MoleculesViewHeaderBarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$d);
            i0.ɵɵelementStart(0, "header", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "bc-atoms-button", 6);
            i0.ɵɵlistener("onButtonClicked", function MoleculesViewHeaderBarComponent_Template_bc_atoms_button_onButtonClicked_6_listener($event) { return ctx.onFirstPage($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "bc-atoms-button", 7);
            i0.ɵɵelementStart(8, "bc-atoms-button", 8);
            i0.ɵɵlistener("onButtonClicked", function MoleculesViewHeaderBarComponent_Template_bc_atoms_button_onButtonClicked_8_listener($event) { return ctx.onNextPage($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 9)(10, "bc-atoms-button", 10)(11, "div", 11)(12, "form", 12)(13, "bc-atoms-input-group", 13)(14, "div", 14)(15, "bc-atoms-button-group", 15);
            i0.ɵɵlistener("modelChange", function MoleculesViewHeaderBarComponent_Template_bc_atoms_button_group_modelChange_15_listener($event) { return ctx.pageSize = $event; })("onSelectionChanged", function MoleculesViewHeaderBarComponent_Template_bc_atoms_button_group_onSelectionChanged_15_listener($event) { return ctx.onPageSizeChange($event); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(16, "bc-atoms-input-group", 16);
            i0.ɵɵtemplate(17, MoleculesViewHeaderBarComponent_div_17_Template, 3, 4, "div", 17);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(18, "div", 18);
            i0.ɵɵprojection(19);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(20, "div", 2)(21, "div", 3)(22, "div", 19)(23, "div", 20)(24, "bc-atoms-button", 21);
            i0.ɵɵlistener("onButtonClicked", function MoleculesViewHeaderBarComponent_Template_bc_atoms_button_onButtonClicked_24_listener($event) { return ctx.onExportsButtonClicked($event); });
            i0.ɵɵelementStart(25, "div", 11);
            i0.ɵɵprojection(26, 1);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(27, "div", 22)(28, "bc-atoms-button", 23);
            i0.ɵɵlistener("onButtonClicked", function MoleculesViewHeaderBarComponent_Template_bc_atoms_button_onButtonClicked_28_listener($event) { return ctx.onFiltersButtonClicked($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(29, "div", 24)(30, "bc-atoms-input", 25);
            i0.ɵɵlistener("modelChange", function MoleculesViewHeaderBarComponent_Template_bc_atoms_input_modelChange_30_listener($event) { return ctx.searchValue = $event; })("modelChange", function MoleculesViewHeaderBarComponent_Template_bc_atoms_input_modelChange_30_listener($event) { return ctx.onSearchChange($event); });
            i0.ɵɵelementEnd()()()()()()();
            i0.ɵɵelementStart(31, "div", 26);
            i0.ɵɵprojection(32, 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("hidden", !ctx.showNavigation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("title", ctx.firstPageTitle)("disabled", ctx.navigationDisabled || ctx.currentPage === 1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("label", ctx.currentPageLabel)("title", ctx.currentPageTitle);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("title", ctx.nextPageTitle)("disabled", ctx.navigationDisabled || ctx.currentDatasetCount < ctx.pageSize);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.showSettings);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("iconOnly", true)("title", ctx.settingsTitle)("disabled", ctx.settingsDisabled);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("labelTitle", ctx.pageSizeLabel)("labelDescription", ctx.pageSizeDescription)("hidden", ctx.pageSizeOptions.length === 0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("options", ctx.pageSizeOptions)("model", ctx.pageSize);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("labelTitle", ctx.toggleColumnsLabel)("labelDescription", ctx.toggleColumnsDescription)("hidden", ctx.columnsOptions.length === 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.columnsOptions);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.showActions);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("hidden", !ctx.showExports);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("iconOnly", true)("title", ctx.exportsDescription)("disabled", ctx.exportsDisabled);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hidden", !ctx.showFilters);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("iconOnly", true)("title", ctx.filtersDescription)("disabled", ctx.filtersDisabled)("pressed", ctx.filtersVisible);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.showSearch);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("debounceTime", 2000)("maxlength", ctx.searchMaxLength)("placeholder", ctx.searchPlaceholder)("disabled", ctx.searchDisabled)("title", ctx.searchTitle)("model", ctx.searchValue)("canClear", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.filtersVisible);
        } }, dependencies: [AtomsButtonComponent, AtomsButtonGroupComponent, AtomsCheckboxComponent, AtomsInputComponent, AtomsInputGroupComponent, i1.NgForOf, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.NgForm], styles: [".bcx-view-header-bar{background:whitesmoke;border:solid 1px lightgray;min-height:38px;margin:8px 0}.bcx-view-header-bar .main-container{display:flex;flex-wrap:wrap;justify-content:space-between}.bcx-view-header-bar .main-container .left-container,.bcx-view-header-bar .main-container .right-container{display:flex;flex-wrap:wrap;justify-content:center;width:100%}.bcx-view-header-bar .main-container .left-container:empty,.bcx-view-header-bar .main-container .right-container:empty{display:none}.bcx-view-header-bar .main-container .inner-content{flex-basis:content;margin:5px;box-sizing:border-box}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button{display:inline-block}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button #first.btn{border-right:0;border-top-right-radius:0;border-bottom-right-radius:0}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button #next.btn{border-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button #currentPage.btn{border-radius:0;min-width:100px}.bcx-view-header-bar .main-container .inner-content #settings .btn span.arrow,.bcx-view-header-bar .main-container .inner-content #dateType .btn span.arrow,.bcx-view-header-bar .main-container .inner-content #btnUpdateStatuses .btn span.arrow{position:initial}.bcx-view-header-bar .main-container .inner-content #settings .dropdown-menu{width:270px!important}.bcx-view-header-bar .main-container .inner-content.navigation,.bcx-view-header-bar .main-container .inner-content.settings{flex-grow:0;flex-basis:content}.bcx-view-header-bar .main-container .inner-content.select-action{min-width:202px}@media (max-width: 767px){.bcx-view-header-bar .main-container .inner-content{flex-basis:content}.bcx-view-header-bar .main-container .inner-content.navigation,.bcx-view-header-bar .main-container .inner-content.settings{flex:none}}@media (max-width: 991px){.bcx-view-header-bar .main-container .inner-content.date-type{flex-grow:1;flex-basis:content}}@media (min-width: 991px){.bcx-view-header-bar .main-container .inner-content{flex-basis:content}.bcx-view-header-bar .main-container .inner-content .bc-date-picker{width:120px}}.bcx-view-header-bar .main-container .inner-content:empty{display:none}.bcx-view-header-bar .main-container .left-container{justify-content:flex-start}@media (max-width: 575px){.bcx-view-header-bar .main-container .left-container{justify-content:center}.bcx-view-header-bar .main-container .left-container .inner-content{text-align:center}}.bcx-view-header-bar .main-container .right-container{justify-content:flex-end}@media (max-width: 575px){.bcx-view-header-bar .main-container .right-container{justify-content:center}.bcx-view-header-bar .main-container .right-container .inner-content{text-align:center}}.bcx-view-header-bar .main-container:empty{display:none}.bcx-view-header-filters{border:solid 1px lightgray;min-height:auto;margin-bottom:8px;padding:10px;background:#FFFFFA;margin-top:-9px;border-bottom-left-radius:5px}.bcx-view-header-filters .dynamic-cols{display:grid;gap:10px 10px}.bcx-view-header-filters .dynamic-cols .bc-input-group{margin-bottom:0;line-height:normal}.bcx-view-header-filters .dynamic-cols .bc-input-group .bc-input-group-label{margin-bottom:2px;font-size:smaller}.bcx-view-header-filters .dynamic-cols .bc-input-group .form-group{margin-bottom:0}@media (max-width: 768px){.bcx-view-header-filters .dynamic-cols{grid-template-columns:repeat(auto-fit,minmax(202px,1fr))}}@media (min-width: 768px){.bcx-view-header-filters .dynamic-cols{grid-template-columns:repeat(auto-fit,202px)}}.bcx-view-header-filters .dynamic-cols>div{text-align:center}@media (min-width: 768px){.bcx-view-header-filters{border-bottom-right-radius:25px}}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MoleculesViewHeaderBarComponent, [{
        type: Component,
        args: [{ selector: 'bc-molecules-view-header-bar', encapsulation: ViewEncapsulation.None, template: "<!--\n - Molecules view header component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2024 Build Centrix\n -->\n<header class=\"bcx-view-header-bar\">\n  <div class=\"row\">\n    <!-- Main Container -->\n    <div class=\"col-sm-6 col-md\">\n      <div class=\"main-container\">\n        <!-- Left Div -->\n        <div class=\"left-container\">\n          <!--Navigation-->\n          <div class=\"inner-content navigation\" [hidden]=\"!showNavigation\">\n            <!--First Page-->\n            <bc-atoms-button\n              id=\"first\"\n              icon=\"first\"\n              display=\"block\"\n              size=\"small\"\n              type=\"default\"\n              [title]=\"firstPageTitle\"\n              [disabled]=\"navigationDisabled || currentPage === 1\"\n              (onButtonClicked)=\"onFirstPage($event)\"\n            >\n            </bc-atoms-button>\n            <!--Current Page-->\n            <bc-atoms-button\n              id=\"currentPage\"\n              display=\"block\"\n              size=\"small\"\n              type=\"default\"\n              disabled=\"true\"\n              [label]=\"currentPageLabel\"\n              [title]=\"currentPageTitle\"\n            >\n            </bc-atoms-button>\n            <!--Next Page-->\n            <bc-atoms-button\n              id=\"next\"\n              icon=\"forward\"\n              display=\"block\"\n              size=\"small\"\n              type=\"default\"\n              [title]=\"nextPageTitle\"\n              [disabled]=\"navigationDisabled || currentDatasetCount < pageSize\"\n              (onButtonClicked)=\"onNextPage($event)\"\n            >\n            </bc-atoms-button>\n          </div>\n          <!--Settings-->\n          <div class=\"inner-content settings\" [hidden]=\"!showSettings\">\n            <bc-atoms-button\n              id=\"settings\"\n              icon=\"webduct\"\n              display=\"block\"\n              size=\"small\"\n              type=\"default\"\n              [iconOnly]=\"true\"\n              [title]=\"settingsTitle\"\n              [disabled]=\"settingsDisabled\"\n            >\n              <div dropdown-content>\n                <form class=\"m-2\">\n                  <!--Page Size-->\n                  <bc-atoms-input-group\n                    labelIcon=\"workOrders\"\n                    [labelTitle]=\"pageSizeLabel\"\n                    [labelDescription]=\"pageSizeDescription\"\n                    [hidden]=\"pageSizeOptions.length === 0\"\n                  >\n                    <div class=\"sub-item\">\n                      <bc-atoms-button-group\n                        direction=\"horizontal\"\n                        size=\"small\"\n                        selectedType=\"primary\"\n                        [options]=\"pageSizeOptions\"\n                        [(model)]=\"pageSize\"\n                        (onSelectionChanged)=\"onPageSizeChange($event)\"\n                      ></bc-atoms-button-group>\n                    </div>\n                  </bc-atoms-input-group>\n                  <!--Toggle Columns-->\n                  <bc-atoms-input-group\n                    labelIcon=\"all\"\n                    [labelTitle]=\"toggleColumnsLabel\"\n                    [labelDescription]=\"toggleColumnsDescription\"\n                    [hidden]=\"columnsOptions.length === 0\"\n                  >\n                    <!--Toggle Columns-->\n                    <div *ngFor=\"let column of columnsOptions\">\n                      <div class=\"item\">\n                        <bc-atoms-checkbox\n                          [label]=\"column.label\"\n                          [title]=\"column.description\"\n                          [(model)]=\"column.selected\"\n                          [disabled]=\"!column.canToggle\"\n                          (onCheckboxClicked)=\"onColumnOptionsChange()\"\n                        >\n                        </bc-atoms-checkbox>\n                      </div>\n                    </div>\n                  </bc-atoms-input-group>\n                </form>\n              </div>\n            </bc-atoms-button>\n          </div>\n          <!--Select Action-->\n          <div class=\"inner-content select-action\" [hidden]=\"!showActions\">\n            <ng-content select=\"[select-action]\"></ng-content>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!-- Right Div -->\n    <div class=\"col-sm-6 col-md\">\n      <div class=\"main-container\">\n        <div class=\"right-container\">\n          <!--Exports-->\n          <div class=\"inner-content export\" [hidden]=\"!showExports\">\n            <bc-atoms-button\n              id=\"exports\"\n              icon=\"download\"\n              size=\"small\"\n              type=\"default\"\n              [iconOnly]=\"true\"\n              [title]=\"exportsDescription\"\n              [disabled]=\"exportsDisabled\"\n              (onButtonClicked)=\"onExportsButtonClicked($event)\"\n            >\n              <div dropdown-content>\n                <ng-content select=\"[exports]\"></ng-content>\n              </div>\n            </bc-atoms-button>\n          </div>\n          <!--Filters-->\n          <div class=\"inner-content filter\" [hidden]=\"!showFilters\">\n            <bc-atoms-button\n              id=\"filters\"\n              icon=\"filter\"\n              size=\"small\"\n              type=\"default\"\n              [iconOnly]=\"true\"\n              [title]=\"filtersDescription\"\n              [disabled]=\"filtersDisabled\"\n              [pressed]=\"filtersVisible\"\n              (onButtonClicked)=\"onFiltersButtonClicked($event)\"\n            >\n            </bc-atoms-button>\n          </div>\n          <!--Search-->\n          <div class=\"inner-content search\" [hidden]=\"!showSearch\">\n            <bc-atoms-input\n              type=\"text\"\n              size=\"small\"\n              [debounceTime]=\"2000\"\n              [maxlength]=\"searchMaxLength\"\n              [placeholder]=\"searchPlaceholder\"\n              [disabled]=\"searchDisabled\"\n              [title]=\"searchTitle\"\n              [(model)]=\"searchValue\"\n              (modelChange)=\"onSearchChange($event)\"\n              [canClear]=\"true\"\n            >\n            </bc-atoms-input>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n<div class=\"bcx-view-header-filters\" [hidden]=\"!filtersVisible\">\n  <ng-content select=\"[filters]\"></ng-content>\n</div>\n", styles: [".bcx-view-header-bar{background:whitesmoke;border:solid 1px lightgray;min-height:38px;margin:8px 0}.bcx-view-header-bar .main-container{display:flex;flex-wrap:wrap;justify-content:space-between}.bcx-view-header-bar .main-container .left-container,.bcx-view-header-bar .main-container .right-container{display:flex;flex-wrap:wrap;justify-content:center;width:100%}.bcx-view-header-bar .main-container .left-container:empty,.bcx-view-header-bar .main-container .right-container:empty{display:none}.bcx-view-header-bar .main-container .inner-content{flex-basis:content;margin:5px;box-sizing:border-box}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button{display:inline-block}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button #first.btn{border-right:0;border-top-right-radius:0;border-bottom-right-radius:0}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button #next.btn{border-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.bcx-view-header-bar .main-container .inner-content.navigation bc-atoms-button #currentPage.btn{border-radius:0;min-width:100px}.bcx-view-header-bar .main-container .inner-content #settings .btn span.arrow,.bcx-view-header-bar .main-container .inner-content #dateType .btn span.arrow,.bcx-view-header-bar .main-container .inner-content #btnUpdateStatuses .btn span.arrow{position:initial}.bcx-view-header-bar .main-container .inner-content #settings .dropdown-menu{width:270px!important}.bcx-view-header-bar .main-container .inner-content.navigation,.bcx-view-header-bar .main-container .inner-content.settings{flex-grow:0;flex-basis:content}.bcx-view-header-bar .main-container .inner-content.select-action{min-width:202px}@media (max-width: 767px){.bcx-view-header-bar .main-container .inner-content{flex-basis:content}.bcx-view-header-bar .main-container .inner-content.navigation,.bcx-view-header-bar .main-container .inner-content.settings{flex:none}}@media (max-width: 991px){.bcx-view-header-bar .main-container .inner-content.date-type{flex-grow:1;flex-basis:content}}@media (min-width: 991px){.bcx-view-header-bar .main-container .inner-content{flex-basis:content}.bcx-view-header-bar .main-container .inner-content .bc-date-picker{width:120px}}.bcx-view-header-bar .main-container .inner-content:empty{display:none}.bcx-view-header-bar .main-container .left-container{justify-content:flex-start}@media (max-width: 575px){.bcx-view-header-bar .main-container .left-container{justify-content:center}.bcx-view-header-bar .main-container .left-container .inner-content{text-align:center}}.bcx-view-header-bar .main-container .right-container{justify-content:flex-end}@media (max-width: 575px){.bcx-view-header-bar .main-container .right-container{justify-content:center}.bcx-view-header-bar .main-container .right-container .inner-content{text-align:center}}.bcx-view-header-bar .main-container:empty{display:none}.bcx-view-header-filters{border:solid 1px lightgray;min-height:auto;margin-bottom:8px;padding:10px;background:#FFFFFA;margin-top:-9px;border-bottom-left-radius:5px}.bcx-view-header-filters .dynamic-cols{display:grid;gap:10px 10px}.bcx-view-header-filters .dynamic-cols .bc-input-group{margin-bottom:0;line-height:normal}.bcx-view-header-filters .dynamic-cols .bc-input-group .bc-input-group-label{margin-bottom:2px;font-size:smaller}.bcx-view-header-filters .dynamic-cols .bc-input-group .form-group{margin-bottom:0}@media (max-width: 768px){.bcx-view-header-filters .dynamic-cols{grid-template-columns:repeat(auto-fit,minmax(202px,1fr))}}@media (min-width: 768px){.bcx-view-header-filters .dynamic-cols{grid-template-columns:repeat(auto-fit,202px)}}.bcx-view-header-filters .dynamic-cols>div{text-align:center}@media (min-width: 768px){.bcx-view-header-filters{border-bottom-right-radius:25px}}\n"] }]
    }], null, { currentDatasetCount: [{
            type: Input
        }], currentPage: [{
            type: Input
        }], currentPageLabel: [{
            type: Input
        }], currentPageTitle: [{
            type: Input
        }], firstPageTitle: [{
            type: Input
        }], nextPageTitle: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }], onColumnOptionsChanged: [{
            type: Output
        }], onExportsClicked: [{
            type: Output
        }], onFiltersClicked: [{
            type: Output
        }], onFirstPageClicked: [{
            type: Output
        }], onNextPageClicked: [{
            type: Output
        }], onPageSizeChanged: [{
            type: Output
        }], onSearchChanged: [{
            type: Output
        }], onResetFiltersClicked: [{
            type: Output
        }], exportsTitle: [{
            type: Input
        }], exportsDescription: [{
            type: Input
        }], filtersTitle: [{
            type: Input
        }], filtersDescription: [{
            type: Input
        }], searchPlaceholder: [{
            type: Input
        }], searchTitle: [{
            type: Input
        }], searchValue: [{
            type: Input
        }], searchMaxLength: [{
            type: Input
        }], settingsTitle: [{
            type: Input
        }], pageSizeLabel: [{
            type: Input
        }], pageSizeDescription: [{
            type: Input
        }], filtersVisible: [{
            type: Input
        }], toggleColumnsLabel: [{
            type: Input
        }], toggleColumnsDescription: [{
            type: Input
        }], columnsOptions: [{
            type: Input
        }], showExports: [{
            type: Input
        }], showFilters: [{
            type: Input
        }], showNavigation: [{
            type: Input
        }], showSearch: [{
            type: Input
        }], showSettings: [{
            type: Input
        }], showActions: [{
            type: Input
        }], exportsDisabled: [{
            type: Input
        }], filtersDisabled: [{
            type: Input
        }], navigationDisabled: [{
            type: Input
        }], searchDisabled: [{
            type: Input
        }], settingsDisabled: [{
            type: Input
        }] }); })();

/**
 * Components module (components.module.ts).
 * Components Module.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
class BcMoleculesModule {
    /** @nocollapse */ static ɵfac = function BcMoleculesModule_Factory(t) { return new (t || BcMoleculesModule)(); };
    /** @nocollapse */ static ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: BcMoleculesModule });
    /** @nocollapse */ static ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [BcAtomsModule,
            CommonModule,
            NgSelectModule,
            FormsModule,
            RouterModule,
            ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
            TranslateModule, BcAtomsModule,
            TranslateModule] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BcMoleculesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BcAtomsModule,
                    CommonModule,
                    NgSelectModule,
                    FormsModule,
                    RouterModule,
                    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
                    TranslateModule,
                ],
                exports: [
                    BcAtomsModule,
                    MoleculesMultiSelectDropdownComponent,
                    MoleculesNotificationsFormComponent,
                    MoleculesSidebarDropdownComponent,
                    MoleculesSidebarItemComponent,
                    MoleculesViewHeaderComponent,
                    MoleculesViewHeaderBarComponent,
                    TranslateModule,
                ],
                declarations: [
                    MoleculesMultiSelectDropdownComponent,
                    MoleculesNotificationsFormComponent,
                    MoleculesSidebarDropdownComponent,
                    MoleculesSidebarItemComponent,
                    MoleculesViewHeaderComponent,
                    MoleculesViewHeaderBarComponent,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BcMoleculesModule, { declarations: [MoleculesMultiSelectDropdownComponent,
        MoleculesNotificationsFormComponent,
        MoleculesSidebarDropdownComponent,
        MoleculesSidebarItemComponent,
        MoleculesViewHeaderComponent,
        MoleculesViewHeaderBarComponent], imports: [BcAtomsModule,
        CommonModule,
        NgSelectModule,
        FormsModule,
        RouterModule, i2.ReactiveFormsModule, TranslateModule], exports: [BcAtomsModule,
        MoleculesMultiSelectDropdownComponent,
        MoleculesNotificationsFormComponent,
        MoleculesSidebarDropdownComponent,
        MoleculesSidebarItemComponent,
        MoleculesViewHeaderComponent,
        MoleculesViewHeaderBarComponent,
        TranslateModule] }); })();

/**
 * Organisms header component (organisms-header.component.ts).
 * Organisms -> Header Component
 *
 * @version
 * 3.13.0 LIBNGSG-142 Remove manager link
 * 3.9.0 PRDS-340 Add spooling-ui menu items to style guides
 * 3.3.0 LIBNGSG-119 Add assemblies link to the header
 * 3.2.0 LIBNGSG-116 Update header links with landing page options
 * 3.0.0 UIUP-5 Upgrade Angular to v16
 * 2.4.0 LIBNGSG-107 Update and replace the dashboard URL with the correct manager URL
 * 1.15.0 LIBNGSG-61 Add manufacturing admin link to header menu
 * 1.6.0 LIBNGSG-36 Add Crew Link to Header
 * 1.6.0 LIBNGSG-33 Minor Issues found during QA testing
 * 1.5.0 LIBNGSG-31 User avatar path doesn't resolve after build
 * 1.4.0 LIBNGSG-24 Add header sidebar layout components
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
function OrganismsHeaderComponent_li_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 22)(1, "a", 23);
    i0.ɵɵelement(2, "bc-atoms-icon", 24);
    i0.ɵɵtext(3, " Dashboard ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r0.getDashboardUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_li_11_div_4_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 33);
    i0.ɵɵelement(1, "bc-atoms-icon", 34);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Duct & Fabrication");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r9.getDuctAndFabricationUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_li_11_div_4_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 36);
    i0.ɵɵelement(1, "bc-atoms-icon", 37);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Piping & Plumbing");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r10.getPipingAndPlumbingUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_li_11_div_4_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 38);
    i0.ɵɵelement(1, "bc-atoms-icon", 39);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "3D Takeoffs");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r11.getAssembliesUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_li_11_div_4_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 40);
    i0.ɵɵelement(1, "bc-atoms-icon", 41);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Model Spooling");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r12.getSpoolingUIUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_li_11_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, OrganismsHeaderComponent_li_11_div_4_a_1_Template, 4, 1, "a", 29);
    i0.ɵɵtemplate(2, OrganismsHeaderComponent_li_11_div_4_a_2_Template, 4, 1, "a", 30);
    i0.ɵɵtemplate(3, OrganismsHeaderComponent_li_11_div_4_a_3_Template, 4, 1, "a", 31);
    i0.ɵɵtemplate(4, OrganismsHeaderComponent_li_11_div_4_a_4_Template, 4, 1, "a", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.canViewDuctAndFabricationUI());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.canViewPipingAndPlumbingUI());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.canViewAssembliesUI());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.canViewSpoolingUI());
} }
const _c0$c = function (a0, a1) { return { "dropdown-toggle": a0, "disabled": a1 }; };
function OrganismsHeaderComponent_li_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 25)(1, "a", 26);
    i0.ɵɵlistener("click", function OrganismsHeaderComponent_li_11_Template_a_click_1_listener($event) { return $event.preventDefault(); });
    i0.ɵɵelement(2, "bc-atoms-icon", 27);
    i0.ɵɵtext(3, " Products ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, OrganismsHeaderComponent_li_11_div_4_Template, 5, 4, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$c, !ctx_r1.hideProductsDropdown, ctx_r1.hideProductsDropdown));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.hideProductsDropdown);
} }
function OrganismsHeaderComponent_li_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 42)(1, "a", 23);
    i0.ɵɵelement(2, "bc-atoms-icon", 43);
    i0.ɵɵtext(3, " Timecards ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r2.getTimecardsUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_li_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 44)(1, "a", 23);
    i0.ɵɵelement(2, "bc-atoms-icon", 45);
    i0.ɵɵtext(3, " Reimbursements ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r3.getReimbursementsUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_li_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 46)(1, "a", 23);
    i0.ɵɵelement(2, "bc-atoms-icon", 47);
    i0.ɵɵtext(3, " Calendar ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r4.getCalendarUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelement(1, "img", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r5.getUserImage(), i0.ɵɵsanitizeUrl)("alt", ctx_r5.getUserFullName());
} }
function OrganismsHeaderComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelement(1, "img", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r6.avatarSrc, i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 62);
    i0.ɵɵelement(1, "bc-atoms-icon", 63);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Orders Admin");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r14.getOrderAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 64);
    i0.ɵɵelement(1, "bc-atoms-icon", 65);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Saved Orders");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r15.getSavedOrdersUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 66);
    i0.ɵɵelement(1, "bc-atoms-icon", 67);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Jobs Admin");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r16.getJobAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 68);
    i0.ɵɵelement(1, "bc-atoms-icon", 69);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Tracker Admin");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r17.getInventoryAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 70);
    i0.ɵɵelement(1, "bc-atoms-icon", 71);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Users Admin");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r18.getUserAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 72);
    i0.ɵɵelement(1, "bc-atoms-icon", 73);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "User Groups");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r19.getUserGroupsAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 74);
    i0.ɵɵelement(1, "bc-atoms-icon", 75);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Crews Admin");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r20.getCrewAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 76);
    i0.ɵɵelement(1, "bc-atoms-icon", 77);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Environments");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r21.getEnvironmentsAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_a_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 78);
    i0.ɵɵelement(1, "bc-atoms-icon", 79);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Manufacturing");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r22.getManufacturingAdminUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 80);
} }
function OrganismsHeaderComponent_div_24_a_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 81);
    i0.ɵɵelement(1, "bc-atoms-icon", 82);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3, "Logout");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r24.getLogoutUrl(), i0.ɵɵsanitizeUrl);
} }
function OrganismsHeaderComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, OrganismsHeaderComponent_div_24_a_1_Template, 4, 1, "a", 51);
    i0.ɵɵtemplate(2, OrganismsHeaderComponent_div_24_a_2_Template, 4, 1, "a", 52);
    i0.ɵɵtemplate(3, OrganismsHeaderComponent_div_24_a_3_Template, 4, 1, "a", 53);
    i0.ɵɵtemplate(4, OrganismsHeaderComponent_div_24_a_4_Template, 4, 1, "a", 54);
    i0.ɵɵtemplate(5, OrganismsHeaderComponent_div_24_a_5_Template, 4, 1, "a", 55);
    i0.ɵɵtemplate(6, OrganismsHeaderComponent_div_24_a_6_Template, 4, 1, "a", 56);
    i0.ɵɵtemplate(7, OrganismsHeaderComponent_div_24_a_7_Template, 4, 1, "a", 57);
    i0.ɵɵtemplate(8, OrganismsHeaderComponent_div_24_a_8_Template, 4, 1, "a", 58);
    i0.ɵɵtemplate(9, OrganismsHeaderComponent_div_24_a_9_Template, 4, 1, "a", 59);
    i0.ɵɵtemplate(10, OrganismsHeaderComponent_div_24_div_10_Template, 1, 0, "div", 60);
    i0.ɵɵtemplate(11, OrganismsHeaderComponent_div_24_a_11_Template, 4, 1, "a", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewOrdersAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewSavedOrders());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewJobsAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewToolsAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewUsersAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewUserGroupsAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewCrewsAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewEnvironmentsAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewManufacturingAdmin());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewLogout());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.canViewLogout());
} }
const _c1$8 = function (a0) { return { open: a0 }; };
class OrganismsHeaderComponent {
    // Environment
    environment;
    user;
    // Booleans
    hasAdminContent = false;
    hideAdminDropdown = true;
    hideProductsDropdown = true;
    // Images
    avatarSrc = 'assets/images/avatars/user-avatar.jpg';
    // Menu State
    mainMenuOpen = false;
    /**
     * Has Environment Property
     * @since 1.4.0
     */
    hasEnvironmentProperty(target, key) {
        let result = this.environment && this.environment[target];
        if (result && key) {
            result = Object.prototype.hasOwnProperty.call(this.environment[target], key);
        }
        return result;
    }
    /**
     * Has User
     * @since 1.4.0
     */
    hasUser() {
        return this.user;
    }
    /**
     * Can View Assemblies UI
     * @since 3.3.0
     */
    canViewAssembliesUI() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewAssembliesUI')
            ? this.environment.permissions.canViewAssembliesUI()
            : false;
        return this.getAssembliesUrl() && hasPermission;
    }
    /**
     * Can View Spooling UI
     * @since 3.9.0
     */
    canViewSpoolingUI() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewSpoolingUI')
            ? this.environment.permissions.canViewSpoolingUI()
            : false;
        return this.getSpoolingUIUrl() && hasPermission;
    }
    /**
     * Can View Calendar
     * @since 1.4.0
     */
    canViewCalendar() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewCalendar')
            ? this.environment.permissions.canViewCalendar()
            : false;
        return this.getCalendarUrl() && hasPermission;
    }
    /**
     * Can View Crews Admin
     * @since 1.6.0
     */
    canViewCrewsAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewCrewsAdmin')
            ? this.environment.permissions.canViewCrewsAdmin()
            : false;
        return this.getCrewAdminUrl() && hasPermission;
    }
    /**
     * Can View Dashboard
     * @since 3.2.0
     */
    canViewDashboardUI() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewDashboardUI')
            ? this.environment.permissions.canViewDashboardUI()
            : false;
        return this.getDashboardUrl() && hasPermission;
    }
    /**
     * Can View Duct And Fabrication (Ordering) UI
     * @since 3.3.0
     */
    canViewDuctAndFabricationUI() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewOrderingUI')
            ? this.environment.permissions.canViewOrderingUI()
            : false;
        return this.getDuctAndFabricationUrl() && hasPermission;
    }
    /**
     * Can View Environments Admin
     * @since 1.6.0
     */
    canViewEnvironmentsAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewEnvironmentsAdmin')
            ? this.environment.permissions.canViewEnvironmentsAdmin()
            : false;
        return this.getEnvironmentsAdminUrl() && hasPermission;
    }
    /**
     * Can View Jobs Admin
     * @since 1.4.0
     */
    canViewJobsAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewJobsAdmin')
            ? this.environment.permissions.canViewJobsAdmin()
            : false;
        return this.getJobAdminUrl() && hasPermission;
    }
    /**
     * Can View Logout
     * @since 1.4.0
     */
    canViewLogout() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewLogout')
            ? this.environment.permissions.canViewLogout()
            : false;
        return this.getLogoutUrl() && hasPermission;
    }
    /**
     * Can View Manufacturing Admin
     * @since 1.15.0
     */
    canViewManufacturingAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewManufacturingAdmin')
            ? this.environment.permissions.canViewManufacturingAdmin()
            : false;
        return this.getManufacturingAdminUrl() && hasPermission;
    }
    /**
     * Can View Orders
     * @since 1.4.0
     */
    canViewOrdersAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewOrdersAdmin')
            ? this.environment.permissions.canViewOrdersAdmin()
            : false;
        return this.getOrderAdminUrl() && hasPermission;
    }
    /**
     * Can View Piping And Plumbing (Product) UI
     * @since 3.3.0
     */
    canViewPipingAndPlumbingUI() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewProductUI')
            ? this.environment.permissions.canViewProductUI()
            : false;
        return this.getPipingAndPlumbingUrl() && hasPermission;
    }
    /**
     * Can View Products Dropdown
     * @since 3.3.0
     */
    canViewProductsDropdown() {
        // Spools
        const getSpoolingUIUrl = this.getSpoolingUIUrl();
        const canViewSpools = this.canViewSpoolingUI();
        const showSpoolsLink = getSpoolingUIUrl && canViewSpools;
        // Assemblies
        const getAssembliesUrl = this.getAssembliesUrl();
        const canViewAssemblies = this.canViewAssembliesUI();
        const showAssembliesLink = getAssembliesUrl && canViewAssemblies;
        // Duct and Fabrication
        const getDuctAndFabricationUrl = this.getDuctAndFabricationUrl();
        const canViewDuctAndFabrication = this.canViewDuctAndFabricationUI();
        const showDuctAndFabricationLink = getDuctAndFabricationUrl && canViewDuctAndFabrication;
        // Piping and Plumbing
        const getPipingAndPlumbingUrl = this.getPipingAndPlumbingUrl();
        const canViewPipingAndPlumbing = this.canViewPipingAndPlumbingUI();
        const showPipingAndPlumbingLink = getPipingAndPlumbingUrl && canViewPipingAndPlumbing;
        // Show / hide dropdown
        return (showSpoolsLink ||
            showAssembliesLink ||
            showDuctAndFabricationLink ||
            showPipingAndPlumbingLink);
    }
    /**
     * Can View Saved Orders
     * @since 1.4.0
     */
    canViewSavedOrders() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewSavedOrders')
            ? this.environment.permissions.canViewSavedOrders()
            : false;
        return this.getSavedOrdersUrl() && hasPermission;
    }
    /**
     * Can View Reimbursements
     * @since 1.4.0
     */
    canViewReimbursements() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewReimbursementsUI')
            ? this.environment.permissions.canViewReimbursementsUI()
            : false;
        return this.getReimbursementsUrl() && hasPermission;
    }
    /**
     * Can View Timecards
     * @since 1.4.0
     */
    canViewTimecards() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewTimecards')
            ? this.environment.permissions.canViewTimecards()
            : false;
        return this.getTimecardsUrl() && hasPermission;
    }
    /**
     * Can View Tools Admin
     * @since 1.4.0
     */
    canViewToolsAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewToolsAdmin')
            ? this.environment.permissions.canViewToolsAdmin()
            : false;
        return this.getInventoryAdminUrl() && hasPermission;
    }
    /**
     * Can View Users Admin
     * @since 1.4.0
     */
    canViewUsersAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewUsersAdmin')
            ? this.environment.permissions.canViewUsersAdmin()
            : false;
        return this.getUserAdminUrl() && hasPermission;
    }
    /**
     * Can View User Groups Admin
     * @since 1.6.0
     */
    canViewUserGroupsAdmin() {
        const hasPermission = this.hasEnvironmentProperty('permissions', 'canViewUserGroupsAdmin')
            ? this.environment.permissions.canViewUserGroupsAdmin()
            : false;
        return this.getUserGroupsAdminUrl() && hasPermission;
    }
    /**
     * Get Assemblies Url
     * @since 3.3.0
     */
    getAssembliesUrl() {
        return this.hasEnvironmentProperty('resources', 'getAssembliesUrl')
            ? this.environment.resources.getAssembliesUrl()
            : null;
    }
    /**
     * Get Spooling Url
     * @since 3.9.0
     */
    getSpoolingUIUrl() {
        return this.hasEnvironmentProperty('resources', 'getSpoolingUIUrl')
            ? this.environment.resources.getSpoolingUIUrl()
            : null;
    }
    /**
     * Get Company Name
     * @since 1.4.0
     */
    getCompanyName() {
        return this.hasEnvironmentProperty('constants', 'getCompanyName')
            ? this.environment.constants.getCompanyName()
            : null;
    }
    /**
     * Get Crews Admin Url
     * @since 1.6.0
     */
    getCrewAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getCrewsListUrl')
            ? this.environment.resources.getCrewsListUrl()
            : null;
    }
    /**
     * Get Environments Admin Url
     * @since 1.6.0
     */
    getEnvironmentsAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getEnvironmentsUrl')
            ? this.environment.resources.getEnvironmentsUrl(true)
            : null;
    }
    /**
     * Get Calendar Url
     * @since 1.4.0
     */
    getCalendarUrl() {
        return this.hasEnvironmentProperty('resources', 'getCalendarUrl')
            ? this.environment.resources.getCalendarUrl()
            : null;
    }
    /**
     * Get Dashboard Url
     * @since 3.2.0
     */
    getDashboardUrl() {
        return this.hasEnvironmentProperty('resources', 'getDashboardUrl')
            ? this.environment.resources.getDashboardUrl()
            : null;
    }
    /**
     * Get Default Landing Page Url
     * @since 3.2.0
     */
    getDefaultLandingPageUrl() {
        return this.hasEnvironmentProperty('resources', 'getDefaultLandingPageUrl')
            ? this.environment.resources.getDefaultLandingPageUrl()
            : null;
    }
    /**
     * Get Duct & Fabrication Url
     * @since 3.3.0
     */
    getDuctAndFabricationUrl() {
        return this.hasEnvironmentProperty('resources', 'getFittingsUrl')
            ? this.environment.resources.getFittingsUrl()
            : null;
    }
    /**
     * Get Header Logo Url
     * @since 1.4.0
     */
    getHeaderLogoUrl() {
        return this.hasEnvironmentProperty('resources', 'getHeaderLogoUrl')
            ? this.environment.resources.getHeaderLogoUrl()
            : null;
    }
    /**
     * Get Jobs Admin Url
     * @since 1.4.0
     */
    getJobAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getJobAdminUrl')
            ? this.environment.resources.getJobAdminUrl()
            : null;
    }
    /**
     * Get Logout Url
     * @since 1.4.0
     */
    getLogoutUrl() {
        return this.hasEnvironmentProperty('resources', 'getLogoutUrl')
            ? this.environment.resources.getLogoutUrl()
            : null;
    }
    /**
     * Get Manufacturing Admin Url
     * @since 1.15.0
     */
    getManufacturingAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getManufacturingAdminUrl')
            ? this.environment.resources.getManufacturingAdminUrl()
            : null;
    }
    /**
     * Get Piping And Plumbing Url
     */
    getPipingAndPlumbingUrl() {
        // Attempt to get the piping/plumbing URL
        if (this.hasEnvironmentProperty('resources', 'getPipingPlumbingUrl')) {
            // Attempt to get the plumbing URL override
            const plumbingUrlOverride = this.hasEnvironmentProperty('constants', 'getPlumbingUrlOverride')
                ? this.environment.constants.getPlumbingUrlOverride()
                : null;
            return this.environment.resources.getPipingPlumbingUrl(plumbingUrlOverride);
        }
        // Fallback to product URL if piping/plumbing URL is not available
        if (this.hasEnvironmentProperty('resources', 'getProductUrl')) {
            return this.environment.resources.getProductUrl();
        }
        // Default to a null value if no URL is found
        return null;
    }
    /**
     * Get Reimbursements Url
     * @since 1.4.0
     */
    getReimbursementsUrl() {
        return this.hasEnvironmentProperty('resources', 'getReimbursementsUrl')
            ? this.environment.resources.getReimbursementsUrl()
            : null;
    }
    /**
     * Get Timecards Url
     * @since 1.4.0
     */
    getTimecardsUrl() {
        return this.hasEnvironmentProperty('resources', 'getTimecardsUrl')
            ? this.environment.resources.getTimecardsUrl()
            : null;
    }
    /**
     * Get Inventory Admin Url
     * @since 1.4.0
     */
    getInventoryAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getToolTrackerUrl')
            ? this.environment.resources.getToolTrackerUrl()
            : null;
    }
    /**
     * Get User Admin Url
     * @since 1.4.0
     */
    getUserAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getUsersUrl')
            ? this.environment.resources.getUsersUrl()
            : null;
    }
    /**
     * Get User Groups Admin Url
     * @since 1.6.0
     */
    getUserGroupsAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getUserGroupsUrl')
            ? this.environment.resources.getUserGroupsUrl(true)
            : null;
    }
    /**
     * Get Order Admin Url
     * @since 1.4.0
     */
    getOrderAdminUrl() {
        return this.hasEnvironmentProperty('resources', 'getWorkOrdersUrl')
            ? this.environment.resources.getWorkOrdersUrl()
            : null;
    }
    /**
     * Get Saved Orders Url
     * @since 1.4.0
     */
    getSavedOrdersUrl() {
        return this.hasEnvironmentProperty('resources', 'getSavedJobOrdersUrl')
            ? this.environment.resources.getSavedJobOrdersUrl()
            : null;
    }
    /**
     * Get User First Name
     * @since 1.4.0
     */
    getUserFirstName() {
        return this.hasUser() && this.user.firstName ? this.user.firstName : 'User';
    }
    /**
     * Get User Full Name
     * @since 1.4.0
     */
    getUserFullName() {
        return this.hasUser()
            ? this.getUserFirstName() + ' ' + this.getUserLastName()
            : 'User Name';
    }
    /**
     * Get User Image
     * @since 1.4.0
     */
    getUserImage() {
        return this.hasUser() && this.user.image ? this.user.image : null;
    }
    /**
     * Get User Last Name
     * @since 1.4.0
     */
    getUserLastName() {
        return this.hasUser() && this.user.lastName ? this.user.lastName : 'Name';
    }
    /**
     * Watch for Changes
     * @since 1.4.0
     */
    ngOnChanges() {
        // Admin Content
        this.hasAdminContent =
            this.canViewOrdersAdmin() ||
                this.canViewSavedOrders() ||
                this.canViewJobsAdmin() ||
                this.canViewToolsAdmin() ||
                this.canViewUsersAdmin();
        this.canViewCrewsAdmin();
        // Manager Separator
        if (this.hasAdminContent || this.canViewLogout()) {
            this.hideAdminDropdown = false;
        }
        // Products Dropdown
        if (this.canViewProductsDropdown()) {
            this.hideProductsDropdown = false;
        }
    }
    /** @nocollapse */ static ɵfac = function OrganismsHeaderComponent_Factory(t) { return new (t || OrganismsHeaderComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: OrganismsHeaderComponent, selectors: [["bc-organisms-header"]], inputs: { environment: "environment", user: "user" }, features: [i0.ɵɵNgOnChangesFeature], decls: 25, vars: 22, consts: [[1, "navbar", "fixed-top", "navbar-expand-md", "navbar-dark", "bg-dark"], [1, "container-fluid"], [1, "header-toggle-container"], ["type", "button", "data-toggle", "collapse", "data-target", "#navbar-collapse", 1, "navbar-toggler", 3, "click"], ["type", "all"], [1, "header-brand-container"], [1, "navbar-brand", 3, "href", "title"], ["type", "name", 3, "image", "title", "alt"], ["id", "navbar-collapse", 1, "header-content-container", "collapse", "navbar-collapse"], [1, "nav", "navbar-nav", "ml-auto"], ["class", "nav-item ml-md-2", "title", "Dashboard", 4, "ngIf"], ["class", "nav-item dropdown ml-md-2 products-dropdown", 4, "ngIf"], ["class", "nav-item ml-md-2", "title", "Timecards", 4, "ngIf"], ["class", "nav-item ml-md-2", "title", "Reimbursements", 4, "ngIf"], ["class", "nav-item ml-md-2", "title", "Calendar", 4, "ngIf"], [1, "admin-container", 3, "ngClass"], [1, "nav-item", "dropdown", "admin-dropdown", 3, "title"], ["href", "#", "id", "navbarDropdownMenuLink", "role", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "nav-link", "admin-link", 3, "ngClass", "click"], ["class", "admin-image", 4, "ngIf"], [1, "admin-name"], [1, "full"], ["class", "dropdown-menu", "aria-labelledby", "navbarDropdownMenuLink", 4, "ngIf"], ["title", "Dashboard", 1, "nav-item", "ml-md-2"], [1, "nav-link", 3, "href"], ["type", "dashboard"], [1, "nav-item", "dropdown", "ml-md-2", "products-dropdown"], ["href", "#", "id", "navbarDropdownProductsLink", "role", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", "title", "Products", 1, "nav-link", "products-link", 3, "ngClass", "click"], ["type", "products"], ["aria-labelledby", "navbarDropdownMenuLink", 1, "dropdown-menu"], ["class", "dropdown-item", "title", "Duct & Fabrication", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Piping & Plumbing", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "3D Takeoffs", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Model Spooling", 3, "href", 4, "ngIf"], ["title", "Duct & Fabrication", 1, "dropdown-item", 3, "href"], ["type", "ductFabrication"], [1, "ml-2"], ["title", "Piping & Plumbing", 1, "dropdown-item", 3, "href"], ["type", "plumbing"], ["title", "3D Takeoffs", 1, "dropdown-item", 3, "href"], ["type", "assemblies"], ["title", "Model Spooling", 1, "dropdown-item", 3, "href"], ["type", "modelSpooling"], ["title", "Timecards", 1, "nav-item", "ml-md-2"], ["type", "timecards"], ["title", "Reimbursements", 1, "nav-item", "ml-md-2"], ["type", "reimbursements"], ["title", "Calendar", 1, "nav-item", "ml-md-2"], ["type", "calendar"], [1, "admin-image"], [1, "rounded-circle", 3, "src", "alt"], ["alt", "user", 1, "rounded-circle", 3, "src"], ["class", "dropdown-item", "title", "Orders Admin", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Saved Orders", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Jobs Admin", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Tracker Admin", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Users Admin", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "User Groups", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Crews Admin", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Environments", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "title", "Manufacturing", 3, "href", 4, "ngIf"], ["class", "dropdown-divider", 4, "ngIf"], ["class", "dropdown-item", "title", "Logout", 3, "href", 4, "ngIf"], ["title", "Orders Admin", 1, "dropdown-item", 3, "href"], ["type", "workOrders"], ["title", "Saved Orders", 1, "dropdown-item", 3, "href"], ["type", "savedOrders"], ["title", "Jobs Admin", 1, "dropdown-item", 3, "href"], ["type", "jobsAdmin"], ["title", "Tracker Admin", 1, "dropdown-item", 3, "href"], ["type", "trackerAdmin"], ["title", "Users Admin", 1, "dropdown-item", 3, "href"], ["type", "user"], ["title", "User Groups", 1, "dropdown-item", 3, "href"], ["type", "userGroup"], ["title", "Crews Admin", 1, "dropdown-item", 3, "href"], ["type", "crews"], ["title", "Environments", 1, "dropdown-item", 3, "href"], ["type", "environment"], ["title", "Manufacturing", 1, "dropdown-item", 3, "href"], ["type", "manufacturingAdmin"], [1, "dropdown-divider"], ["title", "Logout", 1, "dropdown-item", 3, "href"], ["type", "logout"]], template: function OrganismsHeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "nav", 0)(1, "div", 1)(2, "div", 2)(3, "button", 3);
            i0.ɵɵlistener("click", function OrganismsHeaderComponent_Template_button_click_3_listener() { return ctx.mainMenuOpen = !ctx.mainMenuOpen; });
            i0.ɵɵelement(4, "bc-atoms-icon", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 5)(6, "a", 6);
            i0.ɵɵelement(7, "bc-atoms-branding", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 8)(9, "ul", 9);
            i0.ɵɵtemplate(10, OrganismsHeaderComponent_li_10_Template, 4, 1, "li", 10);
            i0.ɵɵtemplate(11, OrganismsHeaderComponent_li_11_Template, 5, 5, "li", 11);
            i0.ɵɵtemplate(12, OrganismsHeaderComponent_li_12_Template, 4, 1, "li", 12);
            i0.ɵɵtemplate(13, OrganismsHeaderComponent_li_13_Template, 4, 1, "li", 13);
            i0.ɵɵtemplate(14, OrganismsHeaderComponent_li_14_Template, 4, 1, "li", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "div", 15)(16, "ul", 9)(17, "li", 16)(18, "a", 17);
            i0.ɵɵlistener("click", function OrganismsHeaderComponent_Template_a_click_18_listener($event) { return $event.preventDefault(); });
            i0.ɵɵtemplate(19, OrganismsHeaderComponent_div_19_Template, 2, 2, "div", 18);
            i0.ɵɵtemplate(20, OrganismsHeaderComponent_div_20_Template, 2, 1, "div", 18);
            i0.ɵɵelementStart(21, "div", 19)(22, "div", 20);
            i0.ɵɵtext(23);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(24, OrganismsHeaderComponent_div_24_Template, 12, 11, "div", 21);
            i0.ɵɵelementEnd()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("href", ctx.getDefaultLandingPageUrl(), i0.ɵɵsanitizeUrl)("title", ctx.getCompanyName());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("image", ctx.getHeaderLogoUrl())("title", ctx.getCompanyName())("alt", ctx.getCompanyName());
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.canViewDashboardUI());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.hideProductsDropdown);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.canViewTimecards());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.canViewReimbursements());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.canViewCalendar());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c1$8, ctx.mainMenuOpen));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("title", ctx.getUserFullName());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(19, _c0$c, !ctx.hideAdminDropdown, ctx.hideAdminDropdown));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getUserImage());
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.getUserImage());
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.getUserFirstName() + " " + ctx.getUserLastName(), " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.hideAdminDropdown);
        } }, dependencies: [AtomsBrandingComponent, AtomsIconComponent, i1.NgClass, i1.NgIf], styles: ["nav.navbar{padding:0}nav.navbar .container-fluid{display:flex;justify-content:space-between;align-items:center;width:100%;padding:0}nav.navbar .header-toggle-container .navbar-toggler{padding:0 1em;border:none}nav.navbar .header-toggle-container .navbar-toggler bc-atoms-icon{font-size:32px}nav.navbar .header-brand-container .navbar-brand{margin:0 10px}nav.navbar .header-brand-container .navbar-brand .brand-wrapper{min-width:115px}nav.navbar .header-brand-container .navbar-brand .brand-wrapper .brand-image{height:38px}nav.navbar .admin-container{margin:0 10px}nav.navbar .header-content-container{flex-grow:1}nav.navbar .header-content-container .nav .nav-item .nav-link{white-space:nowrap}nav.navbar .header-toggle-container,nav.navbar .header-brand-container,nav.navbar .admin-container{width:auto}nav.navbar .admin-dropdown .admin-link{display:flex;align-items:center}nav.navbar .admin-dropdown .admin-link .admin-image img{height:30px;width:30px}nav.navbar .admin-dropdown .admin-link .admin-image,nav.navbar .admin-dropdown .admin-link .admin-name{display:inline-block;vertical-align:middle;margin:0 5px}nav.navbar .admin-dropdown .admin-link .admin-name .full{width:auto;word-break:break-word;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;white-space:normal;max-height:3em;line-height:1.5em}nav.navbar .admin-dropdown .dropdown-menu{border-radius:0 0 0 25px;min-width:180px;position:absolute;margin-top:-1px}nav.navbar .products-dropdown .dropdown-menu{border-radius:0 0 5px 5px;left:-15px;width:200px}nav.navbar .admin-dropdown .dropdown-menu,nav.navbar .products-dropdown .dropdown-menu{border:none;background:#343a40}nav.navbar .admin-dropdown .dropdown-menu .dropdown-item,nav.navbar .products-dropdown .dropdown-menu .dropdown-item{color:gray;background:none;overflow:hidden;text-overflow:ellipsis}nav.navbar .admin-dropdown .dropdown-menu .dropdown-item span.fa,nav.navbar .products-dropdown .dropdown-menu .dropdown-item span.fa{vertical-align:middle;text-align:center;font-size:inherit}nav.navbar .admin-dropdown .dropdown-menu .dropdown-item:hover,nav.navbar .products-dropdown .dropdown-menu .dropdown-item:hover{color:#fff;border-color:transparent}@media (max-width: 767px){nav.navbar .admin-container{display:none}nav.navbar .admin-container.open{display:block}nav.navbar .admin-container.open .admin-dropdown .dropdown-menu{position:unset}nav.navbar .header-content-container{padding:0 10px}nav.navbar .header-content-container .nav-link span.fa{font-size:25px;margin:0 2.5px;vertical-align:bottom;width:35px;text-align:center}}@media (min-width: 767px){nav.navbar .admin-dropdown .admin-link .admin-image img{height:24px;width:24px}nav.navbar .admin-dropdown .admin-link .admin-name{font-size:smaller;text-align:center;font-weight:700;letter-spacing:1px}nav.navbar .admin-dropdown .admin-link .admin-name .full{width:100px}}\n"], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganismsHeaderComponent, [{
        type: Component,
        args: [{ selector: 'bc-organisms-header', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<!--\n - Organisms header component (organisms-header.component.html).\n - Organism -> Header Component.\n -\n - @version\n - 3.13.0 LIBNGSG-142 Remove manager link\n - 3.10.0 LIBNGSG-133 Rename 3D Assemblies as 3D Takeoffs\n - 3.9.0 PRDS-340 Add spooling-ui menu items to style guides\n - 3.3.0 LIBNGSG-119 Add assemblies link to the header\n - 3.2.0 LIBNGSG-116 Update header links with landing page options\n - 2.4.0 LIBNGSG-107 Update and replace the dashboard URL with the correct manager URL\n - 1.15.0 LIBNGSG-61 Add manufacturing admin link to header menu\n - 1.6.0 LIBNGSG-36 Add Crew Link to Header\n - 1.6.0 LIBNGSG-33 Minor Issues found during QA testing\n - 1.5.0 LIBNGSG-31 User avatar path doesn't resolve after build\n - 1.4.0 LIBNGSG-24 Add header sidebar layout components\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @author Monika Gole <monika.gole@ncircletech.com>\n - @copyright (c) 2021-2024 Build Centrix\n -->\n<!--Navbar-->\n<nav class=\"navbar fixed-top navbar-expand-md navbar-dark bg-dark\">\n  <div class=\"container-fluid\">\n    <div class=\"header-toggle-container\">\n      <!--Toggle Collapse Button-->\n      <button\n        class=\"navbar-toggler\"\n        type=\"button\"\n        data-toggle=\"collapse\"\n        data-target=\"#navbar-collapse\"\n        (click)=\"mainMenuOpen =! mainMenuOpen\"\n      >\n        <bc-atoms-icon type=\"all\"></bc-atoms-icon>\n      </button>\n    </div>\n    <div class=\"header-brand-container\">\n      <!--Brand-->\n      <a\n        class=\"navbar-brand\"\n        [href]=\"getDefaultLandingPageUrl()\"\n        [title]=\"getCompanyName()\"\n      >\n        <bc-atoms-branding\n          [image]=\"getHeaderLogoUrl()\"\n          [title]=\"getCompanyName()\"\n          [alt]=\"getCompanyName()\"\n          type=\"name\"\n        ></bc-atoms-branding>\n      </a>\n    </div>\n    <div\n      class=\"header-content-container collapse navbar-collapse\"\n      id=\"navbar-collapse\"\n    >\n      <!--Collapsing Content-->\n      <ul class=\"nav navbar-nav ml-auto\">\n        <!--Dashboard-->\n        <li\n          class=\"nav-item ml-md-2\"\n          *ngIf=\"canViewDashboardUI()\"\n          title=\"Dashboard\"\n        >\n          <a class=\"nav-link\" [href]=\"getDashboardUrl()\">\n            <bc-atoms-icon type=\"dashboard\"></bc-atoms-icon>\n            Dashboard\n          </a>\n        </li>\n\n        <!--Products-->\n        <li\n          class=\"nav-item dropdown ml-md-2 products-dropdown\"\n          *ngIf=\"!hideProductsDropdown\"\n        >\n          <a\n            class=\"nav-link products-link\"\n            href=\"#\"\n            id=\"navbarDropdownProductsLink\"\n            role=\"button\"\n            data-toggle=\"dropdown\"\n            aria-haspopup=\"true\"\n            aria-expanded=\"false\"\n            title=\"Products\"\n            [ngClass]=\"{ 'dropdown-toggle': !hideProductsDropdown, 'disabled': hideProductsDropdown }\"\n            (click)=\"$event.preventDefault(); \"\n          >\n            <bc-atoms-icon type=\"products\"></bc-atoms-icon>\n            Products\n          </a>\n          <div\n            class=\"dropdown-menu\"\n            aria-labelledby=\"navbarDropdownMenuLink\"\n            *ngIf=\"!hideProductsDropdown\"\n          >\n            <!--Duct and Fabrication-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getDuctAndFabricationUrl()\"\n              title=\"Duct & Fabrication\"\n              *ngIf=\"canViewDuctAndFabricationUI()\"\n            >\n              <bc-atoms-icon type=\"ductFabrication\"></bc-atoms-icon>\n              <span class=\"ml-2\">Duct & Fabrication</span>\n            </a>\n\n            <!--Piping and Plumbing-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getPipingAndPlumbingUrl()\"\n              title=\"Piping & Plumbing\"\n              *ngIf=\"canViewPipingAndPlumbingUI()\"\n            >\n              <bc-atoms-icon type=\"plumbing\"></bc-atoms-icon>\n              <span class=\"ml-2\">Piping & Plumbing</span>\n            </a>\n\n            <!--3D Takeoffs-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getAssembliesUrl()\"\n              title=\"3D Takeoffs\"\n              *ngIf=\"canViewAssembliesUI()\"\n            >\n              <bc-atoms-icon type=\"assemblies\"></bc-atoms-icon>\n              <span class=\"ml-2\">3D Takeoffs</span>\n            </a>\n\n            <!--Model Spooling-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getSpoolingUIUrl()\"\n              title=\"Model Spooling\"\n              *ngIf=\"canViewSpoolingUI()\"\n            >\n              <bc-atoms-icon type=\"modelSpooling\"></bc-atoms-icon>\n              <span class=\"ml-2\">Model Spooling</span>\n            </a>\n          </div>\n        </li>\n\n        <!--Timecards-->\n        <li\n          class=\"nav-item ml-md-2\"\n          *ngIf=\"canViewTimecards()\"\n          title=\"Timecards\"\n        >\n          <a class=\"nav-link\" [href]=\"getTimecardsUrl()\">\n            <bc-atoms-icon type=\"timecards\"></bc-atoms-icon>\n            Timecards\n          </a>\n        </li>\n\n        <!--Reimbursements-->\n        <li\n          class=\"nav-item ml-md-2\"\n          *ngIf=\"canViewReimbursements()\"\n          title=\"Reimbursements\"\n        >\n          <a class=\"nav-link\" [href]=\"getReimbursementsUrl()\">\n            <bc-atoms-icon type=\"reimbursements\"></bc-atoms-icon>\n            Reimbursements\n          </a>\n        </li>\n\n        <!--Calendar-->\n        <li class=\"nav-item ml-md-2\" *ngIf=\"canViewCalendar()\" title=\"Calendar\">\n          <a class=\"nav-link\" [href]=\"getCalendarUrl()\">\n            <bc-atoms-icon type=\"calendar\"></bc-atoms-icon>\n            Calendar\n          </a>\n        </li>\n      </ul>\n    </div>\n    <div class=\"admin-container\" [ngClass]=\"{ open: mainMenuOpen }\">\n      <!--Admin Menu-->\n      <ul class=\"nav navbar-nav ml-auto\">\n        <!--Admin Dropdown-->\n        <li\n          class=\"nav-item dropdown admin-dropdown\"\n          [title]=\"getUserFullName()\"\n        >\n          <a\n            class=\"nav-link admin-link\"\n            href=\"#\"\n            id=\"navbarDropdownMenuLink\"\n            role=\"button\"\n            data-toggle=\"dropdown\"\n            aria-haspopup=\"true\"\n            aria-expanded=\"false\"\n            [ngClass]=\"{ 'dropdown-toggle': !hideAdminDropdown, 'disabled': hideAdminDropdown }\"\n            (click)=\"$event.preventDefault()\"\n          >\n            <!--User Image-->\n            <div class=\"admin-image\" *ngIf=\"getUserImage()\">\n              <img\n                [src]=\"getUserImage()\"\n                [alt]=\"getUserFullName()\"\n                class=\"rounded-circle\"\n              />\n            </div>\n\n            <!--User Icon-->\n            <div class=\"admin-image\" *ngIf=\"!getUserImage()\">\n              <img [src]=\"avatarSrc\" alt=\"user\" class=\"rounded-circle\" />\n            </div>\n\n            <!--User Name-->\n            <div class=\"admin-name\">\n              <div class=\"full\">\n                {{getUserFirstName() + ' ' + getUserLastName()}}\n              </div>\n            </div>\n          </a>\n          <div\n            class=\"dropdown-menu\"\n            aria-labelledby=\"navbarDropdownMenuLink\"\n            *ngIf=\"!hideAdminDropdown\"\n          >\n            <!--Orders-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getOrderAdminUrl()\"\n              *ngIf=\"canViewOrdersAdmin()\"\n              title=\"Orders Admin\"\n            >\n              <bc-atoms-icon type=\"workOrders\"></bc-atoms-icon>\n              <span class=\"ml-2\">Orders Admin</span>\n            </a>\n\n            <!--Saved Orders-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getSavedOrdersUrl()\"\n              *ngIf=\"canViewSavedOrders()\"\n              title=\"Saved Orders\"\n            >\n              <bc-atoms-icon type=\"savedOrders\"></bc-atoms-icon>\n              <span class=\"ml-2\">Saved Orders</span>\n            </a>\n\n            <!--Jobs-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getJobAdminUrl()\"\n              *ngIf=\"canViewJobsAdmin()\"\n              title=\"Jobs Admin\"\n            >\n              <bc-atoms-icon type=\"jobsAdmin\"></bc-atoms-icon>\n              <span class=\"ml-2\">Jobs Admin</span>\n            </a>\n\n            <!--Inventory-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getInventoryAdminUrl()\"\n              *ngIf=\"canViewToolsAdmin()\"\n              title=\"Tracker Admin\"\n            >\n              <bc-atoms-icon type=\"trackerAdmin\"></bc-atoms-icon>\n              <span class=\"ml-2\">Tracker Admin</span>\n            </a>\n\n            <!--Users-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getUserAdminUrl()\"\n              *ngIf=\"canViewUsersAdmin()\"\n              title=\"Users Admin\"\n            >\n              <bc-atoms-icon type=\"user\"></bc-atoms-icon>\n              <span class=\"ml-2\">Users Admin</span>\n            </a>\n\n            <!--User Groups-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getUserGroupsAdminUrl()\"\n              *ngIf=\"canViewUserGroupsAdmin()\"\n              title=\"User Groups\"\n            >\n              <bc-atoms-icon type=\"userGroup\"></bc-atoms-icon>\n              <span class=\"ml-2\">User Groups</span>\n            </a>\n\n            <!--Crews-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getCrewAdminUrl()\"\n              *ngIf=\"canViewCrewsAdmin()\"\n              title=\"Crews Admin\"\n            >\n              <bc-atoms-icon type=\"crews\"></bc-atoms-icon>\n              <span class=\"ml-2\">Crews Admin</span>\n            </a>\n\n            <!--Environments-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getEnvironmentsAdminUrl()\"\n              *ngIf=\"canViewEnvironmentsAdmin()\"\n              title=\"Environments\"\n            >\n              <bc-atoms-icon type=\"environment\"></bc-atoms-icon>\n              <span class=\"ml-2\">Environments</span>\n            </a>\n\n            <!--Manufacturing Admin-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getManufacturingAdminUrl()\"\n              *ngIf=\"canViewManufacturingAdmin()\"\n              title=\"Manufacturing\"\n            >\n              <bc-atoms-icon type=\"manufacturingAdmin\"></bc-atoms-icon>\n              <span class=\"ml-2\">Manufacturing</span>\n            </a>\n\n            <div class=\"dropdown-divider\" *ngIf=\"canViewLogout()\"></div>\n\n            <!--Logout-->\n            <a\n              class=\"dropdown-item\"\n              [href]=\"getLogoutUrl()\"\n              *ngIf=\"canViewLogout()\"\n              title=\"Logout\"\n            >\n              <bc-atoms-icon type=\"logout\"></bc-atoms-icon>\n              <span class=\"ml-2\">Logout</span>\n            </a>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </div>\n</nav>\n", styles: ["nav.navbar{padding:0}nav.navbar .container-fluid{display:flex;justify-content:space-between;align-items:center;width:100%;padding:0}nav.navbar .header-toggle-container .navbar-toggler{padding:0 1em;border:none}nav.navbar .header-toggle-container .navbar-toggler bc-atoms-icon{font-size:32px}nav.navbar .header-brand-container .navbar-brand{margin:0 10px}nav.navbar .header-brand-container .navbar-brand .brand-wrapper{min-width:115px}nav.navbar .header-brand-container .navbar-brand .brand-wrapper .brand-image{height:38px}nav.navbar .admin-container{margin:0 10px}nav.navbar .header-content-container{flex-grow:1}nav.navbar .header-content-container .nav .nav-item .nav-link{white-space:nowrap}nav.navbar .header-toggle-container,nav.navbar .header-brand-container,nav.navbar .admin-container{width:auto}nav.navbar .admin-dropdown .admin-link{display:flex;align-items:center}nav.navbar .admin-dropdown .admin-link .admin-image img{height:30px;width:30px}nav.navbar .admin-dropdown .admin-link .admin-image,nav.navbar .admin-dropdown .admin-link .admin-name{display:inline-block;vertical-align:middle;margin:0 5px}nav.navbar .admin-dropdown .admin-link .admin-name .full{width:auto;word-break:break-word;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;white-space:normal;max-height:3em;line-height:1.5em}nav.navbar .admin-dropdown .dropdown-menu{border-radius:0 0 0 25px;min-width:180px;position:absolute;margin-top:-1px}nav.navbar .products-dropdown .dropdown-menu{border-radius:0 0 5px 5px;left:-15px;width:200px}nav.navbar .admin-dropdown .dropdown-menu,nav.navbar .products-dropdown .dropdown-menu{border:none;background:#343a40}nav.navbar .admin-dropdown .dropdown-menu .dropdown-item,nav.navbar .products-dropdown .dropdown-menu .dropdown-item{color:gray;background:none;overflow:hidden;text-overflow:ellipsis}nav.navbar .admin-dropdown .dropdown-menu .dropdown-item span.fa,nav.navbar .products-dropdown .dropdown-menu .dropdown-item span.fa{vertical-align:middle;text-align:center;font-size:inherit}nav.navbar .admin-dropdown .dropdown-menu .dropdown-item:hover,nav.navbar .products-dropdown .dropdown-menu .dropdown-item:hover{color:#fff;border-color:transparent}@media (max-width: 767px){nav.navbar .admin-container{display:none}nav.navbar .admin-container.open{display:block}nav.navbar .admin-container.open .admin-dropdown .dropdown-menu{position:unset}nav.navbar .header-content-container{padding:0 10px}nav.navbar .header-content-container .nav-link span.fa{font-size:25px;margin:0 2.5px;vertical-align:bottom;width:35px;text-align:center}}@media (min-width: 767px){nav.navbar .admin-dropdown .admin-link .admin-image img{height:24px;width:24px}nav.navbar .admin-dropdown .admin-link .admin-name{font-size:smaller;text-align:center;font-weight:700;letter-spacing:1px}nav.navbar .admin-dropdown .admin-link .admin-name .full{width:100px}}\n"] }]
    }], null, { environment: [{
            type: Input
        }], user: [{
            type: Input
        }] }); })();

/**
 * Organisms login component (organisms-login.component.ts).
 * Organisms -> Login Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @deprecated - The was never used or implemented
 *
 */
const _c0$b = ["loginForm"];
/**
 * Login Interface
 * @since 1.1.0
 */
class Login {
    username = null;
    password = null;
}
class OrganismsLoginComponent {
    // Two Way Data Binding
    model = new Login();
    modelChange = new EventEmitter();
    // Form
    loginForm;
    /**
     * On Submit Form
     * @since 1.1.0
     */
    onSubmit(form) {
        console.log('submitted form', this.model);
        form.reset();
    }
    /** @nocollapse */ static ɵfac = function OrganismsLoginComponent_Factory(t) { return new (t || OrganismsLoginComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: OrganismsLoginComponent, selectors: [["bc-organisms-login"]], viewQuery: function OrganismsLoginComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$b, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loginForm = _t.first);
        } }, inputs: { model: "model" }, outputs: { modelChange: "modelChange" }, decls: 14, vars: 15, consts: [[1, "row"], [1, "container-fluid"], [3, "ngSubmit"], ["loginForm", "ngForm"], [1, "col-xs-12"], ["labelIcon", "user", "labelTitle", "Username", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "loginUsername", "name", "loginUsername", "placeholder", "Username", "type", "email", "pattern", "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$", "email", "", 3, "required", "model", "ngModel", "modelChange", "ngModelChange"], ["usernameControl", "ngModel"], ["labelIcon", "password", "labelTitle", "Password", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "loginPassword", "name", "loginPassword", "placeholder", "Password", "type", "password", 3, "required", "model", "ngModel", "modelChange", "ngModelChange"], ["passwordControl", "ngModel"], ["tag", "submit", "type", "primary", "display", "block", "label", "Login", 3, "disabled"]], template: function OrganismsLoginComponent_Template(rf, ctx) { if (rf & 1) {
            const _r3 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "form", 2, 3);
            i0.ɵɵlistener("ngSubmit", function OrganismsLoginComponent_Template_form_ngSubmit_2_listener() { i0.ɵɵrestoreView(_r3); const _r0 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx.onSubmit(_r0)); });
            i0.ɵɵelementStart(4, "div", 4)(5, "bc-atoms-input-group", 5)(6, "bc-atoms-input", 6, 7);
            i0.ɵɵlistener("modelChange", function OrganismsLoginComponent_Template_bc_atoms_input_modelChange_6_listener($event) { return ctx.model.username = $event; })("ngModelChange", function OrganismsLoginComponent_Template_bc_atoms_input_ngModelChange_6_listener($event) { return ctx.model.username = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(8, "div", 4)(9, "bc-atoms-input-group", 8)(10, "bc-atoms-input", 9, 10);
            i0.ɵɵlistener("modelChange", function OrganismsLoginComponent_Template_bc_atoms_input_modelChange_10_listener($event) { return ctx.model.password = $event; })("ngModelChange", function OrganismsLoginComponent_Template_bc_atoms_input_ngModelChange_10_listener($event) { return ctx.model.password = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(12, "div", 4);
            i0.ɵɵelement(13, "bc-atoms-button", 11);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            const _r0 = i0.ɵɵreference(3);
            const _r1 = i0.ɵɵreference(7);
            const _r2 = i0.ɵɵreference(11);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("required", true)("state", _r1.status)("stateInput", _r1.errors)("stateTrigger", _r1.invalid && _r1.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("model", ctx.model.username)("ngModel", ctx.model.username);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r2.status)("stateInput", _r2.errors)("stateTrigger", _r2.invalid && _r2.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("model", ctx.model.password)("ngModel", ctx.model.password);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !_r0.touched || !_r0.valid);
        } }, dependencies: [AtomsButtonComponent, AtomsInputComponent, AtomsInputGroupComponent, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.PatternValidator, i2.EmailValidator, i2.NgModel, i2.NgForm], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganismsLoginComponent, [{
        type: Component,
        args: [{ selector: 'bc-organisms-login', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<!--\n - Organisms login component (organisms-login.component.html).\n - Organism -> Login Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @deprecated - The was never used or implemented\n -\n -->\n<div class=\"row\">\n  <div class=\"container-fluid\">\n    <form #loginForm=\"ngForm\" (ngSubmit)=\"onSubmit(loginForm)\">\n      <!--Username-->\n      <div class=\"col-xs-12\">\n        <bc-atoms-input-group\n          labelIcon=\"user\"\n          labelTitle=\"Username\"\n          [required]=\"true\"\n          [state]=\"usernameControl.status\"\n          [stateInput]=\"usernameControl.errors\"\n          [stateTrigger]=\"usernameControl.invalid && (usernameControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"loginUsername\"\n            name=\"loginUsername\"\n            placeholder=\"Username\"\n            type=\"email\"\n            pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$\"\n            email\n            [required]=\"true\"\n            [(model)]=\"model.username\"\n            [(ngModel)]=\"model.username\"\n            #usernameControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--Password-->\n      <div class=\"col-xs-12\">\n        <bc-atoms-input-group\n          labelIcon=\"password\"\n          labelTitle=\"Password\"\n          [required]=\"true\"\n          [state]=\"passwordControl.status\"\n          [stateInput]=\"passwordControl.errors\"\n          [stateTrigger]=\"passwordControl.invalid && (passwordControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"loginPassword\"\n            name=\"loginPassword\"\n            placeholder=\"Password\"\n            type=\"password\"\n            [required]=\"true\"\n            [(model)]=\"model.password\"\n            [(ngModel)]=\"model.password\"\n            #passwordControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--Login Button-->\n      <div class=\"col-xs-12\">\n        <bc-atoms-button\n          tag=\"submit\"\n          type=\"primary\"\n          display=\"block\"\n          label=\"Login\"\n          [disabled]=\"!loginForm.touched || !loginForm.valid\"\n        ></bc-atoms-button>\n      </div>\n    </form>\n  </div>\n</div>\n" }]
    }], null, { model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], loginForm: [{
            type: ViewChild,
            args: ['loginForm', { static: true }]
        }] }); })();

/**
 * Organisms: Order assembly component
 * Organisms -> Order Assembly Component
 *
 * @version
 * 3.5.0 LIBNGSG-123 Migrate tslint to eslint
 * 3.1.0 PRDS-133 Create ordering UI in ng-library-style-guide
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
const _c0$a = ["orderAssemblyForm"];
class OrganismsOrderAssemblyComponent {
    // Options
    requestedStartDateMin;
    // Booleans
    inputsDisabled;
    jobPhasesLoading;
    // Array options
    usersOptions;
    jobsOptions;
    jobPhasesOptions;
    userGroupsOptions;
    // Two Way Data Binding
    model = new OrderAssembly();
    modelChange = new EventEmitter();
    modelValueChange = new EventEmitter();
    // Form
    orderAssemblyForm;
    /**
     * On change of any field
     *
     * @since 3.1.0
     */
    onModelChange() {
        this.modelChange.emit(this.model);
    }
    /**
     * On change of specific field
     *
     * @since 3.1.0
     */
    onModelValueChange(event, key) {
        this.modelValueChange.emit({ event, key });
    }
    /** @nocollapse */ static ɵfac = function OrganismsOrderAssemblyComponent_Factory(t) { return new (t || OrganismsOrderAssemblyComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: OrganismsOrderAssemblyComponent, selectors: [["bc-organisms-order-assembly"]], viewQuery: function OrganismsOrderAssemblyComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$a, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.orderAssemblyForm = _t.first);
        } }, inputs: { requestedStartDateMin: "requestedStartDateMin", inputsDisabled: "inputsDisabled", jobPhasesLoading: "jobPhasesLoading", usersOptions: "usersOptions", jobsOptions: "jobsOptions", jobPhasesOptions: "jobPhasesOptions", userGroupsOptions: "userGroupsOptions", model: "model" }, outputs: { modelChange: "modelChange", modelValueChange: "modelValueChange" }, decls: 36, vars: 73, consts: [[1, "row"], [1, "container-fluid"], ["orderAssemblyForm", "ngForm"], [1, "col-12"], ["labelIcon", "workOrders", "labelTitle", "Order Label", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "orderLabel", "name", "orderLabel", "placeholder", "label", 3, "disabled", "required", "model", "ngModel", "modelChange", "ngModelChange"], ["orderLabelControl", "ngModel"], [1, "col-6"], ["labelIcon", "jobsAdmin", "labelTitle", "Job Name / Number", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "jobNameAndNumber", "name", "jobNameAndNumber", "title", "Job Name / Number", "placeholder", "Job Name / Number", "labelKey", "nameAndNumber", 3, "editable", "canClear", "required", "disabled", "options", "model", "ngModel", "modelChange", "ngModelChange"], ["jobNameAndNumberModelControl", "ngModel"], ["labelIcon", "jobsAdmin", "labelTitle", "Job Phase", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "jobPhase", "name", "jobPhase", "title", "Job Phase", "placeholder", "Job Phase", "labelKey", "label", 3, "editable", "canClear", "required", "disabled", "options", "model", "ngModel", "modelChange", "ngModelChange"], ["jobPhaseModelControl", "ngModel"], ["labelIcon", "user", "labelTitle", "Ordered By", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "orderedBy", "name", "orderedBy", "title", "Ordered By", "placeholder", "Ordered By", "labelKey", "name", 3, "editable", "canClear", "required", "disabled", "options", "maxResults", "model", "ngModel", "modelChange", "ngModelChange"], ["orderedByModelControl", "ngModel"], ["labelIcon", "user", "labelTitle", "Ordered For", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "orderedFor", "name", "orderedFor", "title", "Ordered For", "placeholder", "Ordered For", "labelKey", "name", 3, "editable", "canClear", "required", "disabled", "options", "model", "ngModel", "modelChange", "ngModelChange"], ["orderedForModelControl", "ngModel"], ["labelIcon", "trackerAdmin", "labelTitle", "Trade", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "trade", "name", "trade", "title", "Trade", "placeholder", "Trade", "labelKey", "label", 3, "editable", "canClear", "required", "disabled", "options", "model", "ngModel", "modelChange", "ngModelChange"], ["tradeModelControl", "ngModel"], ["labelIcon", "calendar", "labelTitle", "Requested Start Date", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "requestedStartDate", "name", "requestedStartDate", "title", "Requested Start Date", "placeholder", "Select a Date", "size", "default", "ngDefaultControl", "", 3, "disabled", "model", "min", "ngModel", "required", "modelChange", "ngModelChange"], ["requestedStartDateControl", "ngModel"]], template: function OrganismsOrderAssemblyComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "form", null, 2)(4, "div", 0)(5, "div", 3)(6, "bc-atoms-input-group", 4)(7, "bc-atoms-input", 5, 6);
            i0.ɵɵlistener("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_input_modelChange_7_listener($event) { return ctx.model.orderLabel = $event; })("ngModelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_input_ngModelChange_7_listener($event) { return ctx.model.orderLabel = $event; })("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_input_modelChange_7_listener($event) { ctx.onModelChange(); return ctx.onModelValueChange($event, "orderLabel"); });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(9, "div", 0)(10, "div", 7)(11, "bc-atoms-input-group", 8)(12, "bc-atoms-typeahead", 9, 10);
            i0.ɵɵlistener("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_12_listener($event) { return ctx.model.jobNameAndNumber = $event; })("ngModelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_ngModelChange_12_listener($event) { return ctx.model.jobNameAndNumber = $event; })("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_12_listener($event) { ctx.onModelChange(); return ctx.onModelValueChange($event, "jobNameAndNumber"); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(14, "div", 7)(15, "bc-atoms-input-group", 11)(16, "bc-atoms-typeahead", 12, 13);
            i0.ɵɵlistener("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_16_listener($event) { return ctx.model.jobPhase = $event; })("ngModelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_ngModelChange_16_listener($event) { return ctx.model.jobPhase = $event; })("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_16_listener($event) { ctx.onModelChange(); return ctx.onModelValueChange($event, "jobPhase"); });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(18, "div", 0)(19, "div", 7)(20, "bc-atoms-input-group", 14)(21, "bc-atoms-typeahead", 15, 16);
            i0.ɵɵlistener("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_21_listener($event) { return ctx.model.orderedBy = $event; })("ngModelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_ngModelChange_21_listener($event) { return ctx.model.orderedBy = $event; })("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_21_listener($event) { ctx.onModelChange(); return ctx.onModelValueChange($event, "orderedBy"); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(23, "div", 7)(24, "bc-atoms-input-group", 17)(25, "bc-atoms-typeahead", 18, 19);
            i0.ɵɵlistener("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_25_listener($event) { return ctx.model.orderedFor = $event; })("ngModelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_ngModelChange_25_listener($event) { return ctx.model.orderedFor = $event; })("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_25_listener($event) { ctx.onModelChange(); return ctx.onModelValueChange($event, "orderedFor"); });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(27, "div", 0)(28, "div", 7)(29, "bc-atoms-input-group", 20)(30, "bc-atoms-typeahead", 21, 22);
            i0.ɵɵlistener("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_30_listener($event) { return ctx.model.trade = $event; })("ngModelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_ngModelChange_30_listener($event) { return ctx.model.trade = $event; })("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_typeahead_modelChange_30_listener($event) { ctx.onModelChange(); return ctx.onModelValueChange($event, "trade"); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(32, "div", 7)(33, "bc-atoms-input-group", 23)(34, "bc-atoms-date-picker", 24, 25);
            i0.ɵɵlistener("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_date_picker_modelChange_34_listener($event) { return ctx.model.requestedStartDate = $event; })("ngModelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_date_picker_ngModelChange_34_listener($event) { return ctx.model.requestedStartDate = $event; })("modelChange", function OrganismsOrderAssemblyComponent_Template_bc_atoms_date_picker_modelChange_34_listener() { ctx.onModelChange(); return ctx.onModelValueChange(ctx.model.requestedStartDate, "requestedStartDate"); });
            i0.ɵɵelementEnd()()()()()()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(8);
            const _r2 = i0.ɵɵreference(13);
            const _r3 = i0.ɵɵreference(17);
            const _r4 = i0.ɵɵreference(22);
            const _r5 = i0.ɵɵreference(26);
            const _r6 = i0.ɵɵreference(31);
            const _r7 = i0.ɵɵreference(35);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("required", true)("state", _r1.status)("stateInput", _r1.errors)("stateTrigger", _r1.invalid && _r1.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.inputsDisabled)("required", true)("model", ctx.model.orderLabel)("ngModel", ctx.model.orderLabel);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("required", true)("state", _r2.status)("stateInput", _r2.errors)("stateTrigger", _r2.invalid && _r2.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editable", false)("canClear", true)("required", true)("disabled", ctx.inputsDisabled)("options", ctx.jobsOptions)("model", ctx.model.jobNameAndNumber)("ngModel", ctx.model.jobNameAndNumber);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r3.status)("stateInput", _r3.errors)("stateTrigger", _r3.invalid && _r3.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editable", false)("canClear", true)("required", true)("disabled", ctx.inputsDisabled || ctx.jobPhasesLoading)("options", ctx.jobPhasesOptions)("model", ctx.model.jobPhase)("ngModel", ctx.model.jobPhase);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("required", true)("state", _r4.status)("stateInput", _r4.errors)("stateTrigger", _r4.invalid && _r4.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editable", false)("canClear", true)("required", true)("disabled", ctx.inputsDisabled)("options", ctx.usersOptions)("maxResults", 100)("model", ctx.model.orderedBy)("ngModel", ctx.model.orderedBy);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r5.status)("stateInput", _r5.errors)("stateTrigger", _r5.invalid && _r5.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editable", false)("canClear", true)("required", true)("disabled", ctx.inputsDisabled)("options", ctx.usersOptions)("model", ctx.model.orderedFor)("ngModel", ctx.model.orderedFor);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("required", true)("state", _r6.status)("stateInput", _r6.errors)("stateTrigger", _r6.invalid && _r6.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("editable", false)("canClear", true)("required", true)("disabled", ctx.inputsDisabled)("options", ctx.userGroupsOptions)("model", ctx.model.trade)("ngModel", ctx.model.trade);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r7.status)("stateInput", _r7.errors)("stateTrigger", _r7.invalid && _r7.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.inputsDisabled)("model", ctx.model.requestedStartDate)("min", ctx.requestedStartDateMin)("ngModel", ctx.model.requestedStartDate)("required", true);
        } }, dependencies: [AtomsDatePickerComponent, AtomsInputComponent, AtomsInputGroupComponent, AtomsTypeaheadComponent, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.NgModel, i2.NgForm], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganismsOrderAssemblyComponent, [{
        type: Component,
        args: [{ selector: 'bc-organisms-order-assembly', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Organisms: Order assembly component HTML\n - Organisms -> Order Assembly.\n -\n - @version\n - 3.1.0 PRDS-133 Create ordering UI in ng-library-style-guide\n -\n - @author Monika Gole <monika.gole@ncircletech.com>\n - @copyright (c) 2021-2023 Build Centrix\n -->\n<div class=\"row\">\n  <div class=\"container-fluid\">\n    <form #orderAssemblyForm=\"ngForm\">\n      <div class=\"row\">\n        <!--Order Label-->\n        <div class=\"col-12\">\n          <bc-atoms-input-group\n            labelIcon=\"workOrders\"\n            labelTitle=\"Order Label\"\n            [required]=\"true\"\n            [state]=\"orderLabelControl.status\"\n            [stateInput]=\"orderLabelControl.errors\"\n            [stateTrigger]=\"\n              orderLabelControl.invalid && orderLabelControl.touched\n            \"\n          >\n            <bc-atoms-input\n              id=\"orderLabel\"\n              name=\"orderLabel\"\n              placeholder=\"label\"\n              [disabled]=\"inputsDisabled\"\n              [required]=\"true\"\n              [(model)]=\"model.orderLabel\"\n              [(ngModel)]=\"model.orderLabel\"\n              #orderLabelControl=\"ngModel\"\n              (modelChange)=\"\n                onModelChange(); onModelValueChange($event, 'orderLabel')\n              \"\n            >\n            </bc-atoms-input>\n          </bc-atoms-input-group>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <!--Job Name and Number-->\n        <div class=\"col-6\">\n          <bc-atoms-input-group\n            labelIcon=\"jobsAdmin\"\n            labelTitle=\"Job Name / Number\"\n            [required]=\"true\"\n            [state]=\"jobNameAndNumberModelControl.status\"\n            [stateInput]=\"jobNameAndNumberModelControl.errors\"\n            [stateTrigger]=\"\n              jobNameAndNumberModelControl.invalid &&\n              jobNameAndNumberModelControl.touched\n            \"\n          >\n            <bc-atoms-typeahead\n              id=\"jobNameAndNumber\"\n              name=\"jobNameAndNumber\"\n              title=\"Job Name / Number\"\n              placeholder=\"Job Name / Number\"\n              labelKey=\"nameAndNumber\"\n              [editable]=\"false\"\n              [canClear]=\"true\"\n              [required]=\"true\"\n              [disabled]=\"inputsDisabled\"\n              [options]=\"jobsOptions\"\n              [(model)]=\"model.jobNameAndNumber\"\n              [(ngModel)]=\"model.jobNameAndNumber\"\n              #jobNameAndNumberModelControl=\"ngModel\"\n              (modelChange)=\"\n                onModelChange(); onModelValueChange($event, 'jobNameAndNumber')\n              \"\n            >\n            </bc-atoms-typeahead>\n          </bc-atoms-input-group>\n        </div>\n\n        <!--Job Phase-->\n        <div class=\"col-6\">\n          <bc-atoms-input-group\n            labelIcon=\"jobsAdmin\"\n            labelTitle=\"Job Phase\"\n            [required]=\"true\"\n            [state]=\"jobPhaseModelControl.status\"\n            [stateInput]=\"jobPhaseModelControl.errors\"\n            [stateTrigger]=\"\n              jobPhaseModelControl.invalid && jobPhaseModelControl.touched\n            \"\n          >\n            <bc-atoms-typeahead\n              id=\"jobPhase\"\n              name=\"jobPhase\"\n              title=\"Job Phase\"\n              placeholder=\"Job Phase\"\n              labelKey=\"label\"\n              [editable]=\"false\"\n              [canClear]=\"true\"\n              [required]=\"true\"\n              [disabled]=\"inputsDisabled || jobPhasesLoading\"\n              [options]=\"jobPhasesOptions\"\n              [(model)]=\"model.jobPhase\"\n              [(ngModel)]=\"model.jobPhase\"\n              #jobPhaseModelControl=\"ngModel\"\n              (modelChange)=\"\n                onModelChange(); onModelValueChange($event, 'jobPhase')\n              \"\n            >\n            </bc-atoms-typeahead>\n          </bc-atoms-input-group>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <!--Ordered By-->\n        <div class=\"col-6\">\n          <bc-atoms-input-group\n            labelIcon=\"user\"\n            labelTitle=\"Ordered By\"\n            [required]=\"true\"\n            [state]=\"orderedByModelControl.status\"\n            [stateInput]=\"orderedByModelControl.errors\"\n            [stateTrigger]=\"\n              orderedByModelControl.invalid && orderedByModelControl.touched\n            \"\n          >\n            <bc-atoms-typeahead\n              id=\"orderedBy\"\n              name=\"orderedBy\"\n              title=\"Ordered By\"\n              placeholder=\"Ordered By\"\n              labelKey=\"name\"\n              [editable]=\"false\"\n              [canClear]=\"true\"\n              [required]=\"true\"\n              [disabled]=\"inputsDisabled\"\n              [options]=\"usersOptions\"\n              [maxResults]=\"100\"\n              [(model)]=\"model.orderedBy\"\n              [(ngModel)]=\"model.orderedBy\"\n              #orderedByModelControl=\"ngModel\"\n              (modelChange)=\"\n                onModelChange(); onModelValueChange($event, 'orderedBy')\n              \"\n            >\n            </bc-atoms-typeahead>\n          </bc-atoms-input-group>\n        </div>\n\n        <!--Ordered For-->\n        <div class=\"col-6\">\n          <bc-atoms-input-group\n            labelIcon=\"user\"\n            labelTitle=\"Ordered For\"\n            [required]=\"true\"\n            [state]=\"orderedForModelControl.status\"\n            [stateInput]=\"orderedForModelControl.errors\"\n            [stateTrigger]=\"\n              orderedForModelControl.invalid && orderedForModelControl.touched\n            \"\n          >\n            <bc-atoms-typeahead\n              id=\"orderedFor\"\n              name=\"orderedFor\"\n              title=\"Ordered For\"\n              placeholder=\"Ordered For\"\n              labelKey=\"name\"\n              [editable]=\"false\"\n              [canClear]=\"true\"\n              [required]=\"true\"\n              [disabled]=\"inputsDisabled\"\n              [options]=\"usersOptions\"\n              [(model)]=\"model.orderedFor\"\n              [(ngModel)]=\"model.orderedFor\"\n              #orderedForModelControl=\"ngModel\"\n              (modelChange)=\"\n                onModelChange(); onModelValueChange($event, 'orderedFor')\n              \"\n            >\n            </bc-atoms-typeahead>\n          </bc-atoms-input-group>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <!--Trade-->\n        <div class=\"col-6\">\n          <bc-atoms-input-group\n            labelIcon=\"trackerAdmin\"\n            labelTitle=\"Trade\"\n            [required]=\"true\"\n            [state]=\"tradeModelControl.status\"\n            [stateInput]=\"tradeModelControl.errors\"\n            [stateTrigger]=\"\n              tradeModelControl.invalid && tradeModelControl.touched\n            \"\n          >\n            <bc-atoms-typeahead\n              id=\"trade\"\n              name=\"trade\"\n              title=\"Trade\"\n              placeholder=\"Trade\"\n              labelKey=\"label\"\n              [editable]=\"false\"\n              [canClear]=\"true\"\n              [required]=\"true\"\n              [disabled]=\"inputsDisabled\"\n              [options]=\"userGroupsOptions\"\n              [(model)]=\"model.trade\"\n              [(ngModel)]=\"model.trade\"\n              #tradeModelControl=\"ngModel\"\n              (modelChange)=\"\n                onModelChange(); onModelValueChange($event, 'trade')\n              \"\n            >\n            </bc-atoms-typeahead>\n          </bc-atoms-input-group>\n        </div>\n\n        <!--Requested Start Date-->\n        <div class=\"col-6\">\n          <bc-atoms-input-group\n            labelIcon=\"calendar\"\n            labelTitle=\"Requested Start Date\"\n            [required]=\"true\"\n            [state]=\"requestedStartDateControl.status\"\n            [stateInput]=\"requestedStartDateControl.errors\"\n            [stateTrigger]=\"\n              requestedStartDateControl.invalid &&\n              requestedStartDateControl.touched\n            \"\n          >\n            <bc-atoms-date-picker\n              id=\"requestedStartDate\"\n              name=\"requestedStartDate\"\n              title=\"Requested Start Date\"\n              placeholder=\"Select a Date\"\n              size=\"default\"\n              [disabled]=\"inputsDisabled\"\n              [(model)]=\"model.requestedStartDate\"\n              [min]=\"requestedStartDateMin\"\n              [(ngModel)]=\"model.requestedStartDate\"\n              [required]=\"true\"\n              #requestedStartDateControl=\"ngModel\"\n              ngDefaultControl\n              (modelChange)=\"\n                onModelChange();\n                onModelValueChange(\n                  model.requestedStartDate,\n                  'requestedStartDate'\n                )\n              \"\n            >\n            </bc-atoms-date-picker>\n          </bc-atoms-input-group>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n" }]
    }], null, { requestedStartDateMin: [{
            type: Input
        }], inputsDisabled: [{
            type: Input
        }], jobPhasesLoading: [{
            type: Input
        }], usersOptions: [{
            type: Input
        }], jobsOptions: [{
            type: Input
        }], jobPhasesOptions: [{
            type: Input
        }], userGroupsOptions: [{
            type: Input
        }], model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], modelValueChange: [{
            type: Output
        }], orderAssemblyForm: [{
            type: ViewChild,
            args: ['orderAssemblyForm', { static: true }]
        }] }); })();
/**
 * Order Assembly Model
 * @since 3.1.0
 */
class OrderAssembly {
    orderLabel;
    orderedFor;
    orderedBy;
    jobNameAndNumber;
    jobPhase;
    trade;
    requestedStartDate;
}

/**
 * Organisms sidebar component (organisms-sidebar.component.ts).
 * Organisms -> Sidebar Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <erik.orozco@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.10.0 LIBNGSG-46 Add a toggle button to the side bar
 * 1.4.0 LIBNGSG-24 Add header sidebar layout components
 *
 */
const _c0$9 = [[["", "sidebar-links", ""]]];
const _c1$7 = function (a0) { return { "toggled": a0 }; };
const _c2$5 = ["[sidebar-links]"];
class OrganismsSidebarComponent {
    isToggled = false;
    toggleChange = new EventEmitter();
    // Environment
    environment = null;
    user = null;
    /** @nocollapse */ static ɵfac = function OrganismsSidebarComponent_Factory(t) { return new (t || OrganismsSidebarComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: OrganismsSidebarComponent, selectors: [["bc-organisms-sidebar"]], inputs: { isToggled: "isToggled", environment: "environment", user: "user" }, outputs: { toggleChange: "toggleChange" }, ngContentSelectors: _c2$5, decls: 15, vars: 5, consts: [["id", "sidebar-container", 3, "ngClass"], ["id", "sidebar", 1, "collapse", "width", "show"], ["id", "linksContainer", 1, "list-group", "border-0", "text-center"], ["id", "fullLogoBrand", "title", "Powered by BuildCentrix", 1, "sidebar-brand", "list-group-item", "collapsed"], [1, "powered-by-text"], ["type", "nameLight", "title", "Powered by BuildCentrix"], ["id", "logoBrand", "title", "Powered by BuildCentrix", 1, "sidebar-brand", "list-group-item", "collapsed"], ["type", "logo", "title", "Powered by BuildCentrix"], ["id", "collapse-button", 1, "sidebar-brand", "list-group-item", "collapsed", 3, "title", "click"], ["type", "button", 1, "navbar-toggler"], ["type", "all", 3, "title"], [1, "menu-text"]], template: function OrganismsSidebarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$9);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4);
            i0.ɵɵtext(5, "Powered By");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "bc-atoms-branding", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6);
            i0.ɵɵelement(8, "bc-atoms-branding", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 8);
            i0.ɵɵlistener("click", function OrganismsSidebarComponent_Template_div_click_9_listener() { ctx.isToggled = !ctx.isToggled; return ctx.toggleChange.emit(ctx.isToggled); });
            i0.ɵɵelementStart(10, "button", 9);
            i0.ɵɵelement(11, "bc-atoms-icon", 10);
            i0.ɵɵelementStart(12, "span", 11);
            i0.ɵɵtext(13, "Menu");
            i0.ɵɵelementEnd()()();
            i0.ɵɵprojection(14);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$7, ctx.isToggled));
            i0.ɵɵadvance(9);
            i0.ɵɵproperty("title", (ctx.isToggled ? "Expand" : "Collapse") + " Sidebar");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("title", (ctx.isToggled ? "Expand" : "Collapse") + " Sidebar");
        } }, dependencies: [AtomsBrandingComponent, AtomsIconComponent, i1.NgClass], styles: ["#sidebar{overflow:hidden;z-index:3;left:0;transition:all .25s ease;width:235px}#sidebar #logoBrand{display:none!important}#sidebar #fullLogoBrand{display:inline-block!important}#sidebar #linksContainer{text-align:left!important}#sidebar .sidebar-brand{background:#333;text-align:center}#sidebar .sidebar-brand img{max-height:32px;padding:5px 0}#sidebar .sidebar-brand .powered-by-text{color:#fff;letter-spacing:5px;font-size:8px;display:block;line-height:8px}#sidebar #collapse-button{cursor:pointer}#sidebar #collapse-button button{color:#fff;display:inline-flex;padding:0}#sidebar #collapse-button button .menu-text{margin-right:10px}#sidebar .list-group{background-color:#333;min-height:calc(100vh - 46px);border-radius:0}#sidebar .fa{margin-right:6px}#sidebar div[sidebar-links]{z-index:1}#sidebar div[sidebar-links] div[dropdown-content] .list-group-item{padding-left:30px}#sidebar div[sidebar-links] div[dropdown-content] div[dropdown-content] .list-group-item{padding-left:45px}@media (max-width: 768px){#sidebar{width:60px;overflow-y:auto;overflow-x:visible}#sidebar .fa{margin-right:0}#sidebar #logoBrand{display:inline-block!important}#sidebar #fullLogoBrand{display:none!important}#sidebar .menu-text{display:none}#sidebar::-webkit-scrollbar{width:0}#sidebar,#sidebar .list-group{min-width:1px;overflow:visible}#sidebar .list-group .collapse.show,#sidebar .list-group .collapsing{position:relative;z-index:1;top:0}#sidebar div[sidebar-links] .list-group-item,#sidebar div[sidebar-links] div[dropdown-content] .list-group-item{padding-left:20px!important;text-align:left;overflow:visible}#sidebar div[sidebar-links] .list-group-item .fa,#sidebar div[sidebar-links] div[dropdown-content] .list-group-item .fa{vertical-align:middle;min-width:20px;text-align:center}#sidebar div[sidebar-links] .list-group-item .item-label,#sidebar div[sidebar-links] div[dropdown-content] .list-group-item .item-label{font-size:small;vertical-align:middle;width:100%;overflow:hidden;text-overflow:ellipsis}#sidebar .list-group-item:not(.sidebar-brand):hover,#sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show,#sidebar .list-group-item:not(.sidebar-brand):hover .collapsing{width:auto;padding-right:25px;border-radius:0 10px 10px 0}#sidebar .list-group-item:not(.sidebar-brand):hover .fa,#sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .fa,#sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .fa{margin-right:6px!important}#sidebar .list-group-item:not(.sidebar-brand):hover .item-label,#sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .item-label,#sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .item-label{display:inherit!important}#sidebar .list-group-item{text-align:center;font-size:20px;float:none}#sidebar .list-group-item .item-label{display:none}#sidebar .list-group-item[aria-expanded=true]:after,#sidebar .list-group-item[aria-expanded=false]:after{display:none}#sidebar #collapse-button{display:none!important}}#sidebar-container.toggled #sidebar{width:60px;overflow-y:auto;overflow-x:visible}#sidebar-container.toggled #sidebar .fa{margin-right:0}#sidebar-container.toggled #sidebar #logoBrand{display:inline-block!important}#sidebar-container.toggled #sidebar #fullLogoBrand{display:none!important}#sidebar-container.toggled #sidebar .menu-text{display:none}#sidebar-container.toggled #sidebar::-webkit-scrollbar{width:0}#sidebar-container.toggled #sidebar,#sidebar-container.toggled #sidebar .list-group{min-width:1px;overflow:visible}#sidebar-container.toggled #sidebar .list-group .collapse.show,#sidebar-container.toggled #sidebar .list-group .collapsing{position:relative;z-index:1;top:0}#sidebar-container.toggled #sidebar div[sidebar-links] .list-group-item,#sidebar-container.toggled #sidebar div[sidebar-links] div[dropdown-content] .list-group-item{padding-left:20px!important;text-align:left;overflow:visible}#sidebar-container.toggled #sidebar div[sidebar-links] .list-group-item .fa,#sidebar-container.toggled #sidebar div[sidebar-links] div[dropdown-content] .list-group-item .fa{vertical-align:middle;min-width:20px;text-align:center}#sidebar-container.toggled #sidebar div[sidebar-links] .list-group-item .item-label,#sidebar-container.toggled #sidebar div[sidebar-links] div[dropdown-content] .list-group-item .item-label{font-size:small;vertical-align:middle;width:100%;overflow:hidden;text-overflow:ellipsis}#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapsing{width:auto;padding-right:25px;border-radius:0 10px 10px 0}#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .fa,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .fa,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .fa{margin-right:6px!important}#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .item-label,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .item-label,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .item-label{display:inherit!important}#sidebar-container.toggled #sidebar .list-group-item{text-align:center;font-size:20px;float:none}#sidebar-container.toggled #sidebar .list-group-item .item-label{display:none}#sidebar-container.toggled #sidebar .list-group-item[aria-expanded=true]:after,#sidebar-container.toggled #sidebar .list-group-item[aria-expanded=false]:after{display:none}.collapse.show{visibility:visible}.collapsing{visibility:visible;height:0;transition-property:height,visibility;transition-timing-function:ease-out}.collapsing.width{transition-property:width,visibility;width:0;height:100%;transition-timing-function:ease-out}\n"], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganismsSidebarComponent, [{
        type: Component,
        args: [{ selector: 'bc-organisms-sidebar', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<!--\n - Organisms sidebar component (organisms-sidebar.component.html).\n - Organism -> Sidebar Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @author Erik Orozco <erik.orozco@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.10.0 LIBNGSG-46 Add a toggle button to the side bar\n - 1.6.0 LIBNGSG-35 Change sidebar logo to light version\n - 1.4.0 LIBNGSG-24 Add header sidebar layout components\n -\n -->\n<div [ngClass]=\"{'toggled' : isToggled}\" id=\"sidebar-container\">\n  <div class=\"collapse width show\" id=\"sidebar\">\n    <div class=\"list-group border-0 text-center\" id=\"linksContainer\">\n      <!--Full Branding-->\n      <div\n        id=\"fullLogoBrand\"\n        class=\"sidebar-brand list-group-item collapsed\"\n        title=\"Powered by BuildCentrix\"\n      >\n        <div class=\"powered-by-text\">Powered By</div>\n        <bc-atoms-branding\n          type=\"nameLight\"\n          title=\"Powered by BuildCentrix\"\n        ></bc-atoms-branding>\n      </div>\n\n      <!--Icon Branding-->\n      <div\n        id=\"logoBrand\"\n        class=\"sidebar-brand list-group-item collapsed\"\n        title=\"Powered by BuildCentrix\"\n      >\n        <bc-atoms-branding\n          type=\"logo\"\n          title=\"Powered by BuildCentrix\"\n        ></bc-atoms-branding>\n      </div>\n\n      <!--Toggle Collapse Button-->\n      <div\n        id=\"collapse-button\"\n        class=\"sidebar-brand list-group-item collapsed\"\n        [title]=\"(isToggled ? 'Expand' : 'Collapse') + ' Sidebar'\"\n        (click)=\"isToggled=!isToggled; this.toggleChange.emit(isToggled)\"\n      >\n        <button class=\"navbar-toggler\" type=\"button\">\n          <bc-atoms-icon\n            type=\"all\"\n            [title]=\"(isToggled ? 'Expand' : 'Collapse') + ' Sidebar'\"\n          ></bc-atoms-icon>\n          <span class=\"menu-text\">Menu</span>\n        </button>\n      </div>\n\n      <!--Sidebar Links-->\n      <ng-content select=\"[sidebar-links]\"></ng-content>\n    </div>\n  </div>\n</div>\n", styles: ["#sidebar{overflow:hidden;z-index:3;left:0;transition:all .25s ease;width:235px}#sidebar #logoBrand{display:none!important}#sidebar #fullLogoBrand{display:inline-block!important}#sidebar #linksContainer{text-align:left!important}#sidebar .sidebar-brand{background:#333;text-align:center}#sidebar .sidebar-brand img{max-height:32px;padding:5px 0}#sidebar .sidebar-brand .powered-by-text{color:#fff;letter-spacing:5px;font-size:8px;display:block;line-height:8px}#sidebar #collapse-button{cursor:pointer}#sidebar #collapse-button button{color:#fff;display:inline-flex;padding:0}#sidebar #collapse-button button .menu-text{margin-right:10px}#sidebar .list-group{background-color:#333;min-height:calc(100vh - 46px);border-radius:0}#sidebar .fa{margin-right:6px}#sidebar div[sidebar-links]{z-index:1}#sidebar div[sidebar-links] div[dropdown-content] .list-group-item{padding-left:30px}#sidebar div[sidebar-links] div[dropdown-content] div[dropdown-content] .list-group-item{padding-left:45px}@media (max-width: 768px){#sidebar{width:60px;overflow-y:auto;overflow-x:visible}#sidebar .fa{margin-right:0}#sidebar #logoBrand{display:inline-block!important}#sidebar #fullLogoBrand{display:none!important}#sidebar .menu-text{display:none}#sidebar::-webkit-scrollbar{width:0}#sidebar,#sidebar .list-group{min-width:1px;overflow:visible}#sidebar .list-group .collapse.show,#sidebar .list-group .collapsing{position:relative;z-index:1;top:0}#sidebar div[sidebar-links] .list-group-item,#sidebar div[sidebar-links] div[dropdown-content] .list-group-item{padding-left:20px!important;text-align:left;overflow:visible}#sidebar div[sidebar-links] .list-group-item .fa,#sidebar div[sidebar-links] div[dropdown-content] .list-group-item .fa{vertical-align:middle;min-width:20px;text-align:center}#sidebar div[sidebar-links] .list-group-item .item-label,#sidebar div[sidebar-links] div[dropdown-content] .list-group-item .item-label{font-size:small;vertical-align:middle;width:100%;overflow:hidden;text-overflow:ellipsis}#sidebar .list-group-item:not(.sidebar-brand):hover,#sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show,#sidebar .list-group-item:not(.sidebar-brand):hover .collapsing{width:auto;padding-right:25px;border-radius:0 10px 10px 0}#sidebar .list-group-item:not(.sidebar-brand):hover .fa,#sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .fa,#sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .fa{margin-right:6px!important}#sidebar .list-group-item:not(.sidebar-brand):hover .item-label,#sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .item-label,#sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .item-label{display:inherit!important}#sidebar .list-group-item{text-align:center;font-size:20px;float:none}#sidebar .list-group-item .item-label{display:none}#sidebar .list-group-item[aria-expanded=true]:after,#sidebar .list-group-item[aria-expanded=false]:after{display:none}#sidebar #collapse-button{display:none!important}}#sidebar-container.toggled #sidebar{width:60px;overflow-y:auto;overflow-x:visible}#sidebar-container.toggled #sidebar .fa{margin-right:0}#sidebar-container.toggled #sidebar #logoBrand{display:inline-block!important}#sidebar-container.toggled #sidebar #fullLogoBrand{display:none!important}#sidebar-container.toggled #sidebar .menu-text{display:none}#sidebar-container.toggled #sidebar::-webkit-scrollbar{width:0}#sidebar-container.toggled #sidebar,#sidebar-container.toggled #sidebar .list-group{min-width:1px;overflow:visible}#sidebar-container.toggled #sidebar .list-group .collapse.show,#sidebar-container.toggled #sidebar .list-group .collapsing{position:relative;z-index:1;top:0}#sidebar-container.toggled #sidebar div[sidebar-links] .list-group-item,#sidebar-container.toggled #sidebar div[sidebar-links] div[dropdown-content] .list-group-item{padding-left:20px!important;text-align:left;overflow:visible}#sidebar-container.toggled #sidebar div[sidebar-links] .list-group-item .fa,#sidebar-container.toggled #sidebar div[sidebar-links] div[dropdown-content] .list-group-item .fa{vertical-align:middle;min-width:20px;text-align:center}#sidebar-container.toggled #sidebar div[sidebar-links] .list-group-item .item-label,#sidebar-container.toggled #sidebar div[sidebar-links] div[dropdown-content] .list-group-item .item-label{font-size:small;vertical-align:middle;width:100%;overflow:hidden;text-overflow:ellipsis}#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapsing{width:auto;padding-right:25px;border-radius:0 10px 10px 0}#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .fa,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .fa,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .fa{margin-right:6px!important}#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .item-label,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapse.show .item-label,#sidebar-container.toggled #sidebar .list-group-item:not(.sidebar-brand):hover .collapsing .item-label{display:inherit!important}#sidebar-container.toggled #sidebar .list-group-item{text-align:center;font-size:20px;float:none}#sidebar-container.toggled #sidebar .list-group-item .item-label{display:none}#sidebar-container.toggled #sidebar .list-group-item[aria-expanded=true]:after,#sidebar-container.toggled #sidebar .list-group-item[aria-expanded=false]:after{display:none}.collapse.show{visibility:visible}.collapsing{visibility:visible;height:0;transition-property:height,visibility;transition-timing-function:ease-out}.collapsing.width{transition-property:width,visibility;width:0;height:100%;transition-timing-function:ease-out}\n"] }]
    }], null, { isToggled: [{
            type: Input
        }], toggleChange: [{
            type: Output
        }], environment: [{
            type: Input
        }], user: [{
            type: Input
        }] }); })();

/**
 * Organisms user details component (organisms-user-details.component.ts).
 * Organisms -> User Details Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.2.0 LIBNGSG-19 Update typeahead component to be compatible with Angular forms
 * 1.1.0 LIBNGSG-17 Template driven input form validation
 *
 */
const _c0$8 = ["userDetailsForm"];
/**
 * User Type
 * @since 1.1.0
 */
class User {
    // Strings
    id;
    image;
    employeeId;
    firstName;
    lastName;
    displayName;
    phoneNumber;
    username;
    state;
}
class OrganismsUserDetailsComponent {
    // Sample options
    options = [
        {
            label: 'Alabama',
        },
        {
            label: 'Alaska',
        },
        {
            label: 'Arizona',
        },
    ];
    // Two Way Data Binding
    model = new User();
    modelChange = new EventEmitter();
    // Form
    userDetailsForm;
    /** @nocollapse */ static ɵfac = function OrganismsUserDetailsComponent_Factory(t) { return new (t || OrganismsUserDetailsComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: OrganismsUserDetailsComponent, selectors: [["bc-organisms-user-details"]], viewQuery: function OrganismsUserDetailsComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$8, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.userDetailsForm = _t.first);
        } }, inputs: { model: "model" }, outputs: { modelChange: "modelChange" }, decls: 32, vars: 48, consts: [[1, "row"], [1, "container-fluid"], ["userDetailsForm", "ngForm"], [1, "col-xs-6"], ["labelIcon", "user", "labelTitle", "First Name", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "userDetailsFirstName", "name", "userDetailsFirstName", "placeholder", "First Name", 3, "required", "model", "ngModel", "modelChange", "ngModelChange"], ["firstNameControl", "ngModel"], ["labelIcon", "user", "labelTitle", "Last Name", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "userDetailsLastName", "name", "userDetailsLastName", "placeholder", "Last Name", 3, "required", "model", "ngModel", "modelChange", "ngModelChange"], ["lastNameControl", "ngModel"], [1, "col-xs-12"], ["labelIcon", "user", "labelTitle", "Display Name", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "userDetailsDisplayName", "name", "userDetailsDisplayName", "placeholder", "Display Name", 3, "required", "model", "ngModel", "modelChange", "ngModelChange"], ["displayNameControl", "ngModel"], ["labelIcon", "user", "labelTitle", "Employee ID", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "userDetailsEmployeeID", "name", "userDetailsEmployeeID", "placeholder", "Employee ID", 3, "required", "model", "ngModel", "modelChange", "ngModelChange"], ["employeeIdControl", "ngModel"], ["labelIcon", "email", "labelTitle", "E-mail / Username", 3, "required", "state", "stateInput", "stateTrigger"], ["id", "userDetailsUsername", "name", "userDetailsUsername", "placeholder", "Username", "email", "", 3, "required", "model", "ngModel", "modelChange", "ngModelChange"], ["usernameControl", "ngModel"], ["labelIcon", "phone", "labelTitle", "Phone Number", 3, "state", "stateInput", "stateTrigger"], ["id", "userDetailsPhoneNumber", "name", "userDetailsPhoneNumber", "placeholder", "Phone Number", 3, "model", "ngModel", "modelChange", "ngModelChange"], ["phoneNumberControl", "ngModel"], ["labelIcon", "country", "labelTitle", "Country", 3, "state", "stateInput", "stateTrigger"], ["id", "state", "name", "state", "title", "User Country", "placeholder", "User Country", "labelKey", "label", "required", "true", 3, "disabled", "canClear", "options", "model", "ngModel", "modelChange", "ngModelChange"], ["stateControl", "ngModel"]], template: function OrganismsUserDetailsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "form", null, 2)(4, "div", 3)(5, "bc-atoms-input-group", 4)(6, "bc-atoms-input", 5, 6);
            i0.ɵɵlistener("modelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_modelChange_6_listener($event) { return ctx.model.firstName = $event; })("ngModelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_ngModelChange_6_listener($event) { return ctx.model.firstName = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(8, "div", 3)(9, "bc-atoms-input-group", 7)(10, "bc-atoms-input", 8, 9);
            i0.ɵɵlistener("modelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_modelChange_10_listener($event) { return ctx.model.lastName = $event; })("ngModelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_ngModelChange_10_listener($event) { return ctx.model.lastName = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(12, "div", 10)(13, "bc-atoms-input-group", 11)(14, "bc-atoms-input", 12, 13);
            i0.ɵɵlistener("modelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_modelChange_14_listener($event) { return ctx.model.displayName = $event; })("ngModelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_ngModelChange_14_listener($event) { return ctx.model.displayName = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(16, "div", 10)(17, "bc-atoms-input-group", 14)(18, "bc-atoms-input", 15, 16);
            i0.ɵɵlistener("modelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_modelChange_18_listener($event) { return ctx.model.employeeId = $event; })("ngModelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_ngModelChange_18_listener($event) { return ctx.model.employeeId = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(20, "div", 10)(21, "bc-atoms-input-group", 17)(22, "bc-atoms-input", 18, 19);
            i0.ɵɵlistener("modelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_modelChange_22_listener($event) { return ctx.model.username = $event; })("ngModelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_ngModelChange_22_listener($event) { return ctx.model.username = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(24, "div", 3)(25, "bc-atoms-input-group", 20)(26, "bc-atoms-input", 21, 22);
            i0.ɵɵlistener("modelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_modelChange_26_listener($event) { return ctx.model.phoneNumber = $event; })("ngModelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_input_ngModelChange_26_listener($event) { return ctx.model.phoneNumber = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(28, "div", 3)(29, "bc-atoms-input-group", 23)(30, "bc-atoms-typeahead", 24, 25);
            i0.ɵɵlistener("modelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_typeahead_modelChange_30_listener($event) { return ctx.model.state = $event; })("ngModelChange", function OrganismsUserDetailsComponent_Template_bc_atoms_typeahead_ngModelChange_30_listener($event) { return ctx.model.state = $event; });
            i0.ɵɵelementEnd()()()()()();
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(7);
            const _r2 = i0.ɵɵreference(11);
            const _r3 = i0.ɵɵreference(15);
            const _r4 = i0.ɵɵreference(19);
            const _r5 = i0.ɵɵreference(23);
            const _r6 = i0.ɵɵreference(27);
            const _r7 = i0.ɵɵreference(31);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("required", true)("state", _r1.status)("stateInput", _r1.errors)("stateTrigger", _r1.invalid && _r1.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("model", ctx.model.firstName)("ngModel", ctx.model.firstName);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r2.status)("stateInput", _r2.errors)("stateTrigger", _r2.invalid && _r2.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("model", ctx.model.lastName)("ngModel", ctx.model.lastName);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r3.status)("stateInput", _r3.errors)("stateTrigger", _r3.invalid && _r3.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("model", ctx.model.displayName)("ngModel", ctx.model.displayName);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r4.status)("stateInput", _r4.errors)("stateTrigger", _r4.invalid && _r4.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("model", ctx.model.employeeId)("ngModel", ctx.model.employeeId);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("state", _r5.status)("stateInput", _r5.errors)("stateTrigger", _r5.invalid && _r5.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("model", ctx.model.username)("ngModel", ctx.model.username);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("state", _r6.status)("stateInput", _r6.errors)("stateTrigger", _r6.invalid && _r6.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model.phoneNumber)("ngModel", ctx.model.phoneNumber);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("state", _r7.status)("stateInput", _r7.errors)("stateTrigger", _r7.invalid && _r7.touched);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", false)("canClear", true)("options", ctx.options)("model", ctx.model.state)("ngModel", ctx.model.state);
        } }, dependencies: [AtomsInputComponent, AtomsInputGroupComponent, AtomsTypeaheadComponent, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.EmailValidator, i2.NgModel, i2.NgForm], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganismsUserDetailsComponent, [{
        type: Component,
        args: [{ selector: 'bc-organisms-user-details', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<!--\n - Organisms user details component (organisms-user-details.component.html).\n - Organism -> User Details Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @author Erik Orozco <eorozco@intersog.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.1.0 LIBNGSG-17 Template driven input form validation\n - 1.2.0 LIBNGSG-19 Update typeahead component to be compatible with Angular forms\n -\n -->\n<div class=\"row\">\n  <div class=\"container-fluid\">\n    <form #userDetailsForm=\"ngForm\">\n      <!--First Name-->\n      <div class=\"col-xs-6\">\n        <bc-atoms-input-group\n          labelIcon=\"user\"\n          labelTitle=\"First Name\"\n          [required]=\"true\"\n          [state]=\"firstNameControl.status\"\n          [stateInput]=\"firstNameControl.errors\"\n          [stateTrigger]=\"firstNameControl.invalid && (firstNameControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"userDetailsFirstName\"\n            name=\"userDetailsFirstName\"\n            placeholder=\"First Name\"\n            [required]=\"true\"\n            [(model)]=\"model.firstName\"\n            [(ngModel)]=\"model.firstName\"\n            #firstNameControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--Last Name-->\n      <div class=\"col-xs-6\">\n        <bc-atoms-input-group\n          labelIcon=\"user\"\n          labelTitle=\"Last Name\"\n          [required]=\"true\"\n          [state]=\"lastNameControl.status\"\n          [stateInput]=\"lastNameControl.errors\"\n          [stateTrigger]=\"lastNameControl.invalid && (lastNameControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"userDetailsLastName\"\n            name=\"userDetailsLastName\"\n            placeholder=\"Last Name\"\n            [required]=\"true\"\n            [(model)]=\"model.lastName\"\n            [(ngModel)]=\"model.lastName\"\n            #lastNameControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--Display Name-->\n      <div class=\"col-xs-12\">\n        <bc-atoms-input-group\n          labelIcon=\"user\"\n          labelTitle=\"Display Name\"\n          [required]=\"true\"\n          [state]=\"displayNameControl.status\"\n          [stateInput]=\"displayNameControl.errors\"\n          [stateTrigger]=\"displayNameControl.invalid && (displayNameControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"userDetailsDisplayName\"\n            name=\"userDetailsDisplayName\"\n            placeholder=\"Display Name\"\n            [required]=\"true\"\n            [(model)]=\"model.displayName\"\n            [(ngModel)]=\"model.displayName\"\n            #displayNameControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--Employee ID-->\n      <div class=\"col-xs-12\">\n        <bc-atoms-input-group\n          labelIcon=\"user\"\n          labelTitle=\"Employee ID\"\n          [required]=\"true\"\n          [state]=\"employeeIdControl.status\"\n          [stateInput]=\"employeeIdControl.errors\"\n          [stateTrigger]=\"employeeIdControl.invalid && (employeeIdControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"userDetailsEmployeeID\"\n            name=\"userDetailsEmployeeID\"\n            placeholder=\"Employee ID\"\n            [required]=\"true\"\n            [(model)]=\"model.employeeId\"\n            [(ngModel)]=\"model.employeeId\"\n            #employeeIdControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--E-mail/Username-->\n      <div class=\"col-xs-12\">\n        <bc-atoms-input-group\n          labelIcon=\"email\"\n          labelTitle=\"E-mail / Username\"\n          [required]=\"true\"\n          [state]=\"usernameControl.status\"\n          [stateInput]=\"usernameControl.errors\"\n          [stateTrigger]=\"usernameControl.invalid && (usernameControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"userDetailsUsername\"\n            name=\"userDetailsUsername\"\n            placeholder=\"Username\"\n            [required]=\"true\"\n            [(model)]=\"model.username\"\n            [(ngModel)]=\"model.username\"\n            email\n            #usernameControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--Phone Number-->\n      <div class=\"col-xs-6\">\n        <bc-atoms-input-group\n          labelIcon=\"phone\"\n          labelTitle=\"Phone Number\"\n          [state]=\"phoneNumberControl.status\"\n          [stateInput]=\"phoneNumberControl.errors\"\n          [stateTrigger]=\"phoneNumberControl.invalid && (phoneNumberControl.touched)\"\n        >\n          <bc-atoms-input\n            id=\"userDetailsPhoneNumber\"\n            name=\"userDetailsPhoneNumber\"\n            placeholder=\"Phone Number\"\n            [(model)]=\"model.phoneNumber\"\n            [(ngModel)]=\"model.phoneNumber\"\n            #phoneNumberControl=\"ngModel\"\n          ></bc-atoms-input>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--State-->\n      <div class=\"col-xs-6\">\n        <bc-atoms-input-group\n          labelIcon=\"country\"\n          labelTitle=\"Country\"\n          [state]=\"stateControl.status\"\n          [stateInput]=\"stateControl.errors\"\n          [stateTrigger]=\"stateControl.invalid && (stateControl.touched)\"\n        >\n          <bc-atoms-typeahead\n            id=\"state\"\n            name=\"state\"\n            title=\"User Country\"\n            placeholder=\"User Country\"\n            labelKey=\"label\"\n            [disabled]=\"false\"\n            [canClear]=\"true\"\n            required=\"true\"\n            [options]=\"options\"\n            [(model)]=\"model.state\"\n            [(ngModel)]=\"model.state\"\n            #stateControl=\"ngModel\"\n          >\n          </bc-atoms-typeahead>\n        </bc-atoms-input-group>\n      </div>\n\n      <!--Password-->\n      <!--Company / Division-->\n      <!--User Group-->\n      <!--Environment-->\n      <!--Organisation-->\n    </form>\n  </div>\n</div>\n" }]
    }], null, { model: [{
            type: Input
        }], modelChange: [{
            type: Output
        }], userDetailsForm: [{
            type: ViewChild,
            args: ['userDetailsForm', { static: true }]
        }] }); })();

/**
 * Create Assembly Order Statuses panel
 */
function colorsLegendOverlayPanel(panelContainer_1, panelId, panelTitle, panelContent) {
    // Wrapping in function as Autodesk namespace might not be defined
    class ColorsLegendOverlayPanel extends Autodesk.Viewing.UI.DockingPanel {
        orderStatusesData;
        /**
         * Constructor
         */
        constructor(parentContainer, id, title, content) {
            super(parentContainer, id, title);
            this.orderStatusesData = content;
            // Create Assembly Order colors legend overlay
            this.container.innerHTML = `
                <div class='colors-legend'>
                    <div class='legend-title'>Order Takeoff Statuses</div>
                    <div class='legend-scale'>
                        <ul class='legend-labels'>
                            ${Object.entries(this.orderStatusesData.statusColor)
                .map(([status, color]) => `
                                          <li><span style='background:#${color};'></span>${status}</li>
                                          `)
                .join('')}
                        </ul>
                    </div>
                </div>
            `;
        }
        /**
         * Initialize panel
         */
        initialize() {
            this.container.style.top = '50px';
            this.container.classList.add('movable-container');
            // Allow move
            this.initializeMoveHandlers(this.container);
        }
    }
    const panel = new ColorsLegendOverlayPanel(panelContainer_1, panelId, panelTitle, panelContent);
    panel?.setVisible(true);
    return panel;
}
/**
 * Registers the ToggleAssemblyStatusColorExtension with Autodesk Viewer.
 */
async function registerAssemblyStatusColourExtension() {
    try {
        /**
         * Forge Viewer Extension: ToggleAssemblyStatusColorExtension
         */
        class ToggleAssemblyStatusColorExtension extends Autodesk.Viewing
            .Extension {
            /**
             * Panel
             */
            legendOverlayPanel;
            /**
             * To expose the click event outside of extension
             */
            assemblyStatusColorEmitter;
            /**
             * Reset status colors
             */
            resetColorStatus = false;
            /**
             * order statuses
             */
            orderStatuses = {};
            /**
             * Viewer object
             */
            viewer = {};
            /**
             * Constructor
             */
            constructor(viewer, options) {
                super(viewer, options);
                this.viewer = viewer;
                this.assemblyStatusColorEmitter = options.assemblyStatusColorEmitter;
                this.orderStatuses = options.orderStatusesData;
                // Initialize status colors legend overlay panel, default setVisible to true
                if (this.orderStatuses) {
                    this.legendOverlayPanel = colorsLegendOverlayPanel(this.viewer.container, 'colors-legend-overlay-panel', 'Order Takeoff Statuses', this.orderStatuses);
                    this.legendOverlayPanel.setVisible(true);
                }
            }
            /**
             * Load extension
             */
            load() {
                this.resetColorStatus = false;
                if (this.assemblyStatusColorEmitter.observers.length === 0) {
                    const ext = this.viewer.getExtension('BCX.ToggleAssemblyStatusColorExtension');
                    ext?.assemblyStatusColorEmitter.emit({
                        isAssemblyResetColor: this.resetColorStatus,
                    });
                }
                else {
                    this.assemblyStatusColorEmitter.emit({
                        isAssemblyResetColor: this.resetColorStatus,
                    });
                }
                if (!this.resetColorStatus) {
                    this.legendOverlayPanel.setVisible(true);
                }
                else {
                    if (this.legendOverlayPanel.isVisible()) {
                        this.legendOverlayPanel.setVisible(false);
                    }
                }
                return true;
            }
            /**
             * Add CSS class to BCX toolbar group
             */
            applyCustomClassToToolbarGroup(groupId_2, className) {
                const toolbarGroup = this.viewer.toolbar.getControl(groupId_2);
                if (toolbarGroup) {
                    const groupElement = document.getElementById(toolbarGroup.container.id);
                    if (groupElement) {
                        groupElement.classList.add(className);
                    }
                }
            }
            /**
             * Unload extension
             */
            unload() {
                if (this.legendOverlayPanel) {
                    this.legendOverlayPanel.uninitialize();
                }
                if (this.assemblyStatusColorEmitter.observers.length === 0) {
                    const ext = this.viewer.getExtension('BCX.ToggleAssemblyStatusColorExtension');
                    ext?.assemblyStatusColorEmitter.emit({
                        isAssemblyResetColor: true,
                    });
                }
                else {
                    this.assemblyStatusColorEmitter.emit({
                        isAssemblyResetColor: true,
                    });
                }
                return true;
            }
        }
        // Register the extension with Autodesk Viewer
        Autodesk.Viewing.theExtensionManager.registerExtension('BCX.ToggleAssemblyStatusColorExtension', ToggleAssemblyStatusColorExtension);
    }
    catch (error) {
        console.error('Failed to load BCX.ToggleAssemblyStatusColorExtension.', error);
    }
}

/**
 * Registers the ChangeItemStatusExtension with Autodesk Viewer.
 */
async function registerChangeItemStatusExtension() {
    try {
        /**
         * Forge Viewer Extension: ChangeItemStatusExtension
         */
        class ChangeItemStatusExtension extends Autodesk.Viewing.Extension {
            /**
             * Viewer object
             */
            viewer = {};
            /**
             * To expose the click event outside of extension
             */
            changeItemStatusEmitter;
            /**
             * Constructor
             */
            constructor(viewer, options) {
                super(viewer, options);
                this.viewer = viewer;
                this.changeItemStatusEmitter = options.changeItemStatusEmitter;
            }
            /**
             * Load extension
             */
            load() {
                this.viewer.addEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreated.bind(this));
                return true;
            }
            /**
             * on Toolbar created event
             */
            onToolbarCreated() {
                this.viewer.removeEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreated);
                this.createUI();
            }
            /**
             * Create extension UI
             */
            createUI() {
                const createUpdateStatusButton = new Autodesk.Viewing.UI.Button('Update Status');
                createUpdateStatusButton.onClick = this.handleUpdateStatusButton.bind(this);
                // Added css class to assign icon on button
                createUpdateStatusButton.addClass('update_status_viewer_extension');
                createUpdateStatusButton.setToolTip('Update Status');
                const groupId = 'BCX_custom_toolbar_group';
                const bcxCustomToolbarGroup = this.viewer.toolbar.getControl(groupId);
                if (bcxCustomToolbarGroup) {
                    bcxCustomToolbarGroup.addControl(createUpdateStatusButton);
                }
                else {
                    const subToolbar = new Autodesk.Viewing.UI.ControlGroup(groupId);
                    subToolbar.addControl(createUpdateStatusButton);
                    this.viewer.toolbar.addControl(subToolbar);
                    // Apply custom class to the ControlGroup
                    this.applyCustomClassToToolbarGroup(groupId, 'bcx-custom-toolbar-group');
                }
            }
            /**
             * Add CSS class to BCX toolbar group
             */
            applyCustomClassToToolbarGroup(groupId_2, className) {
                const toolbarGroup = this.viewer.toolbar.getControl(groupId_2);
                if (toolbarGroup) {
                    const groupElement = document.getElementById(toolbarGroup.container.id);
                    if (groupElement) {
                        groupElement.classList.add(className);
                    }
                }
            }
            /**
             * On click of toolbar button
             */
            async handleUpdateStatusButton() {
                if (this.changeItemStatusEmitter.observers.length === 0) {
                    const ext = this.viewer.getExtension('BCX.ChangeItemStatusExtension');
                    ext?.changeItemStatusEmitter.emit({
                        viewer: this.viewer,
                        dbIds: this.viewer.getSelection(),
                    });
                }
                else {
                    this.changeItemStatusEmitter.emit({
                        viewer: this.viewer,
                        dbIds: this.viewer.getSelection(),
                    });
                }
            }
            /**
             * Unload Extension
             */
            unload() {
                return true;
            }
        }
        // Register extension
        Autodesk.Viewing.theExtensionManager.registerExtension('BCX.ChangeItemStatusExtension', ChangeItemStatusExtension);
    }
    catch (error) {
        console.error('Failed to load BCX.ChangeItemStatusExtension.', error);
    }
}

/**
 * Registers the ChangeItemStatusExtension with Autodesk Viewer.
 */
async function registerCreateAssemblyExtension() {
    try {
        /**
         * Forge Viewer Extension: CreateAssemblyExtension
         */
        class CreateAssemblyExtension extends Autodesk.Viewing.Extension {
            /**
             * Viewer Object
             */
            viewer = {};
            /**
             * To expose the click event outside of extension
             */
            createAssemblyEmitter;
            /**
             * Constructor
             */
            constructor(viewer, options) {
                super(viewer, options);
                this.viewer = viewer;
                this.createAssemblyEmitter = options.createAssemblyEmitter;
            }
            /**
             * Load extension
             */
            load() {
                this.viewer.addEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreated.bind(this));
                return true;
            }
            /**
             * On toolbar created event
             */
            onToolbarCreated() {
                this.viewer.removeEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreated);
                this.createUI();
            }
            /**
             * Create extension UI
             */
            createUI() {
                const createAssemblyButton = new Autodesk.Viewing.UI.Button('Create_Assembly');
                createAssemblyButton.onClick = this.handleCreateAssemblyButton.bind(this);
                // Added css class to assign icon on button
                createAssemblyButton.addClass('create_assembly_viewer_extension');
                createAssemblyButton.setToolTip('Create Takeoff');
                const groupId = 'BCX_custom_toolbar_group';
                const bcxCustomToolbarGroup = this.viewer.toolbar.getControl(groupId);
                if (bcxCustomToolbarGroup) {
                    bcxCustomToolbarGroup.addControl(createAssemblyButton);
                }
                else {
                    const subToolbar = new Autodesk.Viewing.UI.ControlGroup(groupId);
                    subToolbar.addControl(createAssemblyButton);
                    this.viewer.toolbar.addControl(subToolbar);
                    // Apply custom class to the ControlGroup
                    this.applyCustomClassToToolbarGroup(groupId, 'bcx-custom-toolbar-group');
                }
            }
            /**
             * Add CSS class to BCX toolbar group
             */
            applyCustomClassToToolbarGroup(groupId_2, className) {
                const toolbarGroup = this.viewer.toolbar.getControl(groupId_2);
                if (toolbarGroup) {
                    const groupElement = document.getElementById(toolbarGroup.container.id);
                    if (groupElement) {
                        groupElement.classList.add(className);
                    }
                }
            }
            /**
             * Get the data for selected entities only
             */
            async handleCreateAssemblyButton() {
                const selectedNodeProperties = await this.getDbIdData();
                const elementIds = await this.getElementIds();
                if (this.createAssemblyEmitter.observers.length === 0) {
                    const ext = this.viewer.getExtension('BCX.CreateAssemblyExtension');
                    ext?.createAssemblyEmitter.emit({
                        elementIds,
                        selectedIds: this.viewer.getSelection(),
                        viewerState: this.viewer.getState(),
                        selectedNodeProperties,
                    });
                }
                else {
                    this.createAssemblyEmitter.emit({
                        elementIds,
                        selectedIds: this.viewer.getSelection(),
                        viewerState: this.viewer.getState(),
                        selectedNodeProperties,
                    });
                }
            }
            /**
             * Get elementIds for selected items
             */
            async getElementIds() {
                const dbIds = this.viewer.getSelection();
                const elementIds_1 = [];
                await Promise.all(dbIds.map(async (id) => {
                    return new Promise((resolve, reject) => {
                        this.viewer.model.getProperties(id, (res) => {
                            res.properties.forEach((element) => {
                                if (element.displayName === 'ElementId') {
                                    elementIds_1.push(element.displayValue);
                                }
                            });
                            resolve(elementIds_1);
                        }, (onError) => {
                            reject(onError);
                        });
                    });
                }));
                return elementIds_1;
            }
            /**
             * Get data associated with dbId
             */
            async getDbIdData() {
                const dbIds_1 = this.viewer.getSelection();
                const selectedIdsDimensions = dbIds_1.map((id_1) => {
                    return this.getProperties(id_1);
                });
                return await Promise.all(selectedIdsDimensions);
            }
            /**
             * Function will be used to get the dimensions from viewer for node id
             */
            getProperties(nodeId_1) {
                return new Promise((resolve_1, reject_1) => {
                    this.viewer.model.getProperties(nodeId_1, (res_1) => {
                        const dimensions = [];
                        const mechanical = [];
                        const insulation = [];
                        const identityData = [];
                        res_1.properties.forEach((element_1) => {
                            if (element_1.displayCategory === 'Dimensions')
                                dimensions.push(element_1);
                            if (element_1.displayCategory === 'Mechanical')
                                mechanical.push(element_1);
                            if (element_1.displayCategory === 'Insulation')
                                insulation.push(element_1);
                            if (element_1.displayCategory === 'Identity Data')
                                identityData.push(element_1);
                        });
                        resolve_1({
                            dbId: res_1.dbId,
                            externalId: res_1.externalId,
                            name: res_1.name,
                            dimensions,
                            mechanical,
                            insulation,
                            identityData,
                        });
                    }, (onError_1) => {
                        reject_1(onError_1);
                    });
                });
            }
            /**
             * Remove forge viewer toolbar button
             */
            removeToolbarButton() {
                const toolbar = this.viewer.toolbar;
                if (toolbar) {
                    const group = toolbar.getControl('BCX_custom_toolbar_group');
                    if (group) {
                        const button = group.getControl('Create_Assembly');
                        if (button)
                            group.removeControl(button);
                    }
                }
            }
            /**
             * Unload extension
             */
            unload() {
                this.removeToolbarButton();
                return true;
            }
        }
        // Register the extension with Autodesk Viewer
        Autodesk.Viewing.theExtensionManager.registerExtension('BCX.CreateAssemblyExtension', CreateAssemblyExtension);
    }
    catch (error) {
        console.error('Failed to load BCX.CreateAssemblyExtension.', error);
    }
}

/**
 * Autodesk Viewer Extension Event Service (autodesk-viewer-extension-event.service.ts).
 * Services -> Autodesk Viewer Extension Event Service
 *
 * This service designed to manage a shared EventEmitter
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2025 Build Centrix
 */
class AutodeskViewerExtensionEventService {
    static _instance;
    createOrderEmitter = new EventEmitter(); // Shared Emitter
    /**
     * Constructor
     */
    constructor() {
        if (!AutodeskViewerExtensionEventService._instance) {
            AutodeskViewerExtensionEventService._instance = this;
        }
        return AutodeskViewerExtensionEventService._instance;
    }
    /**
     * Provides access to the singleton instance of the service.
     */
    static getInstance() {
        return this._instance || new AutodeskViewerExtensionEventService();
    }
    /**
     * Store the latest EventEmitter from options (if provided)
     */
    setCreateOrderEmitter(emitter) {
        if (emitter) {
            this.createOrderEmitter = emitter;
        }
    }
    /** @nocollapse */ static ɵfac = function AutodeskViewerExtensionEventService_Factory(t) { return new (t || AutodeskViewerExtensionEventService)(); };
    /** @nocollapse */ static ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: AutodeskViewerExtensionEventService, factory: AutodeskViewerExtensionEventService.ɵfac, providedIn: 'root' });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutodeskViewerExtensionEventService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

/**
 * Registers the CreateOrderExtension with Autodesk Viewer.
 */
async function registerCreateOrderExtension() {
    try {
        /**
         * Forge Viewer Extension: CreateOrderExtension
         */
        class CreateOrderExtension extends Autodesk.Viewing.Extension {
            /**
             * Viewer object
             */
            viewer = {};
            /**
             * Assemblies list
             */
            assembliesList = [];
            /**
             * Assemblies List Dialog
             */
            assembliesListDialog;
            /**
             * Selected assembly
             */
            selectedAssembly;
            /**
             * Item selection changed callback
             */
            selectionChangedCallback;
            /**
             * To expose the click event outside of extension
             */
            createOrderEmitter;
            /**
             * Ignore selection event if items selected programmatically
             */
            ignoreSelectionEvent;
            /**
             * Constructor
             */
            constructor(viewer, options) {
                super(viewer, options);
                this.viewer = viewer;
                this.assembliesList = options.assembliesList || [];
                this.selectionChangedCallback = this.onSelectionChanged.bind(this);
                const eventService = AutodeskViewerExtensionEventService.getInstance();
                if (options.createOrderEmitter) {
                    this.createOrderEmitter = options.createOrderEmitter;
                    // If EventEmitter is provided, store it in the service for reuse
                    eventService.setCreateOrderEmitter(options.createOrderEmitter);
                }
                else {
                    this.createOrderEmitter = eventService.createOrderEmitter;
                }
                this.assembliesListDialog = null;
                this.selectedAssembly = null;
                this.ignoreSelectionEvent = false;
            }
            /**
             * Load extension
             */
            load() {
                this.viewer.addEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreated.bind(this));
                this.viewer.removeEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this.selectionChangedCallback);
                // Listen for selection changed event
                this.viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this.selectionChangedCallback);
                return true;
            }
            /**
             * On item selection changed event
             */
            onSelectionChanged(event) {
                if (!event.dbIdArray || event.dbIdArray.length === 0) {
                    this.selectedAssembly = null; // Clear selected assembly
                    return;
                }
                // Handle assembly selection for user selected assembly item from forge viewer
                if (event.dbIdArray.length === 1) {
                    if (this.ignoreSelectionEvent) {
                        return; // Prevent handling selection change
                    }
                    this.selectedAssembly = null;
                    const selectedDbId = event.dbIdArray[0];
                    if (!selectedDbId)
                        return;
                    const filteredAssemblies = this.getMatchingAssemblies(selectedDbId);
                    if (filteredAssemblies.length > 1) {
                        this.showAssembliesListDialog(filteredAssemblies);
                    }
                    else if (filteredAssemblies.length === 1) {
                        // Disable the event listener
                        this.ignoreSelectionEvent = true;
                        this.selectedAssembly = filteredAssemblies[0];
                        this.viewer.select(filteredAssemblies[0].selectedIds);
                        // Re-enable the event listener after a short delay
                        setTimeout(() => {
                            this.ignoreSelectionEvent = false;
                        }, 100);
                    }
                }
            }
            /**
             * Add styles for the dialog box dynamically
             */
            addDialogStyles() {
                if (!document.getElementById('assembly-dialog-styles')) {
                    const style = document.createElement('style');
                    style.id = 'assembly-dialog-styles';
                    style.innerHTML = `
                        .assembly-dialog {
                            position: fixed;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 300px;
                            background: white;
                            border-radius: 10px;
                            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
                            padding: 20px;
                            z-index: 1000;
                            display: none;
                        }
                        .assembly-dialog h3 {
                            margin-top: 0;
                            font-size: 18px;
                            text-align: center;
                            border-bottom: 1px solid #ccc;
                            padding-bottom: 10px;
                        }
                        .assembly-list {
                            list-style: none;
                            padding: 0;
                            margin: 10px 0;
                            max-height: 200px;
                            overflow-y: auto;
                        }
                        .assembly-item {
                            padding: 10px;
                            border-bottom: 1px solid #ddd;
                            cursor: pointer;
                            text-align: center;
                            transition: background 0.2s;
                        }
                        .assembly-item:hover {
                            background: #0078D7;
                            color: white;
                        }
                        .close-dialog {
                            position: absolute;
                            top: 10px;
                            right: 10px;
                            cursor: pointer;
                            font-size: 16px;
                            background: none;
                            border: none;
                            color: #333;
                        }
                        .close-dialog:hover {
                            color: red;
                        }
                    `;
                    document.head.appendChild(style);
                }
            }
            /**
             * Show assembly selection dialog
             */
            showAssembliesListDialog(assemblies) {
                if (!this.assembliesListDialog) {
                    this.createAssembliesListDialog();
                }
                this.populateAssembliesListDialog(assemblies);
                this.assembliesListDialog.style.display = 'block';
            }
            /**
             * Create the dialog HTML structure
             */
            createAssembliesListDialog() {
                this.assembliesListDialog = document.createElement('div');
                this.assembliesListDialog.id = 'assembly-selection-dialog';
                this.assembliesListDialog.classList.add('assembly-dialog');
                const title = document.createElement('h3');
                title.innerText = 'Select Takeoff';
                this.assembliesListDialog.appendChild(title);
                const closeButton = document.createElement('button');
                closeButton.innerText = '✖';
                closeButton.classList.add('close-dialog');
                closeButton.onclick = () => {
                    this.assembliesListDialog.style.display = 'none';
                };
                this.assembliesListDialog.appendChild(closeButton);
                const listContainer = document.createElement('ul');
                listContainer.id = 'assembly-list';
                listContainer.classList.add('assembly-list');
                this.assembliesListDialog.appendChild(listContainer);
                document.body.appendChild(this.assembliesListDialog);
                this.addDialogStyles(); // Apply styles
            }
            /**
             * Populate the dialog with assemblies
             */
            populateAssembliesListDialog(assemblies) {
                const listContainer = this.assembliesListDialog.querySelector('#assembly-list');
                listContainer.innerHTML = '';
                assemblies.forEach((assembly) => {
                    const listItem = document.createElement('li');
                    listItem.innerText = assembly.name;
                    listItem.classList.add('assembly-item');
                    listItem.addEventListener('click', () => {
                        this.onAssemblySelected(assembly);
                    });
                    listContainer.appendChild(listItem);
                });
            }
            /**
             * Handle assembly selection
             */
            onAssemblySelected(selectedAssembly) {
                // Disable the event listener
                this.ignoreSelectionEvent = true;
                this.selectedAssembly = selectedAssembly;
                this.assembliesListDialog.style.display = 'none';
                this.viewer.select(selectedAssembly.selectedIds);
                // Re-enable the event listener after a short delay
                setTimeout(() => {
                    this.ignoreSelectionEvent = false;
                }, 100);
            }
            /**
             * Get matching assemblies for selected id
             */
            getMatchingAssemblies(selectedId) {
                return this.assembliesList.filter((assembly) => assembly.selectedIds.includes(selectedId));
            }
            /**
             * on Toolbar created event
             */
            onToolbarCreated() {
                this.viewer.removeEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreated);
                this.createUI();
            }
            /**
             * Create extension UI
             */
            createUI() {
                const createOrderButton = new Autodesk.Viewing.UI.Button('Create Order');
                createOrderButton.onClick = this.handleCreateOrder;
                // Added css class to assign icon on button
                createOrderButton.addClass('create_order_viewer_extension');
                createOrderButton.setToolTip('Create Order');
                const groupId = 'BCX_custom_toolbar_group';
                const bcxCustomToolbarGroup = this.viewer.toolbar.getControl(groupId);
                if (bcxCustomToolbarGroup) {
                    const createOrderBtnControl = bcxCustomToolbarGroup.getControl('Create Order');
                    if (createOrderBtnControl) {
                        bcxCustomToolbarGroup.removeControl(createOrderBtnControl);
                    }
                    bcxCustomToolbarGroup.addControl(createOrderButton);
                }
                else {
                    const subToolbar = new Autodesk.Viewing.UI.ControlGroup(groupId);
                    subToolbar.addControl(createOrderButton);
                    this.viewer.toolbar.addControl(subToolbar);
                    // Apply custom class to the ControlGroup
                    this.applyCustomClassToToolbarGroup(groupId, 'bcx-custom-toolbar-group');
                }
            }
            /**
             * Add CSS class to BCX toolbar group
             */
            applyCustomClassToToolbarGroup(groupId_2, className) {
                const toolbarGroup = this.viewer.toolbar.getControl(groupId_2);
                if (toolbarGroup) {
                    const groupElement = document.getElementById(toolbarGroup.container.id);
                    if (groupElement) {
                        groupElement.classList.add(className);
                    }
                }
            }
            /**
             * On click of toolbar button
             */
            handleCreateOrder = () => {
                if (this.createOrderEmitter.observers.length === 0) {
                    const ext = this.viewer.getExtension('BCX.CreateOrderExtension');
                    ext?.createOrderEmitter.emit({
                        selectedAssembly: this.selectedAssembly,
                    });
                }
                else {
                    this.createOrderEmitter.emit({
                        selectedAssembly: this.selectedAssembly,
                    });
                }
                //Ensure event is emitted before assigning null
                setTimeout(() => {
                    this.selectedAssembly = null;
                }, 100);
            };
            /**
             * Remove forge viewer toolbar button
             */
            removeToolbarButton() {
                const toolbar = this.viewer.toolbar;
                if (toolbar) {
                    const group = toolbar.getControl('BCX_custom_toolbar_group');
                    if (group) {
                        const button = group.getControl('Create Order');
                        if (button)
                            group.removeControl(button);
                    }
                }
            }
            /**
             * Unload Extension
             */
            unload() {
                this.selectedAssembly = null;
                this.removeToolbarButton();
                this.viewer.removeEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this.selectionChangedCallback);
                return true;
            }
        }
        // Register extension
        Autodesk.Viewing.theExtensionManager.registerExtension('BCX.CreateOrderExtension', CreateOrderExtension);
    }
    catch (error) {
        console.error('Failed to load BCX.CreateOrderExtension.', error);
    }
}

/**
 * text-geometry-three-full.adapter.ts
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2025 Build Centrix
 */
/**
 * TextGeometryThreeFullAdapter handles the creation of text geometry.
 */
class TextGeometryThreeFullAdapter {
    /**
     * Creates text geometry for the given name with a specific size and height.
     * @param name The name to display as text.
     * @param fontJson The font for the name.
     */
    async createTextGeometry(name, fontJson) {
        const font = new Font(fontJson);
        // Create geometry with the provided font, size, and height
        const geometry = new TextGeometry(name, {
            font: font,
            size: 0.7,
            height: 0.0001,
            curveSegments: 12,
        });
        // Compute bounding box to adjust the text position
        geometry.computeBoundingBox();
        const textBBox = geometry.boundingBox;
        const textCenter = textBBox.getCenter();
        geometry.translate(-textCenter.x, -textCenter.y, -textCenter.z);
        return geometry;
    }
    /** @nocollapse */ static ɵfac = function TextGeometryThreeFullAdapter_Factory(t) { return new (t || TextGeometryThreeFullAdapter)(); };
    /** @nocollapse */ static ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: TextGeometryThreeFullAdapter, factory: TextGeometryThreeFullAdapter.ɵfac, providedIn: 'root' });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextGeometryThreeFullAdapter, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

/**
 * bcx-text-geometry.service.ts
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2025 Build Centrix
 */
class BcxTextGeometryService {
    textGeometryAdapter;
    constructor() {
        this.textGeometryAdapter = new TextGeometryThreeFullAdapter();
    }
    /**
     * Creates text geometry for the given name.
     * @param name The name to display as text.
     * @param fontJson The font for the name.
     */
    async createTextGeometry(name, fontJson) {
        return this.textGeometryAdapter.createTextGeometry(name, fontJson);
    }
    /** @nocollapse */ static ɵfac = function BcxTextGeometryService_Factory(t) { return new (t || BcxTextGeometryService)(); };
    /** @nocollapse */ static ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: BcxTextGeometryService, factory: BcxTextGeometryService.ɵfac, providedIn: 'root' });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BcxTextGeometryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class ForgeViewerUtils {
    /**
     * Get fragment ids
     */
    static async getFragIds(model, dbIds) {
        return new Promise((resolve, reject) => {
            try {
                const it = model.getData().instanceTree;
                dbIds = dbIds || it.getRootId();
                const dbIdArray = Array.isArray(dbIds) ? dbIds : [dbIds];
                // Call async function separately
                this.getLeafNodes(model, dbIdArray)
                    .then((leafIds) => {
                    let fragIds = [];
                    for (let i = 0; i < leafIds.length; ++i) {
                        if (it) {
                            it.enumNodeFragments(leafIds[i], (fragId) => {
                                fragIds.push(fragId);
                            });
                        }
                        else {
                            const leafFragIds = this.getLeafFragIds(model, leafIds[i]);
                            fragIds = [...fragIds, ...leafFragIds];
                        }
                    }
                    resolve(fragIds);
                })
                    .catch((ex) => reject(ex));
            }
            catch (ex) {
                reject(ex);
            }
        });
    }
    /**
     * Get leaf nodes
     */
    static async getLeafNodes(model, dbIds) {
        return new Promise((resolve, reject) => {
            try {
                const instanceTree = model.getData().instanceTree || model.getFragmentMap();
                dbIds = dbIds || instanceTree.getRootId();
                const dbIdArray = Array.isArray(dbIds) ? dbIds : [dbIds];
                const leafIds = [];
                const getLeafNodeIdsRec = (id) => {
                    let childCount = 0;
                    instanceTree.enumNodeChildren(id, (childId) => {
                        getLeafNodeIdsRec(childId);
                        ++childCount;
                    });
                    if (childCount === 0) {
                        leafIds.push(id);
                    }
                };
                dbIdArray.forEach((dbId) => {
                    getLeafNodeIdsRec(dbId);
                });
                return resolve(leafIds);
            }
            catch (ex) {
                return reject(ex);
            }
        });
    }
    /**
     * Get leaf fragment IDs
     */
    static getLeafFragIds(model, leafId) {
        if (model.getData().instanceTree) {
            const it = model.getData().instanceTree;
            const fragIds = [];
            it.enumNodeFragments(leafId, (fragId) => {
                fragIds.push(fragId);
            });
            return fragIds;
        }
        else {
            const fragments = model.getData().fragments;
            const fragIds = fragments.dbId2fragId[leafId];
            return !Array.isArray(fragIds) ? [fragIds] : fragIds;
        }
    }
    /**
     * Get modified bounding box
     */
    static getModifiedWorldBoundingBox(fragIds, fragList) {
        const fragbBox = new THREE.Box3();
        const nodebBox = new THREE.Box3();
        fragIds.forEach(function (fragId) {
            fragList.getWorldBounds(fragId, fragbBox);
            nodebBox.union(fragbBox);
        });
        return nodebBox;
    }
}

/**
 * Registers the ToggleAssemblyLabelExtension with Autodesk Viewer.
 */
async function registerAssemblyLabelExtension() {
    try {
        /**
         * Forge Viewer Extension: ToggleAssemblyLabelExtension
         */
        class ToggleAssemblyLabelExtension extends Autodesk.Viewing.Extension {
            /**
             * Viewer object
             */
            viewer = {};
            /**
             * Assemblies list
             */
            assembliesList = [];
            /**
             * Assembly name label div
             */
            labelDiv;
            /**
             * Text geometry service
             */
            bcxTextGeometryService;
            /**
             * Bounding boxes labels data
             */
            boundingBoxLabelData;
            /**
             * Font json URL
             */
            fontJsonUrl = 'assets/fonts/helvetiker_regular.typeface.json';
            /**
             * Text meshes array
             */
            textMeshes = [];
            /**
             * Constructor
             */
            constructor(viewer, options) {
                super(viewer, options);
                this.viewer = viewer;
                this.assembliesList = options.assembliesList || [];
                this.boundingBoxLabelData = [];
                this.textMeshes = [];
                this.bcxTextGeometryService = new BcxTextGeometryService();
                this.labelDiv = this.createLabelDiv();
            }
            /**
             * Load extension
             */
            async load() {
                this.enableHoverLabels();
                await this.getBoundingBox();
                await this.createLabelsForBBoxes();
                return true;
            }
            /**
             * Create labelDiv element
             */
            createLabelDiv() {
                // HTML for the label
                const labelDiv = document.createElement('div');
                labelDiv.style.zIndex = '1000';
                labelDiv.id = 'hover-label';
                labelDiv.style.position = 'absolute';
                labelDiv.style.pointerEvents = 'none';
                labelDiv.style.background = 'rgba(255, 255, 255, 0.8)';
                labelDiv.style.border = '1px solid #000';
                labelDiv.style.padding = '5px';
                labelDiv.style.display = 'none'; // Initially hidden
                document.body.appendChild(labelDiv);
                return labelDiv;
            }
            /**
             * Enable assembly name as label on hover of item
             */
            enableHoverLabels() {
                if (!this.assembliesList || this.assembliesList.length === 0) {
                    console.warn('No assemblies provided.');
                    return;
                }
                this.viewer.container.addEventListener('mousemove', this.showLabelOnHover.bind(this));
            }
            /**
             * Show assembly name as label on hover of item
             */
            showLabelOnHover(event) {
                const rect = this.viewer.container.getBoundingClientRect();
                const clientX = event.clientX - rect.left;
                const clientY = event.clientY - rect.top;
                const hitTest = this.viewer.impl.hitTest(clientX, clientY, true);
                if (hitTest && hitTest.dbId) {
                    const dbId = hitTest.dbId;
                    // Find all assemblies that include the current dbId
                    const assemblyNames = this.assembliesList
                        .filter((assembly) => assembly.selectedIds.includes(dbId))
                        .map((assembly) => `Takeoff: ${assembly.name}`);
                    if (assemblyNames.length > 0) {
                        const labelText = assemblyNames.join(', ');
                        this.labelDiv.style.display = 'block';
                        this.labelDiv.style.left = `${event.clientX + 10}px`;
                        this.labelDiv.style.top = `${event.clientY + 10}px`;
                        this.labelDiv.textContent = labelText;
                    }
                    else {
                        this.labelDiv.style.display = 'none';
                    }
                }
                else {
                    this.labelDiv.style.display = 'none';
                }
            }
            /**
             * Loads the font JSON file from the provided URL.
             */
            async loadFontJson() {
                const response = await fetch(this.fontJsonUrl);
                if (!response.ok) {
                    throw new Error(`Failed to load font JSON from ${this.fontJsonUrl}`);
                }
                return response.json();
            }
            /**
             * Create bounding box with labels
             */
            async getBoundingBox() {
                if (this.assembliesList.length > 0) {
                    this.fontJson = await this.loadFontJson();
                    await Promise.all(this.assembliesList.map(async (assembly) => {
                        return this.getBoundingBoxForAssembly(assembly.selectedIds, assembly.name);
                    }));
                }
            }
            /**
             * Create bounding boxes
             */
            async getBoundingBoxForAssembly(dbIdArray, name) {
                const fragIdsArray = await ForgeViewerUtils.getFragIds(this.viewer.model, dbIdArray);
                if (dbIdArray.length) {
                    this.viewer.select([]);
                    const bBox = ForgeViewerUtils.getModifiedWorldBoundingBox(fragIdsArray, this.viewer.model.getFragmentList());
                    const textGeometry = await this.bcxTextGeometryService.createTextGeometry(name, this.fontJson);
                    this.boundingBoxLabelData.push({ name, bBox, textGeometry });
                    // Update the viewer to apply the changes
                    this.viewer.impl.sceneUpdated(true);
                }
            }
            /**
             * Create labels to show within bounding boxes
             */
            async createLabelsForBBoxes() {
                for (const box of this.boundingBoxLabelData) {
                    const textGeometry = await this.bcxTextGeometryService.createTextGeometry(box.name, this.fontJson);
                    await this.addLabelToBoundingBox(box.bBox, textGeometry);
                }
                // Update the viewer after all labels are added
                this.viewer.impl.sceneUpdated(true);
            }
            /**
             * Add label to bounding box
             */
            async addLabelToBoundingBox(bBox, textGeometry) {
                const center = bBox.getCenter(new THREE.Vector3());
                const size = new THREE.Vector3();
                bBox.getSize(size);
                const isHorizontal = size.x >= size.y && size.x >= size.z;
                const isVertical = size.z >= size.x && size.z >= size.y;
                // Create material for the text
                const mat = new THREE.MeshBasicMaterial({
                    color: 0x000000,
                    transparent: true,
                    opacity: 0.9,
                    depthTest: false,
                });
                // Create mesh from geometry and material
                const textMesh = new THREE.Mesh(textGeometry, mat);
                // Set the text position at the center of the bounding box
                textMesh.position.copy(center);
                // Adjust rotation and alignment if the bounding box is vertical
                if (isVertical) {
                    textMesh.rotation.y = Math.PI / 2;
                }
                else if (isHorizontal) {
                    textMesh.rotation.z = 0;
                }
                else {
                    textMesh.rotation.z = Math.PI / 2;
                }
                this.textMeshes.push(textMesh);
                // Add the text mesh to a custom overlay scene
                const overlayScene = 'custom-scene';
                this.viewer.overlays.addScene(overlayScene);
                this.viewer.overlays.addMesh(textMesh, overlayScene);
            }
            /**
             * Remove test meshes from viewer
             */
            removeTextMeshes() {
                this.textMeshes.forEach((text) => {
                    this.viewer.overlays.removeMesh(text, 'custom-scene');
                    this.viewer.overlays.removeScene('custom-scene');
                });
                this.viewer.impl.invalidate(true);
                this.textMeshes = [];
            }
            /**
             * Unload extension
             */
            unload() {
                // Remove the labelDiv from the DOM
                if (this.labelDiv && this.labelDiv.parentElement) {
                    this.labelDiv.parentElement.removeChild(this.labelDiv);
                }
                this.removeTextMeshes();
                // Remove the mousemove event listener
                this.viewer.container.removeEventListener('mousemove', this.showLabelOnHover.bind(this));
                return true;
            }
        }
        // Register the extension with Autodesk Viewer
        Autodesk.Viewing.theExtensionManager.registerExtension('BCX.ToggleAssemblyLabelExtension', ToggleAssemblyLabelExtension);
    }
    catch (error) {
        console.error('Failed to load BCX.ToggleAssemblyLabelExtension.', error);
    }
}

/**
 * Forge Viewer Extension: toggle-assembly-bounding-box-extension.ts
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2025 Build Centrix
 */
/**
 * Registers the ToggleAssemblyBoundingBoxExtension with Autodesk Viewer.
 */
async function registerAssemblyBoundingBoxExtension() {
    try {
        /**
         * Forge Viewer Extension: ToggleAssemblyBoundingBoxExtension
         */
        class ToggleAssemblyBoundingBoxExtension extends Autodesk.Viewing
            .Extension {
            /**
             * Viewer object
             */
            viewer = {};
            /**
             * Assemblies list
             */
            assembliesList = [];
            /**
             * Order takeoff statuses colors
             */
            orderStatuses = {};
            /**
             * Bounding box lines array
             */
            bBoxLines = [];
            /**
             * Constructor
             */
            constructor(viewer, options) {
                super(viewer, options);
                this.viewer = viewer;
                this.assembliesList = options.assembliesList || [];
                this.orderStatuses = options.orderStatuses;
                this.isBBoxEnabled = true;
                this.bBoxLines = [];
            }
            /**
             * Load extension
             */
            async load() {
                await this.createBoundingBox();
                return true;
            }
            /**
             * Add CSS class to BCX toolbar group
             */
            applyCustomClassToToolbarGroup(groupId_2, className) {
                const toolbarGroup = this.viewer.toolbar.getControl(groupId_2);
                if (toolbarGroup) {
                    const groupElement = document.getElementById(toolbarGroup.container.id);
                    if (groupElement) {
                        groupElement.classList.add(className);
                    }
                }
            }
            /**
             * Create bounding box with labels
             */
            async createBoundingBox() {
                if (this.assembliesList.length > 0) {
                    await Promise.all(this.assembliesList.map(async (assembly) => {
                        const statusColor = this.orderStatuses.statusColor[assembly.orderInfo.status];
                        return this.createBoundingBoxForAssembly(assembly.selectedIds, statusColor);
                    }));
                }
            }
            /**
             * Remove bounding boxes from model
             */
            removeBoundingBoxForAssembly() {
                this.bBoxLines.forEach((line) => {
                    this.viewer.impl.scene.remove(line);
                });
                this.viewer.impl.invalidate(true);
                this.bBoxLines = [];
            }
            /**
             * Create bounding boxes
             */
            async createBoundingBoxForAssembly(dbIdArray, statusColor) {
                const fragIdsArray = await ForgeViewerUtils.getFragIds(this.viewer.model, dbIdArray);
                if (dbIdArray.length) {
                    this.viewer.select([]);
                    const bBox = ForgeViewerUtils.getModifiedWorldBoundingBox(fragIdsArray, this.viewer.model.getFragmentList());
                    this.drawBox(bBox.min, bBox.max, statusColor);
                    // Update the viewer to apply the changes
                    this.viewer.impl.sceneUpdated(true);
                }
            }
            /**
             * Draw bounding box
             */
            drawBox(min, max, statusColor) {
                const material = new THREE.LineBasicMaterial({
                    color: new THREE.Color(`#${statusColor}`),
                    linewidth: 5,
                });
                this.viewer.impl.matman().addMaterial('Material-Line', material, true);
                this.drawLines([
                    { x: min.x, y: min.y, z: min.z },
                    { x: max.x, y: min.y, z: min.z },
                    { x: max.x, y: min.y, z: min.z },
                    { x: max.x, y: min.y, z: max.z },
                    { x: max.x, y: min.y, z: max.z },
                    { x: min.x, y: min.y, z: max.z },
                    { x: min.x, y: min.y, z: max.z },
                    { x: min.x, y: min.y, z: min.z },
                    { x: min.x, y: max.y, z: max.z },
                    { x: max.x, y: max.y, z: max.z },
                    { x: max.x, y: max.y, z: max.z },
                    { x: max.x, y: max.y, z: min.z },
                    { x: max.x, y: max.y, z: min.z },
                    { x: min.x, y: max.y, z: min.z },
                    { x: min.x, y: max.y, z: min.z },
                    { x: min.x, y: max.y, z: max.z },
                    { x: min.x, y: min.y, z: min.z },
                    { x: min.x, y: max.y, z: min.z },
                    { x: max.x, y: min.y, z: min.z },
                    { x: max.x, y: max.y, z: min.z },
                    { x: max.x, y: min.y, z: max.z },
                    { x: max.x, y: max.y, z: max.z },
                    { x: min.x, y: min.y, z: max.z },
                    { x: min.x, y: max.y, z: max.z },
                ], material);
                this.viewer.impl.sceneUpdated(true);
            }
            /**
             * Draw lines
             */
            drawLines(coordsArray, material) {
                for (let i = 0; i < coordsArray.length; i += 2) {
                    const start = coordsArray[i];
                    const end = coordsArray[i + 1];
                    const geometry = new THREE.BufferGeometry();
                    const vertices = new Float32Array([
                        start.x,
                        start.y,
                        start.z,
                        end.x,
                        end.y,
                        end.z,
                    ]);
                    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
                    const line = new THREE.Line(geometry, material);
                    this.viewer.impl.scene.add(line);
                    this.bBoxLines.push(line);
                }
            }
            /**
             * Unload extension
             */
            unload() {
                this.removeBoundingBoxForAssembly();
                return true;
            }
        }
        // Register the extension with Autodesk Viewer
        Autodesk.Viewing.theExtensionManager.registerExtension('BCX.ToggleAssemblyBoundingBoxExtension', ToggleAssemblyBoundingBoxExtension);
    }
    catch (error) {
        console.error('Failed to load BCX.ToggleAssemblyBoundingBoxExtension.', error);
    }
}

/**
 * Create Revit Statuses panel
 */
function createRevitStatusesPanel(panelContainer_1, panelId, panelTitle, panelContent) {
    class RevitStatusesPanel extends Autodesk.Viewing.UI.DockingPanel {
        statusesInfo;
        /**
         * Constructor
         */
        constructor(parentContainer, id, title, content) {
            super(parentContainer, id, title);
            this.statusesInfo = content;
            // Create status colors legend overlay
            this.container.innerHTML = `
                        <div class='colors-legend'>
                            <div class='legend-title'>Revit Item Statuses</div>
                            <div class='legend-scale'>
                                <ul class='legend-labels'>
                                        ${this.statusesInfo
                .map(({ input: { label, colour } }) => `
                                                            <li><span style='background:${colour};'></span>${label}</li>
                                                        `)
                .join('')}

                                </ul>
                            </div>
                        </div>
                    `;
        }
        /**
         * Initialize the panel
         */
        initialize() {
            this.container.style.top = '200px';
            this.container.classList.add('movable-container');
            // Allow move
            this.initializeMoveHandlers(this.container);
        }
    }
    // Create and return the panel
    const panel = new RevitStatusesPanel(panelContainer_1, panelId, panelTitle, panelContent);
    panel?.setVisible(true);
    return panel;
}
/**
 * Registers the registerToggleRevitItemStatusExtension with Autodesk Viewer.
 */
async function registerToggleRevitItemStatusExtension() {
    try {
        /**
         * Forge Viewer Extension: ToggleRevitItemStatusExtension
         */
        class ToggleRevitItemStatusExtension extends Autodesk.Viewing.Extension {
            /**
             * Viewer Object
             */
            viewer = {};
            /**
             * Statuses list panel
             */
            revitItemStatusPanel;
            /**
             * Statuses data
             */
            statusesData;
            /**
             * Item statuses data
             */
            modelItemStatusesData;
            /**
             * Assembly model data
             */
            assemblyModel;
            /**
             * Constructor
             */
            constructor(viewer, options) {
                super(viewer, options);
                this.revitItemStatusPanel = null;
                this.viewer = viewer;
                this.statusesData = options.statusesData;
                this.modelItemStatusesData = options.modelItemStatusesData;
                this.assemblyModel = options.assemblyModel;
                if (this.statusesData) {
                    this.revitItemStatusPanel = createRevitStatusesPanel(this.viewer.container, 'revit-statuses-overlay-panel', 'Revit Item Statuses', this.statusesData);
                    this.revitItemStatusPanel.setVisible(true);
                }
            }
            /**
             * Load extension
             */
            async load() {
                await this.applyStatusColorsToItems();
                return true;
            }
            /**
             * Apply colours to the Items
             */
            async applyStatusColorsToItems() {
                if (!this.viewer ||
                    !this.modelItemStatusesData ||
                    !this.modelItemStatusesData.items ||
                    this.modelItemStatusesData.items.length === 0) {
                    return;
                }
                // Map over the items and apply colors
                const applyColorPromises = this.modelItemStatusesData.items?.map(async (item) => {
                    // Check if the item is included in the specified assemblyIds, if assembly is loaded
                    if (this.assemblyModel?.elementIds === undefined ||
                        this.assemblyModel?.elementIds.includes(item.itemId)) {
                        const dbId = await this.mapElementIdToDbId(this.viewer, item.itemId);
                        const statusColour = this.getItemStatusColor(item.mappingId);
                        if (statusColour) {
                            this.viewer.setThemingColor(dbId, this.hexToThreeVector4(statusColour), this.viewer.model);
                        }
                        this.viewer.impl.toggleGhosting(false);
                    }
                });
                // Await all the color application promises
                await Promise.all(applyColorPromises);
            }
            /**
             * Extract the dbId for ElementId
             */
            mapElementIdToDbId(viewer, elementId) {
                return new Promise((resolve, reject) => {
                    viewer.search(elementId, (dbIds) => {
                        viewer.model?.getBulkProperties(dbIds, ['ElementId'], (elements) => {
                            for (const element of elements) {
                                if (element.properties[0].displayValue === elementId) {
                                    resolve(element.dbId);
                                    return;
                                }
                            }
                        }, reject);
                    }, ['ElementId']);
                });
            }
            /**
             * Get item status colour using stored mappingID
             */
            getItemStatusColor(statusMapId) {
                let colour;
                for (const item of this.statusesData) {
                    if (item._id === statusMapId) {
                        colour = item.input.colour;
                    }
                }
                return colour;
            }
            /**
             * Convert Hex color to RGBA Format
             */
            hexToRgba(hex) {
                const bigint = parseInt(hex?.slice(1), 16);
                const r = (bigint >> 16) & 255;
                const g = (bigint >> 8) & 255;
                const b = bigint & 255;
                return { r, g, b, a: 1 };
            }
            /**
             * Convert Hex color to THREE.Vector4
             */
            hexToThreeVector4(hex) {
                const { r, g, b, a } = this.hexToRgba(hex);
                return new THREE.Vector4(r / 255, g / 255, b / 255, a);
            }
            async clearItemStatusesColors() {
                // Map over the items and clear colors
                const clearColorsPromises = this.modelItemStatusesData?.items?.map(async (item) => {
                    // Check if the item is included in the specified assemblyIds, if assembly is loaded
                    const dbId = await this.mapElementIdToDbId(this.viewer, item.itemId);
                    this.viewer.setThemingColor(dbId, null);
                });
                // Await all the color clear promises
                if (clearColorsPromises)
                    await Promise.all(clearColorsPromises);
            }
            /**
             * Unload extension
             */
            unload() {
                if (this.revitItemStatusPanel) {
                    this.revitItemStatusPanel.uninitialize();
                }
                this.clearItemStatusesColors();
                return true;
            }
        }
        // Register the extension with Autodesk Viewer
        Autodesk.Viewing.theExtensionManager.registerExtension('BCX.ToggleRevitItemStatusExtension', ToggleRevitItemStatusExtension);
    }
    catch (error) {
        console.error('Failed to load BCX.ToggleRevitItemStatusExtension.', error);
    }
}

/**
 * Autodesk Loader Service (autodesk-loader.service.ts).
 * Services -> Autodesk Loader Service
 *
 * This service automatically loads the Autodesk Viewer script for the Forge Viewer,
 * so the parent repository using the component does not need to include the script manually.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
class AutodeskViewerLoaderService {
    rendererFactory2;
    document;
    renderer;
    scriptsLoaded = false;
    scriptCssUrl = 'https://developer.api.autodesk.com/modelderivative/v2/viewers/7.99/style.css';
    scriptJsUrl = 'https://developer.api.autodesk.com/modelderivative/v2/viewers/7.99/viewer3D.js';
    /**
     * Constructor
     */
    constructor(rendererFactory2, document) {
        this.rendererFactory2 = rendererFactory2;
        this.document = document;
        this.renderer = this.rendererFactory2.createRenderer(null, null);
    }
    /**
     * Build viewer css
     */
    buildViewerCss() {
        return new Promise((resolve, reject) => {
            const link = this.renderer.createElement('link');
            link.rel = 'stylesheet';
            link.href = this.scriptCssUrl;
            link.onload = () => {
                resolve();
            };
            link.onerror = (error) => reject(error);
            this.renderer.appendChild(this.document.head, link); // Append to head
        });
    }
    /**
     * Build viewer script
     */
    buildViewerScript() {
        return new Promise((resolve, reject) => {
            const script = this.renderer.createElement('script');
            script.type = 'text/javascript';
            script.src = this.scriptJsUrl;
            script.onload = () => {
                this.scriptsLoaded = true;
                resolve();
            };
            script.onerror = (error) => reject(error);
            this.renderer.appendChild(this.document.body, script); // Append to body
        });
    }
    /**
     * Load autodesk viewer script
     */
    async loadViewerScript() {
        // Avoid loading the scripts multiple times
        if (this.scriptsLoaded) {
            return Promise.resolve();
        }
        // Load the Autodesk files for viewer
        try {
            await Promise.all([this.buildViewerCss(), this.buildViewerScript()]);
            this.scriptsLoaded = true; // Ensure scriptsLoaded is true after both are loaded
        }
        catch (error) {
            console.error('Error loading Autodesk Viewer scripts:', error);
            throw error; // Rethrow to handle in calling code if necessary
        }
    }
    /** @nocollapse */ static ɵfac = function AutodeskViewerLoaderService_Factory(t) { return new (t || AutodeskViewerLoaderService)(i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(DOCUMENT)); };
    /** @nocollapse */ static ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: AutodeskViewerLoaderService, factory: AutodeskViewerLoaderService.ɵfac, providedIn: 'root' });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutodeskViewerLoaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i0.RendererFactory2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

/**
 * Organisms forge viewer component (organisms-forge-viewer.component.ts).
 * Organisms -> Forge Viewer Component
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @author Vishal Pandey <vishal.pandey@ncircletech.com>
 * @copyright (c) 2024-2025 Build Centrix
 *
 */
const _c0$7 = ["forgeviewerdiv"];
function OrganismsForgeViewerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5, 6);
} }
function OrganismsForgeViewerComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "bc-atoms-button", 7);
    i0.ɵɵlistener("onButtonClicked", function OrganismsForgeViewerComponent_div_4_Template_bc_atoms_button_onButtonClicked_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.switchViewEvent()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r1.isSwitchViewButtonDisabled)("loading", ctx_r1.viewerLoading);
} }
class OrganismsForgeViewerComponent {
    viewerLoader;
    // Inputs
    accessToken = '';
    dataUrn = '';
    viewerLoading = false;
    screenHeight = 0;
    screenWidth = 0;
    assemblyModel = null;
    statusesData = null;
    viewerFunctionalityBcxExtensions = [];
    toggleViewerBcxExtensions = [];
    orderStatusesData = null;
    isSwitchViewButtonVisible = false;
    modelItemStatusesData = null;
    modelViewerData = null;
    assembliesList = null;
    // Outputs
    assemblyStatusColorEmitted = new EventEmitter();
    viewerDataEmitted = new EventEmitter();
    changeItemStatusEmitted = new EventEmitter();
    createAssemblyEmitted = new EventEmitter();
    isSwitchViewButtonVisibleChange = new EventEmitter();
    createOrderEmitted = new EventEmitter();
    currentViewer = null;
    viewables = [];
    loaderTitle = 'Loading Viewer';
    indexViewable = 0;
    isSwitchViewButtonDisabled = true;
    geometryLoadedEventCount = 0;
    toggleViewerExtensionsList = [
        'BCX.ToggleAssemblyStatusColorExtension',
        'BCX.ToggleAssemblyBoundingBoxExtension',
        'BCX.ToggleAssemblyLabelExtension',
        'BCX.ToggleRevitItemStatusExtension',
    ];
    forgeViewerContainer;
    constructor(viewerLoader) {
        this.viewerLoader = viewerLoader;
    }
    /**
     * On Changes
     */
    ngOnChanges(changes) {
        if ((changes.dataUrn && !changes.dataUrn.firstChange) ||
            (changes.assemblyModel && !changes.assemblyModel.firstChange) ||
            (changes.modelItemStatusesData &&
                !changes.modelItemStatusesData.firstChange)) {
            this.loadModelInViewer();
        }
        if (changes.viewerFunctionalityBcxExtensions &&
            !changes.viewerFunctionalityBcxExtensions.firstChange) {
            this.unloadExtensions(changes.viewerFunctionalityBcxExtensions.currentValue);
            this.loadCustomExtensions(changes.viewerFunctionalityBcxExtensions.currentValue);
        }
        if (changes.toggleViewerBcxExtensions &&
            !changes.toggleViewerBcxExtensions.firstChange) {
            if (changes.toggleViewerBcxExtensions.currentValue.length === 0) {
                this.unloadExtensions(this.toggleViewerExtensionsList);
            }
            else {
                this.checkAndReloadExtensions(changes.toggleViewerBcxExtensions.currentValue);
            }
        }
    }
    /**
     * Unload and reload toggle extensions
     */
    checkAndReloadExtensions(bcxExtensionsList) {
        // Identify extensions to unload
        const extensionsToUnload = this.toggleViewerExtensionsList.filter((ext) => !bcxExtensionsList.includes(ext));
        // Identify extensions to load
        const newExtensionsToLoad = bcxExtensionsList.filter((ext) => !Object.prototype.hasOwnProperty.call(this.currentViewer.loadedExtensions, ext));
        this.unloadExtensions(extensionsToUnload);
        this.loadCustomExtensions(newExtensionsToLoad);
    }
    /**
     * Unload toggle extensions
     */
    unloadExtensions(bcxExtensionsList) {
        bcxExtensionsList.map((extension) => {
            // Unload extension
            this.currentViewer.getExtension(extension, () => {
                this.currentViewer.unloadExtension(extension);
            });
        });
    }
    /**
     * After view init
     */
    ngAfterViewInit() {
        if (this.forgeViewerContainer) {
            if (this.modelViewerData != null) {
                // Load the stored model viewer
                this.forgeViewerContainer.nativeElement.appendChild(this.modelViewerData.container);
                this.currentViewer = this.modelViewerData;
                // When switching between tabs, unload and reload extensions again
                const extensionsToReload = this.viewerFunctionalityBcxExtensions.concat(this.toggleViewerBcxExtensions);
                this.unloadAndReloadCustomExtensions(extensionsToReload);
            }
            else {
                this.initViewer(this.forgeViewerContainer.nativeElement).then((viewer) => {
                    this.currentViewer = viewer;
                    this.loadModelInViewer();
                });
            }
        }
    }
    /**
     * Unload and reload the extensions
     */
    unloadAndReloadCustomExtensions(bcxExtensionsList) {
        bcxExtensionsList.map((extension) => {
            // Unload extension
            this.currentViewer.getExtension(extension, () => {
                this.currentViewer.unloadExtension(extension);
            });
        });
        // Reload extension
        this.loadCustomExtensions(bcxExtensionsList);
    }
    /**
     * Initialize the forge viewer
     */
    initViewer(container) {
        return new Promise((resolve) => {
            this.viewerLoader
                .loadViewerScript()
                .then(() => {
                Autodesk.Viewing.Initializer({
                    accessToken: this.accessToken,
                }, () => {
                    const config = {
                        extensions: ['Autodesk.DocumentBrowser'],
                    };
                    const viewer = new Autodesk.Viewing.GuiViewer3D(container, config);
                    viewer.start();
                    viewer.setTheme('light-theme');
                    // For touch devices override handleSingleTap method of the viewer.clickHandler
                    viewer.clickHandler.handleSingleTap = (event) => {
                        const result = this.currentViewer.impl.hitTestViewport(this.currentViewer.impl.clientToViewport(event.canvasX, event.canvasY), false);
                        if (result) {
                            this.currentViewer.toggleSelect(result.dbId, result.model);
                        }
                        else {
                            this.currentViewer.clearSelection();
                        }
                        return true;
                    };
                    // Add context menu to change item status
                    viewer.registerContextMenuCallback('changeItemStatus', (menu, status) => {
                        const createOrderExt = this.currentViewer.getExtension('BCX.CreateOrderExtension');
                        const createTakeoffExt = this.currentViewer.getExtension('BCX.CreateAssemblyExtension');
                        if (status.hasSelected) {
                            menu.unshift({
                                title: 'Change Item Status',
                                target: () => {
                                    const data = {
                                        viewer: this.currentViewer,
                                        dbIds: this.currentViewer.getSelection(),
                                    };
                                    this.changeItemStatusEmitted.emit(data);
                                },
                            }, {
                                divider: true,
                            });
                        }
                        if (status.hasSelected &&
                            !createOrderExt &&
                            !createTakeoffExt) {
                            menu.unshift({
                                divider: true,
                            });
                        }
                    });
                    // Add context menu to create order
                    viewer.registerContextMenuCallback('createOrder', (menu, status) => {
                        const createOrderExt = this.currentViewer.getExtension('BCX.CreateOrderExtension');
                        if (createOrderExt && status.hasSelected) {
                            menu.unshift({
                                title: 'Create Order',
                                target: () => {
                                    createOrderExt.handleCreateOrder();
                                },
                            });
                        }
                    });
                    // Add context menu to create takeoff
                    viewer.registerContextMenuCallback('createTakeoff', (menu, status) => {
                        const createTakeoffExt = this.currentViewer.getExtension('BCX.CreateAssemblyExtension');
                        if (createTakeoffExt && status.hasSelected) {
                            menu.unshift({
                                divider: true,
                            }, {
                                title: 'Create Takeoff',
                                target: () => {
                                    createTakeoffExt.handleCreateAssemblyButton();
                                },
                            });
                        }
                    });
                    resolve(viewer);
                });
            })
                .catch((error) => {
                console.error('Failed to load Autodesk Forge Viewer script.', error);
            });
        });
    }
    /**
     * Load Model
     */
    loadModelInViewer() {
        if (this.dataUrn && this.accessToken) {
            this.geometryLoadedEventCount = 1;
            this.currentViewer.setLightPreset(0);
            const documentId = 'urn:' + this.dataUrn;
            Autodesk.Viewing.Document.load(documentId, this.onDocumentLoadSuccess.bind(this), this.onDocumentLoadFailure.bind(this));
        }
    }
    /**
     * Document successfully loaded
     */
    onDocumentLoadSuccess(document) {
        this.viewables = document.getRoot().search({ type: 'geometry' });
        if (this.viewables.length === 0) {
            console.error('Document contains no viewables.');
            return;
        }
        const modelViewerOptions = {
            statusesData: this.statusesData,
            orderStatusesData: this.orderStatusesData,
            extensions: this.viewerFunctionalityBcxExtensions,
        };
        if (this.assemblyModel !== null) {
            // Load spooling assembly model
            const options = {
                ids: this.assemblyModel.selectedIds,
                statusesData: this.statusesData,
                extensions: this.viewerFunctionalityBcxExtensions,
            };
            this.currentViewer.loadDocumentNode(document, this.viewables[this.indexViewable], options);
        }
        else {
            // Show Switch View button
            this.isSwitchViewButtonVisible = true;
            this.isSwitchViewButtonVisibleChange.emit(this.isSwitchViewButtonVisible);
            // Load Revit model
            this.currentViewer.loadDocumentNode(document, document.getRoot().getDefaultGeometry(), modelViewerOptions);
        }
        this.currentViewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, this.onGeometryLoaded.bind(this));
    }
    /**
     * Model geometry successfully loaded
     */
    onGeometryLoaded() {
        /**
         * IF: Do the all required settings only once when geometry loaded
         */
        if (this.geometryLoadedEventCount === 1) {
            this.geometryLoadedEventCount++;
        }
        else {
            return;
        }
        void this.itemLoaded();
        this.viewerDataEmitted.emit(this.currentViewer);
    }
    /**
     * Failed to load document
     */
    onDocumentLoadFailure = (code, message, errors) => {
        console.error({ code, message, errors });
    };
    /**
     * On Item loaded
     */
    async itemLoaded() {
        const extensionsToLoad = this.viewerFunctionalityBcxExtensions.concat(this.toggleViewerBcxExtensions);
        await this.loadCustomExtensions(extensionsToLoad);
        if (this.assemblyModel) {
            this.initAssemblyViewerSettings();
        }
        this.currentViewer.fitToView();
    }
    /**
     * Load BCX extensions
     */
    async loadCustomExtensions(bcxExtensionsList) {
        for (const extension of bcxExtensionsList) {
            try {
                if (extension === 'BCX.ToggleRevitItemStatusExtension') {
                    await registerToggleRevitItemStatusExtension();
                    await this.currentViewer.loadExtension(extension, {
                        statusesData: this.statusesData,
                        modelItemStatusesData: this.modelItemStatusesData,
                        assemblyModel: this.assemblyModel,
                    });
                }
                else if (extension === 'BCX.ToggleAssemblyStatusColorExtension') {
                    await registerAssemblyStatusColourExtension();
                    await this.currentViewer.loadExtension(extension, {
                        assemblyStatusColorEmitter: this.assemblyStatusColorEmitted,
                        orderStatusesData: this.orderStatusesData,
                    });
                }
                else if (extension === 'BCX.ChangeItemStatusExtension') {
                    await registerChangeItemStatusExtension();
                    await this.currentViewer.loadExtension(extension, {
                        changeItemStatusEmitter: this.changeItemStatusEmitted,
                    });
                }
                else if (extension === 'BCX.CreateAssemblyExtension') {
                    await registerCreateAssemblyExtension();
                    await this.currentViewer.loadExtension(extension, {
                        createAssemblyEmitter: this.createAssemblyEmitted,
                    });
                }
                else if (extension === 'BCX.ToggleAssemblyLabelExtension') {
                    await registerAssemblyLabelExtension();
                    await this.currentViewer.loadExtension(extension, {
                        assembliesList: this.assembliesList,
                    });
                }
                else if (extension === 'BCX.ToggleAssemblyBoundingBoxExtension') {
                    await registerAssemblyBoundingBoxExtension();
                    await this.currentViewer.loadExtension(extension, {
                        assembliesList: this.assembliesList,
                        orderStatuses: this.orderStatusesData,
                    });
                }
                else if (extension === 'BCX.CreateOrderExtension') {
                    await registerCreateOrderExtension();
                    await this.currentViewer.loadExtension(extension, {
                        assembliesList: this.assembliesList,
                        createOrderEmitter: this.createOrderEmitted,
                    });
                }
            }
            catch (error) {
                console.error(`Error loading extension ${extension}:`, error);
            }
        }
    }
    /**
     * Apply colours to the Items
     */
    async applyStatusColorsToItems() {
        if (!this.currentViewer ||
            !this.modelItemStatusesData ||
            !this.modelItemStatusesData.items ||
            this.modelItemStatusesData.items.length === 0) {
            return;
        }
        // Map over the items and apply colors
        const applyColorPromises = this.modelItemStatusesData.items?.map(async (item) => {
            // Check if the item is included in the specified assemblyIds, if assembly is loaded
            if (this.assemblyModel?.elementIds === undefined ||
                this.assemblyModel?.elementIds.includes(item.itemId)) {
                const dbId = await this.mapElementIdToDbId(this.currentViewer, item.itemId);
                const statusColour = this.getItemStatusColor(item.mappingId);
                if (statusColour) {
                    this.currentViewer.setThemingColor(dbId, this.hexToThreeVector4(statusColour), this.currentViewer.model);
                }
                this.currentViewer.impl.toggleGhosting(false);
            }
        });
        // Await all the color application promises
        await Promise.all(applyColorPromises);
    }
    /**
     * Get item status colour using stored mappingID
     *
     */
    getItemStatusColor(statusMapId) {
        let colour;
        for (const item of this.statusesData) {
            if (item._id === statusMapId) {
                colour = item.input.colour;
            }
        }
        return colour;
    }
    /**
     * Convert Hex colour to RGBA Format
     */
    hexToRgba(hex) {
        const bigint = parseInt(hex?.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return { r, g, b, a: 1 };
    }
    /**
     * Convert Hex colour to THREE.Vector4
     */
    hexToThreeVector4(hex) {
        const { r, g, b, a } = this.hexToRgba(hex);
        return new THREE.Vector4(r / 255, g / 255, b / 255, a);
    }
    /**
     * Extract the dbId for ElementId
     */
    mapElementIdToDbId(viewer, elementId) {
        return new Promise((resolve, reject) => {
            viewer.search(elementId, (dbIds) => {
                viewer.model?.getBulkProperties(dbIds, ['ElementId'], (elements) => {
                    for (const element of elements) {
                        if (element.properties[0].displayValue === elementId) {
                            resolve(element.dbId);
                            return;
                        }
                    }
                }, reject);
            }, ['ElementId']);
        });
    }
    /**
     * Called when "Switch View" button is clicked in the UI
     */
    switchViewEvent() {
        // Next viewable index. Loop back to 0 when overflown.
        this.indexViewable = (this.indexViewable + 1) % this.viewables.length;
        const documentId = 'urn:' + this.dataUrn;
        Autodesk.Viewing.Document.load(documentId, this.onDocumentLoadSuccess.bind(this), this.onDocumentLoadFailure);
    }
    /**
     * Initialize settings in case of assembly is loaded
     */
    initAssemblyViewerSettings() {
        // Restore camera state
        this.currentViewer.restoreState(this.assemblyModel?.viewerState);
        this.currentViewer.clearSelection();
        // Copied text from autodesk context "show all objects" menu
        const showAllContextMenuTitle = 'Show All Objects';
        // Remove show all object option
        // To avoid user to show whole model in assembly viewer
        this.currentViewer.registerContextMenuCallback('Autodesk.Viewing.AssemblyContextMenuCallback', (menu) => {
            menu.forEach((element, index) => {
                if (showAllContextMenuTitle === element.title) {
                    menu.splice(index, 1);
                }
            });
        });
        // Copied text from autodesk toolbar "Model Browser" button
        const modelStructureToolButtonId = 'toolbar-modelStructureTool';
        const modelStructureTool = this.currentViewer.toolbar.settingsTools.getControl(modelStructureToolButtonId);
        // Remove model browser button to avoid model toggle
        this.currentViewer.toolbar.settingsTools.removeControl(modelStructureTool);
    }
    /** @nocollapse */ static ɵfac = function OrganismsForgeViewerComponent_Factory(t) { return new (t || OrganismsForgeViewerComponent)(i0.ɵɵdirectiveInject(AutodeskViewerLoaderService)); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: OrganismsForgeViewerComponent, selectors: [["bc-organisms-forge-viewer"]], viewQuery: function OrganismsForgeViewerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$7, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.forgeViewerContainer = _t.first);
        } }, inputs: { accessToken: "accessToken", dataUrn: "dataUrn", viewerLoading: "viewerLoading", screenHeight: "screenHeight", screenWidth: "screenWidth", assemblyModel: "assemblyModel", statusesData: "statusesData", viewerFunctionalityBcxExtensions: "viewerFunctionalityBcxExtensions", toggleViewerBcxExtensions: "toggleViewerBcxExtensions", orderStatusesData: "orderStatusesData", isSwitchViewButtonVisible: "isSwitchViewButtonVisible", modelItemStatusesData: "modelItemStatusesData", modelViewerData: "modelViewerData", assembliesList: "assembliesList" }, outputs: { assemblyStatusColorEmitted: "assemblyStatusColorEmitted", viewerDataEmitted: "viewerDataEmitted", changeItemStatusEmitted: "changeItemStatusEmitted", createAssemblyEmitted: "createAssemblyEmitted", isSwitchViewButtonVisibleChange: "isSwitchViewButtonVisibleChange", createOrderEmitted: "createOrderEmitted" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 9, consts: [[1, "viewer-container"], [1, "viewer"], [3, "title", "active", "fullscreen"], ["ngDefaultControl", "", "ngModel", "", 4, "ngIf"], [4, "ngIf"], ["ngDefaultControl", "", "ngModel", ""], ["forgeviewerdiv", ""], ["label", "Switch View", "title", "Switch View", "display", "block", "size", "small", "type", "default", 1, "switchViewButton", 3, "disabled", "loading", "onButtonClicked"]], template: function OrganismsForgeViewerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "bc-atoms-loader", 2);
            i0.ɵɵtemplate(3, OrganismsForgeViewerComponent_div_3_Template, 2, 0, "div", 3);
            i0.ɵɵtemplate(4, OrganismsForgeViewerComponent_div_4_Template, 2, 2, "div", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵstyleProp("height", ctx.screenHeight, "px")("width", ctx.screenWidth, "px");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("title", ctx.loaderTitle)("active", ctx.viewerLoading)("fullscreen", false);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.viewerLoading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isSwitchViewButtonVisible);
        } }, dependencies: [AtomsButtonComponent, AtomsLoaderComponent, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel], styles: [".viewer-container .viewer{text-align:center;margin:0 auto;border:3px solid lightblue;position:relative;border-radius:3px;z-index:0}.viewer-container .viewer bc-atoms-loader{position:absolute;left:calc(50% - 125px);top:calc(50% - 84px)}.viewer-container .viewer bc-atoms-loader .loader-container,.viewer-container .viewer bc-atoms-loader .branded-info-container{background:transparent!important}.viewer-container .viewer .switchViewButton{position:absolute;top:5px;left:5px;z-index:1;font-size:10px;cursor:pointer}.viewer-container .viewer .movable-container{left:10px;width:auto;height:auto;padding:10px;background-color:#fffffff0}.viewer-container .viewer .movable-container .colors-legend .legend-title{text-align:left;margin-bottom:5px;font-weight:700;font-size:90%}.viewer-container .viewer .movable-container .colors-legend .legend-scale ul{margin:0;padding:0;float:left;list-style:none}.viewer-container .viewer .movable-container .colors-legend .legend-scale ul li{font-size:80%;list-style:none;margin-left:0;margin-bottom:2px;display:flex;align-items:center}.viewer-container .viewer .movable-container .colors-legend ul.legend-labels li span{display:inline-block;height:16px;width:30px;margin-right:5px;margin-left:0;border:1px solid #999;float:left}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganismsForgeViewerComponent, [{
        type: Component,
        args: [{ selector: 'bc-organisms-forge-viewer', encapsulation: ViewEncapsulation.None, template: "<!--\n - Organisms forge viewer component (organisms-forge-viewer.component.html).\n - Organism -> Forge Viewer Component.\n -\n - @author Monika Gole <monika.gole@ncircletech.com>\n - @copyright (c) 2024 Build Centrix\n -->\n<div class=\"viewer-container\">\n  <div\n    class=\"viewer\"\n    [style.height.px]=\"screenHeight\"\n    [style.width.px]=\"screenWidth\"\n  >\n    <!--Loader-->\n    <bc-atoms-loader\n      [title]=\"loaderTitle\"\n      [active]=\"viewerLoading\"\n      [fullscreen]=\"false\"\n    ></bc-atoms-loader>\n    <!--Viewer-->\n    <div *ngIf=\"!viewerLoading\" ngDefaultControl ngModel #forgeviewerdiv></div>\n    <div *ngIf=\"isSwitchViewButtonVisible\">\n      <bc-atoms-button\n        class=\"switchViewButton\"\n        label=\"Switch View\"\n        title=\"Switch View\"\n        display=\"block\"\n        size=\"small\"\n        type=\"default\"\n        [disabled]=\"isSwitchViewButtonDisabled\"\n        [loading]=\"viewerLoading\"\n        (onButtonClicked)=\"switchViewEvent()\"\n      >\n      </bc-atoms-button>\n    </div>\n  </div>\n</div>\n", styles: [".viewer-container .viewer{text-align:center;margin:0 auto;border:3px solid lightblue;position:relative;border-radius:3px;z-index:0}.viewer-container .viewer bc-atoms-loader{position:absolute;left:calc(50% - 125px);top:calc(50% - 84px)}.viewer-container .viewer bc-atoms-loader .loader-container,.viewer-container .viewer bc-atoms-loader .branded-info-container{background:transparent!important}.viewer-container .viewer .switchViewButton{position:absolute;top:5px;left:5px;z-index:1;font-size:10px;cursor:pointer}.viewer-container .viewer .movable-container{left:10px;width:auto;height:auto;padding:10px;background-color:#fffffff0}.viewer-container .viewer .movable-container .colors-legend .legend-title{text-align:left;margin-bottom:5px;font-weight:700;font-size:90%}.viewer-container .viewer .movable-container .colors-legend .legend-scale ul{margin:0;padding:0;float:left;list-style:none}.viewer-container .viewer .movable-container .colors-legend .legend-scale ul li{font-size:80%;list-style:none;margin-left:0;margin-bottom:2px;display:flex;align-items:center}.viewer-container .viewer .movable-container .colors-legend ul.legend-labels li span{display:inline-block;height:16px;width:30px;margin-right:5px;margin-left:0;border:1px solid #999;float:left}\n"] }]
    }], function () { return [{ type: AutodeskViewerLoaderService }]; }, { accessToken: [{
            type: Input
        }], dataUrn: [{
            type: Input
        }], viewerLoading: [{
            type: Input
        }], screenHeight: [{
            type: Input
        }], screenWidth: [{
            type: Input
        }], assemblyModel: [{
            type: Input
        }], statusesData: [{
            type: Input
        }], viewerFunctionalityBcxExtensions: [{
            type: Input
        }], toggleViewerBcxExtensions: [{
            type: Input
        }], orderStatusesData: [{
            type: Input
        }], isSwitchViewButtonVisible: [{
            type: Input
        }], modelItemStatusesData: [{
            type: Input
        }], modelViewerData: [{
            type: Input
        }], assembliesList: [{
            type: Input
        }], assemblyStatusColorEmitted: [{
            type: Output
        }], viewerDataEmitted: [{
            type: Output
        }], changeItemStatusEmitted: [{
            type: Output
        }], createAssemblyEmitted: [{
            type: Output
        }], isSwitchViewButtonVisibleChange: [{
            type: Output
        }], createOrderEmitted: [{
            type: Output
        }], forgeViewerContainer: [{
            type: ViewChild,
            args: ['forgeviewerdiv']
        }] }); })();

/**
 * Components module (components.module.ts).
 * Components Module.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
class BcOrganismsModule {
    /** @nocollapse */ static ɵfac = function BcOrganismsModule_Factory(t) { return new (t || BcOrganismsModule)(); };
    /** @nocollapse */ static ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: BcOrganismsModule });
    /** @nocollapse */ static ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [BcAtomsModule,
            BcMoleculesModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            TranslateModule, BcAtomsModule,
            BcMoleculesModule,
            TranslateModule] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BcOrganismsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BcAtomsModule,
                    BcMoleculesModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDialogModule,
                    TranslateModule,
                ],
                exports: [
                    BcAtomsModule,
                    BcMoleculesModule,
                    OrganismsHeaderComponent,
                    OrganismsLoginComponent,
                    OrganismsOrderAssemblyComponent,
                    OrganismsSidebarComponent,
                    OrganismsUserDetailsComponent,
                    OrganismsForgeViewerComponent,
                    TranslateModule,
                ],
                declarations: [
                    OrganismsHeaderComponent,
                    OrganismsLoginComponent,
                    OrganismsOrderAssemblyComponent,
                    OrganismsSidebarComponent,
                    OrganismsUserDetailsComponent,
                    OrganismsForgeViewerComponent,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BcOrganismsModule, { declarations: [OrganismsHeaderComponent,
        OrganismsLoginComponent,
        OrganismsOrderAssemblyComponent,
        OrganismsSidebarComponent,
        OrganismsUserDetailsComponent,
        OrganismsForgeViewerComponent], imports: [BcAtomsModule,
        BcMoleculesModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        TranslateModule], exports: [BcAtomsModule,
        BcMoleculesModule,
        OrganismsHeaderComponent,
        OrganismsLoginComponent,
        OrganismsOrderAssemblyComponent,
        OrganismsSidebarComponent,
        OrganismsUserDetailsComponent,
        OrganismsForgeViewerComponent,
        TranslateModule] }); })();

/**
 * Templates banner page component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */
function TemplatesBannerPageComponent_a_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1, "Privacy Policy");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("href", ctx_r0.privacyPolicyUrl, i0.ɵɵsanitizeUrl);
} }
function TemplatesBannerPageComponent_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " | ");
    i0.ɵɵelementEnd();
} }
function TemplatesBannerPageComponent_a_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1, "Terms and Conditions");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("href", ctx_r2.termsAndConditionsUrl, i0.ɵɵsanitizeUrl);
} }
const _c0$6 = [[["", "bcx-banner-image", ""]], [["", "bcx-banner-content", ""]], [["", "bcx-banner-buttons", ""]]];
const _c1$6 = function (a0) { return { "full-page": a0 }; };
const _c2$4 = ["[bcx-banner-image]", "[bcx-banner-content]", "[bcx-banner-buttons]"];
class TemplatesBannerPageComponent {
    // Strings
    privacyPolicyUrl;
    termsAndConditionsUrl;
    pageTitle;
    pageSubtitle;
    // Booleans
    fullPage = false; // i.e. Don't include spacing for the header
    // Branding Href
    brandHref = 'https://buildcentrix.com/';
    // Banner image
    bannerImageLoaded = false;
    // Company Name and Year
    internalCompanyName = 'BuildCentrix';
    currentYear = new Date().getFullYear();
    /**
     * Constructor
     */
    constructor() {
        this.setBannerImage();
    }
    /**
     * After view init
     */
    ngAfterViewInit() {
        // Fade-in the banner image
        setTimeout(() => {
            this.bannerImageLoaded = true;
        }, 10);
    }
    /**
     * Set banner image
     */
    setBannerImage() {
        this.bannerImageLoaded = false;
    }
    /** @nocollapse */ static ɵfac = function TemplatesBannerPageComponent_Factory(t) { return new (t || TemplatesBannerPageComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesBannerPageComponent, selectors: [["bc-templates-banner-page"]], inputs: { privacyPolicyUrl: "privacyPolicyUrl", termsAndConditionsUrl: "termsAndConditionsUrl", pageTitle: "pageTitle", pageSubtitle: "pageSubtitle", fullPage: "fullPage" }, ngContentSelectors: _c2$4, decls: 20, vars: 12, consts: [[1, "bcx-template-container", 3, "ngClass"], [1, "page-container"], [1, "page-inner-container"], [1, "page-image-container"], [1, "banner-page-container"], [1, "banner-page-inner-container", "fade-in"], [1, "bcx-banner-logo"], [3, "title", "subtitle", "brandHref", "brandTitle"], [1, "bcx-banner-content"], [1, "bcx-banner-buttons"], [1, "bottom-container"], [1, "bottom-left", "copyright"], [1, "bottom-right", "legal"], ["target", "_blank", 3, "href", 4, "ngIf"], [4, "ngIf"], ["target", "_blank", 3, "href"]], template: function TemplatesBannerPageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$6);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "div", 6);
            i0.ɵɵelement(8, "bc-atoms-branded-info", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 8);
            i0.ɵɵprojection(10, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 9);
            i0.ɵɵprojection(12, 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 10)(14, "div", 11);
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "div", 12);
            i0.ɵɵtemplate(17, TemplatesBannerPageComponent_a_17_Template, 2, 1, "a", 13);
            i0.ɵɵtemplate(18, TemplatesBannerPageComponent_span_18_Template, 2, 0, "span", 14);
            i0.ɵɵtemplate(19, TemplatesBannerPageComponent_a_19_Template, 2, 1, "a", 13);
            i0.ɵɵelementEnd()()()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1$6, ctx.fullPage));
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("title", ctx.pageTitle)("subtitle", ctx.pageSubtitle)("brandHref", ctx.brandHref)("brandTitle", ctx.internalCompanyName);
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate2(" \u00A9 ", ctx.internalCompanyName, " ", ctx.currentYear, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.privacyPolicyUrl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.privacyPolicyUrl && ctx.termsAndConditionsUrl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.termsAndConditionsUrl);
        } }, dependencies: [i1.NgClass, i1.NgIf, AtomsBrandedInfoComponent], styles: ["@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.bcx-template-container{opacity:0;animation:fadeIn ease-in .5s;animation-fill-mode:forwards}.bcx-template-container.full-page .page-container{height:100vh}.bcx-template-container.full-page .page-container .banner-page-container{min-height:100vh}.bcx-template-container:not(.full-page){margin:-10px -15px}.bcx-template-container:not(.full-page) .page-container{height:calc(100vh - 46px)}.bcx-template-container:not(.full-page) .page-container .banner-page-container{min-height:calc(100vh - 46px)}.bcx-template-container .page-container{overflow:auto;width:100%}.bcx-template-container .page-container::-webkit-scrollbar{width:5px}.bcx-template-container .page-container::-webkit-scrollbar-track{background:#f1f1f1}.bcx-template-container .page-container::-webkit-scrollbar-thumb{background:#2e1f7a}.bcx-template-container .page-container::-webkit-scrollbar-thumb:hover{background:#4520ff}.bcx-template-container .page-container .page-inner-container{display:flex;min-height:100%;text-align:center}.bcx-template-container .page-container .page-image-container{width:35%;background-color:#1e5c93;min-height:100%;padding:5%;display:flex;justify-content:center;align-items:center}.bcx-template-container .page-container .page-image-container .group-image{width:100%;display:block}.bcx-template-container .page-container .banner-page-container{flex-grow:2;padding:5%;background:white url(assets/images/backgrounds/wave.png) no-repeat fixed center center;background-size:cover;display:flex;flex-direction:column;justify-content:space-between;position:relative}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container{width:280px;margin:auto}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-content{margin:15px auto 0;color:#3f3f45}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-content:empty{display:none}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons{margin:15px auto 0}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons .main-button button{width:100%;padding:10px;border-radius:20px;cursor:pointer;letter-spacing:1px;text-transform:uppercase;color:#fff;border:0}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons .main-button button.btn-light{color:#3f3f45;border:solid 1px lightgrey}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons:empty{display:none}.bcx-template-container .page-container .banner-page-container .bottom-container{position:absolute;bottom:0;left:0;width:100%;padding:0;display:flex;justify-content:space-between}.bcx-template-container .page-container .banner-page-container .bottom-left,.bcx-template-container .page-container .banner-page-container .bottom-right{font-size:xx-small;margin-bottom:10px;color:#a5a4a4;letter-spacing:2px}.bcx-template-container .page-container .banner-page-container .bottom-left a,.bcx-template-container .page-container .banner-page-container .bottom-right a{color:#a5a4a4}.bcx-template-container .page-container .banner-page-container .bottom-left a:hover,.bcx-template-container .page-container .banner-page-container .bottom-right a:hover{color:#0056b3}.bcx-template-container .page-container .banner-page-container .bottom-left{margin-left:2%;text-align:left}.bcx-template-container .page-container .banner-page-container .bottom-right{margin-right:2%;text-align:right}@media only screen and (max-width: 1200px){.bcx-template-container .page-inner-container .page-image-container{width:50%}}@media only screen and (max-width: 800px){.bcx-template-container .page-inner-container .page-image-container{display:none}.bcx-template-container .banner-page-container{justify-content:center}}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesBannerPageComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-banner-page', encapsulation: ViewEncapsulation.None, template: "<!--\n - Templates banner page component\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2025 Build Centrix\n -->\n<div class=\"bcx-template-container\" [ngClass]=\"{ 'full-page': fullPage }\">\n  <div class=\"page-container\">\n    <div class=\"page-inner-container\">\n      <!--Banner Image-->\n      <div class=\"page-image-container\">\n        <!--Transclude banner image-->\n        <ng-content select=\"[bcx-banner-image]\"></ng-content>\n      </div>\n      <!--Form Container-->\n      <div class=\"banner-page-container\">\n        <div class=\"banner-page-inner-container fade-in\">\n          <!--Company Logo-->\n          <div class=\"bcx-banner-logo\">\n            <bc-atoms-branded-info\n              [title]=\"pageTitle\"\n              [subtitle]=\"pageSubtitle\"\n              [brandHref]=\"brandHref\"\n              [brandTitle]=\"internalCompanyName\"\n            >\n            </bc-atoms-branded-info>\n          </div>\n          <!--Content-->\n          <div class=\"bcx-banner-content\">\n            <!--Transclude content-->\n            <ng-content select=\"[bcx-banner-content]\"></ng-content>\n          </div>\n          <div class=\"bcx-banner-buttons\">\n            <!--Transclude buttons-->\n            <ng-content select=\"[bcx-banner-buttons]\"></ng-content>\n          </div>\n        </div>\n        <div class=\"bottom-container\">\n          <div class=\"bottom-left copyright\">\n            \u00A9 {{internalCompanyName}} {{currentYear}}\n          </div>\n          <div class=\"bottom-right legal\">\n            <a\n              href=\"{{privacyPolicyUrl}}\"\n              target=\"_blank\"\n              *ngIf=\"privacyPolicyUrl\"\n              >Privacy Policy</a\n            >\n            <span *ngIf=\"privacyPolicyUrl && termsAndConditionsUrl\"> | </span>\n            <a\n              href=\"{{termsAndConditionsUrl}}\"\n              target=\"_blank\"\n              *ngIf=\"termsAndConditionsUrl\"\n              >Terms and Conditions</a\n            >\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: ["@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.bcx-template-container{opacity:0;animation:fadeIn ease-in .5s;animation-fill-mode:forwards}.bcx-template-container.full-page .page-container{height:100vh}.bcx-template-container.full-page .page-container .banner-page-container{min-height:100vh}.bcx-template-container:not(.full-page){margin:-10px -15px}.bcx-template-container:not(.full-page) .page-container{height:calc(100vh - 46px)}.bcx-template-container:not(.full-page) .page-container .banner-page-container{min-height:calc(100vh - 46px)}.bcx-template-container .page-container{overflow:auto;width:100%}.bcx-template-container .page-container::-webkit-scrollbar{width:5px}.bcx-template-container .page-container::-webkit-scrollbar-track{background:#f1f1f1}.bcx-template-container .page-container::-webkit-scrollbar-thumb{background:#2e1f7a}.bcx-template-container .page-container::-webkit-scrollbar-thumb:hover{background:#4520ff}.bcx-template-container .page-container .page-inner-container{display:flex;min-height:100%;text-align:center}.bcx-template-container .page-container .page-image-container{width:35%;background-color:#1e5c93;min-height:100%;padding:5%;display:flex;justify-content:center;align-items:center}.bcx-template-container .page-container .page-image-container .group-image{width:100%;display:block}.bcx-template-container .page-container .banner-page-container{flex-grow:2;padding:5%;background:white url(assets/images/backgrounds/wave.png) no-repeat fixed center center;background-size:cover;display:flex;flex-direction:column;justify-content:space-between;position:relative}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container{width:280px;margin:auto}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-content{margin:15px auto 0;color:#3f3f45}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-content:empty{display:none}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons{margin:15px auto 0}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons .main-button button{width:100%;padding:10px;border-radius:20px;cursor:pointer;letter-spacing:1px;text-transform:uppercase;color:#fff;border:0}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons .main-button button.btn-light{color:#3f3f45;border:solid 1px lightgrey}.bcx-template-container .page-container .banner-page-container .banner-page-inner-container .bcx-banner-buttons:empty{display:none}.bcx-template-container .page-container .banner-page-container .bottom-container{position:absolute;bottom:0;left:0;width:100%;padding:0;display:flex;justify-content:space-between}.bcx-template-container .page-container .banner-page-container .bottom-left,.bcx-template-container .page-container .banner-page-container .bottom-right{font-size:xx-small;margin-bottom:10px;color:#a5a4a4;letter-spacing:2px}.bcx-template-container .page-container .banner-page-container .bottom-left a,.bcx-template-container .page-container .banner-page-container .bottom-right a{color:#a5a4a4}.bcx-template-container .page-container .banner-page-container .bottom-left a:hover,.bcx-template-container .page-container .banner-page-container .bottom-right a:hover{color:#0056b3}.bcx-template-container .page-container .banner-page-container .bottom-left{margin-left:2%;text-align:left}.bcx-template-container .page-container .banner-page-container .bottom-right{margin-right:2%;text-align:right}@media only screen and (max-width: 1200px){.bcx-template-container .page-inner-container .page-image-container{width:50%}}@media only screen and (max-width: 800px){.bcx-template-container .page-inner-container .page-image-container{display:none}.bcx-template-container .banner-page-container{justify-content:center}}\n"] }]
    }], function () { return []; }, { privacyPolicyUrl: [{
            type: Input
        }], termsAndConditionsUrl: [{
            type: Input
        }], pageTitle: [{
            type: Input
        }], pageSubtitle: [{
            type: Input
        }], fullPage: [{
            type: Input
        }] }); })();

/**
 * 403 (Access Denied) Template Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */
class Templates403AccessDeniedComponent {
    location;
    route;
    // Page text
    pageTitle = 'Access Denied';
    pageSubtitle = 'You may not have the necessary permissions to access this resource.<br/><br/>\n' +
        'Please check with your administrator if you believe this is an error.';
    // Banner image
    bannerImage = 'assets/images/banner/bcx-403-banner.png';
    // Button
    buttonLabel = 'Go Back';
    buttonTitle = 'Click the button to return to your previous page';
    // Booleans
    fullPage = false; // i.e. Don't include spacing for the header
    /**
     * Constructor
     */
    constructor(location, route) {
        this.location = location;
        this.route = route;
        this.route.data.subscribe((data) => {
            this.fullPage = data['fullPage'] ?? false;
        });
    }
    /**
     * Go back
     * Returns user to last known location
     */
    goBack() {
        this.location.back();
    }
    /** @nocollapse */ static ɵfac = function Templates403AccessDeniedComponent_Factory(t) { return new (t || Templates403AccessDeniedComponent)(i0.ɵɵdirectiveInject(i1.Location), i0.ɵɵdirectiveInject(i2$2.ActivatedRoute)); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: Templates403AccessDeniedComponent, selectors: [["bc-templates-403-access-denied"]], inputs: { fullPage: "fullPage" }, decls: 6, vars: 6, consts: [[3, "pageTitle", "pageSubtitle", "fullPage"], ["bcx-banner-image", ""], ["alt", "bcx-oauth2-banner", 1, "group-image", "loaded", 3, "src"], ["bcx-banner-buttons", ""], [1, "main-button"], ["id", "backButton", "name", "backButton", "type", "default", "size", "small", "display", "block", 3, "label", "title", "onButtonClicked"]], template: function Templates403AccessDeniedComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "bc-templates-banner-page", 0)(1, "div", 1);
            i0.ɵɵelement(2, "img", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "bc-atoms-button", 5);
            i0.ɵɵlistener("onButtonClicked", function Templates403AccessDeniedComponent_Template_bc_atoms_button_onButtonClicked_5_listener() { return ctx.goBack(); });
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("pageTitle", ctx.pageTitle)("pageSubtitle", ctx.pageSubtitle)("fullPage", ctx.fullPage);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("src", ctx.bannerImage, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", ctx.buttonLabel)("title", ctx.buttonTitle);
        } }, dependencies: [AtomsButtonComponent, TemplatesBannerPageComponent], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Templates403AccessDeniedComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-403-access-denied', encapsulation: ViewEncapsulation.None, template: "<!--\n - 403 (Access Denied) Template Component HTML\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2025 Build Centrix\n -->\n<bc-templates-banner-page\n  [pageTitle]=\"pageTitle\"\n  [pageSubtitle]=\"pageSubtitle\"\n  [fullPage]=\"fullPage\"\n>\n  <div bcx-banner-image>\n    <!--suppress AngularNgOptimizedImage -->\n    <img\n      src=\"{{bannerImage}}\"\n      class=\"group-image loaded\"\n      alt=\"bcx-oauth2-banner\"\n    />\n  </div>\n  <div bcx-banner-buttons>\n    <!--Back Button-->\n    <div class=\"main-button\">\n      <bc-atoms-button\n        id=\"backButton\"\n        name=\"backButton\"\n        [label]=\"buttonLabel\"\n        [title]=\"buttonTitle\"\n        type=\"default\"\n        size=\"small\"\n        display=\"block\"\n        (onButtonClicked)=\"goBack()\"\n      >\n      </bc-atoms-button>\n    </div>\n  </div>\n</bc-templates-banner-page>\n" }]
    }], function () { return [{ type: i1.Location }, { type: i2$2.ActivatedRoute }]; }, { fullPage: [{
            type: Input
        }] }); })();

/**
 * 404 (Not Found) Template Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */
class Templates404NotFoundComponent {
    location;
    route;
    router;
    // Page text
    pageTitle = 'Page Not Found';
    pageSubtitle = 'Congratulations! It looks like you’ve found a page that does not exist.<br/><br/>\n' +
        'The page you’re looking for may have been moved, deleted, or never existed.';
    // Banner image
    bannerImage = 'assets/images/banner/bcx-404-banner.png';
    // Button
    buttonLabel = 'Go Back';
    buttonTitle = 'Click the button to return to your previous page';
    // Booleans
    fullPage = false; // i.e. Don't include spacing for the header
    // Fallback path
    fallbackPath = false; // i.e. Where to go back if there is no previous value
    // Track router urls
    previousUrl = null;
    currentUrl = null;
    /**
     * Constructor
     */
    constructor(location, route, router) {
        this.location = location;
        this.route = route;
        this.router = router;
        this.route.data.subscribe((data) => {
            this.fullPage = data['fullPage'] ?? false;
            this.fallbackPath = data['fallbackPath'] ?? false;
        });
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
            this.previousUrl = this.currentUrl;
            this.currentUrl = event.urlAfterRedirects;
        });
    }
    /**
     * Go back (or fall back to specified path)
     * Returns user to last known location
     */
    goBack() {
        if (this.previousUrl) {
            this.location.back();
        }
        else if (this.fallbackPath) {
            void this.router.navigate([this.fallbackPath]);
        }
    }
    /** @nocollapse */ static ɵfac = function Templates404NotFoundComponent_Factory(t) { return new (t || Templates404NotFoundComponent)(i0.ɵɵdirectiveInject(i1.Location), i0.ɵɵdirectiveInject(i2$2.ActivatedRoute), i0.ɵɵdirectiveInject(i2$2.Router)); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: Templates404NotFoundComponent, selectors: [["bc-templates-404-not-found"]], inputs: { fullPage: "fullPage", fallbackPath: "fallbackPath" }, decls: 6, vars: 6, consts: [[3, "pageTitle", "pageSubtitle", "fullPage"], ["bcx-banner-image", ""], ["alt", "bcx-oauth2-banner", 1, "group-image", "loaded", 3, "src"], ["bcx-banner-buttons", ""], [1, "main-button"], ["id", "backButton", "name", "backButton", "type", "default", "size", "small", "display", "block", 3, "label", "title", "onButtonClicked"]], template: function Templates404NotFoundComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "bc-templates-banner-page", 0)(1, "div", 1);
            i0.ɵɵelement(2, "img", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "bc-atoms-button", 5);
            i0.ɵɵlistener("onButtonClicked", function Templates404NotFoundComponent_Template_bc_atoms_button_onButtonClicked_5_listener() { return ctx.goBack(); });
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("pageTitle", ctx.pageTitle)("pageSubtitle", ctx.pageSubtitle)("fullPage", ctx.fullPage);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("src", ctx.bannerImage, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", ctx.buttonLabel)("title", ctx.buttonTitle);
        } }, dependencies: [AtomsButtonComponent, TemplatesBannerPageComponent], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Templates404NotFoundComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-404-not-found', encapsulation: ViewEncapsulation.None, template: "<!--\n - 404 (Not Found) Template Component HTML\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2025 Build Centrix\n -->\n<bc-templates-banner-page\n  [pageTitle]=\"pageTitle\"\n  [pageSubtitle]=\"pageSubtitle\"\n  [fullPage]=\"fullPage\"\n>\n  <div bcx-banner-image>\n    <!--suppress AngularNgOptimizedImage -->\n    <img\n      src=\"{{bannerImage}}\"\n      class=\"group-image loaded\"\n      alt=\"bcx-oauth2-banner\"\n    />\n  </div>\n  <div bcx-banner-buttons>\n    <!--Back Button-->\n    <div class=\"main-button\">\n      <bc-atoms-button\n        id=\"backButton\"\n        name=\"backButton\"\n        [label]=\"buttonLabel\"\n        [title]=\"buttonTitle\"\n        type=\"default\"\n        size=\"small\"\n        display=\"block\"\n        (onButtonClicked)=\"goBack()\"\n      >\n      </bc-atoms-button>\n    </div>\n  </div>\n</bc-templates-banner-page>\n" }]
    }], function () { return [{ type: i1.Location }, { type: i2$2.ActivatedRoute }, { type: i2$2.Router }]; }, { fullPage: [{
            type: Input
        }], fallbackPath: [{
            type: Input
        }] }); })();

/**
 * @version
 * 3.5.0 LIBNGSG-123 Migrate tslint to eslint
 * 3.1.0 PRDS-133 Create ordering UI in ng-library-style-guide
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
function TemplatesModalLayoutComponent_div_1_bc_atoms_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bc-atoms-button", 11);
    i0.ɵɵlistener("onButtonClicked", function TemplatesModalLayoutComponent_div_1_bc_atoms_button_7_Template_bc_atoms_button_onButtonClicked_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.onClickCloseButton($event)); });
    i0.ɵɵelementEnd();
} }
function TemplatesModalLayoutComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵprojection(5, 1);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtemplate(7, TemplatesModalLayoutComponent_div_1_bc_atoms_button_7_Template, 1, 0, "bc-atoms-button", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", !ctx_r0.disableClose);
} }
function TemplatesModalLayoutComponent_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 2, ["*ngIf", "!isLoading"]);
} }
function TemplatesModalLayoutComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "bc-atoms-loader", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.loadingText)("active", true);
} }
function TemplatesModalLayoutComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵelementEnd();
} }
const _c0$5 = [[["", "title-content", ""]], [["", "subtitle-content", ""]], [["", "body-content", ""]], [["", "footer-content", ""]]];
const _c1$5 = ["[title-content]", "[subtitle-content]", "[body-content]", "[footer-content]"];
class TemplatesModalLayoutComponent {
    // Booleans
    disableClose = false;
    isLoading = false;
    // Inputs
    loadingText = 'Loading';
    // Callback Functions
    onCloseButtonClicked = new EventEmitter();
    /**
     * Close Button Clicked
     */
    onClickCloseButton = (event) => {
        // Trigger Callback Function
        this.onCloseButtonClicked.emit(event);
    };
    /** @nocollapse */ static ɵfac = function TemplatesModalLayoutComponent_Factory(t) { return new (t || TemplatesModalLayoutComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesModalLayoutComponent, selectors: [["bc-templates-modal-layout"]], inputs: { disableClose: "disableClose", isLoading: "isLoading", loadingText: "loadingText" }, outputs: { onCloseButtonClicked: "onCloseButtonClicked" }, ngContentSelectors: _c1$5, decls: 6, vars: 4, consts: [[1, "bcx-modal"], ["class", "modal-header", 4, "ngIf"], [1, "modal-body"], [4, "ngIf"], ["class", "modal-footer", 4, "ngIf"], [1, "modal-header"], [1, "left-stack"], [1, "top-item"], [1, "bottom-item"], [1, "right-item"], ["iconOnly", "true", "icon", "cancel", "size", "small", 3, "onButtonClicked", 4, "ngIf"], ["iconOnly", "true", "icon", "cancel", "size", "small", 3, "onButtonClicked"], [3, "title", "active"], [1, "modal-footer"]], template: function TemplatesModalLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$5);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, TemplatesModalLayoutComponent_div_1_Template, 8, 1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, TemplatesModalLayoutComponent_ng_content_3_Template, 1, 0, "ng-content", 3);
            i0.ɵɵtemplate(4, TemplatesModalLayoutComponent_div_4_Template, 2, 2, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, TemplatesModalLayoutComponent_div_5_Template, 2, 0, "div", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isLoading);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isLoading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isLoading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isLoading);
        } }, dependencies: [i1.NgIf, AtomsButtonComponent, AtomsLoaderComponent], styles: [".bcx-modal .modal-header{padding:1rem;display:flex;justify-content:space-between;align-items:center}.bcx-modal .modal-header .left-stack{display:flex;flex-direction:column}.bcx-modal .modal-header .left-stack .top-item{font-weight:700;font-size:15px;letter-spacing:1px}.bcx-modal .modal-header .left-stack .bottom-item{font-style:italic;font-size:12px;color:gray}.bcx-modal .modal-header .right-item{align-self:center;margin-left:auto}.bcx-modal .modal-header .right-item button{border:solid 1px transparent}.bcx-modal .modal-body{padding:1rem;max-height:65vh;overflow:hidden;overflow-y:auto}.bcx-modal .modal-footer{display:block;padding:1rem}.bcx-modal .modal-footer [footer-content] .buttons-container{display:flex;width:100%;align-items:center;justify-content:space-between}.bcx-modal .modal-footer [footer-content] .buttons-container:not(:last-child){margin-bottom:1rem}.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{display:flex;align-items:center;gap:10px}.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons bc-atoms-button:not([icononly]) button,.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons bc-atoms-button[icononly=false] button,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons bc-atoms-button:not([icononly]) button,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons bc-atoms-button[icononly=false] button{min-width:100px}.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{margin-left:auto}.bcx-modal .modal-footer [footer-content] .footer-buttons bc-atoms-button{display:inline-block;margin:0 0 0 5px;min-width:100px}@media (max-width: 575.98px){.bcx-modal .modal-footer [footer-content] .buttons-container{flex-direction:column;align-items:stretch;gap:1rem}.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{justify-content:center;width:100%}.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{margin-left:0}.bcx-modal .modal-footer [footer-content] .buttons-container bc-atoms-button{width:100%}}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesModalLayoutComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-modal-layout', encapsulation: ViewEncapsulation.None, template: "<!--\n -\n - @version\n - 3.1.0 PRDS-133 Create ordering UI in ng-library-style-guide\n -\n - @author Monika Gole <monika.gole@ncircletech.com>\n - @copyright (c) 2021-2023 Build Centrix\n-->\n<div class=\"bcx-modal\">\n  <div class=\"modal-header\" *ngIf=\"!isLoading\">\n    <div class=\"left-stack\">\n      <div class=\"top-item\">\n        <!--Main title (transclude)-->\n        <ng-content select=\"[title-content]\"></ng-content>\n      </div>\n      <!--Subtitle (Transclude)-->\n      <div class=\"bottom-item\">\n        <ng-content select=\"[subtitle-content]\"></ng-content>\n      </div>\n    </div>\n    <div class=\"right-item\">\n      <!--Close-->\n      <bc-atoms-button\n        *ngIf=\"!disableClose\"\n        iconOnly=\"true\"\n        icon=\"cancel\"\n        size=\"small\"\n        (onButtonClicked)=\"onClickCloseButton($event)\"\n      ></bc-atoms-button>\n    </div>\n  </div>\n  <div class=\"modal-body\">\n    <!--Main content (transclude)-->\n    <ng-content select=\"[body-content]\" *ngIf=\"!isLoading\"></ng-content>\n    <!--Loader-->\n    <div *ngIf=\"isLoading\">\n      <bc-atoms-loader [title]=\"loadingText\" [active]=\"true\"></bc-atoms-loader>\n    </div>\n  </div>\n  <div class=\"modal-footer\" *ngIf=\"!isLoading\">\n    <ng-content select=\"[footer-content]\"></ng-content>\n  </div>\n</div>\n", styles: [".bcx-modal .modal-header{padding:1rem;display:flex;justify-content:space-between;align-items:center}.bcx-modal .modal-header .left-stack{display:flex;flex-direction:column}.bcx-modal .modal-header .left-stack .top-item{font-weight:700;font-size:15px;letter-spacing:1px}.bcx-modal .modal-header .left-stack .bottom-item{font-style:italic;font-size:12px;color:gray}.bcx-modal .modal-header .right-item{align-self:center;margin-left:auto}.bcx-modal .modal-header .right-item button{border:solid 1px transparent}.bcx-modal .modal-body{padding:1rem;max-height:65vh;overflow:hidden;overflow-y:auto}.bcx-modal .modal-footer{display:block;padding:1rem}.bcx-modal .modal-footer [footer-content] .buttons-container{display:flex;width:100%;align-items:center;justify-content:space-between}.bcx-modal .modal-footer [footer-content] .buttons-container:not(:last-child){margin-bottom:1rem}.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{display:flex;align-items:center;gap:10px}.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons bc-atoms-button:not([icononly]) button,.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons bc-atoms-button[icononly=false] button,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons bc-atoms-button:not([icononly]) button,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons bc-atoms-button[icononly=false] button{min-width:100px}.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{margin-left:auto}.bcx-modal .modal-footer [footer-content] .footer-buttons bc-atoms-button{display:inline-block;margin:0 0 0 5px;min-width:100px}@media (max-width: 575.98px){.bcx-modal .modal-footer [footer-content] .buttons-container{flex-direction:column;align-items:stretch;gap:1rem}.bcx-modal .modal-footer [footer-content] .buttons-container .left-buttons,.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{justify-content:center;width:100%}.bcx-modal .modal-footer [footer-content] .buttons-container .right-buttons{margin-left:0}.bcx-modal .modal-footer [footer-content] .buttons-container bc-atoms-button{width:100%}}\n"] }]
    }], null, { disableClose: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], loadingText: [{
            type: Input
        }], onCloseButtonClicked: [{
            type: Output
        }] }); })();

/**
 * Filters container component (filters-container.component.ts).
 *
 * @version
 * 3.5.0 LIBNGSG-123 Migrate tslint to eslint
 * 1.11.0 LIBNGSG-51 Add shared filter and table container components
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
function TemplatesFiltersContainerComponent_bc_atoms_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "bc-atoms-icon", 18);
} }
function TemplatesFiltersContainerComponent_bc_atoms_icon_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "bc-atoms-icon", 19);
} }
const _c0$4 = [[["", 8, "content"]], [["", 8, "information"]], [["", 8, "actions"]]];
const _c1$4 = function (a0) { return { collapsed: a0 }; };
const _c2$3 = function (a0, a1) { return { "collapse show": a0, "collapse": a1 }; };
const _c3$3 = [".content", ".information", ".actions"];
class TemplatesFiltersContainerComponent {
    isOpenState = true;
    containerTitle;
    /** @nocollapse */ static ɵfac = function TemplatesFiltersContainerComponent_Factory(t) { return new (t || TemplatesFiltersContainerComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesFiltersContainerComponent, selectors: [["bc-templates-filters-container"]], inputs: { containerTitle: "containerTitle" }, ngContentSelectors: _c3$3, decls: 23, vars: 10, consts: [[1, "row", "filters-container"], [1, "col-sm-12"], [1, "card", "mb-0"], ["data-toggle", "collapse", "data-parent", "#filters", "data-target", "#filterContent", 1, "card-header", 3, "ngClass", "click"], [1, "card-title"], ["type", "collapsed", 4, "ngIf"], ["type", "expanded", 4, "ngIf"], [1, "pull-right"], ["title", "filterTitle", "data-container", "body", 1, "clickable", "filter"], ["type", "filter"], ["id", "filterContent1", "data-parent", "#filters1", 1, "filter-content-body", 3, "ngClass"], [1, "card-body", "filters-card", "ng2-transclude"], [1, "row"], [1, "col-sm-12", "col-md-6", "col-lg-8"], [1, "filters-content"], [1, "col-sm-6", "col-md-3", "col-lg-2"], [1, "filters-information"], [1, "filters-actions"], ["type", "collapsed"], ["type", "expanded"]], template: function TemplatesFiltersContainerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$4);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵlistener("click", function TemplatesFiltersContainerComponent_Template_div_click_3_listener() { return ctx.isOpenState = !ctx.isOpenState; });
            i0.ɵɵelementStart(4, "a", 4);
            i0.ɵɵtemplate(5, TemplatesFiltersContainerComponent_bc_atoms_icon_5_Template, 1, 0, "bc-atoms-icon", 5);
            i0.ɵɵtemplate(6, TemplatesFiltersContainerComponent_bc_atoms_icon_6_Template, 1, 0, "bc-atoms-icon", 6);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 7)(9, "span", 8);
            i0.ɵɵelement(10, "bc-atoms-icon", 9);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(11, "div", 10)(12, "div", 11)(13, "div", 12)(14, "div", 13)(15, "div", 14);
            i0.ɵɵprojection(16);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 15)(18, "div", 16);
            i0.ɵɵprojection(19, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 15)(21, "div", 17);
            i0.ɵɵprojection(22, 2);
            i0.ɵɵelementEnd()()()()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$4, !ctx.isOpenState));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isOpenState);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isOpenState);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.containerTitle, " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c2$3, ctx.isOpenState, !ctx.isOpenState));
        } }, dependencies: [i1.NgClass, i1.NgIf, AtomsIconComponent], styles: [".filters-container{margin-bottom:20px}.filters-container .filter-content-body{background:#fffaf0}.filters-container .card-header span.fa{line-height:20px}.card-body.filters-card{display:none}.card-body.filters-card.ng2-transclude{display:block}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesFiltersContainerComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-filters-container', encapsulation: ViewEncapsulation.None, template: "<!--\n - Filters container component (filters-container.component.html).\n -\n - @version\n - 2.0.0 LIBNGSG-97 Upgrade to font-awesome v6\n - 1.11.0 LIBNGSG-51 Add shared filter and table container components\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021-2023 Build Centrix\n -->\n<div class=\"row filters-container\">\n  <div class=\"col-sm-12\">\n    <!--Container-->\n    <div class=\"card mb-0\">\n      <!--Header-->\n      <div\n        class=\"card-header\"\n        data-toggle=\"collapse\"\n        data-parent=\"#filters\"\n        data-target=\"#filterContent\"\n        (click)=\"isOpenState=!isOpenState\"\n        [ngClass]=\"{ collapsed: !isOpenState }\"\n      >\n        <a class=\"card-title\">\n          <bc-atoms-icon type=\"collapsed\" *ngIf=\"!isOpenState\"></bc-atoms-icon>\n          <bc-atoms-icon type=\"expanded\" *ngIf=\"isOpenState\"></bc-atoms-icon>\n          {{ containerTitle }}\n        </a>\n        <div class=\"pull-right\">\n          <span\n            class=\"clickable filter\"\n            title=\"filterTitle\"\n            data-container=\"body\"\n          >\n            <bc-atoms-icon type=\"filter\"></bc-atoms-icon>\n          </span>\n        </div>\n      </div>\n      <!--Content-->\n      <div\n        class=\"filter-content-body\"\n        id=\"filterContent1\"\n        data-parent=\"#filters1\"\n        [ngClass]=\"{ 'collapse show': isOpenState, 'collapse': !isOpenState }\"\n      >\n        <div class=\"card-body filters-card ng2-transclude\">\n          <div class=\"row\">\n            <!-- Filters -->\n            <div class=\"col-sm-12 col-md-6 col-lg-8\">\n              <div class=\"filters-content\">\n                <ng-content select=\".content\"></ng-content>\n              </div>\n            </div>\n\n            <!-- Information -->\n            <div class=\"col-sm-6 col-md-3 col-lg-2\">\n              <div class=\"filters-information\">\n                <ng-content select=\".information\"></ng-content>\n              </div>\n            </div>\n\n            <!-- Actions -->\n            <div class=\"col-sm-6 col-md-3 col-lg-2\">\n              <div class=\"filters-actions\">\n                <ng-content select=\".actions\"></ng-content>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".filters-container{margin-bottom:20px}.filters-container .filter-content-body{background:#fffaf0}.filters-container .card-header span.fa{line-height:20px}.card-body.filters-card{display:none}.card-body.filters-card.ng2-transclude{display:block}\n"] }]
    }], null, { containerTitle: [{
            type: Input
        }] }); })();

/**
 * Templates layout component (templates-layout.component.ts).
 * Templates -> Layout Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.4.0 LIBNGSG-24 Add header sidebar layout components
 *
 */
const _c0$3 = ["headerContent"];
const _c1$3 = ["sidebarContent"];
const _c2$2 = ["mainContent"];
const _c3$2 = ["mainContentContainer"];
const _c4$1 = [[["", "header-content", ""]], [["", "sidebar-content", ""]], [["", "main-content", ""]]];
const _c5 = function (a0) { return { "sidebar": a0 }; };
const _c6 = function (a0) { return { "bc-main-header": a0 }; };
const _c7 = function (a0, a1) { return { "bc-main-content": a0, "header-padding": a1 }; };
const _c8 = function (a0) { return { "bc-main-sidebar": a0 }; };
const _c9 = function (a0) { return { "bc-main-content-inner": a0 }; };
const _c10 = ["[header-content]", "[sidebar-content]", "[main-content]"];
class TemplatesLayoutComponent {
    cdRef;
    // Require Data
    environment = {};
    user = {};
    // Transclude Wrappers
    headerContent;
    sidebarContent;
    mainContent;
    mainContentContainer;
    // Booleans
    hasHeaderContent = false;
    hasSidebarContent = false;
    hasMainContent = false;
    constructor(cdRef) {
        this.cdRef = cdRef;
    }
    /**
     * Adjusts padding-top of .bc-main-content dynamically based on header height
     */
    adjustContentPadding() {
        if (this.headerContent?.nativeElement && this.mainContent?.nativeElement) {
            // Find the first nav element within headerContent
            const navElement = this.headerContent.nativeElement.querySelector('nav');
            if (navElement) {
                // Get the dynamic height of the nav element
                const navHeight = navElement.offsetHeight;
                // Set the padding-top of the main content based on the nav height
                this.mainContentContainer.nativeElement.style.paddingTop = `${navHeight}px`;
            }
        }
    }
    /**
     * After View Init
     * @since 1.4.0
     */
    ngAfterViewInit() {
        this.hasHeaderContent =
            this.headerContent.nativeElement &&
                this.headerContent.nativeElement.children.length > 0;
        this.hasSidebarContent =
            this.sidebarContent.nativeElement &&
                this.sidebarContent.nativeElement.children.length > 0;
        this.hasMainContent =
            this.mainContent.nativeElement &&
                this.mainContent.nativeElement.children.length > 0;
        this.cdRef.detectChanges();
        // Adjust padding based on the initial nav height
        this.adjustContentPadding();
        // Use ResizeObserver to track the nav element height changes dynamically
        const navElement = this.headerContent?.nativeElement.querySelector('nav');
        if (navElement) {
            const observer = new ResizeObserver(() => this.adjustContentPadding());
            observer.observe(navElement);
        }
    }
    /** @nocollapse */ static ɵfac = function TemplatesLayoutComponent_Factory(t) { return new (t || TemplatesLayoutComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesLayoutComponent, selectors: [["bc-templates-layout"]], viewQuery: function TemplatesLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$3, 5);
            i0.ɵɵviewQuery(_c1$3, 5);
            i0.ɵɵviewQuery(_c2$2, 5);
            i0.ɵɵviewQuery(_c3$2, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidebarContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mainContent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mainContentContainer = _t.first);
        } }, inputs: { environment: "environment", user: "user" }, ngContentSelectors: _c10, decls: 12, vars: 16, consts: [[1, "bc-layout", 3, "ngClass"], [3, "ngClass"], ["headerContent", ""], ["mainContentContainer", ""], ["sidebarContent", ""], ["mainContent", ""]], template: function TemplatesLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c4$1);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 1, 3)(6, "div", 1, 4);
            i0.ɵɵprojection(8, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 1, 5);
            i0.ɵɵprojection(11, 2);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c5, ctx.hasSidebarContent));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6, ctx.hasHeaderContent));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c7, ctx.hasSidebarContent || ctx.hasMainContent, ctx.hasHeaderContent));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c8, ctx.hasSidebarContent));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c9, ctx.hasMainContent));
        } }, dependencies: [i1.NgClass], styles: [".bc-layout[_ngcontent-%COMP%]   .bc-main-header[_ngcontent-%COMP%]{height:46px;display:block;position:absolute}.bc-layout[_ngcontent-%COMP%]   .bc-main-content[_ngcontent-%COMP%]{background:white;display:flex;overflow:hidden;padding-top:46px}.bc-layout[_ngcontent-%COMP%]   .bc-main-content[_ngcontent-%COMP%]   .bc-main-content-inner[_ngcontent-%COMP%]{padding:10px 15px;width:100%}.bc-layout[_ngcontent-%COMP%]   .bc-main-content[_ngcontent-%COMP%]   .bc-main-sidebar[_ngcontent-%COMP%]{background-color:#333}"], changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesLayoutComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-layout', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Templates layout component (templates-layout.component.html).\n - Template -> Layout Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.4.0 LIBNGSG-24 Add header sidebar layout components\n -\n -->\n<div class=\"bc-layout\" [ngClass]=\"{ 'sidebar': hasSidebarContent }\">\n  <!--Header-->\n  <div #headerContent [ngClass]=\"{ 'bc-main-header': hasHeaderContent }\">\n    <ng-content select=\"[header-content]\"></ng-content>\n  </div>\n\n  <!--Sidebar and Content-->\n  <div\n    #mainContentContainer\n    [ngClass]=\"{ 'bc-main-content': hasSidebarContent || hasMainContent, 'header-padding': hasHeaderContent }\"\n  >\n    <div #sidebarContent [ngClass]=\"{ 'bc-main-sidebar': hasSidebarContent }\">\n      <ng-content select=\"[sidebar-content]\"></ng-content>\n    </div>\n    <div #mainContent [ngClass]=\"{ 'bc-main-content-inner': hasMainContent }\">\n      <ng-content select=\"[main-content]\"></ng-content>\n    </div>\n  </div>\n</div>\n", styles: [".bc-layout .bc-main-header{height:46px;display:block;position:absolute}.bc-layout .bc-main-content{background:white;display:flex;overflow:hidden;padding-top:46px}.bc-layout .bc-main-content .bc-main-content-inner{padding:10px 15px;width:100%}.bc-layout .bc-main-content .bc-main-sidebar{background-color:#333}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { environment: [{
            type: Input
        }], user: [{
            type: Input
        }], headerContent: [{
            type: ViewChild,
            args: ['headerContent']
        }], sidebarContent: [{
            type: ViewChild,
            args: ['sidebarContent']
        }], mainContent: [{
            type: ViewChild,
            args: ['mainContent']
        }], mainContentContainer: [{
            type: ViewChild,
            args: ['mainContentContainer']
        }] }); })();

/**
 * Templates login component (templates-login.component.ts).
 * Templates -> Login Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @deprecated - The was never used or implemented
 *
 */
class TemplatesLoginComponent {
    /** @nocollapse */ static ɵfac = function TemplatesLoginComponent_Factory(t) { return new (t || TemplatesLoginComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesLoginComponent, selectors: [["bc-templates-login"]], decls: 5, vars: 0, consts: [[1, "row", "justify-content-center", "mx-0"], [1, "col-md-3", "col-6", "pt-100"], [1, "text-center"], [1, "form-signin"]], template: function TemplatesLoginComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "form", 3);
            i0.ɵɵelement(4, "bc-organisms-login");
            i0.ɵɵelementEnd()()()();
        } }, dependencies: [OrganismsLoginComponent, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.NgForm], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesLoginComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-login', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Templates login component (templates-login.component.html).\n - Template -> Login Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @deprecated - The was never used or implemented\n -\n -->\n<div class=\"row justify-content-center mx-0\">\n  <div class=\"col-md-3 col-6 pt-100\">\n    <div class=\"text-center\">\n      <form class=\"form-signin\">\n        <bc-organisms-login></bc-organisms-login>\n      </form>\n    </div>\n  </div>\n</div>\n" }]
    }], null, null); })();

/**
 * Templates style guide component (templates-style-guide.component.ts).
 * Templates -> Style Guide Component
 *
 * @deprecated - This the layout template for our custom style guide examples. Use Storybook instead.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
const _c0$2 = ["outputWrapper"];
const _c1$2 = [[["", "style-guide-input", ""]], [["", "style-guide-usage", ""]], [["", "style-guide-output", ""]]];
const _c2$1 = function (a0) { return { "card card-body bg-light": a0 }; };
const _c3$1 = ["[style-guide-input]", "[style-guide-usage]", "[style-guide-output]"];
class TemplatesStyleGuideComponent {
    // Title
    title;
    // Usage
    usage;
    // Description
    description;
    // Breadcrumbs
    breadcrumbs = [];
    // Transcludes
    outputWrapper;
    // Booleans
    hasOutputContent = false;
    /**
     * Watch for Changes
     */
    ngOnChanges() {
        this.hasOutputContent =
            this.outputWrapper.nativeElement &&
                this.outputWrapper.nativeElement.children.length > 0;
    }
    /** @nocollapse */ static ɵfac = function TemplatesStyleGuideComponent_Factory(t) { return new (t || TemplatesStyleGuideComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesStyleGuideComponent, selectors: [["bc-templates-style-guide"]], viewQuery: function TemplatesStyleGuideComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$2, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.outputWrapper = _t.first);
        } }, inputs: { title: "title", usage: "usage", description: "description", breadcrumbs: "breadcrumbs" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3$1, decls: 13, vars: 7, consts: [[1, "container-fluid"], [1, "row"], [1, "col-sm-12", "mb-4"], [3, "breadcrumbs", "title", "code", "subtitle"], [1, "col-md-4"], [1, "card", "card-body", "bg-light", "example-inputs"], [1, "col-md-8"], [1, "card", "card-body", "bg-light", "example-usage"], [1, "example-output", "mt-4", 3, "ngClass"], ["outputWrapper", ""]], template: function TemplatesStyleGuideComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c1$2);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "bc-molecules-view-header", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
            i0.ɵɵprojection(9, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 8, 9);
            i0.ɵɵprojection(12, 2);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("breadcrumbs", ctx.breadcrumbs)("title", ctx.title)("code", ctx.usage)("subtitle", ctx.description);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$1, ctx.hasOutputContent));
        } }, dependencies: [i1.NgClass, MoleculesViewHeaderComponent], styles: [".card.example-inputs header{margin:0 10px 10px 0;padding-bottom:5px;border-bottom:1px dotted #AAB2BD}.card.example-inputs header .title{color:#656d78;font-size:20px}.usage-container{border:1px dashed #d3d3d3;height:auto;width:100%;margin-bottom:20px;padding:10px;float:inherit;border-radius:5px}.output-container{background:aliceblue;border:solid 1px lightblue;border-radius:5px;padding:10px}.output-container .output-label{color:#2f4f4f}.output-container .output-field{font-family:monospace;font-size:smaller;line-height:20px;letter-spacing:1px}\n"], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesStyleGuideComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-style-guide', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Templates style guide component (templates-style-guide.component.html).\n - Template -> Style Guide Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @deprecated - This the layout template for our custom style guide examples. Use Storybook instead.\n -\n -->\n\n<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-sm-12 mb-4\">\n      <!--View header-->\n      <bc-molecules-view-header\n        [breadcrumbs]=\"breadcrumbs\"\n        [title]=\"title\"\n        [code]=\"usage\"\n        [subtitle]=\"description\"\n      ></bc-molecules-view-header>\n    </div>\n    <div class=\"col-md-4\">\n      <div class=\"card card-body bg-light example-inputs\">\n        <ng-content select=\"[style-guide-input]\"></ng-content>\n      </div>\n    </div>\n    <div class=\"col-md-8\">\n      <div class=\"card card-body bg-light example-usage\">\n        <ng-content select=\"[style-guide-usage]\"></ng-content>\n      </div>\n      <div\n        #outputWrapper\n        class=\"example-output mt-4\"\n        [ngClass]=\"{ 'card card-body bg-light': hasOutputContent }\"\n      >\n        <ng-content select=\"[style-guide-output]\"></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".card.example-inputs header{margin:0 10px 10px 0;padding-bottom:5px;border-bottom:1px dotted #AAB2BD}.card.example-inputs header .title{color:#656d78;font-size:20px}.usage-container{border:1px dashed #d3d3d3;height:auto;width:100%;margin-bottom:20px;padding:10px;float:inherit;border-radius:5px}.output-container{background:aliceblue;border:solid 1px lightblue;border-radius:5px;padding:10px}.output-container .output-label{color:#2f4f4f}.output-container .output-field{font-family:monospace;font-size:smaller;line-height:20px;letter-spacing:1px}\n"] }]
    }], null, { title: [{
            type: Input
        }], usage: [{
            type: Input
        }], description: [{
            type: Input
        }], breadcrumbs: [{
            type: Input
        }], outputWrapper: [{
            type: ViewChild,
            args: ['outputWrapper', { static: true }]
        }] }); })();

/**
 * Templates user details component (templates-user-details.component.ts).
 * Templates -> User Details Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.1.0 LIBNGSG-17 Template driven input form validation
 *
 */
class TemplatesUserDetailsComponent {
    /** @nocollapse */ static ɵfac = function TemplatesUserDetailsComponent_Factory(t) { return new (t || TemplatesUserDetailsComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesUserDetailsComponent, selectors: [["bc-templates-user-details"]], decls: 5, vars: 0, consts: [[1, "row", "justify-content-center", "mx-0"], [1, "col-md-3", "col-6", "pt-100"], [1, "text-center"], [1, "form-signin"]], template: function TemplatesUserDetailsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "form", 3);
            i0.ɵɵelement(4, "bc-organisms-user-details");
            i0.ɵɵelementEnd()()()();
        } }, dependencies: [OrganismsUserDetailsComponent, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.NgForm], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesUserDetailsComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-user-details', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Templates user details component (templates-user-details.component.html).\n - Template -> User Details Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.1.0 LIBNGSG-17 Template driven input form validation\n -\n -->\n<div class=\"row justify-content-center mx-0\">\n  <div class=\"col-md-3 col-6 pt-100\">\n    <div class=\"text-center\">\n      <form class=\"form-signin\">\n        <bc-organisms-user-details></bc-organisms-user-details>\n      </form>\n    </div>\n  </div>\n</div>\n" }]
    }], null, null); })();

/**
 * Table container component (table-container.component.ts).
 *
 * @version
 * 3.15.0 LIBNGSG-151 Add table container column subheadings
 * 3.2.0 LIBNGSG-117 Fix angular upgrade styling issues
 * 3.0.0 UIUP-5 Upgrade Angular to v16
 * 1.25.0 LIBNGSG-87 Support drag and drop for table container component
 * 1.11.0 LIBNGSG-51 Add shared filter and table container components
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
const _c0$1 = ["list"];
function TemplatesTableContainerComponent_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 11);
} }
function TemplatesTableContainerComponent_ng_container_6_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 13);
} }
function TemplatesTableContainerComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TemplatesTableContainerComponent_ng_container_6_tr_1_Template, 1, 0, "tr", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r2.subheadersPrimary);
} }
function TemplatesTableContainerComponent_ng_container_7_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 15);
} }
function TemplatesTableContainerComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TemplatesTableContainerComponent_ng_container_7_tr_1_Template, 1, 0, "tr", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r3.subheadersSecondary);
} }
const _c1$1 = function (a0) { return { "d-none": a0 }; };
function TemplatesTableContainerComponent_ng_container_8_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 17);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1$1, ctx_r13.isLoading));
} }
function TemplatesTableContainerComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TemplatesTableContainerComponent_ng_container_8_tr_1_Template, 1, 3, "tr", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r4.headers);
} }
function TemplatesTableContainerComponent_ng_container_9_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 19);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1$1, ctx_r15.isLoading));
} }
function TemplatesTableContainerComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TemplatesTableContainerComponent_ng_container_9_tr_1_Template, 1, 3, "tr", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r5.headers);
} }
function TemplatesTableContainerComponent_tr_10_bc_atoms_branded_info_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "bc-atoms-branded-info", 23);
} }
function TemplatesTableContainerComponent_tr_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 20)(1, "td", 21);
    i0.ɵɵtemplate(2, TemplatesTableContainerComponent_tr_10_bc_atoms_branded_info_2_Template, 1, 0, "bc-atoms-branded-info", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$1, ctx_r6.isLoading));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", ctx_r6.customColSpan ? ctx_r6.customColSpan : ctx_r6.headers.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.isLoading);
} }
function TemplatesTableContainerComponent_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 24);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1$1, !ctx_r7.isLoading));
} }
function TemplatesTableContainerComponent_td_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 25);
    i0.ɵɵelement(1, "bc-atoms-loader", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵattribute("colspan", ctx_r8.customColSpan ? ctx_r8.customColSpan : ctx_r8.headers.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("active", ctx_r8.isLoading)("fullscreen", false);
} }
function TemplatesTableContainerComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 24);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1$1, ctx_r9.isLoading || !ctx_r9.showPagination || ctx_r9.dataSource.data.length === 0));
} }
function TemplatesTableContainerComponent_td_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 25);
    i0.ɵɵelement(1, "mat-paginator", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵattribute("colspan", ctx_r10.customColSpan ? ctx_r10.customColSpan : ctx_r10.headers.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pageSize", ctx_r10.paginationPageSize)("pageSizeOptions", ctx_r10.paginationPageSizeOptions);
} }
const _c2 = function () { return ["loading"]; };
const _c3 = function () { return ["pagination"]; };
const _c4 = ["*"];
class TemplatesTableContainerComponent {
    headerRowDefs;
    rowDefs;
    columnDefs;
    noDataRow;
    paginator;
    sort;
    // View Children
    table;
    // Inputs: Table headers and data source
    headers;
    subheadersPrimary;
    subheadersSecondary;
    dataSource = new MatTableDataSource();
    // Inputs: Pagination Settings
    paginationPageSize;
    paginationPageSizeOptions;
    // Inputs: Booleans
    isLoading;
    showPagination;
    // Inputs: Column Spans
    customColSpan;
    // Inputs/Outputs: Drag and Drop
    isDragAndDropEnabled = false;
    dropHandler = new EventEmitter();
    list;
    /**
     * After Content Init
     * @since 3.0.0
     */
    ngAfterContentInit() {
        this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef));
        this.rowDefs.forEach((rowDef) => this.table.addRowDef(rowDef));
        this.headerRowDefs.forEach((headerRowDef) => this.table.addHeaderRowDef(headerRowDef));
        this.table.setNoDataRow(this.noDataRow);
    }
    /**
     * After View Init
     * @since 3.0.0
     */
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }
    /**
     * Drop event handler
     *
     * @since 3.2.0
     * @param event
     */
    drop(event) {
        this.dropHandler.emit(event);
    }
    /** @nocollapse */ static ɵfac = function TemplatesTableContainerComponent_Factory(t) { return new (t || TemplatesTableContainerComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesTableContainerComponent, selectors: [["bc-templates-table-container"]], contentQueries: function TemplatesTableContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatNoDataRow, 5);
            i0.ɵɵcontentQuery(dirIndex, MatHeaderRowDef, 4);
            i0.ɵɵcontentQuery(dirIndex, MatRowDef, 4);
            i0.ɵɵcontentQuery(dirIndex, MatColumnDef, 4);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noDataRow = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerRowDefs = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDefs = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnDefs = _t);
        } }, viewQuery: function TemplatesTableContainerComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatPaginator, 5);
            i0.ɵɵviewQuery(MatSort, 5);
            i0.ɵɵviewQuery(MatTable, 7);
            i0.ɵɵviewQuery(_c0$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.table = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.list = _t.first);
        } }, inputs: { headers: "headers", subheadersPrimary: "subheadersPrimary", subheadersSecondary: "subheadersSecondary", dataSource: "dataSource", paginationPageSize: "paginationPageSize", paginationPageSizeOptions: "paginationPageSizeOptions", isLoading: "isLoading", showPagination: "showPagination", customColSpan: "customColSpan", isDragAndDropEnabled: "isDragAndDropEnabled" }, outputs: { dropHandler: "dropHandler" }, ngContentSelectors: _c4, decls: 17, vars: 11, consts: [[1, "bc-templates-table-container"], [1, "table-container"], ["mat-table", "", "cdkDropList", "", 3, "dataSource", "cdkDropListData", "cdkDropListDropped"], ["list", "cdkDropList"], ["class", "bcx-header-row", "mat-header-row", "", 4, "matHeaderRowDef"], [4, "ngIf"], ["class", "mat-row", 3, "ngClass", 4, "matNoDataRow"], ["mat-footer-row", "", 3, "ngClass", 4, "matFooterRowDef"], ["matColumnDef", "loading"], ["mat-footer-cell", "", 4, "matFooterCellDef"], ["matColumnDef", "pagination"], ["mat-header-row", "", 1, "bcx-header-row"], ["class", "bcx-sub-header-row primary", "mat-header-row", "", 4, "matHeaderRowDef"], ["mat-header-row", "", 1, "bcx-sub-header-row", "primary"], ["class", "bcx-sub-header-row secondary", "mat-header-row", "", 4, "matHeaderRowDef"], ["mat-header-row", "", 1, "bcx-sub-header-row", "secondary"], ["mat-row", "", 3, "ngClass", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 3, "ngClass"], ["mat-row", "", "cdkDrag", "", 3, "ngClass", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "cdkDrag", "", 3, "ngClass"], [1, "mat-row", 3, "ngClass"], [1, "mat-cell"], ["title", "No Results Found", 4, "ngIf"], ["title", "No Results Found"], ["mat-footer-row", "", 3, "ngClass"], ["mat-footer-cell", ""], ["title", "Loading", 3, "active", "fullscreen"], ["showFirstLastButtons", "", 3, "pageSize", "pageSizeOptions"]], template: function TemplatesTableContainerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "table", 2, 3);
            i0.ɵɵlistener("cdkDropListDropped", function TemplatesTableContainerComponent_Template_table_cdkDropListDropped_2_listener($event) { return ctx.drop($event); });
            i0.ɵɵprojection(4);
            i0.ɵɵtemplate(5, TemplatesTableContainerComponent_tr_5_Template, 1, 0, "tr", 4);
            i0.ɵɵtemplate(6, TemplatesTableContainerComponent_ng_container_6_Template, 2, 1, "ng-container", 5);
            i0.ɵɵtemplate(7, TemplatesTableContainerComponent_ng_container_7_Template, 2, 1, "ng-container", 5);
            i0.ɵɵtemplate(8, TemplatesTableContainerComponent_ng_container_8_Template, 2, 1, "ng-container", 5);
            i0.ɵɵtemplate(9, TemplatesTableContainerComponent_ng_container_9_Template, 2, 1, "ng-container", 5);
            i0.ɵɵtemplate(10, TemplatesTableContainerComponent_tr_10_Template, 3, 5, "tr", 6);
            i0.ɵɵtemplate(11, TemplatesTableContainerComponent_tr_11_Template, 1, 3, "tr", 7);
            i0.ɵɵelementContainerStart(12, 8);
            i0.ɵɵtemplate(13, TemplatesTableContainerComponent_td_13_Template, 2, 3, "td", 9);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(14, TemplatesTableContainerComponent_tr_14_Template, 1, 3, "tr", 7);
            i0.ɵɵelementContainerStart(15, 10);
            i0.ɵɵtemplate(16, TemplatesTableContainerComponent_td_16_Template, 2, 3, "td", 9);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("dataSource", ctx.dataSource)("cdkDropListData", ctx.dataSource.data);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matHeaderRowDef", ctx.headers);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.subheadersPrimary);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.subheadersSecondary);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isDragAndDropEnabled);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isDragAndDropEnabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("matFooterRowDef", i0.ɵɵpureFunction0(9, _c2));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matFooterRowDef", i0.ɵɵpureFunction0(10, _c3));
        } }, dependencies: [i1.NgClass, i1.NgIf, AtomsBrandedInfoComponent, AtomsLoaderComponent, i4.CdkDropList, i4.CdkDrag, i5.MatTable, i5.MatHeaderRowDef, i5.MatColumnDef, i5.MatRowDef, i5.MatFooterCellDef, i5.MatFooterRowDef, i5.MatFooterCell, i5.MatHeaderRow, i5.MatRow, i5.MatFooterRow, i5.MatNoDataRow, i6.MatPaginator], styles: [".bc-templates-table-container table{table-layout:fixed;border-collapse:collapse;width:100%}.bc-templates-table-container table thead tr.bcx-sub-header-row,.bc-templates-table-container table tbody,.bc-templates-table-container table tfoot{border:1px solid #d3d3d3}.bc-templates-table-container table thead{font-weight:700;letter-spacing:2px}.bc-templates-table-container table thead .bcx-header-row{border:solid 1px #6495ed;background:#6495ed;letter-spacing:2px}.bc-templates-table-container table thead .bcx-header-row .mat-mdc-header-cell,.bc-templates-table-container table thead .bcx-header-row .mat-mdc-header-cell .mat-sort-header-arrow{color:#fff}.bc-templates-table-container table thead .bcx-header-row .mat-mdc-header-cell .mdc-checkbox .mdc-checkbox__background{border:1px solid white}.bc-templates-table-container table thead .bcx-header-row,.bc-templates-table-container table thead .bcx-sub-header-row{height:30px}.bc-templates-table-container table thead .bcx-sub-header-row{border-top:0}.bc-templates-table-container table thead .bcx-sub-header-row .btn{padding:.25rem .5rem;line-height:1rem}.bc-templates-table-container table tbody .mat-mdc-row:hover{background:aliceblue}.bc-templates-table-container table tbody .mat-mdc-row:hover td.mat-mdc-cell{white-space:unset}.bc-templates-table-container table tbody .mat-mdc-row{cursor:pointer;height:38px}.bc-templates-table-container table tbody .mat-mdc-row.locked{background:#F0F0F0}.bc-templates-table-container table tbody .mat-mdc-row.inactive-row{color:gray;font-style:italic}.bc-templates-table-container table tbody .mat-mdc-row .mat-mdc-cell .mdc-checkbox .mdc-checkbox__background{border:1px solid darkslategrey}.bc-templates-table-container table tbody th .pull-left,.bc-templates-table-container table tbody td .pull-left{margin-right:.5em}.bc-templates-table-container table tbody th .pull-left .fa-bars,.bc-templates-table-container table tbody th .pull-left .fa-calculator,.bc-templates-table-container table tbody th .pull-left .fa-spin,.bc-templates-table-container table tbody th .pull-left .fa-edit,.bc-templates-table-container table tbody td .pull-left .fa-bars,.bc-templates-table-container table tbody td .pull-left .fa-calculator,.bc-templates-table-container table tbody td .pull-left .fa-spin,.bc-templates-table-container table tbody td .pull-left .fa-edit{opacity:.3}.bc-templates-table-container table tbody th .editable,.bc-templates-table-container table tbody td .editable{cursor:text}.bc-templates-table-container table thead .mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-cell,.bc-templates-table-container table tbody .mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-cell{vertical-align:middle;border-color:inherit}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell{white-space:nowrap}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell{font-size:13px!important;padding:0 5px 0 10px}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell.drag-column,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell.drag-column{width:30px;text-align:center}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell.select-column,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell.select-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell.select-column,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell.select-column{width:50px;text-align:center}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell.action-button-column,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell.action-button-column{width:150px}.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell{overflow:unset}.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell:not(.editable-cell),.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell:not(.editable-cell),.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell:not(.editable-cell),.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell:not(.editable-cell){white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bc-templates-table-container table thead .mdc-checkbox,.bc-templates-table-container table tbody .mdc-checkbox,.bc-templates-table-container table tfoot .mdc-checkbox{padding:5px;margin:0}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__background{border:1px solid;background-color:#6495ed;width:18px!important;height:18px!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__ripple,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__ripple,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__ripple{display:none}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__checkmark,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__checkmark,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__checkmark{width:12px!important;height:12px!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__mixedmark,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__mixedmark,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__mixedmark{width:12px!important}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{background-color:#6495ed}.bc-templates-table-container table tfoot .mat-mdc-footer-cell .mat-mdc-paginator{color:#0000008a}\n"], encapsulation: 2 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesTableContainerComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-table-container', encapsulation: ViewEncapsulation.None, template: "<!--\n - Table container component (table-container.component.html).\n -\n - @version\n - 3.15.0 LIBNGSG-151 Add table container column subheadings\n - 3.2.0 LIBNGSG-117 Fix angular upgrade styling issues\n - 3.0.0 UIUP-5 Upgrade Angular to v16\n - 1.25.0 LIBNGSG-87 Support drag and drop for table container component\n - 1.11.0 LIBNGSG-51 Add shared filter and table container components\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021-2024 Build Centrix\n -->\n<div class=\"bc-templates-table-container\">\n  <div class=\"table-container\">\n    <table\n      mat-table\n      [dataSource]=\"dataSource\"\n      cdkDropList\n      [cdkDropListData]=\"dataSource.data\"\n      (cdkDropListDropped)=\"drop($event)\"\n      #list=\"cdkDropList\"\n    >\n      <ng-content></ng-content>\n\n      <!-- Custom Header/Rows - provided to the wrapper table-->\n      <tr class=\"bcx-header-row\" mat-header-row *matHeaderRowDef=\"headers\"></tr>\n      <!-- Custom Subheaders - provided to the wrapper table-->\n      <ng-container *ngIf=\"subheadersPrimary\">\n        <tr\n          class=\"bcx-sub-header-row primary\"\n          mat-header-row\n          *matHeaderRowDef=\"subheadersPrimary\"\n        ></tr>\n      </ng-container>\n      <ng-container *ngIf=\"subheadersSecondary\">\n        <tr\n          class=\"bcx-sub-header-row secondary\"\n          mat-header-row\n          *matHeaderRowDef=\"subheadersSecondary\"\n        ></tr>\n      </ng-container>\n      <ng-container *ngIf=\"!isDragAndDropEnabled\">\n        <!--suppress JSUnusedLocalSymbols -->\n        <tr\n          mat-row\n          *matRowDef=\"let row; columns: headers\"\n          [ngClass]=\"{'d-none': isLoading }\"\n        ></tr>\n      </ng-container>\n      <ng-container *ngIf=\"isDragAndDropEnabled\">\n        <!--suppress JSUnusedLocalSymbols -->\n        <tr\n          mat-row\n          *matRowDef=\"let row; columns: headers\"\n          [ngClass]=\"{'d-none': isLoading }\"\n          cdkDrag\n        ></tr>\n      </ng-container>\n\n      <!-- Empty - row shown in the case of an empty table -->\n      <tr class=\"mat-row\" *matNoDataRow [ngClass]=\"{'d-none': isLoading }\">\n        <td\n          class=\"mat-cell\"\n          [attr.colspan]=\"customColSpan ? customColSpan : headers.length\"\n        >\n          <bc-atoms-branded-info\n            *ngIf=\"!isLoading\"\n            title=\"No Results Found\"\n          ></bc-atoms-branded-info>\n        </td>\n      </tr>\n\n      <!--Loading - shown when isLoading boolean is toggled-->\n      <tr\n        mat-footer-row\n        *matFooterRowDef=\"['loading']\"\n        [ngClass]=\"{'d-none': !isLoading }\"\n      ></tr>\n      <ng-container matColumnDef=\"loading\">\n        <td\n          mat-footer-cell\n          *matFooterCellDef\n          [attr.colspan]=\"customColSpan ? customColSpan : headers.length\"\n        >\n          <bc-atoms-loader\n            title=\"Loading\"\n            [active]=\"isLoading\"\n            [fullscreen]=\"false\"\n          ></bc-atoms-loader>\n        </td>\n      </ng-container>\n\n      <!--Pagination- row shown when showPagination boolean is toggled-->\n      <tr\n        mat-footer-row\n        *matFooterRowDef=\"['pagination']\"\n        [ngClass]=\"{'d-none': isLoading || !showPagination || dataSource.data.length === 0 }\"\n      ></tr>\n      <ng-container matColumnDef=\"pagination\">\n        <td\n          mat-footer-cell\n          *matFooterCellDef\n          [attr.colspan]=\"customColSpan ? customColSpan : headers.length\"\n        >\n          <mat-paginator\n            [pageSize]=\"paginationPageSize\"\n            [pageSizeOptions]=\"paginationPageSizeOptions\"\n            showFirstLastButtons\n          >\n          </mat-paginator>\n        </td>\n      </ng-container>\n    </table>\n  </div>\n</div>\n", styles: [".bc-templates-table-container table{table-layout:fixed;border-collapse:collapse;width:100%}.bc-templates-table-container table thead tr.bcx-sub-header-row,.bc-templates-table-container table tbody,.bc-templates-table-container table tfoot{border:1px solid #d3d3d3}.bc-templates-table-container table thead{font-weight:700;letter-spacing:2px}.bc-templates-table-container table thead .bcx-header-row{border:solid 1px #6495ed;background:#6495ed;letter-spacing:2px}.bc-templates-table-container table thead .bcx-header-row .mat-mdc-header-cell,.bc-templates-table-container table thead .bcx-header-row .mat-mdc-header-cell .mat-sort-header-arrow{color:#fff}.bc-templates-table-container table thead .bcx-header-row .mat-mdc-header-cell .mdc-checkbox .mdc-checkbox__background{border:1px solid white}.bc-templates-table-container table thead .bcx-header-row,.bc-templates-table-container table thead .bcx-sub-header-row{height:30px}.bc-templates-table-container table thead .bcx-sub-header-row{border-top:0}.bc-templates-table-container table thead .bcx-sub-header-row .btn{padding:.25rem .5rem;line-height:1rem}.bc-templates-table-container table tbody .mat-mdc-row:hover{background:aliceblue}.bc-templates-table-container table tbody .mat-mdc-row:hover td.mat-mdc-cell{white-space:unset}.bc-templates-table-container table tbody .mat-mdc-row{cursor:pointer;height:38px}.bc-templates-table-container table tbody .mat-mdc-row.locked{background:#F0F0F0}.bc-templates-table-container table tbody .mat-mdc-row.inactive-row{color:gray;font-style:italic}.bc-templates-table-container table tbody .mat-mdc-row .mat-mdc-cell .mdc-checkbox .mdc-checkbox__background{border:1px solid darkslategrey}.bc-templates-table-container table tbody th .pull-left,.bc-templates-table-container table tbody td .pull-left{margin-right:.5em}.bc-templates-table-container table tbody th .pull-left .fa-bars,.bc-templates-table-container table tbody th .pull-left .fa-calculator,.bc-templates-table-container table tbody th .pull-left .fa-spin,.bc-templates-table-container table tbody th .pull-left .fa-edit,.bc-templates-table-container table tbody td .pull-left .fa-bars,.bc-templates-table-container table tbody td .pull-left .fa-calculator,.bc-templates-table-container table tbody td .pull-left .fa-spin,.bc-templates-table-container table tbody td .pull-left .fa-edit{opacity:.3}.bc-templates-table-container table tbody th .editable,.bc-templates-table-container table tbody td .editable{cursor:text}.bc-templates-table-container table thead .mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-cell,.bc-templates-table-container table tbody .mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-cell{vertical-align:middle;border-color:inherit}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell{white-space:nowrap}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell{font-size:13px!important;padding:0 5px 0 10px}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell.drag-column,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell.drag-column,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell.drag-column{width:30px;text-align:center}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell.select-column,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell.select-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell.select-column,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell.select-column,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell.select-column{width:50px;text-align:center}.bc-templates-table-container table thead .mat-mdc-header-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell.action-button-column,.bc-templates-table-container table thead .mat-mdc-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-cell.mat-mdc-header-cell.action-button-column,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell.action-button-column{width:150px}.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell,.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell{overflow:unset}.bc-templates-table-container table thead .mat-mdc-header-cell.mdc-data-table__cell:not(.editable-cell),.bc-templates-table-container table thead .mat-mdc-cell.mdc-data-table__cell:not(.editable-cell),.bc-templates-table-container table tbody .mat-mdc-header-cell.mdc-data-table__cell:not(.editable-cell),.bc-templates-table-container table tbody .mat-mdc-cell.mdc-data-table__cell:not(.editable-cell){white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bc-templates-table-container table thead .mdc-checkbox,.bc-templates-table-container table tbody .mdc-checkbox,.bc-templates-table-container table tfoot .mdc-checkbox{padding:5px;margin:0}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__background{border:1px solid;background-color:#6495ed;width:18px!important;height:18px!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__ripple,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__ripple,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__ripple{display:none}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__checkmark,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__checkmark,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__checkmark{width:12px!important;height:12px!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__mixedmark,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__mixedmark,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__mixedmark{width:12px!important}.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.bc-templates-table-container table thead .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.bc-templates-table-container table tbody .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.bc-templates-table-container table tfoot .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{background-color:#6495ed}.bc-templates-table-container table tfoot .mat-mdc-footer-cell .mat-mdc-paginator{color:#0000008a}\n"] }]
    }], null, { headerRowDefs: [{
            type: ContentChildren,
            args: [MatHeaderRowDef]
        }], rowDefs: [{
            type: ContentChildren,
            args: [MatRowDef]
        }], columnDefs: [{
            type: ContentChildren,
            args: [MatColumnDef]
        }], noDataRow: [{
            type: ContentChild,
            args: [MatNoDataRow]
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator]
        }], sort: [{
            type: ViewChild,
            args: [MatSort]
        }], table: [{
            type: ViewChild,
            args: [MatTable, { static: true }]
        }], headers: [{
            type: Input
        }], subheadersPrimary: [{
            type: Input
        }], subheadersSecondary: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], paginationPageSize: [{
            type: Input
        }], paginationPageSizeOptions: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], showPagination: [{
            type: Input
        }], customColSpan: [{
            type: Input
        }], isDragAndDropEnabled: [{
            type: Input
        }], dropHandler: [{
            type: Output
        }], list: [{
            type: ViewChild,
            args: ['list']
        }] }); })();

/**
 * Templates thumbnail menu component (templates-thumbnail-menu.component.ts).
 * Templates -> Thumbnail Menu Component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 *
 * @version
 * 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu
 *
 */
function TemplatesThumbnailMenuComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
} }
function TemplatesThumbnailMenuComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subtitle, " ");
} }
const _c0 = [[["", "brand-content", ""]], [["", "menu-content", ""]]];
const _c1 = ["[brand-content]", "[menu-content]"];
class TemplatesThumbnailMenuComponent {
    // Defaults (Non-Inputs)
    thumbnailMenuClass = 'bc-thumbnail-menu';
    // String Inputs
    title = '';
    subtitle = '';
    /** @nocollapse */ static ɵfac = function TemplatesThumbnailMenuComponent_Factory(t) { return new (t || TemplatesThumbnailMenuComponent)(); };
    /** @nocollapse */ static ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TemplatesThumbnailMenuComponent, selectors: [["bc-templates-thumbnail-menu"]], inputs: { title: "title", subtitle: "subtitle" }, ngContentSelectors: _c1, decls: 7, vars: 4, consts: [[1, "menu-brand"], ["class", "menu-title", 4, "ngIf"], ["class", "menu-subtitle", 4, "ngIf"], [1, "menu-buttons"], [1, "menu-title"], [1, "menu-subtitle"]], template: function TemplatesThumbnailMenuComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div")(1, "div", 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, TemplatesThumbnailMenuComponent_div_3_Template, 2, 1, "div", 1);
            i0.ɵɵtemplate(4, TemplatesThumbnailMenuComponent_div_4_Template, 2, 1, "div", 2);
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵprojection(6, 1);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵclassMap(ctx.thumbnailMenuClass);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.subtitle);
        } }, dependencies: [i1.NgIf], styles: [".bc-thumbnail-menu{text-align:center}.bc-thumbnail-menu .menu-brand{margin:0 auto 10px;max-width:250px;max-height:80px}.bc-thumbnail-menu .menu-title,.bc-thumbnail-menu .menu-subtitle{letter-spacing:2px}.bc-thumbnail-menu .menu-title{color:#2f4f4f}.bc-thumbnail-menu .menu-subtitle{color:gray;font-size:smaller}.bc-thumbnail-menu .menu-buttons{margin-top:10px}.bc-thumbnail-menu .menu-buttons .bc-thumbnail{display:inline-block}\n"], encapsulation: 2, changeDetection: 0 });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesThumbnailMenuComponent, [{
        type: Component,
        args: [{ selector: 'bc-templates-thumbnail-menu', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<!--\n - Templates thumbnail menu component (templates-thumbnail-menu.component.html).\n - Template -> Search Component.\n -\n - @author Ryan Sweeney <rsweeney@buildcentrix.com>\n - @copyright (c) 2021 Build Centrix\n -\n - @version\n - 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu\n -\n -->\n<div [class]=\"thumbnailMenuClass\">\n  <!--Optional Branding-->\n  <div class=\"menu-brand\">\n    <ng-content select=\"[brand-content]\"></ng-content>\n  </div>\n\n  <!--Optional Title-->\n  <div class=\"menu-title\" *ngIf=\"title\">\n    {{title}}\n  </div>\n\n  <!--Optional Subtitle-->\n  <div class=\"menu-subtitle\" *ngIf=\"subtitle\">\n    {{subtitle}}\n  </div>\n\n  <!--Menu-->\n  <div class=\"menu-buttons\">\n    <ng-content select=\"[menu-content]\"></ng-content>\n  </div>\n</div>\n", styles: [".bc-thumbnail-menu{text-align:center}.bc-thumbnail-menu .menu-brand{margin:0 auto 10px;max-width:250px;max-height:80px}.bc-thumbnail-menu .menu-title,.bc-thumbnail-menu .menu-subtitle{letter-spacing:2px}.bc-thumbnail-menu .menu-title{color:#2f4f4f}.bc-thumbnail-menu .menu-subtitle{color:gray;font-size:smaller}.bc-thumbnail-menu .menu-buttons{margin-top:10px}.bc-thumbnail-menu .menu-buttons .bc-thumbnail{display:inline-block}\n"] }]
    }], null, { title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }] }); })();

/**
 * Components module (components.module.ts).
 * Components Module.
 *
 * @version
 * 3.1.0 PRDS-133 Create ordering UI in ng-library-style-guide
 * 1.25.0 LIBNGSG-87 Support drag and drop for table container component
 * 1.12.0 LIBNGSG-54 Add missing table CSS and fix hidden drop-downs
 * 1.11.0 LIBNGSG-51 Add shared filter and table container components
 * 1.4.0 LIBNGSG-24 Add header sidebar layout components
 * 1.3.0 LIBNGSG-28 Add thumbnail atom and molecule menu
 * 1.1.0 LIBNGSG-17 Template driven input form validation
 * 1.1.0 LIBNGSG-17 Template driven input form validation
 * 1.0.0 LIBNGSG-5 Add Style Guide Button and Icon Components
 * 1.0.0 LIBNGSG-2 Restructure as a library import
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
class BcTemplatesModule {
    /** @nocollapse */ static ɵfac = function BcTemplatesModule_Factory(t) { return new (t || BcTemplatesModule)(); };
    /** @nocollapse */ static ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: BcTemplatesModule });
    /** @nocollapse */ static ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule,
            BcAtomsModule,
            BcMoleculesModule,
            BcOrganismsModule,
            DragDropModule,
            MatCheckboxModule,
            MatIconModule,
            MatTableModule,
            MatPaginatorModule,
            MatSortModule,
            MatDialogModule,
            FormsModule,
            ReactiveFormsModule,
            BcMoleculesModule,
            TranslateModule, BcAtomsModule,
            BcMoleculesModule,
            BcOrganismsModule,
            DragDropModule,
            TranslateModule] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BcTemplatesModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BcAtomsModule,
                    BcMoleculesModule,
                    BcOrganismsModule,
                    DragDropModule,
                    MatCheckboxModule,
                    MatIconModule,
                    MatTableModule,
                    MatPaginatorModule,
                    MatSortModule,
                    MatDialogModule,
                    FormsModule,
                    ReactiveFormsModule,
                    BcMoleculesModule,
                    TranslateModule,
                ],
                exports: [
                    BcAtomsModule,
                    BcMoleculesModule,
                    BcOrganismsModule,
                    DragDropModule,
                    TemplatesBannerPageComponent,
                    Templates403AccessDeniedComponent,
                    Templates404NotFoundComponent,
                    TemplatesModalLayoutComponent,
                    TemplatesFiltersContainerComponent,
                    TemplatesLayoutComponent,
                    TemplatesLoginComponent,
                    TemplatesStyleGuideComponent,
                    TemplatesUserDetailsComponent,
                    TemplatesTableContainerComponent,
                    TemplatesThumbnailMenuComponent,
                    TranslateModule,
                ],
                declarations: [
                    TemplatesBannerPageComponent,
                    Templates403AccessDeniedComponent,
                    Templates404NotFoundComponent,
                    TemplatesModalLayoutComponent,
                    TemplatesFiltersContainerComponent,
                    TemplatesLayoutComponent,
                    TemplatesLoginComponent,
                    TemplatesStyleGuideComponent,
                    TemplatesUserDetailsComponent,
                    TemplatesTableContainerComponent,
                    TemplatesThumbnailMenuComponent,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BcTemplatesModule, { declarations: [TemplatesBannerPageComponent,
        Templates403AccessDeniedComponent,
        Templates404NotFoundComponent,
        TemplatesModalLayoutComponent,
        TemplatesFiltersContainerComponent,
        TemplatesLayoutComponent,
        TemplatesLoginComponent,
        TemplatesStyleGuideComponent,
        TemplatesUserDetailsComponent,
        TemplatesTableContainerComponent,
        TemplatesThumbnailMenuComponent], imports: [CommonModule,
        BcAtomsModule,
        BcMoleculesModule,
        BcOrganismsModule,
        DragDropModule,
        MatCheckboxModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        BcMoleculesModule,
        TranslateModule], exports: [BcAtomsModule,
        BcMoleculesModule,
        BcOrganismsModule,
        DragDropModule,
        TemplatesBannerPageComponent,
        Templates403AccessDeniedComponent,
        Templates404NotFoundComponent,
        TemplatesModalLayoutComponent,
        TemplatesFiltersContainerComponent,
        TemplatesLayoutComponent,
        TemplatesLoginComponent,
        TemplatesStyleGuideComponent,
        TemplatesUserDetailsComponent,
        TemplatesTableContainerComponent,
        TemplatesThumbnailMenuComponent,
        TranslateModule] }); })();

/**
 * Components module (components.module.ts).
 * Components Module.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021 Build Centrix
 */
class BcComponentsModule {
    /** @nocollapse */ static ɵfac = function BcComponentsModule_Factory(t) { return new (t || BcComponentsModule)(); };
    /** @nocollapse */ static ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: BcComponentsModule });
    /** @nocollapse */ static ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [BcAtomsModule,
            BcMoleculesModule,
            BcOrganismsModule,
            BcTemplatesModule,
            CommonModule,
            TranslateModule, BcAtomsModule,
            BcMoleculesModule,
            BcOrganismsModule,
            BcTemplatesModule,
            TranslateModule] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BcComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BcAtomsModule,
                    BcMoleculesModule,
                    BcOrganismsModule,
                    BcTemplatesModule,
                    CommonModule,
                    TranslateModule,
                ],
                exports: [
                    BcAtomsModule,
                    BcMoleculesModule,
                    BcOrganismsModule,
                    BcTemplatesModule,
                    TranslateModule,
                ],
                declarations: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BcComponentsModule, { imports: [BcAtomsModule,
        BcMoleculesModule,
        BcOrganismsModule,
        BcTemplatesModule,
        CommonModule,
        TranslateModule], exports: [BcAtomsModule,
        BcMoleculesModule,
        BcOrganismsModule,
        BcTemplatesModule,
        TranslateModule] }); })();

/**
 * Environment interfaces for strong typing.
 * Defines configuration settings, constants, permissions, resources, and user details.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */

/**
 * Generic interfaces for strong typing.
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */

/**
 * Public api (public-api.ts).
 * Library Public Exports (Entry Point for Library).
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
// Atoms

/**
 * Generated bundle index. Do not edit.
 */

export { AtomsBrandedInfoComponent, AtomsBrandingComponent, AtomsButtonComponent, AtomsButtonGroupComponent, AtomsChartComponent, AtomsCheckboxComponent, AtomsCheckboxGroupComponent, AtomsCustomInputFieldComponent, AtomsDatePickerComponent, AtomsDropdownComponent, AtomsIconComponent, AtomsInputComponent, AtomsInputGroupComponent, AtomsLoaderComponent, AtomsTextAreaComponent, AtomsThumbnailComponent, AtomsTimePickerComponent, AtomsTypeaheadComponent, BcAtomsModule, BcComponentsModule, BcMoleculesModule, BcOrganismsModule, BcTemplatesModule, ComponentService, ForbiddenValidatorDirective, Login, MoleculesMultiSelectDropdownComponent, MoleculesNotificationsFormComponent, MoleculesSidebarDropdownComponent, MoleculesSidebarItemComponent, MoleculesViewHeaderBarComponent, MoleculesViewHeaderComponent, MustMatch, MustMatchValidatorDirective, NumberRangeValidatorDirective, OrderAssembly, OrganismsForgeViewerComponent, OrganismsHeaderComponent, OrganismsLoginComponent, OrganismsOrderAssemblyComponent, OrganismsSidebarComponent, OrganismsUserDetailsComponent, Templates403AccessDeniedComponent, Templates404NotFoundComponent, TemplatesBannerPageComponent, TemplatesFiltersContainerComponent, TemplatesLayoutComponent, TemplatesLoginComponent, TemplatesModalLayoutComponent, TemplatesStyleGuideComponent, TemplatesTableContainerComponent, TemplatesThumbnailMenuComponent, TemplatesUserDetailsComponent, User, createForbiddenNameValidator };
